(() => {
    var e = {
        816: (e) => {
          "use strict";
          var t =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            function (e) {
              window.setTimeout(e, 1e3 / 60);
            };
          e.exports = function (e, n, i) {
            var r,
              s = !1;
            function a(e) {
              (r = e), s || (t(o), (s = !0));
            }
            function o() {
              i.call(e, r), (s = !1);
            }
            return e.addEventListener(n, a, !1), a;
          };
        },
        626: (e, t) => {
          "use strict";
          t.__esModule = !0;
          var n = (function () {
            function e() {
              !(function (e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              })(this, e);
            }
            return (
              (e.prototype.on = function (e, t) {
                return (
                  (this._eventCollection = this._eventCollection || {}),
                  (this._eventCollection[e] = this._eventCollection[e] || []),
                  this._eventCollection[e].push(t),
                  this
                );
              }),
              (e.prototype.once = function (e, t) {
                var n = this;
                function i() {
                  n.off(e, i), t.apply(this, arguments);
                }
                return (i.listener = t), this.on(e, i), this;
              }),
              (e.prototype.off = function (e, t) {
                var n = void 0;
                return this._eventCollection && (n = this._eventCollection[e])
                  ? (n.forEach(function (e, i) {
                      (e !== t && e.listener !== t) || n.splice(i, 1);
                    }),
                    0 === n.length && delete this._eventCollection[e],
                    this)
                  : this;
              }),
              (e.prototype.emit = function (e) {
                for (
                  var t = this,
                    n = arguments.length,
                    i = Array(n > 1 ? n - 1 : 0),
                    r = 1;
                  r < n;
                  r++
                )
                  i[r - 1] = arguments[r];
                var s = void 0;
                return this._eventCollection && (s = this._eventCollection[e])
                  ? ((s = s.slice(0)).forEach(function (e) {
                      return e.apply(t, i);
                    }),
                    this)
                  : this;
              }),
              e
            );
          })();
          (t.default = n), (e.exports = t.default);
        },
        508: function (e) {
          var t;
          "undefined" != typeof self && self,
            (t = function () {
              return (function (e) {
                var t = {};
                function n(i) {
                  if (t[i]) return t[i].exports;
                  var r = (t[i] = { i, l: !1, exports: {} });
                  return (
                    e[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports
                  );
                }
                return (
                  (n.m = e),
                  (n.c = t),
                  (n.d = function (e, t, i) {
                    n.o(e, t) ||
                      Object.defineProperty(e, t, {
                        configurable: !1,
                        enumerable: !0,
                        get: i,
                      });
                  }),
                  (n.r = function (e) {
                    Object.defineProperty(e, "__esModule", { value: !0 });
                  }),
                  (n.n = function (e) {
                    var t =
                      e && e.__esModule
                        ? function () {
                            return e.default;
                          }
                        : function () {
                            return e;
                          };
                    return n.d(t, "a", t), t;
                  }),
                  (n.o = function (e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                  }),
                  (n.p = ""),
                  n((n.s = 0))
                );
              })({
                "./dist/icons.json": function (e) {
                  e.exports = {
                    activity:
                      '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
                    airplay:
                      '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
                    "alert-circle":
                      '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                    "alert-octagon":
                      '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                    "alert-triangle":
                      '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                    "align-center":
                      '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
                    "align-justify":
                      '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
                    "align-left":
                      '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
                    "align-right":
                      '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
                    anchor:
                      '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
                    aperture:
                      '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
                    archive:
                      '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
                    "arrow-down-circle":
                      '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
                    "arrow-down-left":
                      '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
                    "arrow-down-right":
                      '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
                    "arrow-down":
                      '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
                    "arrow-left-circle":
                      '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
                    "arrow-left":
                      '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
                    "arrow-right-circle":
                      '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "arrow-right":
                      '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
                    "arrow-up-circle":
                      '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
                    "arrow-up-left":
                      '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
                    "arrow-up-right":
                      '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
                    "arrow-up":
                      '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
                    "at-sign":
                      '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
                    award:
                      '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
                    "bar-chart-2":
                      '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
                    "bar-chart":
                      '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
                    "battery-charging":
                      '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
                    battery:
                      '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
                    "bell-off":
                      '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
                    bluetooth:
                      '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
                    bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
                    "book-open":
                      '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
                    book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
                    bookmark:
                      '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
                    box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    briefcase:
                      '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
                    calendar:
                      '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
                    "camera-off":
                      '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
                    camera:
                      '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
                    cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
                    "check-circle":
                      '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
                    "check-square":
                      '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
                    check: '<polyline points="20 6 9 17 4 12"></polyline>',
                    "chevron-down":
                      '<polyline points="6 9 12 15 18 9"></polyline>',
                    "chevron-left":
                      '<polyline points="15 18 9 12 15 6"></polyline>',
                    "chevron-right":
                      '<polyline points="9 18 15 12 9 6"></polyline>',
                    "chevron-up":
                      '<polyline points="18 15 12 9 6 15"></polyline>',
                    "chevrons-down":
                      '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
                    "chevrons-left":
                      '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
                    "chevrons-right":
                      '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
                    "chevrons-up":
                      '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
                    chrome:
                      '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
                    circle: '<circle cx="12" cy="12" r="10"></circle>',
                    clipboard:
                      '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
                    clock:
                      '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
                    "cloud-drizzle":
                      '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                    "cloud-lightning":
                      '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
                    "cloud-off":
                      '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    "cloud-rain":
                      '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                    "cloud-snow":
                      '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
                    cloud:
                      '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
                    code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
                    codepen:
                      '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
                    codesandbox:
                      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    coffee:
                      '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
                    columns:
                      '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
                    command:
                      '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
                    compass:
                      '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
                    copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
                    "corner-down-left":
                      '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
                    "corner-down-right":
                      '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
                    "corner-left-down":
                      '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
                    "corner-left-up":
                      '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
                    "corner-right-down":
                      '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
                    "corner-right-up":
                      '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
                    "corner-up-left":
                      '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
                    "corner-up-right":
                      '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
                    cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
                    "credit-card":
                      '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
                    crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
                    crosshair:
                      '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
                    database:
                      '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
                    delete:
                      '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
                    disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
                    "divide-circle":
                      '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
                    "divide-square":
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
                    divide:
                      '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
                    "dollar-sign":
                      '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
                    "download-cloud":
                      '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
                    download:
                      '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
                    dribbble:
                      '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
                    droplet:
                      '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
                    "edit-2":
                      '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
                    "edit-3":
                      '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
                    edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
                    "external-link":
                      '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
                    "eye-off":
                      '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
                    facebook:
                      '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
                    "fast-forward":
                      '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
                    feather:
                      '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
                    figma:
                      '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
                    "file-minus":
                      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
                    "file-plus":
                      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
                    "file-text":
                      '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
                    file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
                    film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
                    filter:
                      '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
                    flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
                    "folder-minus":
                      '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
                    "folder-plus":
                      '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
                    folder:
                      '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
                    framer:
                      '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
                    frown:
                      '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
                    "git-branch":
                      '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
                    "git-commit":
                      '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
                    "git-merge":
                      '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
                    "git-pull-request":
                      '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
                    github:
                      '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
                    gitlab:
                      '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
                    globe:
                      '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
                    grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
                    "hard-drive":
                      '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
                    hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
                    headphones:
                      '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
                    heart:
                      '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
                    "help-circle":
                      '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                    hexagon:
                      '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
                    home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
                    image:
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
                    inbox:
                      '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
                    info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
                    instagram:
                      '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
                    italic:
                      '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
                    key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
                    layers:
                      '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
                    layout:
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
                    "life-buoy":
                      '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
                    "link-2":
                      '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
                    link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
                    linkedin:
                      '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
                    list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
                    loader:
                      '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
                    lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
                    "log-in":
                      '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
                    "log-out":
                      '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
                    mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
                    "map-pin":
                      '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
                    map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
                    "maximize-2":
                      '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                    maximize:
                      '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
                    meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
                    "message-circle":
                      '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
                    "message-square":
                      '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
                    "mic-off":
                      '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                    mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                    "minimize-2":
                      '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                    minimize:
                      '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
                    "minus-circle":
                      '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "minus-square":
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
                    minus: '<line x1="5" y1="12" x2="19" y2="12"></line>',
                    monitor:
                      '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
                    moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
                    "more-horizontal":
                      '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
                    "more-vertical":
                      '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
                    "mouse-pointer":
                      '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
                    move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
                    music:
                      '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
                    "navigation-2":
                      '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
                    navigation:
                      '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
                    octagon:
                      '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
                    package:
                      '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                    paperclip:
                      '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
                    "pause-circle":
                      '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
                    pause:
                      '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
                    "pen-tool":
                      '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
                    percent:
                      '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
                    "phone-call":
                      '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-forwarded":
                      '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-incoming":
                      '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-missed":
                      '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "phone-off":
                      '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
                    "phone-outgoing":
                      '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    phone:
                      '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                    "pie-chart":
                      '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
                    "play-circle":
                      '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
                    play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
                    "plus-circle":
                      '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                    "plus-square":
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                    plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
                    pocket:
                      '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
                    power:
                      '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
                    printer:
                      '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
                    radio:
                      '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
                    "refresh-ccw":
                      '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
                    "refresh-cw":
                      '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
                    repeat:
                      '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
                    rewind:
                      '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
                    "rotate-ccw":
                      '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
                    "rotate-cw":
                      '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
                    rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
                    save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
                    scissors:
                      '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
                    search:
                      '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
                    send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
                    server:
                      '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
                    settings:
                      '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
                    "share-2":
                      '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
                    share:
                      '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
                    "shield-off":
                      '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    shield:
                      '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
                    "shopping-bag":
                      '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
                    "shopping-cart":
                      '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
                    shuffle:
                      '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
                    sidebar:
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
                    "skip-back":
                      '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
                    "skip-forward":
                      '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
                    slack:
                      '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
                    slash:
                      '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
                    sliders:
                      '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
                    smartphone:
                      '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                    smile:
                      '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                    speaker:
                      '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
                    square:
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
                    star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
                    "stop-circle":
                      '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
                    sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
                    sunrise:
                      '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
                    sunset:
                      '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
                    tablet:
                      '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                    tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
                    target:
                      '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
                    terminal:
                      '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
                    thermometer:
                      '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
                    "thumbs-down":
                      '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
                    "thumbs-up":
                      '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
                    "toggle-left":
                      '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
                    "toggle-right":
                      '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
                    tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
                    "trash-2":
                      '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
                    trash:
                      '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
                    trello:
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
                    "trending-down":
                      '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
                    "trending-up":
                      '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
                    triangle:
                      '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
                    truck:
                      '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
                    tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
                    twitch:
                      '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
                    twitter:
                      '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
                    type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
                    umbrella:
                      '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
                    underline:
                      '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
                    unlock:
                      '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
                    "upload-cloud":
                      '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
                    upload:
                      '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
                    "user-check":
                      '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
                    "user-minus":
                      '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
                    "user-plus":
                      '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
                    "user-x":
                      '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
                    user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
                    users:
                      '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
                    "video-off":
                      '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                    video:
                      '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
                    voicemail:
                      '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
                    "volume-1":
                      '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                    "volume-2":
                      '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                    "volume-x":
                      '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
                    volume:
                      '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
                    watch:
                      '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
                    "wifi-off":
                      '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                    wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                    wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
                    "x-circle":
                      '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                    "x-octagon":
                      '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                    "x-square":
                      '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
                    x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
                    youtube:
                      '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
                    "zap-off":
                      '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
                    zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
                    "zoom-in":
                      '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                    "zoom-out":
                      '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                  };
                },
                "./node_modules/classnames/dedupe.js": function (e, t, n) {
                  var i;
                  !(function () {
                    "use strict";
                    var n = (function () {
                      function e() {}
                      function t(e, t) {
                        for (var n = t.length, i = 0; i < n; ++i) r(e, t[i]);
                      }
                      e.prototype = Object.create(null);
                      var n = {}.hasOwnProperty,
                        i = /\s+/;
                      function r(e, r) {
                        if (r) {
                          var s = typeof r;
                          "string" === s
                            ? (function (e, t) {
                                for (
                                  var n = t.split(i), r = n.length, s = 0;
                                  s < r;
                                  ++s
                                )
                                  e[n[s]] = !0;
                              })(e, r)
                            : Array.isArray(r)
                            ? t(e, r)
                            : "object" === s
                            ? (function (e, t) {
                                for (var i in t) n.call(t, i) && (e[i] = !!t[i]);
                              })(e, r)
                            : "number" === s &&
                              (function (e, t) {
                                e[t] = !0;
                              })(e, r);
                        }
                      }
                      return function () {
                        for (
                          var n = arguments.length, i = Array(n), r = 0;
                          r < n;
                          r++
                        )
                          i[r] = arguments[r];
                        var s = new e();
                        t(s, i);
                        var a = [];
                        for (var o in s) s[o] && a.push(o);
                        return a.join(" ");
                      };
                    })();
                    void 0 !== e && e.exports
                      ? (e.exports = n)
                      : void 0 ===
                          (i = function () {
                            return n;
                          }.apply(t, [])) || (e.exports = i);
                  })();
                },
                "./node_modules/core-js/es/array/from.js": function (e, t, n) {
                  n("./node_modules/core-js/modules/es.string.iterator.js"),
                    n("./node_modules/core-js/modules/es.array.from.js");
                  var i = n("./node_modules/core-js/internals/path.js");
                  e.exports = i.Array.from;
                },
                "./node_modules/core-js/internals/a-function.js": function (
                  e,
                  t
                ) {
                  e.exports = function (e) {
                    if ("function" != typeof e)
                      throw TypeError(String(e) + " is not a function");
                    return e;
                  };
                },
                "./node_modules/core-js/internals/an-object.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/is-object.js");
                  e.exports = function (e) {
                    if (!i(e)) throw TypeError(String(e) + " is not an object");
                    return e;
                  };
                },
                "./node_modules/core-js/internals/array-from.js": function (
                  e,
                  t,
                  n
                ) {
                  "use strict";
                  var i = n("./node_modules/core-js/internals/bind-context.js"),
                    r = n("./node_modules/core-js/internals/to-object.js"),
                    s = n(
                      "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
                    ),
                    a = n(
                      "./node_modules/core-js/internals/is-array-iterator-method.js"
                    ),
                    o = n("./node_modules/core-js/internals/to-length.js"),
                    l = n("./node_modules/core-js/internals/create-property.js"),
                    c = n(
                      "./node_modules/core-js/internals/get-iterator-method.js"
                    );
                  e.exports = function (e) {
                    var t,
                      n,
                      d,
                      u,
                      p = r(e),
                      h = "function" == typeof this ? this : Array,
                      f = arguments.length,
                      m = f > 1 ? arguments[1] : void 0,
                      v = void 0 !== m,
                      y = 0,
                      g = c(p);
                    if (
                      (v && (m = i(m, f > 2 ? arguments[2] : void 0, 2)),
                      null == g || (h == Array && a(g)))
                    )
                      for (n = new h((t = o(p.length))); t > y; y++)
                        l(n, y, v ? m(p[y], y) : p[y]);
                    else
                      for (u = g.call(p), n = new h(); !(d = u.next()).done; y++)
                        l(n, y, v ? s(u, m, [d.value, y], !0) : d.value);
                    return (n.length = y), n;
                  };
                },
                "./node_modules/core-js/internals/array-includes.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n(
                      "./node_modules/core-js/internals/to-indexed-object.js"
                    ),
                    r = n("./node_modules/core-js/internals/to-length.js"),
                    s = n(
                      "./node_modules/core-js/internals/to-absolute-index.js"
                    );
                  e.exports = function (e) {
                    return function (t, n, a) {
                      var o,
                        l = i(t),
                        c = r(l.length),
                        d = s(a, c);
                      if (e && n != n) {
                        for (; c > d; ) if ((o = l[d++]) != o) return !0;
                      } else
                        for (; c > d; d++)
                          if ((e || d in l) && l[d] === n) return e || d || 0;
                      return !e && -1;
                    };
                  };
                },
                "./node_modules/core-js/internals/bind-context.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/a-function.js");
                  e.exports = function (e, t, n) {
                    if ((i(e), void 0 === t)) return e;
                    switch (n) {
                      case 0:
                        return function () {
                          return e.call(t);
                        };
                      case 1:
                        return function (n) {
                          return e.call(t, n);
                        };
                      case 2:
                        return function (n, i) {
                          return e.call(t, n, i);
                        };
                      case 3:
                        return function (n, i, r) {
                          return e.call(t, n, i, r);
                        };
                    }
                    return function () {
                      return e.apply(t, arguments);
                    };
                  };
                },
                "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/an-object.js");
                    e.exports = function (e, t, n, r) {
                      try {
                        return r ? t(i(n)[0], n[1]) : t(n);
                      } catch (t) {
                        var s = e.return;
                        throw (void 0 !== s && i(s.call(e)), t);
                      }
                    };
                  },
                "./node_modules/core-js/internals/check-correctness-of-iteration.js":
                  function (e, t, n) {
                    var i = n(
                        "./node_modules/core-js/internals/well-known-symbol.js"
                      )("iterator"),
                      r = !1;
                    try {
                      var s = 0,
                        a = {
                          next: function () {
                            return { done: !!s++ };
                          },
                          return: function () {
                            r = !0;
                          },
                        };
                      (a[i] = function () {
                        return this;
                      }),
                        Array.from(a, function () {
                          throw 2;
                        });
                    } catch (e) {}
                    e.exports = function (e, t) {
                      if (!t && !r) return !1;
                      var n = !1;
                      try {
                        var s = {};
                        (s[i] = function () {
                          return {
                            next: function () {
                              return { done: (n = !0) };
                            },
                          };
                        }),
                          e(s);
                      } catch (e) {}
                      return n;
                    };
                  },
                "./node_modules/core-js/internals/classof-raw.js": function (
                  e,
                  t
                ) {
                  var n = {}.toString;
                  e.exports = function (e) {
                    return n.call(e).slice(8, -1);
                  };
                },
                "./node_modules/core-js/internals/classof.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/classof-raw.js"),
                    r = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    )("toStringTag"),
                    s =
                      "Arguments" ==
                      i(
                        (function () {
                          return arguments;
                        })()
                      );
                  e.exports = function (e) {
                    var t, n, a;
                    return void 0 === e
                      ? "Undefined"
                      : null === e
                      ? "Null"
                      : "string" ==
                        typeof (n = (function (e, t) {
                          try {
                            return e[t];
                          } catch (e) {}
                        })((t = Object(e)), r))
                      ? n
                      : s
                      ? i(t)
                      : "Object" == (a = i(t)) && "function" == typeof t.callee
                      ? "Arguments"
                      : a;
                  };
                },
                "./node_modules/core-js/internals/copy-constructor-properties.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/has.js"),
                      r = n("./node_modules/core-js/internals/own-keys.js"),
                      s = n(
                        "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                      ),
                      a = n(
                        "./node_modules/core-js/internals/object-define-property.js"
                      );
                    e.exports = function (e, t) {
                      for (
                        var n = r(t), o = a.f, l = s.f, c = 0;
                        c < n.length;
                        c++
                      ) {
                        var d = n[c];
                        i(e, d) || o(e, d, l(t, d));
                      }
                    };
                  },
                "./node_modules/core-js/internals/correct-prototype-getter.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/fails.js");
                    e.exports = !i(function () {
                      function e() {}
                      return (
                        (e.prototype.constructor = null),
                        Object.getPrototypeOf(new e()) !== e.prototype
                      );
                    });
                  },
                "./node_modules/core-js/internals/create-iterator-constructor.js":
                  function (e, t, n) {
                    "use strict";
                    var i = n(
                        "./node_modules/core-js/internals/iterators-core.js"
                      ).IteratorPrototype,
                      r = n("./node_modules/core-js/internals/object-create.js"),
                      s = n(
                        "./node_modules/core-js/internals/create-property-descriptor.js"
                      ),
                      a = n(
                        "./node_modules/core-js/internals/set-to-string-tag.js"
                      ),
                      o = n("./node_modules/core-js/internals/iterators.js"),
                      l = function () {
                        return this;
                      };
                    e.exports = function (e, t, n) {
                      var c = t + " Iterator";
                      return (
                        (e.prototype = r(i, { next: s(1, n) })),
                        a(e, c, !1, !0),
                        (o[c] = l),
                        e
                      );
                    };
                  },
                "./node_modules/core-js/internals/create-property-descriptor.js":
                  function (e, t) {
                    e.exports = function (e, t) {
                      return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t,
                      };
                    };
                  },
                "./node_modules/core-js/internals/create-property.js": function (
                  e,
                  t,
                  n
                ) {
                  "use strict";
                  var i = n("./node_modules/core-js/internals/to-primitive.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-define-property.js"
                    ),
                    s = n(
                      "./node_modules/core-js/internals/create-property-descriptor.js"
                    );
                  e.exports = function (e, t, n) {
                    var a = i(t);
                    a in e ? r.f(e, a, s(0, n)) : (e[a] = n);
                  };
                },
                "./node_modules/core-js/internals/define-iterator.js": function (
                  e,
                  t,
                  n
                ) {
                  "use strict";
                  var i = n("./node_modules/core-js/internals/export.js"),
                    r = n(
                      "./node_modules/core-js/internals/create-iterator-constructor.js"
                    ),
                    s = n(
                      "./node_modules/core-js/internals/object-get-prototype-of.js"
                    ),
                    a = n(
                      "./node_modules/core-js/internals/object-set-prototype-of.js"
                    ),
                    o = n(
                      "./node_modules/core-js/internals/set-to-string-tag.js"
                    ),
                    l = n("./node_modules/core-js/internals/hide.js"),
                    c = n("./node_modules/core-js/internals/redefine.js"),
                    d = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    ),
                    u = n("./node_modules/core-js/internals/is-pure.js"),
                    p = n("./node_modules/core-js/internals/iterators.js"),
                    h = n("./node_modules/core-js/internals/iterators-core.js"),
                    f = h.IteratorPrototype,
                    m = h.BUGGY_SAFARI_ITERATORS,
                    v = d("iterator"),
                    y = "keys",
                    g = "values",
                    x = "entries",
                    b = function () {
                      return this;
                    };
                  e.exports = function (e, t, n, d, h, w, S) {
                    r(n, t, d);
                    var C,
                      T,
                      _,
                      E = function (e) {
                        if (e === h && A) return A;
                        if (!m && e in M) return M[e];
                        switch (e) {
                          case y:
                          case g:
                          case x:
                            return function () {
                              return new n(this, e);
                            };
                        }
                        return function () {
                          return new n(this);
                        };
                      },
                      k = t + " Iterator",
                      $ = !1,
                      M = e.prototype,
                      j = M[v] || M["@@iterator"] || (h && M[h]),
                      A = (!m && j) || E(h),
                      L = ("Array" == t && M.entries) || j;
                    if (
                      (L &&
                        ((C = s(L.call(new e()))),
                        f !== Object.prototype &&
                          C.next &&
                          (u ||
                            s(C) === f ||
                            (a
                              ? a(C, f)
                              : "function" != typeof C[v] && l(C, v, b)),
                          o(C, k, !0, !0),
                          u && (p[k] = b))),
                      h == g &&
                        j &&
                        j.name !== g &&
                        (($ = !0),
                        (A = function () {
                          return j.call(this);
                        })),
                      (u && !S) || M[v] === A || l(M, v, A),
                      (p[t] = A),
                      h)
                    )
                      if (
                        ((T = {
                          values: E(g),
                          keys: w ? A : E(y),
                          entries: E(x),
                        }),
                        S)
                      )
                        for (_ in T) (m || $ || !(_ in M)) && c(M, _, T[_]);
                      else i({ target: t, proto: !0, forced: m || $ }, T);
                    return T;
                  };
                },
                "./node_modules/core-js/internals/descriptors.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/fails.js");
                  e.exports = !i(function () {
                    return (
                      7 !=
                      Object.defineProperty({}, "a", {
                        get: function () {
                          return 7;
                        },
                      }).a
                    );
                  });
                },
                "./node_modules/core-js/internals/document-create-element.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/global.js"),
                      r = n("./node_modules/core-js/internals/is-object.js"),
                      s = i.document,
                      a = r(s) && r(s.createElement);
                    e.exports = function (e) {
                      return a ? s.createElement(e) : {};
                    };
                  },
                "./node_modules/core-js/internals/enum-bug-keys.js": function (
                  e,
                  t
                ) {
                  e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf",
                  ];
                },
                "./node_modules/core-js/internals/export.js": function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                    ).f,
                    s = n("./node_modules/core-js/internals/hide.js"),
                    a = n("./node_modules/core-js/internals/redefine.js"),
                    o = n("./node_modules/core-js/internals/set-global.js"),
                    l = n(
                      "./node_modules/core-js/internals/copy-constructor-properties.js"
                    ),
                    c = n("./node_modules/core-js/internals/is-forced.js");
                  e.exports = function (e, t) {
                    var n,
                      d,
                      u,
                      p,
                      h,
                      f = e.target,
                      m = e.global,
                      v = e.stat;
                    if (
                      (n = m ? i : v ? i[f] || o(f, {}) : (i[f] || {}).prototype)
                    )
                      for (d in t) {
                        if (
                          ((p = t[d]),
                          (u = e.noTargetGet ? (h = r(n, d)) && h.value : n[d]),
                          !c(m ? d : f + (v ? "." : "#") + d, e.forced) &&
                            void 0 !== u)
                        ) {
                          if (typeof p == typeof u) continue;
                          l(p, u);
                        }
                        (e.sham || (u && u.sham)) && s(p, "sham", !0),
                          a(n, d, p, e);
                      }
                  };
                },
                "./node_modules/core-js/internals/fails.js": function (e, t) {
                  e.exports = function (e) {
                    try {
                      return !!e();
                    } catch (e) {
                      return !0;
                    }
                  };
                },
                "./node_modules/core-js/internals/function-to-string.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/shared.js");
                    e.exports = i("native-function-to-string", Function.toString);
                  },
                "./node_modules/core-js/internals/get-iterator-method.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/classof.js"),
                      r = n("./node_modules/core-js/internals/iterators.js"),
                      s = n(
                        "./node_modules/core-js/internals/well-known-symbol.js"
                      )("iterator");
                    e.exports = function (e) {
                      if (null != e) return e[s] || e["@@iterator"] || r[i(e)];
                    };
                  },
                "./node_modules/core-js/internals/global.js": function (e, t, n) {
                  (function (t) {
                    var n = "object",
                      i = function (e) {
                        return e && e.Math == Math && e;
                      };
                    e.exports =
                      i(typeof globalThis == n && globalThis) ||
                      i(typeof window == n && window) ||
                      i(typeof self == n && self) ||
                      i(typeof t == n && t) ||
                      Function("return this")();
                  }.call(this, n("./node_modules/webpack/buildin/global.js")));
                },
                "./node_modules/core-js/internals/has.js": function (e, t) {
                  var n = {}.hasOwnProperty;
                  e.exports = function (e, t) {
                    return n.call(e, t);
                  };
                },
                "./node_modules/core-js/internals/hidden-keys.js": function (
                  e,
                  t
                ) {
                  e.exports = {};
                },
                "./node_modules/core-js/internals/hide.js": function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/descriptors.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-define-property.js"
                    ),
                    s = n(
                      "./node_modules/core-js/internals/create-property-descriptor.js"
                    );
                  e.exports = i
                    ? function (e, t, n) {
                        return r.f(e, t, s(1, n));
                      }
                    : function (e, t, n) {
                        return (e[t] = n), e;
                      };
                },
                "./node_modules/core-js/internals/html.js": function (e, t, n) {
                  var i = n(
                    "./node_modules/core-js/internals/global.js"
                  ).document;
                  e.exports = i && i.documentElement;
                },
                "./node_modules/core-js/internals/ie8-dom-define.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/descriptors.js"),
                    r = n("./node_modules/core-js/internals/fails.js"),
                    s = n(
                      "./node_modules/core-js/internals/document-create-element.js"
                    );
                  e.exports =
                    !i &&
                    !r(function () {
                      return (
                        7 !=
                        Object.defineProperty(s("div"), "a", {
                          get: function () {
                            return 7;
                          },
                        }).a
                      );
                    });
                },
                "./node_modules/core-js/internals/indexed-object.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/fails.js"),
                    r = n("./node_modules/core-js/internals/classof-raw.js"),
                    s = "".split;
                  e.exports = i(function () {
                    return !Object("z").propertyIsEnumerable(0);
                  })
                    ? function (e) {
                        return "String" == r(e) ? s.call(e, "") : Object(e);
                      }
                    : Object;
                },
                "./node_modules/core-js/internals/internal-state.js": function (
                  e,
                  t,
                  n
                ) {
                  var i,
                    r,
                    s,
                    a = n("./node_modules/core-js/internals/native-weak-map.js"),
                    o = n("./node_modules/core-js/internals/global.js"),
                    l = n("./node_modules/core-js/internals/is-object.js"),
                    c = n("./node_modules/core-js/internals/hide.js"),
                    d = n("./node_modules/core-js/internals/has.js"),
                    u = n("./node_modules/core-js/internals/shared-key.js"),
                    p = n("./node_modules/core-js/internals/hidden-keys.js"),
                    h = o.WeakMap;
                  if (a) {
                    var f = new h(),
                      m = f.get,
                      v = f.has,
                      y = f.set;
                    (i = function (e, t) {
                      return y.call(f, e, t), t;
                    }),
                      (r = function (e) {
                        return m.call(f, e) || {};
                      }),
                      (s = function (e) {
                        return v.call(f, e);
                      });
                  } else {
                    var g = u("state");
                    (p[g] = !0),
                      (i = function (e, t) {
                        return c(e, g, t), t;
                      }),
                      (r = function (e) {
                        return d(e, g) ? e[g] : {};
                      }),
                      (s = function (e) {
                        return d(e, g);
                      });
                  }
                  e.exports = {
                    set: i,
                    get: r,
                    has: s,
                    enforce: function (e) {
                      return s(e) ? r(e) : i(e, {});
                    },
                    getterFor: function (e) {
                      return function (t) {
                        var n;
                        if (!l(t) || (n = r(t)).type !== e)
                          throw TypeError(
                            "Incompatible receiver, " + e + " required"
                          );
                        return n;
                      };
                    },
                  };
                },
                "./node_modules/core-js/internals/is-array-iterator-method.js":
                  function (e, t, n) {
                    var i = n(
                        "./node_modules/core-js/internals/well-known-symbol.js"
                      ),
                      r = n("./node_modules/core-js/internals/iterators.js"),
                      s = i("iterator"),
                      a = Array.prototype;
                    e.exports = function (e) {
                      return void 0 !== e && (r.Array === e || a[s] === e);
                    };
                  },
                "./node_modules/core-js/internals/is-forced.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/fails.js"),
                    r = /#|\.prototype\./,
                    s = function (e, t) {
                      var n = o[a(e)];
                      return (
                        n == c ||
                        (n != l && ("function" == typeof t ? i(t) : !!t))
                      );
                    },
                    a = (s.normalize = function (e) {
                      return String(e).replace(r, ".").toLowerCase();
                    }),
                    o = (s.data = {}),
                    l = (s.NATIVE = "N"),
                    c = (s.POLYFILL = "P");
                  e.exports = s;
                },
                "./node_modules/core-js/internals/is-object.js": function (e, t) {
                  e.exports = function (e) {
                    return "object" == typeof e
                      ? null !== e
                      : "function" == typeof e;
                  };
                },
                "./node_modules/core-js/internals/is-pure.js": function (e, t) {
                  e.exports = !1;
                },
                "./node_modules/core-js/internals/iterators-core.js": function (
                  e,
                  t,
                  n
                ) {
                  "use strict";
                  var i,
                    r,
                    s,
                    a = n(
                      "./node_modules/core-js/internals/object-get-prototype-of.js"
                    ),
                    o = n("./node_modules/core-js/internals/hide.js"),
                    l = n("./node_modules/core-js/internals/has.js"),
                    c = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    ),
                    d = n("./node_modules/core-js/internals/is-pure.js"),
                    u = c("iterator"),
                    p = !1;
                  [].keys &&
                    ("next" in (s = [].keys())
                      ? (r = a(a(s))) !== Object.prototype && (i = r)
                      : (p = !0)),
                    null == i && (i = {}),
                    d ||
                      l(i, u) ||
                      o(i, u, function () {
                        return this;
                      }),
                    (e.exports = {
                      IteratorPrototype: i,
                      BUGGY_SAFARI_ITERATORS: p,
                    });
                },
                "./node_modules/core-js/internals/iterators.js": function (e, t) {
                  e.exports = {};
                },
                "./node_modules/core-js/internals/native-symbol.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/fails.js");
                  e.exports =
                    !!Object.getOwnPropertySymbols &&
                    !i(function () {
                      return !String(Symbol());
                    });
                },
                "./node_modules/core-js/internals/native-weak-map.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n(
                      "./node_modules/core-js/internals/function-to-string.js"
                    ),
                    s = i.WeakMap;
                  e.exports =
                    "function" == typeof s && /native code/.test(r.call(s));
                },
                "./node_modules/core-js/internals/object-create.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/an-object.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-define-properties.js"
                    ),
                    s = n("./node_modules/core-js/internals/enum-bug-keys.js"),
                    a = n("./node_modules/core-js/internals/hidden-keys.js"),
                    o = n("./node_modules/core-js/internals/html.js"),
                    l = n(
                      "./node_modules/core-js/internals/document-create-element.js"
                    ),
                    c = n("./node_modules/core-js/internals/shared-key.js")(
                      "IE_PROTO"
                    ),
                    d = function () {},
                    u = function () {
                      var e,
                        t = l("iframe"),
                        n = s.length;
                      for (
                        t.style.display = "none",
                          o.appendChild(t),
                          t.src = String("javascript:"),
                          (e = t.contentWindow.document).open(),
                          e.write("<script>document.F=Object</script>"),
                          e.close(),
                          u = e.F;
                        n--;
  
                      )
                        delete u.prototype[s[n]];
                      return u();
                    };
                  (e.exports =
                    Object.create ||
                    function (e, t) {
                      var n;
                      return (
                        null !== e
                          ? ((d.prototype = i(e)),
                            (n = new d()),
                            (d.prototype = null),
                            (n[c] = e))
                          : (n = u()),
                        void 0 === t ? n : r(n, t)
                      );
                    }),
                    (a[c] = !0);
                },
                "./node_modules/core-js/internals/object-define-properties.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/descriptors.js"),
                      r = n(
                        "./node_modules/core-js/internals/object-define-property.js"
                      ),
                      s = n("./node_modules/core-js/internals/an-object.js"),
                      a = n("./node_modules/core-js/internals/object-keys.js");
                    e.exports = i
                      ? Object.defineProperties
                      : function (e, t) {
                          s(e);
                          for (var n, i = a(t), o = i.length, l = 0; o > l; )
                            r.f(e, (n = i[l++]), t[n]);
                          return e;
                        };
                  },
                "./node_modules/core-js/internals/object-define-property.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/descriptors.js"),
                      r = n("./node_modules/core-js/internals/ie8-dom-define.js"),
                      s = n("./node_modules/core-js/internals/an-object.js"),
                      a = n("./node_modules/core-js/internals/to-primitive.js"),
                      o = Object.defineProperty;
                    t.f = i
                      ? o
                      : function (e, t, n) {
                          if ((s(e), (t = a(t, !0)), s(n), r))
                            try {
                              return o(e, t, n);
                            } catch (e) {}
                          if ("get" in n || "set" in n)
                            throw TypeError("Accessors not supported");
                          return "value" in n && (e[t] = n.value), e;
                        };
                  },
                "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/descriptors.js"),
                      r = n(
                        "./node_modules/core-js/internals/object-property-is-enumerable.js"
                      ),
                      s = n(
                        "./node_modules/core-js/internals/create-property-descriptor.js"
                      ),
                      a = n(
                        "./node_modules/core-js/internals/to-indexed-object.js"
                      ),
                      o = n("./node_modules/core-js/internals/to-primitive.js"),
                      l = n("./node_modules/core-js/internals/has.js"),
                      c = n("./node_modules/core-js/internals/ie8-dom-define.js"),
                      d = Object.getOwnPropertyDescriptor;
                    t.f = i
                      ? d
                      : function (e, t) {
                          if (((e = a(e)), (t = o(t, !0)), c))
                            try {
                              return d(e, t);
                            } catch (e) {}
                          if (l(e, t)) return s(!r.f.call(e, t), e[t]);
                        };
                  },
                "./node_modules/core-js/internals/object-get-own-property-names.js":
                  function (e, t, n) {
                    var i = n(
                        "./node_modules/core-js/internals/object-keys-internal.js"
                      ),
                      r = n(
                        "./node_modules/core-js/internals/enum-bug-keys.js"
                      ).concat("length", "prototype");
                    t.f =
                      Object.getOwnPropertyNames ||
                      function (e) {
                        return i(e, r);
                      };
                  },
                "./node_modules/core-js/internals/object-get-own-property-symbols.js":
                  function (e, t) {
                    t.f = Object.getOwnPropertySymbols;
                  },
                "./node_modules/core-js/internals/object-get-prototype-of.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/has.js"),
                      r = n("./node_modules/core-js/internals/to-object.js"),
                      s = n("./node_modules/core-js/internals/shared-key.js"),
                      a = n(
                        "./node_modules/core-js/internals/correct-prototype-getter.js"
                      ),
                      o = s("IE_PROTO"),
                      l = Object.prototype;
                    e.exports = a
                      ? Object.getPrototypeOf
                      : function (e) {
                          return (
                            (e = r(e)),
                            i(e, o)
                              ? e[o]
                              : "function" == typeof e.constructor &&
                                e instanceof e.constructor
                              ? e.constructor.prototype
                              : e instanceof Object
                              ? l
                              : null
                          );
                        };
                  },
                "./node_modules/core-js/internals/object-keys-internal.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/has.js"),
                      r = n(
                        "./node_modules/core-js/internals/to-indexed-object.js"
                      ),
                      s = n("./node_modules/core-js/internals/array-includes.js"),
                      a = n("./node_modules/core-js/internals/hidden-keys.js"),
                      o = s(!1);
                    e.exports = function (e, t) {
                      var n,
                        s = r(e),
                        l = 0,
                        c = [];
                      for (n in s) !i(a, n) && i(s, n) && c.push(n);
                      for (; t.length > l; )
                        i(s, (n = t[l++])) && (~o(c, n) || c.push(n));
                      return c;
                    };
                  },
                "./node_modules/core-js/internals/object-keys.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n(
                      "./node_modules/core-js/internals/object-keys-internal.js"
                    ),
                    r = n("./node_modules/core-js/internals/enum-bug-keys.js");
                  e.exports =
                    Object.keys ||
                    function (e) {
                      return i(e, r);
                    };
                },
                "./node_modules/core-js/internals/object-property-is-enumerable.js":
                  function (e, t, n) {
                    "use strict";
                    var i = {}.propertyIsEnumerable,
                      r = Object.getOwnPropertyDescriptor,
                      s = r && !i.call({ 1: 2 }, 1);
                    t.f = s
                      ? function (e) {
                          var t = r(this, e);
                          return !!t && t.enumerable;
                        }
                      : i;
                  },
                "./node_modules/core-js/internals/object-set-prototype-of.js":
                  function (e, t, n) {
                    var i = n(
                      "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js"
                    );
                    e.exports =
                      Object.setPrototypeOf ||
                      ("__proto__" in {}
                        ? (function () {
                            var e,
                              t = !1,
                              n = {};
                            try {
                              (e = Object.getOwnPropertyDescriptor(
                                Object.prototype,
                                "__proto__"
                              ).set).call(n, []),
                                (t = n instanceof Array);
                            } catch (e) {}
                            return function (n, r) {
                              return (
                                i(n, r), t ? e.call(n, r) : (n.__proto__ = r), n
                              );
                            };
                          })()
                        : void 0);
                  },
                "./node_modules/core-js/internals/own-keys.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-get-own-property-names.js"
                    ),
                    s = n(
                      "./node_modules/core-js/internals/object-get-own-property-symbols.js"
                    ),
                    a = n("./node_modules/core-js/internals/an-object.js"),
                    o = i.Reflect;
                  e.exports =
                    (o && o.ownKeys) ||
                    function (e) {
                      var t = r.f(a(e)),
                        n = s.f;
                      return n ? t.concat(n(e)) : t;
                    };
                },
                "./node_modules/core-js/internals/path.js": function (e, t, n) {
                  e.exports = n("./node_modules/core-js/internals/global.js");
                },
                "./node_modules/core-js/internals/redefine.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n("./node_modules/core-js/internals/shared.js"),
                    s = n("./node_modules/core-js/internals/hide.js"),
                    a = n("./node_modules/core-js/internals/has.js"),
                    o = n("./node_modules/core-js/internals/set-global.js"),
                    l = n(
                      "./node_modules/core-js/internals/function-to-string.js"
                    ),
                    c = n("./node_modules/core-js/internals/internal-state.js"),
                    d = c.get,
                    u = c.enforce,
                    p = String(l).split("toString");
                  r("inspectSource", function (e) {
                    return l.call(e);
                  }),
                    (e.exports = function (e, t, n, r) {
                      var l = !!r && !!r.unsafe,
                        c = !!r && !!r.enumerable,
                        d = !!r && !!r.noTargetGet;
                      "function" == typeof n &&
                        ("string" != typeof t || a(n, "name") || s(n, "name", t),
                        (u(n).source = p.join("string" == typeof t ? t : ""))),
                        e !== i
                          ? (l ? !d && e[t] && (c = !0) : delete e[t],
                            c ? (e[t] = n) : s(e, t, n))
                          : c
                          ? (e[t] = n)
                          : o(t, n);
                    })(Function.prototype, "toString", function () {
                      return (
                        ("function" == typeof this && d(this).source) ||
                        l.call(this)
                      );
                    });
                },
                "./node_modules/core-js/internals/require-object-coercible.js":
                  function (e, t) {
                    e.exports = function (e) {
                      if (null == e) throw TypeError("Can't call method on " + e);
                      return e;
                    };
                  },
                "./node_modules/core-js/internals/set-global.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n("./node_modules/core-js/internals/hide.js");
                  e.exports = function (e, t) {
                    try {
                      r(i, e, t);
                    } catch (n) {
                      i[e] = t;
                    }
                    return t;
                  };
                },
                "./node_modules/core-js/internals/set-to-string-tag.js":
                  function (e, t, n) {
                    var i = n(
                        "./node_modules/core-js/internals/object-define-property.js"
                      ).f,
                      r = n("./node_modules/core-js/internals/has.js"),
                      s = n(
                        "./node_modules/core-js/internals/well-known-symbol.js"
                      )("toStringTag");
                    e.exports = function (e, t, n) {
                      e &&
                        !r((e = n ? e : e.prototype), s) &&
                        i(e, s, { configurable: !0, value: t });
                    };
                  },
                "./node_modules/core-js/internals/shared-key.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/shared.js"),
                    r = n("./node_modules/core-js/internals/uid.js"),
                    s = i("keys");
                  e.exports = function (e) {
                    return s[e] || (s[e] = r(e));
                  };
                },
                "./node_modules/core-js/internals/shared.js": function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    r = n("./node_modules/core-js/internals/set-global.js"),
                    s = n("./node_modules/core-js/internals/is-pure.js"),
                    a = "__core-js_shared__",
                    o = i[a] || r(a, {});
                  (e.exports = function (e, t) {
                    return o[e] || (o[e] = void 0 !== t ? t : {});
                  })("versions", []).push({
                    version: "3.1.3",
                    mode: s ? "pure" : "global",
                    copyright: "© 2019 Denis Pushkarev (zloirock.ru)",
                  });
                },
                "./node_modules/core-js/internals/string-at.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/to-integer.js"),
                    r = n(
                      "./node_modules/core-js/internals/require-object-coercible.js"
                    );
                  e.exports = function (e, t, n) {
                    var s,
                      a,
                      o = String(r(e)),
                      l = i(t),
                      c = o.length;
                    return l < 0 || l >= c
                      ? n
                        ? ""
                        : void 0
                      : (s = o.charCodeAt(l)) < 55296 ||
                        s > 56319 ||
                        l + 1 === c ||
                        (a = o.charCodeAt(l + 1)) < 56320 ||
                        a > 57343
                      ? n
                        ? o.charAt(l)
                        : s
                      : n
                      ? o.slice(l, l + 2)
                      : a - 56320 + ((s - 55296) << 10) + 65536;
                  };
                },
                "./node_modules/core-js/internals/to-absolute-index.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/to-integer.js"),
                      r = Math.max,
                      s = Math.min;
                    e.exports = function (e, t) {
                      var n = i(e);
                      return n < 0 ? r(n + t, 0) : s(n, t);
                    };
                  },
                "./node_modules/core-js/internals/to-indexed-object.js":
                  function (e, t, n) {
                    var i = n(
                        "./node_modules/core-js/internals/indexed-object.js"
                      ),
                      r = n(
                        "./node_modules/core-js/internals/require-object-coercible.js"
                      );
                    e.exports = function (e) {
                      return i(r(e));
                    };
                  },
                "./node_modules/core-js/internals/to-integer.js": function (
                  e,
                  t
                ) {
                  var n = Math.ceil,
                    i = Math.floor;
                  e.exports = function (e) {
                    return isNaN((e = +e)) ? 0 : (e > 0 ? i : n)(e);
                  };
                },
                "./node_modules/core-js/internals/to-length.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/to-integer.js"),
                    r = Math.min;
                  e.exports = function (e) {
                    return e > 0 ? r(i(e), 9007199254740991) : 0;
                  };
                },
                "./node_modules/core-js/internals/to-object.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n(
                    "./node_modules/core-js/internals/require-object-coercible.js"
                  );
                  e.exports = function (e) {
                    return Object(i(e));
                  };
                },
                "./node_modules/core-js/internals/to-primitive.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/is-object.js");
                  e.exports = function (e, t) {
                    if (!i(e)) return e;
                    var n, r;
                    if (
                      t &&
                      "function" == typeof (n = e.toString) &&
                      !i((r = n.call(e)))
                    )
                      return r;
                    if (
                      "function" == typeof (n = e.valueOf) &&
                      !i((r = n.call(e)))
                    )
                      return r;
                    if (
                      !t &&
                      "function" == typeof (n = e.toString) &&
                      !i((r = n.call(e)))
                    )
                      return r;
                    throw TypeError("Can't convert object to primitive value");
                  };
                },
                "./node_modules/core-js/internals/uid.js": function (e, t) {
                  var n = 0,
                    i = Math.random();
                  e.exports = function (e) {
                    return "Symbol(".concat(
                      void 0 === e ? "" : e,
                      ")_",
                      (++n + i).toString(36)
                    );
                  };
                },
                "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/is-object.js"),
                      r = n("./node_modules/core-js/internals/an-object.js");
                    e.exports = function (e, t) {
                      if ((r(e), !i(t) && null !== t))
                        throw TypeError(
                          "Can't set " + String(t) + " as a prototype"
                        );
                    };
                  },
                "./node_modules/core-js/internals/well-known-symbol.js":
                  function (e, t, n) {
                    var i = n("./node_modules/core-js/internals/global.js"),
                      r = n("./node_modules/core-js/internals/shared.js"),
                      s = n("./node_modules/core-js/internals/uid.js"),
                      a = n("./node_modules/core-js/internals/native-symbol.js"),
                      o = i.Symbol,
                      l = r("wks");
                    e.exports = function (e) {
                      return (
                        l[e] || (l[e] = (a && o[e]) || (a ? o : s)("Symbol." + e))
                      );
                    };
                  },
                "./node_modules/core-js/modules/es.array.from.js": function (
                  e,
                  t,
                  n
                ) {
                  var i = n("./node_modules/core-js/internals/export.js"),
                    r = n("./node_modules/core-js/internals/array-from.js");
                  i(
                    {
                      target: "Array",
                      stat: !0,
                      forced: !n(
                        "./node_modules/core-js/internals/check-correctness-of-iteration.js"
                      )(function (e) {
                        Array.from(e);
                      }),
                    },
                    { from: r }
                  );
                },
                "./node_modules/core-js/modules/es.string.iterator.js": function (
                  e,
                  t,
                  n
                ) {
                  "use strict";
                  var i = n("./node_modules/core-js/internals/string-at.js"),
                    r = n("./node_modules/core-js/internals/internal-state.js"),
                    s = n("./node_modules/core-js/internals/define-iterator.js"),
                    a = "String Iterator",
                    o = r.set,
                    l = r.getterFor(a);
                  s(
                    String,
                    "String",
                    function (e) {
                      o(this, { type: a, string: String(e), index: 0 });
                    },
                    function () {
                      var e,
                        t = l(this),
                        n = t.string,
                        r = t.index;
                      return r >= n.length
                        ? { value: void 0, done: !0 }
                        : ((e = i(n, r, !0)),
                          (t.index += e.length),
                          { value: e, done: !1 });
                    }
                  );
                },
                "./node_modules/webpack/buildin/global.js": function (e, t) {
                  var n;
                  n = (function () {
                    return this;
                  })();
                  try {
                    n = n || Function("return this")() || (0, eval)("this");
                  } catch (e) {
                    "object" == typeof window && (n = window);
                  }
                  e.exports = n;
                },
                "./src/default-attrs.json": function (e) {
                  e.exports = {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: 24,
                    height: 24,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": 2,
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  };
                },
                "./src/icon.js": function (e, t, n) {
                  "use strict";
                  Object.defineProperty(t, "__esModule", { value: !0 });
                  var i =
                      Object.assign ||
                      function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                          var n = arguments[t];
                          for (var i in n)
                            Object.prototype.hasOwnProperty.call(n, i) &&
                              (e[i] = n[i]);
                        }
                        return e;
                      },
                    r = (function () {
                      function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                          var i = t[n];
                          (i.enumerable = i.enumerable || !1),
                            (i.configurable = !0),
                            "value" in i && (i.writable = !0),
                            Object.defineProperty(e, i.key, i);
                        }
                      }
                      return function (t, n, i) {
                        return n && e(t.prototype, n), i && e(t, i), t;
                      };
                    })(),
                    s = o(n("./node_modules/classnames/dedupe.js")),
                    a = o(n("./src/default-attrs.json"));
                  function o(e) {
                    return e && e.__esModule ? e : { default: e };
                  }
                  function l(e, t) {
                    if (!(e instanceof t))
                      throw new TypeError("Cannot call a class as a function");
                  }
                  var c = (function () {
                    function e(t, n) {
                      var r =
                        arguments.length > 2 && void 0 !== arguments[2]
                          ? arguments[2]
                          : [];
                      l(this, e),
                        (this.name = t),
                        (this.contents = n),
                        (this.tags = r),
                        (this.attrs = i({}, a.default, {
                          class: "feather feather-" + t,
                        }));
                    }
                    return (
                      r(e, [
                        {
                          key: "toSvg",
                          value: function () {
                            var e =
                                arguments.length > 0 && void 0 !== arguments[0]
                                  ? arguments[0]
                                  : {},
                              t = i({}, this.attrs, e, {
                                class: (0, s.default)(this.attrs.class, e.class),
                              });
                            return (
                              "<svg " + d(t) + ">" + this.contents + "</svg>"
                            );
                          },
                        },
                        {
                          key: "toString",
                          value: function () {
                            return this.contents;
                          },
                        },
                      ]),
                      e
                    );
                  })();
                  function d(e) {
                    return Object.keys(e)
                      .map(function (t) {
                        return t + '="' + e[t] + '"';
                      })
                      .join(" ");
                  }
                  t.default = c;
                },
                "./src/icons.js": function (e, t, n) {
                  "use strict";
                  Object.defineProperty(t, "__esModule", { value: !0 });
                  var i = a(n("./src/icon.js")),
                    r = a(n("./dist/icons.json")),
                    s = a(n("./src/tags.json"));
                  function a(e) {
                    return e && e.__esModule ? e : { default: e };
                  }
                  t.default = Object.keys(r.default)
                    .map(function (e) {
                      return new i.default(e, r.default[e], s.default[e]);
                    })
                    .reduce(function (e, t) {
                      return (e[t.name] = t), e;
                    }, {});
                },
                "./src/index.js": function (e, t, n) {
                  "use strict";
                  var i = a(n("./src/icons.js")),
                    r = a(n("./src/to-svg.js")),
                    s = a(n("./src/replace.js"));
                  function a(e) {
                    return e && e.__esModule ? e : { default: e };
                  }
                  e.exports = {
                    icons: i.default,
                    toSvg: r.default,
                    replace: s.default,
                  };
                },
                "./src/replace.js": function (e, t, n) {
                  "use strict";
                  Object.defineProperty(t, "__esModule", { value: !0 });
                  var i =
                      Object.assign ||
                      function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                          var n = arguments[t];
                          for (var i in n)
                            Object.prototype.hasOwnProperty.call(n, i) &&
                              (e[i] = n[i]);
                        }
                        return e;
                      },
                    r = a(n("./node_modules/classnames/dedupe.js")),
                    s = a(n("./src/icons.js"));
                  function a(e) {
                    return e && e.__esModule ? e : { default: e };
                  }
                  function o(e) {
                    var t =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {},
                      n = l(e),
                      a = n["data-feather"];
                    delete n["data-feather"];
                    var o = s.default[a].toSvg(
                        i({}, t, n, { class: (0, r.default)(t.class, n.class) })
                      ),
                      c = new DOMParser().parseFromString(o, "image/svg+xml"),
                      d = c.querySelector("svg");
                    e.parentNode.replaceChild(d, e);
                  }
                  function l(e) {
                    return Array.from(e.attributes).reduce(function (e, t) {
                      return (e[t.name] = t.value), e;
                    }, {});
                  }
                  t.default = function () {
                    var e =
                      arguments.length > 0 && void 0 !== arguments[0]
                        ? arguments[0]
                        : {};
                    if ("undefined" == typeof document)
                      throw new Error(
                        "`feather.replace()` only works in a browser environment."
                      );
                    var t = document.querySelectorAll("[data-feather]");
                    Array.from(t).forEach(function (t) {
                      return o(t, e);
                    });
                  };
                },
                "./src/tags.json": function (e) {
                  e.exports = {
                    activity: ["pulse", "health", "action", "motion"],
                    airplay: ["stream", "cast", "mirroring"],
                    "alert-circle": ["warning", "alert", "danger"],
                    "alert-octagon": ["warning", "alert", "danger"],
                    "alert-triangle": ["warning", "alert", "danger"],
                    "align-center": ["text alignment", "center"],
                    "align-justify": ["text alignment", "justified"],
                    "align-left": ["text alignment", "left"],
                    "align-right": ["text alignment", "right"],
                    anchor: [],
                    archive: ["index", "box"],
                    "at-sign": ["mention", "at", "email", "message"],
                    award: ["achievement", "badge"],
                    aperture: ["camera", "photo"],
                    "bar-chart": ["statistics", "diagram", "graph"],
                    "bar-chart-2": ["statistics", "diagram", "graph"],
                    battery: ["power", "electricity"],
                    "battery-charging": ["power", "electricity"],
                    bell: ["alarm", "notification", "sound"],
                    "bell-off": ["alarm", "notification", "silent"],
                    bluetooth: ["wireless"],
                    "book-open": ["read", "library"],
                    book: [
                      "read",
                      "dictionary",
                      "booklet",
                      "magazine",
                      "library",
                    ],
                    bookmark: ["read", "clip", "marker", "tag"],
                    box: ["cube"],
                    briefcase: ["work", "bag", "baggage", "folder"],
                    calendar: ["date"],
                    camera: ["photo"],
                    cast: ["chromecast", "airplay"],
                    circle: ["off", "zero", "record"],
                    clipboard: ["copy"],
                    clock: ["time", "watch", "alarm"],
                    "cloud-drizzle": ["weather", "shower"],
                    "cloud-lightning": ["weather", "bolt"],
                    "cloud-rain": ["weather"],
                    "cloud-snow": ["weather", "blizzard"],
                    cloud: ["weather"],
                    codepen: ["logo"],
                    codesandbox: ["logo"],
                    code: ["source", "programming"],
                    coffee: [
                      "drink",
                      "cup",
                      "mug",
                      "tea",
                      "cafe",
                      "hot",
                      "beverage",
                    ],
                    columns: ["layout"],
                    command: ["keyboard", "cmd", "terminal", "prompt"],
                    compass: ["navigation", "safari", "travel", "direction"],
                    copy: ["clone", "duplicate"],
                    "corner-down-left": ["arrow", "return"],
                    "corner-down-right": ["arrow"],
                    "corner-left-down": ["arrow"],
                    "corner-left-up": ["arrow"],
                    "corner-right-down": ["arrow"],
                    "corner-right-up": ["arrow"],
                    "corner-up-left": ["arrow"],
                    "corner-up-right": ["arrow"],
                    cpu: ["processor", "technology"],
                    "credit-card": ["purchase", "payment", "cc"],
                    crop: ["photo", "image"],
                    crosshair: ["aim", "target"],
                    database: ["storage", "memory"],
                    delete: ["remove"],
                    disc: ["album", "cd", "dvd", "music"],
                    "dollar-sign": ["currency", "money", "payment"],
                    droplet: ["water"],
                    edit: ["pencil", "change"],
                    "edit-2": ["pencil", "change"],
                    "edit-3": ["pencil", "change"],
                    eye: ["view", "watch"],
                    "eye-off": ["view", "watch", "hide", "hidden"],
                    "external-link": ["outbound"],
                    facebook: ["logo", "social"],
                    "fast-forward": ["music"],
                    figma: ["logo", "design", "tool"],
                    "file-minus": ["delete", "remove", "erase"],
                    "file-plus": ["add", "create", "new"],
                    "file-text": ["data", "txt", "pdf"],
                    film: ["movie", "video"],
                    filter: ["funnel", "hopper"],
                    flag: ["report"],
                    "folder-minus": ["directory"],
                    "folder-plus": ["directory"],
                    folder: ["directory"],
                    framer: ["logo", "design", "tool"],
                    frown: ["emoji", "face", "bad", "sad", "emotion"],
                    gift: ["present", "box", "birthday", "party"],
                    "git-branch": ["code", "version control"],
                    "git-commit": ["code", "version control"],
                    "git-merge": ["code", "version control"],
                    "git-pull-request": ["code", "version control"],
                    github: ["logo", "version control"],
                    gitlab: ["logo", "version control"],
                    globe: ["world", "browser", "language", "translate"],
                    "hard-drive": ["computer", "server", "memory", "data"],
                    hash: ["hashtag", "number", "pound"],
                    headphones: ["music", "audio", "sound"],
                    heart: ["like", "love", "emotion"],
                    "help-circle": ["question mark"],
                    hexagon: ["shape", "node.js", "logo"],
                    home: ["house", "living"],
                    image: ["picture"],
                    inbox: ["email"],
                    instagram: ["logo", "camera"],
                    key: ["password", "login", "authentication", "secure"],
                    layers: ["stack"],
                    layout: ["window", "webpage"],
                    "life-bouy": ["help", "life ring", "support"],
                    link: ["chain", "url"],
                    "link-2": ["chain", "url"],
                    linkedin: ["logo", "social media"],
                    list: ["options"],
                    lock: ["security", "password", "secure"],
                    "log-in": ["sign in", "arrow", "enter"],
                    "log-out": ["sign out", "arrow", "exit"],
                    mail: ["email", "message"],
                    "map-pin": ["location", "navigation", "travel", "marker"],
                    map: ["location", "navigation", "travel"],
                    maximize: ["fullscreen"],
                    "maximize-2": ["fullscreen", "arrows", "expand"],
                    meh: ["emoji", "face", "neutral", "emotion"],
                    menu: ["bars", "navigation", "hamburger"],
                    "message-circle": ["comment", "chat"],
                    "message-square": ["comment", "chat"],
                    "mic-off": ["record", "sound", "mute"],
                    mic: ["record", "sound", "listen"],
                    minimize: ["exit fullscreen", "close"],
                    "minimize-2": ["exit fullscreen", "arrows", "close"],
                    minus: ["subtract"],
                    monitor: ["tv", "screen", "display"],
                    moon: ["dark", "night"],
                    "more-horizontal": ["ellipsis"],
                    "more-vertical": ["ellipsis"],
                    "mouse-pointer": ["arrow", "cursor"],
                    move: ["arrows"],
                    music: ["note"],
                    navigation: ["location", "travel"],
                    "navigation-2": ["location", "travel"],
                    octagon: ["stop"],
                    package: ["box", "container"],
                    paperclip: ["attachment"],
                    pause: ["music", "stop"],
                    "pause-circle": ["music", "audio", "stop"],
                    "pen-tool": ["vector", "drawing"],
                    percent: ["discount"],
                    "phone-call": ["ring"],
                    "phone-forwarded": ["call"],
                    "phone-incoming": ["call"],
                    "phone-missed": ["call"],
                    "phone-off": ["call", "mute"],
                    "phone-outgoing": ["call"],
                    phone: ["call"],
                    play: ["music", "start"],
                    "pie-chart": ["statistics", "diagram"],
                    "play-circle": ["music", "start"],
                    plus: ["add", "new"],
                    "plus-circle": ["add", "new"],
                    "plus-square": ["add", "new"],
                    pocket: ["logo", "save"],
                    power: ["on", "off"],
                    printer: ["fax", "office", "device"],
                    radio: ["signal"],
                    "refresh-cw": ["synchronise", "arrows"],
                    "refresh-ccw": ["arrows"],
                    repeat: ["loop", "arrows"],
                    rewind: ["music"],
                    "rotate-ccw": ["arrow"],
                    "rotate-cw": ["arrow"],
                    rss: ["feed", "subscribe"],
                    save: ["floppy disk"],
                    scissors: ["cut"],
                    search: ["find", "magnifier", "magnifying glass"],
                    send: [
                      "message",
                      "mail",
                      "email",
                      "paper airplane",
                      "paper aeroplane",
                    ],
                    settings: ["cog", "edit", "gear", "preferences"],
                    "share-2": ["network", "connections"],
                    shield: ["security", "secure"],
                    "shield-off": ["security", "insecure"],
                    "shopping-bag": ["ecommerce", "cart", "purchase", "store"],
                    "shopping-cart": ["ecommerce", "cart", "purchase", "store"],
                    shuffle: ["music"],
                    "skip-back": ["music"],
                    "skip-forward": ["music"],
                    slack: ["logo"],
                    slash: ["ban", "no"],
                    sliders: ["settings", "controls"],
                    smartphone: ["cellphone", "device"],
                    smile: ["emoji", "face", "happy", "good", "emotion"],
                    speaker: ["audio", "music"],
                    star: ["bookmark", "favorite", "like"],
                    "stop-circle": ["media", "music"],
                    sun: ["brightness", "weather", "light"],
                    sunrise: ["weather", "time", "morning", "day"],
                    sunset: ["weather", "time", "evening", "night"],
                    tablet: ["device"],
                    tag: ["label"],
                    target: ["logo", "bullseye"],
                    terminal: ["code", "command line", "prompt"],
                    thermometer: [
                      "temperature",
                      "celsius",
                      "fahrenheit",
                      "weather",
                    ],
                    "thumbs-down": ["dislike", "bad", "emotion"],
                    "thumbs-up": ["like", "good", "emotion"],
                    "toggle-left": ["on", "off", "switch"],
                    "toggle-right": ["on", "off", "switch"],
                    tool: ["settings", "spanner"],
                    trash: ["garbage", "delete", "remove", "bin"],
                    "trash-2": ["garbage", "delete", "remove", "bin"],
                    triangle: ["delta"],
                    truck: ["delivery", "van", "shipping", "transport", "lorry"],
                    tv: ["television", "stream"],
                    twitch: ["logo"],
                    twitter: ["logo", "social"],
                    type: ["text"],
                    umbrella: ["rain", "weather"],
                    unlock: ["security"],
                    "user-check": ["followed", "subscribed"],
                    "user-minus": ["delete", "remove", "unfollow", "unsubscribe"],
                    "user-plus": ["new", "add", "create", "follow", "subscribe"],
                    "user-x": [
                      "delete",
                      "remove",
                      "unfollow",
                      "unsubscribe",
                      "unavailable",
                    ],
                    user: ["person", "account"],
                    users: ["group"],
                    "video-off": ["camera", "movie", "film"],
                    video: ["camera", "movie", "film"],
                    voicemail: ["phone"],
                    volume: ["music", "sound", "mute"],
                    "volume-1": ["music", "sound"],
                    "volume-2": ["music", "sound"],
                    "volume-x": ["music", "sound", "mute"],
                    watch: ["clock", "time"],
                    "wifi-off": ["disabled"],
                    wifi: ["connection", "signal", "wireless"],
                    wind: ["weather", "air"],
                    "x-circle": [
                      "cancel",
                      "close",
                      "delete",
                      "remove",
                      "times",
                      "clear",
                    ],
                    "x-octagon": [
                      "delete",
                      "stop",
                      "alert",
                      "warning",
                      "times",
                      "clear",
                    ],
                    "x-square": [
                      "cancel",
                      "close",
                      "delete",
                      "remove",
                      "times",
                      "clear",
                    ],
                    x: ["cancel", "close", "delete", "remove", "times", "clear"],
                    youtube: ["logo", "video", "play"],
                    "zap-off": ["flash", "camera", "lightning"],
                    zap: ["flash", "camera", "lightning"],
                    "zoom-in": ["magnifying glass"],
                    "zoom-out": ["magnifying glass"],
                  };
                },
                "./src/to-svg.js": function (e, t, n) {
                  "use strict";
                  Object.defineProperty(t, "__esModule", { value: !0 });
                  var i,
                    r = n("./src/icons.js"),
                    s = (i = r) && i.__esModule ? i : { default: i };
                  t.default = function (e) {
                    var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {};
                    if (
                      (console.warn(
                        "feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."
                      ),
                      !e)
                    )
                      throw new Error(
                        "The required `key` (icon name) parameter is missing."
                      );
                    if (!s.default[e])
                      throw new Error(
                        "No icon matching '" +
                          e +
                          "'. See the complete list of icons at https://feathericons.com"
                      );
                    return s.default[e].toSvg(t);
                  };
                },
                0: function (e, t, n) {
                  n("./node_modules/core-js/es/array/from.js"),
                    (e.exports = n("./src/index.js"));
                },
              });
            }),
            (e.exports = t());
        },
        65: (e, t, n) => {
          var i,
            r,
            s = n(755);
          (r = !0),
            ((i = s).flexslider = function (e, t) {
              var n = i(e);
              void 0 === t.rtl && "rtl" == i("html").attr("dir") && (t.rtl = !0),
                (n.vars = i.extend({}, i.flexslider.defaults, t));
              var s,
                a = n.vars.namespace,
                o =
                  window.navigator &&
                  window.navigator.msPointerEnabled &&
                  window.MSGesture,
                l =
                  ("ontouchstart" in window ||
                    o ||
                    (window.DocumentTouch &&
                      document instanceof DocumentTouch)) &&
                  n.vars.touch,
                c = "click touchend MSPointerUp keyup",
                d = "",
                u = "vertical" === n.vars.direction,
                p = n.vars.reverse,
                h = n.vars.itemWidth > 0,
                f = "fade" === n.vars.animation,
                m = "" !== n.vars.asNavFor,
                v = {};
              i.data(e, "flexslider", n),
                (v = {
                  init: function () {
                    (n.animating = !1),
                      (n.currentSlide = parseInt(
                        n.vars.startAt ? n.vars.startAt : 0,
                        10
                      )),
                      isNaN(n.currentSlide) && (n.currentSlide = 0),
                      (n.animatingTo = n.currentSlide),
                      (n.atEnd =
                        0 === n.currentSlide || n.currentSlide === n.last),
                      (n.containerSelector = n.vars.selector.substr(
                        0,
                        n.vars.selector.search(" ")
                      )),
                      (n.slides = i(n.vars.selector, n)),
                      (n.container = i(n.containerSelector, n)),
                      (n.count = n.slides.length),
                      (n.syncExists = i(n.vars.sync).length > 0),
                      "slide" === n.vars.animation &&
                        (n.vars.animation = "swing"),
                      (n.prop = u
                        ? "top"
                        : n.vars.rtl
                        ? "marginRight"
                        : "marginLeft"),
                      (n.args = {}),
                      (n.manualPause = !1),
                      (n.stopped = !1),
                      (n.started = !1),
                      (n.startTimeout = null),
                      (n.transitions =
                        !n.vars.video &&
                        !f &&
                        n.vars.useCSS &&
                        (function () {
                          var e = document.createElement("div"),
                            t = [
                              "perspectiveProperty",
                              "WebkitPerspective",
                              "MozPerspective",
                              "OPerspective",
                              "msPerspective",
                            ];
                          for (var i in t)
                            if (void 0 !== e.style[t[i]])
                              return (
                                (n.pfx = t[i]
                                  .replace("Perspective", "")
                                  .toLowerCase()),
                                (n.prop = "-" + n.pfx + "-transform"),
                                !0
                              );
                          return !1;
                        })()),
                      (n.isFirefox =
                        navigator.userAgent.toLowerCase().indexOf("firefox") >
                        -1),
                      (n.ensureAnimationEnd = ""),
                      "" !== n.vars.controlsContainer &&
                        (n.controlsContainer =
                          i(n.vars.controlsContainer).length > 0 &&
                          i(n.vars.controlsContainer)),
                      "" !== n.vars.manualControls &&
                        (n.manualControls =
                          i(n.vars.manualControls).length > 0 &&
                          i(n.vars.manualControls)),
                      "" !== n.vars.customDirectionNav &&
                        (n.customDirectionNav =
                          2 === i(n.vars.customDirectionNav).length &&
                          i(n.vars.customDirectionNav)),
                      n.vars.randomize &&
                        (n.slides.sort(function () {
                          return Math.round(Math.random()) - 0.5;
                        }),
                        n.container.empty().append(n.slides)),
                      n.doMath(),
                      n.setup("init"),
                      n.vars.controlNav && v.controlNav.setup(),
                      n.vars.directionNav && v.directionNav.setup(),
                      n.vars.keyboard &&
                        (1 === i(n.containerSelector).length ||
                          n.vars.multipleKeyboard) &&
                        i(document).bind("keyup", function (e) {
                          var t = e.keyCode;
                          if (!n.animating && (39 === t || 37 === t)) {
                            var i = n.vars.rtl
                              ? 37 === t
                                ? n.getTarget("next")
                                : 39 === t && n.getTarget("prev")
                              : 39 === t
                              ? n.getTarget("next")
                              : 37 === t && n.getTarget("prev");
                            n.flexAnimate(i, n.vars.pauseOnAction);
                          }
                        }),
                      n.vars.mousewheel &&
                        n.bind("mousewheel", function (e, t, i, r) {
                          e.preventDefault();
                          var s =
                            t < 0 ? n.getTarget("next") : n.getTarget("prev");
                          n.flexAnimate(s, n.vars.pauseOnAction);
                        }),
                      n.vars.pausePlay && v.pausePlay.setup(),
                      n.vars.slideshow &&
                        n.vars.pauseInvisible &&
                        v.pauseInvisible.init(),
                      n.vars.slideshow &&
                        (n.vars.pauseOnHover &&
                          n.hover(
                            function () {
                              n.manualPlay || n.manualPause || n.pause();
                            },
                            function () {
                              n.manualPause ||
                                n.manualPlay ||
                                n.stopped ||
                                n.play();
                            }
                          ),
                        (n.vars.pauseInvisible && v.pauseInvisible.isHidden()) ||
                          (n.vars.initDelay > 0
                            ? (n.startTimeout = setTimeout(
                                n.play,
                                n.vars.initDelay
                              ))
                            : n.play())),
                      m && v.asNav.setup(),
                      l && n.vars.touch && v.touch(),
                      (!f || (f && n.vars.smoothHeight)) &&
                        i(window).bind(
                          "resize orientationchange focus",
                          v.resize
                        ),
                      n.find("img").attr("draggable", "false"),
                      setTimeout(function () {
                        n.vars.start(n);
                      }, 200);
                  },
                  asNav: {
                    setup: function () {
                      (n.asNav = !0),
                        (n.animatingTo = Math.floor(n.currentSlide / n.move)),
                        (n.currentItem = n.currentSlide),
                        n.slides
                          .removeClass(a + "active-slide")
                          .eq(n.currentItem)
                          .addClass(a + "active-slide"),
                        o
                          ? ((e._slider = n),
                            n.slides.each(function () {
                              var e = this;
                              (e._gesture = new MSGesture()),
                                (e._gesture.target = e),
                                e.addEventListener(
                                  "MSPointerDown",
                                  function (e) {
                                    e.preventDefault(),
                                      e.currentTarget._gesture &&
                                        e.currentTarget._gesture.addPointer(
                                          e.pointerId
                                        );
                                  },
                                  !1
                                ),
                                e.addEventListener("MSGestureTap", function (e) {
                                  e.preventDefault();
                                  var t = i(this),
                                    r = t.index();
                                  i(n.vars.asNavFor).data("flexslider")
                                    .animating ||
                                    t.hasClass("active") ||
                                    ((n.direction =
                                      n.currentItem < r ? "next" : "prev"),
                                    n.flexAnimate(
                                      r,
                                      n.vars.pauseOnAction,
                                      !1,
                                      !0,
                                      !0
                                    ));
                                });
                            }))
                          : n.slides.on(c, function (e) {
                              e.preventDefault();
                              var t = i(this),
                                r = t.index();
                              (n.vars.rtl
                                ? -1 * (t.offset().right - i(n).scrollLeft())
                                : t.offset().left - i(n).scrollLeft()) <= 0 &&
                              t.hasClass(a + "active-slide")
                                ? n.flexAnimate(n.getTarget("prev"), !0)
                                : i(n.vars.asNavFor).data("flexslider")
                                    .animating ||
                                  t.hasClass(a + "active-slide") ||
                                  ((n.direction =
                                    n.currentItem < r ? "next" : "prev"),
                                  n.flexAnimate(
                                    r,
                                    n.vars.pauseOnAction,
                                    !1,
                                    !0,
                                    !0
                                  ));
                            });
                    },
                  },
                  controlNav: {
                    setup: function () {
                      n.manualControls
                        ? v.controlNav.setupManual()
                        : v.controlNav.setupPaging();
                    },
                    setupPaging: function () {
                      var e,
                        t,
                        r =
                          "thumbnails" === n.vars.controlNav
                            ? "control-thumbs"
                            : "control-paging",
                        s = 1;
                      if (
                        ((n.controlNavScaffold = i(
                          '<ol class="' + a + "control-nav " + a + r + '"></ol>'
                        )),
                        n.pagingCount > 1)
                      )
                        for (var o = 0; o < n.pagingCount; o++) {
                          if (
                            (void 0 ===
                              (t = n.slides.eq(o)).attr("data-thumb-alt") &&
                              t.attr("data-thumb-alt", ""),
                            (e = i("<a></a>").attr("href", "#").text(s)),
                            "thumbnails" === n.vars.controlNav &&
                              (e = i("<img/>").attr("src", t.attr("data-thumb"))),
                            "" !== t.attr("data-thumb-alt") &&
                              e.attr("alt", t.attr("data-thumb-alt")),
                            "thumbnails" === n.vars.controlNav &&
                              !0 === n.vars.thumbCaptions)
                          ) {
                            var l = t.attr("data-thumbcaption");
                            if ("" !== l && void 0 !== l) {
                              var u = i("<span></span>")
                                .addClass(a + "caption")
                                .text(l);
                              e.append(u);
                            }
                          }
                          var p = i("<li>");
                          e.appendTo(p),
                            p.append("</li>"),
                            n.controlNavScaffold.append(p),
                            s++;
                        }
                      n.controlsContainer
                        ? i(n.controlsContainer).append(n.controlNavScaffold)
                        : n.append(n.controlNavScaffold),
                        v.controlNav.set(),
                        v.controlNav.active(),
                        n.controlNavScaffold.delegate("a, img", c, function (e) {
                          if ((e.preventDefault(), "" === d || d === e.type)) {
                            var t = i(this),
                              r = n.controlNav.index(t);
                            t.hasClass(a + "active") ||
                              ((n.direction =
                                r > n.currentSlide ? "next" : "prev"),
                              n.flexAnimate(r, n.vars.pauseOnAction));
                          }
                          "" === d && (d = e.type), v.setToClearWatchedEvent();
                        });
                    },
                    setupManual: function () {
                      (n.controlNav = n.manualControls),
                        v.controlNav.active(),
                        n.controlNav.bind(c, function (e) {
                          if ((e.preventDefault(), "" === d || d === e.type)) {
                            var t = i(this),
                              r = n.controlNav.index(t);
                            t.hasClass(a + "active") ||
                              (r > n.currentSlide
                                ? (n.direction = "next")
                                : (n.direction = "prev"),
                              n.flexAnimate(r, n.vars.pauseOnAction));
                          }
                          "" === d && (d = e.type), v.setToClearWatchedEvent();
                        });
                    },
                    set: function () {
                      var e = "thumbnails" === n.vars.controlNav ? "img" : "a";
                      n.controlNav = i(
                        "." + a + "control-nav li " + e,
                        n.controlsContainer ? n.controlsContainer : n
                      );
                    },
                    active: function () {
                      n.controlNav
                        .removeClass(a + "active")
                        .eq(n.animatingTo)
                        .addClass(a + "active");
                    },
                    update: function (e, t) {
                      n.pagingCount > 1 && "add" === e
                        ? n.controlNavScaffold.append(
                            i('<li><a href="#">' + n.count + "</a></li>")
                          )
                        : 1 === n.pagingCount
                        ? n.controlNavScaffold.find("li").remove()
                        : n.controlNav.eq(t).closest("li").remove(),
                        v.controlNav.set(),
                        n.pagingCount > 1 && n.pagingCount !== n.controlNav.length
                          ? n.update(t, e)
                          : v.controlNav.active();
                    },
                  },
                  directionNav: {
                    setup: function () {
                      var e = i(
                        '<ul class="' +
                          a +
                          'direction-nav"><li class="' +
                          a +
                          'nav-prev"><a class="' +
                          a +
                          'prev" href="#">' +
                          n.vars.prevText +
                          '</a></li><li class="' +
                          a +
                          'nav-next"><a class="' +
                          a +
                          'next" href="#">' +
                          n.vars.nextText +
                          "</a></li></ul>"
                      );
                      n.customDirectionNav
                        ? (n.directionNav = n.customDirectionNav)
                        : n.controlsContainer
                        ? (i(n.controlsContainer).append(e),
                          (n.directionNav = i(
                            "." + a + "direction-nav li a",
                            n.controlsContainer
                          )))
                        : (n.append(e),
                          (n.directionNav = i(
                            "." + a + "direction-nav li a",
                            n
                          ))),
                        v.directionNav.update(),
                        n.directionNav.bind(c, function (e) {
                          var t;
                          e.preventDefault(),
                            ("" !== d && d !== e.type) ||
                              ((t = i(this).hasClass(a + "next")
                                ? n.getTarget("next")
                                : n.getTarget("prev")),
                              n.flexAnimate(t, n.vars.pauseOnAction)),
                            "" === d && (d = e.type),
                            v.setToClearWatchedEvent();
                        });
                    },
                    update: function () {
                      var e = a + "disabled";
                      1 === n.pagingCount
                        ? n.directionNav.addClass(e).attr("tabindex", "-1")
                        : n.vars.animationLoop
                        ? n.directionNav.removeClass(e).removeAttr("tabindex")
                        : 0 === n.animatingTo
                        ? n.directionNav
                            .removeClass(e)
                            .filter("." + a + "prev")
                            .addClass(e)
                            .attr("tabindex", "-1")
                        : n.animatingTo === n.last
                        ? n.directionNav
                            .removeClass(e)
                            .filter("." + a + "next")
                            .addClass(e)
                            .attr("tabindex", "-1")
                        : n.directionNav.removeClass(e).removeAttr("tabindex");
                    },
                  },
                  pausePlay: {
                    setup: function () {
                      var e = i(
                        '<div class="' + a + 'pauseplay"><a href="#"></a></div>'
                      );
                      n.controlsContainer
                        ? (n.controlsContainer.append(e),
                          (n.pausePlay = i(
                            "." + a + "pauseplay a",
                            n.controlsContainer
                          )))
                        : (n.append(e),
                          (n.pausePlay = i("." + a + "pauseplay a", n))),
                        v.pausePlay.update(
                          n.vars.slideshow ? a + "pause" : a + "play"
                        ),
                        n.pausePlay.bind(c, function (e) {
                          e.preventDefault(),
                            ("" !== d && d !== e.type) ||
                              (i(this).hasClass(a + "pause")
                                ? ((n.manualPause = !0),
                                  (n.manualPlay = !1),
                                  n.pause())
                                : ((n.manualPause = !1),
                                  (n.manualPlay = !0),
                                  n.play())),
                            "" === d && (d = e.type),
                            v.setToClearWatchedEvent();
                        });
                    },
                    update: function (e) {
                      "play" === e
                        ? n.pausePlay
                            .removeClass(a + "pause")
                            .addClass(a + "play")
                            .html(n.vars.playText)
                        : n.pausePlay
                            .removeClass(a + "play")
                            .addClass(a + "pause")
                            .html(n.vars.pauseText);
                    },
                  },
                  touch: function () {
                    var t,
                      i,
                      r,
                      s,
                      a,
                      l,
                      c,
                      d,
                      m,
                      v = !1,
                      y = 0,
                      g = 0,
                      x = 0;
                    o
                      ? ((e.style.msTouchAction = "none"),
                        (e._gesture = new MSGesture()),
                        (e._gesture.target = e),
                        e.addEventListener(
                          "MSPointerDown",
                          function (t) {
                            t.stopPropagation(),
                              n.animating
                                ? t.preventDefault()
                                : (n.pause(),
                                  e._gesture.addPointer(t.pointerId),
                                  (x = 0),
                                  (s = u ? n.h : n.w),
                                  (l = Number(new Date())),
                                  (r =
                                    h && p && n.animatingTo === n.last
                                      ? 0
                                      : h && p
                                      ? n.limit -
                                        (n.itemW + n.vars.itemMargin) *
                                          n.move *
                                          n.animatingTo
                                      : h && n.currentSlide === n.last
                                      ? n.limit
                                      : h
                                      ? (n.itemW + n.vars.itemMargin) *
                                        n.move *
                                        n.currentSlide
                                      : p
                                      ? (n.last -
                                          n.currentSlide +
                                          n.cloneOffset) *
                                        s
                                      : (n.currentSlide + n.cloneOffset) * s));
                          },
                          !1
                        ),
                        (e._slider = n),
                        e.addEventListener(
                          "MSGestureChange",
                          function (t) {
                            t.stopPropagation();
                            var n = t.target._slider;
                            if (n) {
                              var i = -t.translationX,
                                o = -t.translationY;
                              (x += u ? o : i),
                                (a = (n.vars.rtl ? -1 : 1) * x),
                                (v = u
                                  ? Math.abs(x) < Math.abs(-i)
                                  : Math.abs(x) < Math.abs(-o)),
                                t.detail !== t.MSGESTURE_FLAG_INERTIA
                                  ? (!v || Number(new Date()) - l > 500) &&
                                    (t.preventDefault(),
                                    !f &&
                                      n.transitions &&
                                      (n.vars.animationLoop ||
                                        (a =
                                          x /
                                          ((0 === n.currentSlide && x < 0) ||
                                          (n.currentSlide === n.last && x > 0)
                                            ? Math.abs(x) / s + 2
                                            : 1)),
                                      n.setProps(r + a, "setTouch")))
                                  : setImmediate(function () {
                                      e._gesture.stop();
                                    });
                            }
                          },
                          !1
                        ),
                        e.addEventListener(
                          "MSGestureEnd",
                          function (e) {
                            e.stopPropagation();
                            var n = e.target._slider;
                            if (n) {
                              if (
                                n.animatingTo === n.currentSlide &&
                                !v &&
                                null !== a
                              ) {
                                var o = p ? -a : a,
                                  c =
                                    o > 0
                                      ? n.getTarget("next")
                                      : n.getTarget("prev");
                                n.canAdvance(c) &&
                                ((Number(new Date()) - l < 550 &&
                                  Math.abs(o) > 50) ||
                                  Math.abs(o) > s / 2)
                                  ? n.flexAnimate(c, n.vars.pauseOnAction)
                                  : f ||
                                    n.flexAnimate(
                                      n.currentSlide,
                                      n.vars.pauseOnAction,
                                      !0
                                    );
                              }
                              (t = null),
                                (i = null),
                                (a = null),
                                (r = null),
                                (x = 0);
                            }
                          },
                          !1
                        ))
                      : ((c = function (a) {
                          n.animating
                            ? a.preventDefault()
                            : (window.navigator.msPointerEnabled ||
                                1 === a.touches.length) &&
                              (n.pause(),
                              (s = u ? n.h : n.w),
                              (l = Number(new Date())),
                              (y = a.touches[0].pageX),
                              (g = a.touches[0].pageY),
                              (r =
                                h && p && n.animatingTo === n.last
                                  ? 0
                                  : h && p
                                  ? n.limit -
                                    (n.itemW + n.vars.itemMargin) *
                                      n.move *
                                      n.animatingTo
                                  : h && n.currentSlide === n.last
                                  ? n.limit
                                  : h
                                  ? (n.itemW + n.vars.itemMargin) *
                                    n.move *
                                    n.currentSlide
                                  : p
                                  ? (n.last - n.currentSlide + n.cloneOffset) * s
                                  : (n.currentSlide + n.cloneOffset) * s),
                              (t = u ? g : y),
                              (i = u ? y : g),
                              e.addEventListener("touchmove", d, !1),
                              e.addEventListener("touchend", m, !1));
                        }),
                        (d = function (e) {
                          (y = e.touches[0].pageX),
                            (g = e.touches[0].pageY),
                            (a = u ? t - g : (n.vars.rtl ? -1 : 1) * (t - y)),
                            (!(v = u
                              ? Math.abs(a) < Math.abs(y - i)
                              : Math.abs(a) < Math.abs(g - i)) ||
                              Number(new Date()) - l > 500) &&
                              (e.preventDefault(),
                              !f &&
                                n.transitions &&
                                (n.vars.animationLoop ||
                                  (a /=
                                    (0 === n.currentSlide && a < 0) ||
                                    (n.currentSlide === n.last && a > 0)
                                      ? Math.abs(a) / s + 2
                                      : 1),
                                n.setProps(r + a, "setTouch")));
                        }),
                        (m = function (o) {
                          if (
                            (e.removeEventListener("touchmove", d, !1),
                            n.animatingTo === n.currentSlide && !v && null !== a)
                          ) {
                            var c = p ? -a : a,
                              u =
                                c > 0 ? n.getTarget("next") : n.getTarget("prev");
                            n.canAdvance(u) &&
                            ((Number(new Date()) - l < 550 && Math.abs(c) > 50) ||
                              Math.abs(c) > s / 2)
                              ? n.flexAnimate(u, n.vars.pauseOnAction)
                              : f ||
                                n.flexAnimate(
                                  n.currentSlide,
                                  n.vars.pauseOnAction,
                                  !0
                                );
                          }
                          e.removeEventListener("touchend", m, !1),
                            (t = null),
                            (i = null),
                            (a = null),
                            (r = null);
                        }),
                        e.addEventListener("touchstart", c, !1));
                  },
                  resize: function () {
                    !n.animating &&
                      n.is(":visible") &&
                      (h || n.doMath(),
                      f
                        ? v.smoothHeight()
                        : h
                        ? (n.slides.width(n.computedW),
                          n.update(n.pagingCount),
                          n.setProps())
                        : u
                        ? (n.viewport.height(n.h), n.setProps(n.h, "setTotal"))
                        : (n.vars.smoothHeight && v.smoothHeight(),
                          n.newSlides.width(n.computedW),
                          n.setProps(n.computedW, "setTotal")));
                  },
                  smoothHeight: function (e) {
                    if (!u || f) {
                      var t = f ? n : n.viewport;
                      e
                        ? t.animate(
                            { height: n.slides.eq(n.animatingTo).innerHeight() },
                            e
                          )
                        : t.innerHeight(n.slides.eq(n.animatingTo).innerHeight());
                    }
                  },
                  sync: function (e) {
                    var t = i(n.vars.sync).data("flexslider"),
                      r = n.animatingTo;
                    switch (e) {
                      case "animate":
                        t.flexAnimate(r, n.vars.pauseOnAction, !1, !0);
                        break;
                      case "play":
                        t.playing || t.asNav || t.play();
                        break;
                      case "pause":
                        t.pause();
                    }
                  },
                  uniqueID: function (e) {
                    return (
                      e
                        .filter("[id]")
                        .add(e.find("[id]"))
                        .each(function () {
                          var e = i(this);
                          e.attr("id", e.attr("id") + "_clone");
                        }),
                      e
                    );
                  },
                  pauseInvisible: {
                    visProp: null,
                    init: function () {
                      var e = v.pauseInvisible.getHiddenProp();
                      if (e) {
                        var t = e.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(t, function () {
                          v.pauseInvisible.isHidden()
                            ? n.startTimeout
                              ? clearTimeout(n.startTimeout)
                              : n.pause()
                            : n.started
                            ? n.play()
                            : n.vars.initDelay > 0
                            ? setTimeout(n.play, n.vars.initDelay)
                            : n.play();
                        });
                      }
                    },
                    isHidden: function () {
                      var e = v.pauseInvisible.getHiddenProp();
                      return !!e && document[e];
                    },
                    getHiddenProp: function () {
                      var e = ["webkit", "moz", "ms", "o"];
                      if ("hidden" in document) return "hidden";
                      for (var t = 0; t < e.length; t++)
                        if (e[t] + "Hidden" in document) return e[t] + "Hidden";
                      return null;
                    },
                  },
                  setToClearWatchedEvent: function () {
                    clearTimeout(s),
                      (s = setTimeout(function () {
                        d = "";
                      }, 3e3));
                  },
                }),
                (n.flexAnimate = function (e, t, r, s, o) {
                  if (
                    (n.vars.animationLoop ||
                      e === n.currentSlide ||
                      (n.direction = e > n.currentSlide ? "next" : "prev"),
                    m &&
                      1 === n.pagingCount &&
                      (n.direction = n.currentItem < e ? "next" : "prev"),
                    !n.animating && (n.canAdvance(e, o) || r) && n.is(":visible"))
                  ) {
                    if (m && s) {
                      var c = i(n.vars.asNavFor).data("flexslider");
                      if (
                        ((n.atEnd = 0 === e || e === n.count - 1),
                        c.flexAnimate(e, !0, !1, !0, o),
                        (n.direction = n.currentItem < e ? "next" : "prev"),
                        (c.direction = n.direction),
                        Math.ceil((e + 1) / n.visible) - 1 === n.currentSlide ||
                          0 === e)
                      )
                        return (
                          (n.currentItem = e),
                          n.slides
                            .removeClass(a + "active-slide")
                            .eq(e)
                            .addClass(a + "active-slide"),
                          !1
                        );
                      (n.currentItem = e),
                        n.slides
                          .removeClass(a + "active-slide")
                          .eq(e)
                          .addClass(a + "active-slide"),
                        (e = Math.floor(e / n.visible));
                    }
                    if (
                      ((n.animating = !0),
                      (n.animatingTo = e),
                      t && n.pause(),
                      n.vars.before(n),
                      n.syncExists && !o && v.sync("animate"),
                      n.vars.controlNav && v.controlNav.active(),
                      h ||
                        n.slides
                          .removeClass(a + "active-slide")
                          .eq(e)
                          .addClass(a + "active-slide"),
                      (n.atEnd = 0 === e || e === n.last),
                      n.vars.directionNav && v.directionNav.update(),
                      e === n.last &&
                        (n.vars.end(n), n.vars.animationLoop || n.pause()),
                      f)
                    )
                      l
                        ? (n.slides
                            .eq(n.currentSlide)
                            .css({ opacity: 0, zIndex: 1 }),
                          n.slides.eq(e).css({ opacity: 1, zIndex: 2 }),
                          n.wrapup(x))
                        : (n.slides
                            .eq(n.currentSlide)
                            .css({ zIndex: 1 })
                            .animate(
                              { opacity: 0 },
                              n.vars.animationSpeed,
                              n.vars.easing
                            ),
                          n.slides
                            .eq(e)
                            .css({ zIndex: 2 })
                            .animate(
                              { opacity: 1 },
                              n.vars.animationSpeed,
                              n.vars.easing,
                              n.wrapup
                            ));
                    else {
                      var d,
                        y,
                        g,
                        x = u ? n.slides.filter(":first").height() : n.computedW;
                      h
                        ? ((d = n.vars.itemMargin),
                          (y =
                            (g = (n.itemW + d) * n.move * n.animatingTo) >
                              n.limit && 1 !== n.visible
                              ? n.limit
                              : g))
                        : (y =
                            0 === n.currentSlide &&
                            e === n.count - 1 &&
                            n.vars.animationLoop &&
                            "next" !== n.direction
                              ? p
                                ? (n.count + n.cloneOffset) * x
                                : 0
                              : n.currentSlide === n.last &&
                                0 === e &&
                                n.vars.animationLoop &&
                                "prev" !== n.direction
                              ? p
                                ? 0
                                : (n.count + 1) * x
                              : p
                              ? (n.count - 1 - e + n.cloneOffset) * x
                              : (e + n.cloneOffset) * x),
                        n.setProps(y, "", n.vars.animationSpeed),
                        n.transitions
                          ? ((n.vars.animationLoop && n.atEnd) ||
                              ((n.animating = !1),
                              (n.currentSlide = n.animatingTo)),
                            n.container.unbind(
                              "webkitTransitionEnd transitionend"
                            ),
                            n.container.bind(
                              "webkitTransitionEnd transitionend",
                              function () {
                                clearTimeout(n.ensureAnimationEnd), n.wrapup(x);
                              }
                            ),
                            clearTimeout(n.ensureAnimationEnd),
                            (n.ensureAnimationEnd = setTimeout(function () {
                              n.wrapup(x);
                            }, n.vars.animationSpeed + 100)))
                          : n.container.animate(
                              n.args,
                              n.vars.animationSpeed,
                              n.vars.easing,
                              function () {
                                n.wrapup(x);
                              }
                            );
                    }
                    n.vars.smoothHeight && v.smoothHeight(n.vars.animationSpeed);
                  }
                }),
                (n.wrapup = function (e) {
                  f ||
                    h ||
                    (0 === n.currentSlide &&
                    n.animatingTo === n.last &&
                    n.vars.animationLoop
                      ? n.setProps(e, "jumpEnd")
                      : n.currentSlide === n.last &&
                        0 === n.animatingTo &&
                        n.vars.animationLoop &&
                        n.setProps(e, "jumpStart")),
                    (n.animating = !1),
                    (n.currentSlide = n.animatingTo),
                    n.vars.after(n);
                }),
                (n.animateSlides = function () {
                  !n.animating && r && n.flexAnimate(n.getTarget("next"));
                }),
                (n.pause = function () {
                  clearInterval(n.animatedSlides),
                    (n.animatedSlides = null),
                    (n.playing = !1),
                    n.vars.pausePlay && v.pausePlay.update("play"),
                    n.syncExists && v.sync("pause");
                }),
                (n.play = function () {
                  n.playing && clearInterval(n.animatedSlides),
                    (n.animatedSlides =
                      n.animatedSlides ||
                      setInterval(n.animateSlides, n.vars.slideshowSpeed)),
                    (n.started = n.playing = !0),
                    n.vars.pausePlay && v.pausePlay.update("pause"),
                    n.syncExists && v.sync("play");
                }),
                (n.stop = function () {
                  n.pause(), (n.stopped = !0);
                }),
                (n.canAdvance = function (e, t) {
                  var i = m ? n.pagingCount - 1 : n.last;
                  return !(
                    !t &&
                    (!m ||
                      n.currentItem !== n.count - 1 ||
                      0 !== e ||
                      "prev" !== n.direction) &&
                    ((m &&
                      0 === n.currentItem &&
                      e === n.pagingCount - 1 &&
                      "next" !== n.direction) ||
                      (e === n.currentSlide && !m) ||
                      (!n.vars.animationLoop &&
                        ((n.atEnd &&
                          0 === n.currentSlide &&
                          e === i &&
                          "next" !== n.direction) ||
                          (n.atEnd &&
                            n.currentSlide === i &&
                            0 === e &&
                            "next" === n.direction))))
                  );
                }),
                (n.getTarget = function (e) {
                  return (
                    (n.direction = e),
                    "next" === e
                      ? n.currentSlide === n.last
                        ? 0
                        : n.currentSlide + 1
                      : 0 === n.currentSlide
                      ? n.last
                      : n.currentSlide - 1
                  );
                }),
                (n.setProps = function (e, t, i) {
                  var r,
                    s =
                      ((r =
                        e ||
                        (n.itemW + n.vars.itemMargin) * n.move * n.animatingTo),
                      (function () {
                        if (h)
                          return "setTouch" === t
                            ? e
                            : p && n.animatingTo === n.last
                            ? 0
                            : p
                            ? n.limit -
                              (n.itemW + n.vars.itemMargin) *
                                n.move *
                                n.animatingTo
                            : n.animatingTo === n.last
                            ? n.limit
                            : r;
                        switch (t) {
                          case "setTotal":
                            return p
                              ? (n.count - 1 - n.currentSlide + n.cloneOffset) * e
                              : (n.currentSlide + n.cloneOffset) * e;
                          case "setTouch":
                          default:
                            return e;
                          case "jumpEnd":
                            return p ? e : n.count * e;
                          case "jumpStart":
                            return p ? n.count * e : e;
                        }
                      })() *
                        (n.vars.rtl ? 1 : -1) +
                        "px");
                  n.transitions &&
                    ((s = n.isFirefox
                      ? u
                        ? "translate3d(0," + s + ",0)"
                        : "translate3d(" + parseInt(s) + "px,0,0)"
                      : u
                      ? "translate3d(0," + s + ",0)"
                      : "translate3d(" +
                        (n.vars.rtl ? -1 : 1) * parseInt(s) +
                        "px,0,0)"),
                    (i = void 0 !== i ? i / 1e3 + "s" : "0s"),
                    n.container.css("-" + n.pfx + "-transition-duration", i),
                    n.container.css("transition-duration", i)),
                    (n.args[n.prop] = s),
                    (n.transitions || void 0 === i) && n.container.css(n.args),
                    n.container.css("transform", s);
                }),
                (n.setup = function (e) {
                  var t, r;
                  f
                    ? (n.vars.rtl
                        ? n.slides.css({
                            width: "100%",
                            float: "right",
                            marginLeft: "-100%",
                            position: "relative",
                          })
                        : n.slides.css({
                            width: "100%",
                            float: "left",
                            marginRight: "-100%",
                            position: "relative",
                          }),
                      "init" === e &&
                        (l
                          ? n.slides
                              .css({
                                opacity: 0,
                                display: "block",
                                webkitTransition:
                                  "opacity " +
                                  n.vars.animationSpeed / 1e3 +
                                  "s ease",
                                zIndex: 1,
                              })
                              .eq(n.currentSlide)
                              .css({ opacity: 1, zIndex: 2 })
                          : 0 == n.vars.fadeFirstSlide
                          ? n.slides
                              .css({ opacity: 0, display: "block", zIndex: 1 })
                              .eq(n.currentSlide)
                              .css({ zIndex: 2 })
                              .css({ opacity: 1 })
                          : n.slides
                              .css({ opacity: 0, display: "block", zIndex: 1 })
                              .eq(n.currentSlide)
                              .css({ zIndex: 2 })
                              .animate(
                                { opacity: 1 },
                                n.vars.animationSpeed,
                                n.vars.easing
                              )),
                      n.vars.smoothHeight && v.smoothHeight())
                    : ("init" === e &&
                        ((n.viewport = i('<div class="' + a + 'viewport"></div>')
                          .css({ overflow: "hidden", position: "relative" })
                          .appendTo(n)
                          .append(n.container)),
                        (n.cloneCount = 0),
                        (n.cloneOffset = 0),
                        p &&
                          ((r = i.makeArray(n.slides).reverse()),
                          (n.slides = i(r)),
                          n.container.empty().append(n.slides))),
                      n.vars.animationLoop &&
                        !h &&
                        ((n.cloneCount = 2),
                        (n.cloneOffset = 1),
                        "init" !== e && n.container.find(".clone").remove(),
                        n.container
                          .append(
                            v
                              .uniqueID(
                                n.slides.first().clone().addClass("clone")
                              )
                              .attr("aria-hidden", "true")
                          )
                          .prepend(
                            v
                              .uniqueID(n.slides.last().clone().addClass("clone"))
                              .attr("aria-hidden", "true")
                          )),
                      (n.newSlides = i(n.vars.selector, n)),
                      (t = p
                        ? n.count - 1 - n.currentSlide + n.cloneOffset
                        : n.currentSlide + n.cloneOffset),
                      u && !h
                        ? (n.container
                            .height(200 * (n.count + n.cloneCount) + "%")
                            .css("position", "absolute")
                            .width("100%"),
                          setTimeout(
                            function () {
                              n.newSlides.css({ display: "block" }),
                                n.doMath(),
                                n.viewport.height(n.h),
                                n.setProps(t * n.h, "init");
                            },
                            "init" === e ? 100 : 0
                          ))
                        : (n.container.width(
                            200 * (n.count + n.cloneCount) + "%"
                          ),
                          n.setProps(t * n.computedW, "init"),
                          setTimeout(
                            function () {
                              n.doMath(),
                                n.vars.rtl && n.isFirefox
                                  ? n.newSlides.css({
                                      width: n.computedW,
                                      marginRight: n.computedM,
                                      float: "right",
                                      display: "block",
                                    })
                                  : n.newSlides.css({
                                      width: n.computedW,
                                      marginRight: n.computedM,
                                      float: "left",
                                      display: "block",
                                    }),
                                n.vars.smoothHeight && v.smoothHeight();
                            },
                            "init" === e ? 100 : 0
                          ))),
                    h ||
                      n.slides
                        .removeClass(a + "active-slide")
                        .eq(n.currentSlide)
                        .addClass(a + "active-slide"),
                    n.vars.init(n);
                }),
                (n.doMath = function () {
                  var e = n.slides.first(),
                    t = n.vars.itemMargin,
                    i = n.vars.minItems,
                    r = n.vars.maxItems;
                  (n.w = void 0 === n.viewport ? n.width() : n.viewport.width()),
                    n.isFirefox && (n.w = n.width()),
                    (n.h = e.height()),
                    (n.boxPadding = e.outerWidth() - e.width()),
                    h
                      ? ((n.itemT = n.vars.itemWidth + t),
                        (n.itemM = t),
                        (n.minW = i ? i * n.itemT : n.w),
                        (n.maxW = r ? r * n.itemT - t : n.w),
                        (n.itemW =
                          n.minW > n.w
                            ? (n.w - t * (i - 1)) / i
                            : n.maxW < n.w
                            ? (n.w - t * (r - 1)) / r
                            : n.vars.itemWidth > n.w
                            ? n.w
                            : n.vars.itemWidth),
                        (n.visible = Math.floor(n.w / n.itemW)),
                        (n.move =
                          n.vars.move > 0 && n.vars.move < n.visible
                            ? n.vars.move
                            : n.visible),
                        (n.pagingCount = Math.ceil(
                          (n.count - n.visible) / n.move + 1
                        )),
                        (n.last = n.pagingCount - 1),
                        (n.limit =
                          1 === n.pagingCount
                            ? 0
                            : n.vars.itemWidth > n.w
                            ? n.itemW * (n.count - 1) + t * (n.count - 1)
                            : (n.itemW + t) * n.count - n.w - t))
                      : ((n.itemW = n.w),
                        (n.itemM = t),
                        (n.pagingCount = n.count),
                        (n.last = n.count - 1)),
                    (n.computedW = n.itemW - n.boxPadding),
                    (n.computedM = n.itemM);
                }),
                (n.update = function (e, t) {
                  n.doMath(),
                    h ||
                      (e < n.currentSlide
                        ? (n.currentSlide += 1)
                        : e <= n.currentSlide && 0 !== e && (n.currentSlide -= 1),
                      (n.animatingTo = n.currentSlide)),
                    n.vars.controlNav &&
                      !n.manualControls &&
                      (("add" === t && !h) || n.pagingCount > n.controlNav.length
                        ? v.controlNav.update("add")
                        : (("remove" === t && !h) ||
                            n.pagingCount < n.controlNav.length) &&
                          (h &&
                            n.currentSlide > n.last &&
                            ((n.currentSlide -= 1), (n.animatingTo -= 1)),
                          v.controlNav.update("remove", n.last))),
                    n.vars.directionNav && v.directionNav.update();
                }),
                (n.addSlide = function (e, t) {
                  var r = i(e);
                  (n.count += 1),
                    (n.last = n.count - 1),
                    u && p
                      ? void 0 !== t
                        ? n.slides.eq(n.count - t).after(r)
                        : n.container.prepend(r)
                      : void 0 !== t
                      ? n.slides.eq(t).before(r)
                      : n.container.append(r),
                    n.update(t, "add"),
                    (n.slides = i(n.vars.selector + ":not(.clone)", n)),
                    n.setup(),
                    n.vars.added(n);
                }),
                (n.removeSlide = function (e) {
                  var t = isNaN(e) ? n.slides.index(i(e)) : e;
                  (n.count -= 1),
                    (n.last = n.count - 1),
                    isNaN(e)
                      ? i(e, n.slides).remove()
                      : u && p
                      ? n.slides.eq(n.last).remove()
                      : n.slides.eq(e).remove(),
                    n.doMath(),
                    n.update(t, "remove"),
                    (n.slides = i(n.vars.selector + ":not(.clone)", n)),
                    n.setup(),
                    n.vars.removed(n);
                }),
                v.init();
            }),
            i(window)
              .blur(function (e) {
                r = !1;
              })
              .focus(function (e) {
                r = !0;
              }),
            (i.flexslider.defaults = {
              namespace: "flex-",
              selector: ".slides > li",
              animation: "fade",
              easing: "swing",
              direction: "horizontal",
              reverse: !1,
              animationLoop: !0,
              smoothHeight: !1,
              startAt: 0,
              slideshow: !0,
              slideshowSpeed: 7e3,
              animationSpeed: 600,
              initDelay: 0,
              randomize: !1,
              fadeFirstSlide: !0,
              thumbCaptions: !1,
              pauseOnAction: !0,
              pauseOnHover: !1,
              pauseInvisible: !0,
              useCSS: !0,
              touch: !0,
              video: !1,
              controlNav: !0,
              directionNav: !0,
              prevText: "Previous",
              nextText: "Next",
              keyboard: !0,
              multipleKeyboard: !1,
              mousewheel: !1,
              pausePlay: !1,
              pauseText: "Pause",
              playText: "Play",
              controlsContainer: "",
              manualControls: "",
              customDirectionNav: "",
              sync: "",
              asNavFor: "",
              itemWidth: 0,
              itemMargin: 0,
              minItems: 1,
              maxItems: 0,
              move: 0,
              allowOneSlide: !0,
              isFirefox: !1,
              start: function () {},
              before: function () {},
              after: function () {},
              end: function () {},
              added: function () {},
              removed: function () {},
              init: function () {},
              rtl: !1,
            }),
            (i.fn.flexslider = function (e) {
              if ((void 0 === e && (e = {}), "object" == typeof e))
                return this.each(function () {
                  var t = i(this),
                    n = e.selector ? e.selector : ".slides > li",
                    r = t.find(n);
                  (1 === r.length && !1 === e.allowOneSlide) || 0 === r.length
                    ? (r.fadeIn(400), e.start && e.start(t))
                    : void 0 === t.data("flexslider") &&
                      new i.flexslider(this, e);
                });
              var t = i(this).data("flexslider");
              switch (e) {
                case "play":
                  t.play();
                  break;
                case "pause":
                  t.pause();
                  break;
                case "stop":
                  t.stop();
                  break;
                case "next":
                  t.flexAnimate(t.getTarget("next"), !0);
                  break;
                case "prev":
                case "previous":
                  t.flexAnimate(t.getTarget("prev"), !0);
                  break;
                default:
                  "number" == typeof e && t.flexAnimate(e, !0);
              }
            });
        },
        357: (e, t, n) => {
          var i,
            r,
            s = n(755);
          (r = {
            url: !1,
            callback: !1,
            target: !1,
            duration: 120,
            on: "mouseover",
            touch: !0,
            onZoomIn: !1,
            onZoomOut: !1,
            magnify: 1,
          }),
            ((i = s).zoom = function (e, t, n, r) {
              var s,
                a,
                o,
                l,
                c,
                d,
                u,
                p = i(e),
                h = p.css("position"),
                f = i(t);
              return (
                (e.style.position = /(absolute|fixed)/.test(h) ? h : "relative"),
                (e.style.overflow = "hidden"),
                (n.style.width = n.style.height = ""),
                i(n)
                  .addClass("zoomImg")
                  .css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: n.width * r,
                    height: n.height * r,
                    border: "none",
                    maxWidth: "none",
                    maxHeight: "none",
                  })
                  .appendTo(e),
                {
                  init: function () {
                    (a = p.outerWidth()),
                      (s = p.outerHeight()),
                      t === e
                        ? ((l = a), (o = s))
                        : ((l = f.outerWidth()), (o = f.outerHeight())),
                      (c = (n.width - a) / l),
                      (d = (n.height - s) / o),
                      (u = f.offset());
                  },
                  move: function (e) {
                    var t = e.pageX - u.left,
                      i = e.pageY - u.top;
                    (i = Math.max(Math.min(i, o), 0)),
                      (t = Math.max(Math.min(t, l), 0)),
                      (n.style.left = t * -c + "px"),
                      (n.style.top = i * -d + "px");
                  },
                }
              );
            }),
            (i.fn.zoom = function (e) {
              return this.each(function () {
                var t = i.extend({}, r, e || {}),
                  n = (t.target && i(t.target)[0]) || this,
                  s = this,
                  a = i(s),
                  o = document.createElement("img"),
                  l = i(o),
                  c = "mousemove.zoom",
                  d = !1,
                  u = !1;
                if (!t.url) {
                  var p = s.querySelector("img");
                  if (
                    (p &&
                      (t.url =
                        p.getAttribute("data-src") || p.currentSrc || p.src),
                    !t.url)
                  )
                    return;
                }
                a.one(
                  "zoom.destroy",
                  function (e, t) {
                    a.off(".zoom"),
                      (n.style.position = e),
                      (n.style.overflow = t),
                      (o.onload = null),
                      l.remove();
                  }.bind(this, n.style.position, n.style.overflow)
                ),
                  (o.onload = function () {
                    var e = i.zoom(n, s, o, t.magnify);
                    function r(n) {
                      e.init(),
                        e.move(n),
                        l
                          .stop()
                          .fadeTo(
                            i.support.opacity ? t.duration : 0,
                            1,
                            !!i.isFunction(t.onZoomIn) && t.onZoomIn.call(o)
                          );
                    }
                    function p() {
                      l.stop().fadeTo(
                        t.duration,
                        0,
                        !!i.isFunction(t.onZoomOut) && t.onZoomOut.call(o)
                      );
                    }
                    "grab" === t.on
                      ? a.on("mousedown.zoom", function (t) {
                          1 === t.which &&
                            (i(document).one("mouseup.zoom", function () {
                              p(), i(document).off(c, e.move);
                            }),
                            r(t),
                            i(document).on(c, e.move),
                            t.preventDefault());
                        })
                      : "click" === t.on
                      ? a.on("click.zoom", function (t) {
                          return d
                            ? void 0
                            : ((d = !0),
                              r(t),
                              i(document).on(c, e.move),
                              i(document).one("click.zoom", function () {
                                p(), (d = !1), i(document).off(c, e.move);
                              }),
                              !1);
                        })
                      : "toggle" === t.on
                      ? a.on("click.zoom", function (e) {
                          d ? p() : r(e), (d = !d);
                        })
                      : "mouseover" === t.on &&
                        (e.init(),
                        a
                          .on("mouseenter.zoom", r)
                          .on("mouseleave.zoom", p)
                          .on(c, e.move)),
                      t.touch &&
                        a
                          .on("touchstart.zoom", function (e) {
                            e.preventDefault(),
                              u
                                ? ((u = !1), p())
                                : ((u = !0),
                                  r(
                                    e.originalEvent.touches[0] ||
                                      e.originalEvent.changedTouches[0]
                                  ));
                          })
                          .on("touchmove.zoom", function (t) {
                            t.preventDefault(),
                              e.move(
                                t.originalEvent.touches[0] ||
                                  t.originalEvent.changedTouches[0]
                              );
                          })
                          .on("touchend.zoom", function (e) {
                            e.preventDefault(), u && ((u = !1), p());
                          }),
                      i.isFunction(t.callback) && t.callback.call(o);
                  }),
                  o.setAttribute("role", "presentation"),
                  (o.alt = ""),
                  (o.src = t.url);
              });
            }),
            (i.fn.zoom.defaults = r);
        },
        755: function (e, t) {
          var n;
          !(function (t, n) {
            "use strict";
            "object" == typeof e.exports
              ? (e.exports = t.document
                  ? n(t, !0)
                  : function (e) {
                      if (!e.document)
                        throw new Error(
                          "jQuery requires a window with a document"
                        );
                      return n(e);
                    })
              : n(t);
          })("undefined" != typeof window ? window : this, function (i, r) {
            "use strict";
            var s = [],
              a = Object.getPrototypeOf,
              o = s.slice,
              l = s.flat
                ? function (e) {
                    return s.flat.call(e);
                  }
                : function (e) {
                    return s.concat.apply([], e);
                  },
              c = s.push,
              d = s.indexOf,
              u = {},
              p = u.toString,
              h = u.hasOwnProperty,
              f = h.toString,
              m = f.call(Object),
              v = {},
              y = function (e) {
                return (
                  "function" == typeof e &&
                  "number" != typeof e.nodeType &&
                  "function" != typeof e.item
                );
              },
              g = function (e) {
                return null != e && e === e.window;
              },
              x = i.document,
              b = { type: !0, src: !0, nonce: !0, noModule: !0 };
            function w(e, t, n) {
              var i,
                r,
                s = (n = n || x).createElement("script");
              if (((s.text = e), t))
                for (i in b)
                  (r = t[i] || (t.getAttribute && t.getAttribute(i))) &&
                    s.setAttribute(i, r);
              n.head.appendChild(s).parentNode.removeChild(s);
            }
            function S(e) {
              return null == e
                ? e + ""
                : "object" == typeof e || "function" == typeof e
                ? u[p.call(e)] || "object"
                : typeof e;
            }
            var C = "3.6.0",
              T = function (e, t) {
                return new T.fn.init(e, t);
              };
            function _(e) {
              var t = !!e && "length" in e && e.length,
                n = S(e);
              return (
                !y(e) &&
                !g(e) &&
                ("array" === n ||
                  0 === t ||
                  ("number" == typeof t && t > 0 && t - 1 in e))
              );
            }
            (T.fn = T.prototype =
              {
                jquery: C,
                constructor: T,
                length: 0,
                toArray: function () {
                  return o.call(this);
                },
                get: function (e) {
                  return null == e
                    ? o.call(this)
                    : e < 0
                    ? this[e + this.length]
                    : this[e];
                },
                pushStack: function (e) {
                  var t = T.merge(this.constructor(), e);
                  return (t.prevObject = this), t;
                },
                each: function (e) {
                  return T.each(this, e);
                },
                map: function (e) {
                  return this.pushStack(
                    T.map(this, function (t, n) {
                      return e.call(t, n, t);
                    })
                  );
                },
                slice: function () {
                  return this.pushStack(o.apply(this, arguments));
                },
                first: function () {
                  return this.eq(0);
                },
                last: function () {
                  return this.eq(-1);
                },
                even: function () {
                  return this.pushStack(
                    T.grep(this, function (e, t) {
                      return (t + 1) % 2;
                    })
                  );
                },
                odd: function () {
                  return this.pushStack(
                    T.grep(this, function (e, t) {
                      return t % 2;
                    })
                  );
                },
                eq: function (e) {
                  var t = this.length,
                    n = +e + (e < 0 ? t : 0);
                  return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
                },
                end: function () {
                  return this.prevObject || this.constructor();
                },
                push: c,
                sort: s.sort,
                splice: s.splice,
              }),
              (T.extend = T.fn.extend =
                function () {
                  var e,
                    t,
                    n,
                    i,
                    r,
                    s,
                    a = arguments[0] || {},
                    o = 1,
                    l = arguments.length,
                    c = !1;
                  for (
                    "boolean" == typeof a &&
                      ((c = a), (a = arguments[o] || {}), o++),
                      "object" == typeof a || y(a) || (a = {}),
                      o === l && ((a = this), o--);
                    o < l;
                    o++
                  )
                    if (null != (e = arguments[o]))
                      for (t in e)
                        (i = e[t]),
                          "__proto__" !== t &&
                            a !== i &&
                            (c &&
                            i &&
                            (T.isPlainObject(i) || (r = Array.isArray(i)))
                              ? ((n = a[t]),
                                (s =
                                  r && !Array.isArray(n)
                                    ? []
                                    : r || T.isPlainObject(n)
                                    ? n
                                    : {}),
                                (r = !1),
                                (a[t] = T.extend(c, s, i)))
                              : void 0 !== i && (a[t] = i));
                  return a;
                }),
              T.extend({
                expando: "jQuery" + (C + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (e) {
                  throw new Error(e);
                },
                noop: function () {},
                isPlainObject: function (e) {
                  var t, n;
                  return (
                    !(!e || "[object Object]" !== p.call(e)) &&
                    (!(t = a(e)) ||
                      ("function" ==
                        typeof (n = h.call(t, "constructor") && t.constructor) &&
                        f.call(n) === m))
                  );
                },
                isEmptyObject: function (e) {
                  var t;
                  for (t in e) return !1;
                  return !0;
                },
                globalEval: function (e, t, n) {
                  w(e, { nonce: t && t.nonce }, n);
                },
                each: function (e, t) {
                  var n,
                    i = 0;
                  if (_(e))
                    for (
                      n = e.length;
                      i < n && !1 !== t.call(e[i], i, e[i]);
                      i++
                    );
                  else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                  return e;
                },
                makeArray: function (e, t) {
                  var n = t || [];
                  return (
                    null != e &&
                      (_(Object(e))
                        ? T.merge(n, "string" == typeof e ? [e] : e)
                        : c.call(n, e)),
                    n
                  );
                },
                inArray: function (e, t, n) {
                  return null == t ? -1 : d.call(t, e, n);
                },
                merge: function (e, t) {
                  for (var n = +t.length, i = 0, r = e.length; i < n; i++)
                    e[r++] = t[i];
                  return (e.length = r), e;
                },
                grep: function (e, t, n) {
                  for (var i = [], r = 0, s = e.length, a = !n; r < s; r++)
                    !t(e[r], r) !== a && i.push(e[r]);
                  return i;
                },
                map: function (e, t, n) {
                  var i,
                    r,
                    s = 0,
                    a = [];
                  if (_(e))
                    for (i = e.length; s < i; s++)
                      null != (r = t(e[s], s, n)) && a.push(r);
                  else for (s in e) null != (r = t(e[s], s, n)) && a.push(r);
                  return l(a);
                },
                guid: 1,
                support: v,
              }),
              "function" == typeof Symbol &&
                (T.fn[Symbol.iterator] = s[Symbol.iterator]),
              T.each(
                "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
                  " "
                ),
                function (e, t) {
                  u["[object " + t + "]"] = t.toLowerCase();
                }
              );
            var E = (function (e) {
              var t,
                n,
                i,
                r,
                s,
                a,
                o,
                l,
                c,
                d,
                u,
                p,
                h,
                f,
                m,
                v,
                y,
                g,
                x,
                b = "sizzle" + 1 * new Date(),
                w = e.document,
                S = 0,
                C = 0,
                T = le(),
                _ = le(),
                E = le(),
                k = le(),
                $ = function (e, t) {
                  return e === t && (u = !0), 0;
                },
                M = {}.hasOwnProperty,
                j = [],
                A = j.pop,
                L = j.push,
                I = j.push,
                O = j.slice,
                P = function (e, t) {
                  for (var n = 0, i = e.length; n < i; n++)
                    if (e[n] === t) return n;
                  return -1;
                },
                D =
                  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                z = "[\\x20\\t\\r\\n\\f]",
                N =
                  "(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                q =
                  "\\[[\\x20\\t\\r\\n\\f]*(" +
                  N +
                  ")(?:" +
                  z +
                  "*([*^$|!~]?=)" +
                  z +
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                  N +
                  "))|)" +
                  z +
                  "*\\]",
                H =
                  ":(" +
                  N +
                  ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
                  q +
                  ")*)|.*)\\)|)",
                F = new RegExp(z + "+", "g"),
                B = new RegExp(
                  "^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$",
                  "g"
                ),
                W = new RegExp("^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*"),
                R = new RegExp(
                  "^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*"
                ),
                V = new RegExp(z + "|>"),
                G = new RegExp(H),
                X = new RegExp("^" + N + "$"),
                Y = {
                  ID: new RegExp("^#(" + N + ")"),
                  CLASS: new RegExp("^\\.(" + N + ")"),
                  TAG: new RegExp("^(" + N + "|[*])"),
                  ATTR: new RegExp("^" + q),
                  PSEUDO: new RegExp("^" + H),
                  CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)",
                    "i"
                  ),
                  bool: new RegExp("^(?:" + D + ")$", "i"),
                  needsContext: new RegExp(
                    "^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)",
                    "i"
                  ),
                },
                U = /HTML$/i,
                K = /^(?:input|select|textarea|button)$/i,
                Z = /^h\d$/i,
                Q = /^[^{]+\{\s*\[native \w/,
                J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                ee = /[+~]/,
                te = new RegExp(
                  "\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])",
                  "g"
                ),
                ne = function (e, t) {
                  var n = "0x" + e.slice(1) - 65536;
                  return (
                    t ||
                    (n < 0
                      ? String.fromCharCode(n + 65536)
                      : String.fromCharCode(
                          (n >> 10) | 55296,
                          (1023 & n) | 56320
                        ))
                  );
                },
                ie = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                re = function (e, t) {
                  return t
                    ? "\0" === e
                      ? "�"
                      : e.slice(0, -1) +
                        "\\" +
                        e.charCodeAt(e.length - 1).toString(16) +
                        " "
                    : "\\" + e;
                },
                se = function () {
                  p();
                },
                ae = be(
                  function (e) {
                    return (
                      !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                    );
                  },
                  { dir: "parentNode", next: "legend" }
                );
              try {
                I.apply((j = O.call(w.childNodes)), w.childNodes),
                  j[w.childNodes.length].nodeType;
              } catch (e) {
                I = {
                  apply: j.length
                    ? function (e, t) {
                        L.apply(e, O.call(t));
                      }
                    : function (e, t) {
                        for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                        e.length = n - 1;
                      },
                };
              }
              function oe(e, t, i, r) {
                var s,
                  o,
                  c,
                  d,
                  u,
                  f,
                  y,
                  g = t && t.ownerDocument,
                  w = t ? t.nodeType : 9;
                if (
                  ((i = i || []),
                  "string" != typeof e || !e || (1 !== w && 9 !== w && 11 !== w))
                )
                  return i;
                if (!r && (p(t), (t = t || h), m)) {
                  if (11 !== w && (u = J.exec(e)))
                    if ((s = u[1])) {
                      if (9 === w) {
                        if (!(c = t.getElementById(s))) return i;
                        if (c.id === s) return i.push(c), i;
                      } else if (
                        g &&
                        (c = g.getElementById(s)) &&
                        x(t, c) &&
                        c.id === s
                      )
                        return i.push(c), i;
                    } else {
                      if (u[2]) return I.apply(i, t.getElementsByTagName(e)), i;
                      if (
                        (s = u[3]) &&
                        n.getElementsByClassName &&
                        t.getElementsByClassName
                      )
                        return I.apply(i, t.getElementsByClassName(s)), i;
                    }
                  if (
                    n.qsa &&
                    !k[e + " "] &&
                    (!v || !v.test(e)) &&
                    (1 !== w || "object" !== t.nodeName.toLowerCase())
                  ) {
                    if (((y = e), (g = t), 1 === w && (V.test(e) || R.test(e)))) {
                      for (
                        ((g = (ee.test(e) && ye(t.parentNode)) || t) === t &&
                          n.scope) ||
                          ((d = t.getAttribute("id"))
                            ? (d = d.replace(ie, re))
                            : t.setAttribute("id", (d = b))),
                          o = (f = a(e)).length;
                        o--;
  
                      )
                        f[o] = (d ? "#" + d : ":scope") + " " + xe(f[o]);
                      y = f.join(",");
                    }
                    try {
                      return I.apply(i, g.querySelectorAll(y)), i;
                    } catch (t) {
                      k(e, !0);
                    } finally {
                      d === b && t.removeAttribute("id");
                    }
                  }
                }
                return l(e.replace(B, "$1"), t, i, r);
              }
              function le() {
                var e = [];
                return function t(n, r) {
                  return (
                    e.push(n + " ") > i.cacheLength && delete t[e.shift()],
                    (t[n + " "] = r)
                  );
                };
              }
              function ce(e) {
                return (e[b] = !0), e;
              }
              function de(e) {
                var t = h.createElement("fieldset");
                try {
                  return !!e(t);
                } catch (e) {
                  return !1;
                } finally {
                  t.parentNode && t.parentNode.removeChild(t), (t = null);
                }
              }
              function ue(e, t) {
                for (var n = e.split("|"), r = n.length; r--; )
                  i.attrHandle[n[r]] = t;
              }
              function pe(e, t) {
                var n = t && e,
                  i =
                    n &&
                    1 === e.nodeType &&
                    1 === t.nodeType &&
                    e.sourceIndex - t.sourceIndex;
                if (i) return i;
                if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
                return e ? 1 : -1;
              }
              function he(e) {
                return function (t) {
                  return "input" === t.nodeName.toLowerCase() && t.type === e;
                };
              }
              function fe(e) {
                return function (t) {
                  var n = t.nodeName.toLowerCase();
                  return ("input" === n || "button" === n) && t.type === e;
                };
              }
              function me(e) {
                return function (t) {
                  return "form" in t
                    ? t.parentNode && !1 === t.disabled
                      ? "label" in t
                        ? "label" in t.parentNode
                          ? t.parentNode.disabled === e
                          : t.disabled === e
                        : t.isDisabled === e ||
                          (t.isDisabled !== !e && ae(t) === e)
                      : t.disabled === e
                    : "label" in t && t.disabled === e;
                };
              }
              function ve(e) {
                return ce(function (t) {
                  return (
                    (t = +t),
                    ce(function (n, i) {
                      for (var r, s = e([], n.length, t), a = s.length; a--; )
                        n[(r = s[a])] && (n[r] = !(i[r] = n[r]));
                    })
                  );
                });
              }
              function ye(e) {
                return e && void 0 !== e.getElementsByTagName && e;
              }
              for (t in ((n = oe.support = {}),
              (s = oe.isXML =
                function (e) {
                  var t = e && e.namespaceURI,
                    n = e && (e.ownerDocument || e).documentElement;
                  return !U.test(t || (n && n.nodeName) || "HTML");
                }),
              (p = oe.setDocument =
                function (e) {
                  var t,
                    r,
                    a = e ? e.ownerDocument || e : w;
                  return a != h && 9 === a.nodeType && a.documentElement
                    ? ((f = (h = a).documentElement),
                      (m = !s(h)),
                      w != h &&
                        (r = h.defaultView) &&
                        r.top !== r &&
                        (r.addEventListener
                          ? r.addEventListener("unload", se, !1)
                          : r.attachEvent && r.attachEvent("onunload", se)),
                      (n.scope = de(function (e) {
                        return (
                          f.appendChild(e).appendChild(h.createElement("div")),
                          void 0 !== e.querySelectorAll &&
                            !e.querySelectorAll(":scope fieldset div").length
                        );
                      })),
                      (n.attributes = de(function (e) {
                        return (e.className = "i"), !e.getAttribute("className");
                      })),
                      (n.getElementsByTagName = de(function (e) {
                        return (
                          e.appendChild(h.createComment("")),
                          !e.getElementsByTagName("*").length
                        );
                      })),
                      (n.getElementsByClassName = Q.test(
                        h.getElementsByClassName
                      )),
                      (n.getById = de(function (e) {
                        return (
                          (f.appendChild(e).id = b),
                          !h.getElementsByName || !h.getElementsByName(b).length
                        );
                      })),
                      n.getById
                        ? ((i.filter.ID = function (e) {
                            var t = e.replace(te, ne);
                            return function (e) {
                              return e.getAttribute("id") === t;
                            };
                          }),
                          (i.find.ID = function (e, t) {
                            if (void 0 !== t.getElementById && m) {
                              var n = t.getElementById(e);
                              return n ? [n] : [];
                            }
                          }))
                        : ((i.filter.ID = function (e) {
                            var t = e.replace(te, ne);
                            return function (e) {
                              var n =
                                void 0 !== e.getAttributeNode &&
                                e.getAttributeNode("id");
                              return n && n.value === t;
                            };
                          }),
                          (i.find.ID = function (e, t) {
                            if (void 0 !== t.getElementById && m) {
                              var n,
                                i,
                                r,
                                s = t.getElementById(e);
                              if (s) {
                                if (
                                  (n = s.getAttributeNode("id")) &&
                                  n.value === e
                                )
                                  return [s];
                                for (
                                  r = t.getElementsByName(e), i = 0;
                                  (s = r[i++]);
  
                                )
                                  if (
                                    (n = s.getAttributeNode("id")) &&
                                    n.value === e
                                  )
                                    return [s];
                              }
                              return [];
                            }
                          })),
                      (i.find.TAG = n.getElementsByTagName
                        ? function (e, t) {
                            return void 0 !== t.getElementsByTagName
                              ? t.getElementsByTagName(e)
                              : n.qsa
                              ? t.querySelectorAll(e)
                              : void 0;
                          }
                        : function (e, t) {
                            var n,
                              i = [],
                              r = 0,
                              s = t.getElementsByTagName(e);
                            if ("*" === e) {
                              for (; (n = s[r++]); )
                                1 === n.nodeType && i.push(n);
                              return i;
                            }
                            return s;
                          }),
                      (i.find.CLASS =
                        n.getElementsByClassName &&
                        function (e, t) {
                          if (void 0 !== t.getElementsByClassName && m)
                            return t.getElementsByClassName(e);
                        }),
                      (y = []),
                      (v = []),
                      (n.qsa = Q.test(h.querySelectorAll)) &&
                        (de(function (e) {
                          var t;
                          (f.appendChild(e).innerHTML =
                            "<a id='" +
                            b +
                            "'></a><select id='" +
                            b +
                            "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                            e.querySelectorAll("[msallowcapture^='']").length &&
                              v.push("[*^$]=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"),
                            e.querySelectorAll("[selected]").length ||
                              v.push(
                                "\\[[\\x20\\t\\r\\n\\f]*(?:value|" + D + ")"
                              ),
                            e.querySelectorAll("[id~=" + b + "-]").length ||
                              v.push("~="),
                            (t = h.createElement("input")).setAttribute(
                              "name",
                              ""
                            ),
                            e.appendChild(t),
                            e.querySelectorAll("[name='']").length ||
                              v.push(
                                "\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:''|\"\")"
                              ),
                            e.querySelectorAll(":checked").length ||
                              v.push(":checked"),
                            e.querySelectorAll("a#" + b + "+*").length ||
                              v.push(".#.+[+~]"),
                            e.querySelectorAll("\\\f"),
                            v.push("[\\r\\n\\f]");
                        }),
                        de(function (e) {
                          e.innerHTML =
                            "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                          var t = h.createElement("input");
                          t.setAttribute("type", "hidden"),
                            e.appendChild(t).setAttribute("name", "D"),
                            e.querySelectorAll("[name=d]").length &&
                              v.push("name[\\x20\\t\\r\\n\\f]*[*^$|!~]?="),
                            2 !== e.querySelectorAll(":enabled").length &&
                              v.push(":enabled", ":disabled"),
                            (f.appendChild(e).disabled = !0),
                            2 !== e.querySelectorAll(":disabled").length &&
                              v.push(":enabled", ":disabled"),
                            e.querySelectorAll("*,:x"),
                            v.push(",.*:");
                        })),
                      (n.matchesSelector = Q.test(
                        (g =
                          f.matches ||
                          f.webkitMatchesSelector ||
                          f.mozMatchesSelector ||
                          f.oMatchesSelector ||
                          f.msMatchesSelector)
                      )) &&
                        de(function (e) {
                          (n.disconnectedMatch = g.call(e, "*")),
                            g.call(e, "[s!='']:x"),
                            y.push("!=", H);
                        }),
                      (v = v.length && new RegExp(v.join("|"))),
                      (y = y.length && new RegExp(y.join("|"))),
                      (t = Q.test(f.compareDocumentPosition)),
                      (x =
                        t || Q.test(f.contains)
                          ? function (e, t) {
                              var n = 9 === e.nodeType ? e.documentElement : e,
                                i = t && t.parentNode;
                              return (
                                e === i ||
                                !(
                                  !i ||
                                  1 !== i.nodeType ||
                                  !(n.contains
                                    ? n.contains(i)
                                    : e.compareDocumentPosition &&
                                      16 & e.compareDocumentPosition(i))
                                )
                              );
                            }
                          : function (e, t) {
                              if (t)
                                for (; (t = t.parentNode); )
                                  if (t === e) return !0;
                              return !1;
                            }),
                      ($ = t
                        ? function (e, t) {
                            if (e === t) return (u = !0), 0;
                            var i =
                              !e.compareDocumentPosition -
                              !t.compareDocumentPosition;
                            return (
                              i ||
                              (1 &
                                (i =
                                  (e.ownerDocument || e) == (t.ownerDocument || t)
                                    ? e.compareDocumentPosition(t)
                                    : 1) ||
                              (!n.sortDetached &&
                                t.compareDocumentPosition(e) === i)
                                ? e == h || (e.ownerDocument == w && x(w, e))
                                  ? -1
                                  : t == h || (t.ownerDocument == w && x(w, t))
                                  ? 1
                                  : d
                                  ? P(d, e) - P(d, t)
                                  : 0
                                : 4 & i
                                ? -1
                                : 1)
                            );
                          }
                        : function (e, t) {
                            if (e === t) return (u = !0), 0;
                            var n,
                              i = 0,
                              r = e.parentNode,
                              s = t.parentNode,
                              a = [e],
                              o = [t];
                            if (!r || !s)
                              return e == h
                                ? -1
                                : t == h
                                ? 1
                                : r
                                ? -1
                                : s
                                ? 1
                                : d
                                ? P(d, e) - P(d, t)
                                : 0;
                            if (r === s) return pe(e, t);
                            for (n = e; (n = n.parentNode); ) a.unshift(n);
                            for (n = t; (n = n.parentNode); ) o.unshift(n);
                            for (; a[i] === o[i]; ) i++;
                            return i
                              ? pe(a[i], o[i])
                              : a[i] == w
                              ? -1
                              : o[i] == w
                              ? 1
                              : 0;
                          }),
                      h)
                    : h;
                }),
              (oe.matches = function (e, t) {
                return oe(e, null, null, t);
              }),
              (oe.matchesSelector = function (e, t) {
                if (
                  (p(e),
                  n.matchesSelector &&
                    m &&
                    !k[t + " "] &&
                    (!y || !y.test(t)) &&
                    (!v || !v.test(t)))
                )
                  try {
                    var i = g.call(e, t);
                    if (
                      i ||
                      n.disconnectedMatch ||
                      (e.document && 11 !== e.document.nodeType)
                    )
                      return i;
                  } catch (e) {
                    k(t, !0);
                  }
                return oe(t, h, null, [e]).length > 0;
              }),
              (oe.contains = function (e, t) {
                return (e.ownerDocument || e) != h && p(e), x(e, t);
              }),
              (oe.attr = function (e, t) {
                (e.ownerDocument || e) != h && p(e);
                var r = i.attrHandle[t.toLowerCase()],
                  s =
                    r && M.call(i.attrHandle, t.toLowerCase())
                      ? r(e, t, !m)
                      : void 0;
                return void 0 !== s
                  ? s
                  : n.attributes || !m
                  ? e.getAttribute(t)
                  : (s = e.getAttributeNode(t)) && s.specified
                  ? s.value
                  : null;
              }),
              (oe.escape = function (e) {
                return (e + "").replace(ie, re);
              }),
              (oe.error = function (e) {
                throw new Error("Syntax error, unrecognized expression: " + e);
              }),
              (oe.uniqueSort = function (e) {
                var t,
                  i = [],
                  r = 0,
                  s = 0;
                if (
                  ((u = !n.detectDuplicates),
                  (d = !n.sortStable && e.slice(0)),
                  e.sort($),
                  u)
                ) {
                  for (; (t = e[s++]); ) t === e[s] && (r = i.push(s));
                  for (; r--; ) e.splice(i[r], 1);
                }
                return (d = null), e;
              }),
              (r = oe.getText =
                function (e) {
                  var t,
                    n = "",
                    i = 0,
                    s = e.nodeType;
                  if (s) {
                    if (1 === s || 9 === s || 11 === s) {
                      if ("string" == typeof e.textContent) return e.textContent;
                      for (e = e.firstChild; e; e = e.nextSibling) n += r(e);
                    } else if (3 === s || 4 === s) return e.nodeValue;
                  } else for (; (t = e[i++]); ) n += r(t);
                  return n;
                }),
              (i = oe.selectors =
                {
                  cacheLength: 50,
                  createPseudo: ce,
                  match: Y,
                  attrHandle: {},
                  find: {},
                  relative: {
                    ">": { dir: "parentNode", first: !0 },
                    " ": { dir: "parentNode" },
                    "+": { dir: "previousSibling", first: !0 },
                    "~": { dir: "previousSibling" },
                  },
                  preFilter: {
                    ATTR: function (e) {
                      return (
                        (e[1] = e[1].replace(te, ne)),
                        (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
                        "~=" === e[2] && (e[3] = " " + e[3] + " "),
                        e.slice(0, 4)
                      );
                    },
                    CHILD: function (e) {
                      return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3)
                          ? (e[3] || oe.error(e[0]),
                            (e[4] = +(e[4]
                              ? e[5] + (e[6] || 1)
                              : 2 * ("even" === e[3] || "odd" === e[3]))),
                            (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                          : e[3] && oe.error(e[0]),
                        e
                      );
                    },
                    PSEUDO: function (e) {
                      var t,
                        n = !e[6] && e[2];
                      return Y.CHILD.test(e[0])
                        ? null
                        : (e[3]
                            ? (e[2] = e[4] || e[5] || "")
                            : n &&
                              G.test(n) &&
                              (t = a(n, !0)) &&
                              (t = n.indexOf(")", n.length - t) - n.length) &&
                              ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                          e.slice(0, 3));
                    },
                  },
                  filter: {
                    TAG: function (e) {
                      var t = e.replace(te, ne).toLowerCase();
                      return "*" === e
                        ? function () {
                            return !0;
                          }
                        : function (e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                    },
                    CLASS: function (e) {
                      var t = T[e + " "];
                      return (
                        t ||
                        ((t = new RegExp(
                          "(^|[\\x20\\t\\r\\n\\f])" + e + "(" + z + "|$)"
                        )) &&
                          T(e, function (e) {
                            return t.test(
                              ("string" == typeof e.className && e.className) ||
                                (void 0 !== e.getAttribute &&
                                  e.getAttribute("class")) ||
                                ""
                            );
                          }))
                      );
                    },
                    ATTR: function (e, t, n) {
                      return function (i) {
                        var r = oe.attr(i, e);
                        return null == r
                          ? "!=" === t
                          : !t ||
                              ((r += ""),
                              "=" === t
                                ? r === n
                                : "!=" === t
                                ? r !== n
                                : "^=" === t
                                ? n && 0 === r.indexOf(n)
                                : "*=" === t
                                ? n && r.indexOf(n) > -1
                                : "$=" === t
                                ? n && r.slice(-n.length) === n
                                : "~=" === t
                                ? (" " + r.replace(F, " ") + " ").indexOf(n) > -1
                                : "|=" === t &&
                                  (r === n ||
                                    r.slice(0, n.length + 1) === n + "-"));
                      };
                    },
                    CHILD: function (e, t, n, i, r) {
                      var s = "nth" !== e.slice(0, 3),
                        a = "last" !== e.slice(-4),
                        o = "of-type" === t;
                      return 1 === i && 0 === r
                        ? function (e) {
                            return !!e.parentNode;
                          }
                        : function (t, n, l) {
                            var c,
                              d,
                              u,
                              p,
                              h,
                              f,
                              m = s !== a ? "nextSibling" : "previousSibling",
                              v = t.parentNode,
                              y = o && t.nodeName.toLowerCase(),
                              g = !l && !o,
                              x = !1;
                            if (v) {
                              if (s) {
                                for (; m; ) {
                                  for (p = t; (p = p[m]); )
                                    if (
                                      o
                                        ? p.nodeName.toLowerCase() === y
                                        : 1 === p.nodeType
                                    )
                                      return !1;
                                  f = m = "only" === e && !f && "nextSibling";
                                }
                                return !0;
                              }
                              if (
                                ((f = [a ? v.firstChild : v.lastChild]), a && g)
                              ) {
                                for (
                                  x =
                                    (h =
                                      (c =
                                        (d =
                                          (u = (p = v)[b] || (p[b] = {}))[
                                            p.uniqueID
                                          ] || (u[p.uniqueID] = {}))[e] ||
                                        [])[0] === S && c[1]) && c[2],
                                    p = h && v.childNodes[h];
                                  (p =
                                    (++h && p && p[m]) || (x = h = 0) || f.pop());
  
                                )
                                  if (1 === p.nodeType && ++x && p === t) {
                                    d[e] = [S, h, x];
                                    break;
                                  }
                              } else if (
                                (g &&
                                  (x = h =
                                    (c =
                                      (d =
                                        (u = (p = t)[b] || (p[b] = {}))[
                                          p.uniqueID
                                        ] || (u[p.uniqueID] = {}))[e] ||
                                      [])[0] === S && c[1]),
                                !1 === x)
                              )
                                for (
                                  ;
                                  (p =
                                    (++h && p && p[m]) ||
                                    (x = h = 0) ||
                                    f.pop()) &&
                                  ((o
                                    ? p.nodeName.toLowerCase() !== y
                                    : 1 !== p.nodeType) ||
                                    !++x ||
                                    (g &&
                                      ((d =
                                        (u = p[b] || (p[b] = {}))[p.uniqueID] ||
                                        (u[p.uniqueID] = {}))[e] = [S, x]),
                                    p !== t));
  
                                );
                              return (x -= r) === i || (x % i == 0 && x / i >= 0);
                            }
                          };
                    },
                    PSEUDO: function (e, t) {
                      var n,
                        r =
                          i.pseudos[e] ||
                          i.setFilters[e.toLowerCase()] ||
                          oe.error("unsupported pseudo: " + e);
                      return r[b]
                        ? r(t)
                        : r.length > 1
                        ? ((n = [e, e, "", t]),
                          i.setFilters.hasOwnProperty(e.toLowerCase())
                            ? ce(function (e, n) {
                                for (var i, s = r(e, t), a = s.length; a--; )
                                  e[(i = P(e, s[a]))] = !(n[i] = s[a]);
                              })
                            : function (e) {
                                return r(e, 0, n);
                              })
                        : r;
                    },
                  },
                  pseudos: {
                    not: ce(function (e) {
                      var t = [],
                        n = [],
                        i = o(e.replace(B, "$1"));
                      return i[b]
                        ? ce(function (e, t, n, r) {
                            for (
                              var s, a = i(e, null, r, []), o = e.length;
                              o--;
  
                            )
                              (s = a[o]) && (e[o] = !(t[o] = s));
                          })
                        : function (e, r, s) {
                            return (
                              (t[0] = e),
                              i(t, null, s, n),
                              (t[0] = null),
                              !n.pop()
                            );
                          };
                    }),
                    has: ce(function (e) {
                      return function (t) {
                        return oe(e, t).length > 0;
                      };
                    }),
                    contains: ce(function (e) {
                      return (
                        (e = e.replace(te, ne)),
                        function (t) {
                          return (t.textContent || r(t)).indexOf(e) > -1;
                        }
                      );
                    }),
                    lang: ce(function (e) {
                      return (
                        X.test(e || "") || oe.error("unsupported lang: " + e),
                        (e = e.replace(te, ne).toLowerCase()),
                        function (t) {
                          var n;
                          do {
                            if (
                              (n = m
                                ? t.lang
                                : t.getAttribute("xml:lang") ||
                                  t.getAttribute("lang"))
                            )
                              return (
                                (n = n.toLowerCase()) === e ||
                                0 === n.indexOf(e + "-")
                              );
                          } while ((t = t.parentNode) && 1 === t.nodeType);
                          return !1;
                        }
                      );
                    }),
                    target: function (t) {
                      var n = e.location && e.location.hash;
                      return n && n.slice(1) === t.id;
                    },
                    root: function (e) {
                      return e === f;
                    },
                    focus: function (e) {
                      return (
                        e === h.activeElement &&
                        (!h.hasFocus || h.hasFocus()) &&
                        !!(e.type || e.href || ~e.tabIndex)
                      );
                    },
                    enabled: me(!1),
                    disabled: me(!0),
                    checked: function (e) {
                      var t = e.nodeName.toLowerCase();
                      return (
                        ("input" === t && !!e.checked) ||
                        ("option" === t && !!e.selected)
                      );
                    },
                    selected: function (e) {
                      return (
                        e.parentNode && e.parentNode.selectedIndex,
                        !0 === e.selected
                      );
                    },
                    empty: function (e) {
                      for (e = e.firstChild; e; e = e.nextSibling)
                        if (e.nodeType < 6) return !1;
                      return !0;
                    },
                    parent: function (e) {
                      return !i.pseudos.empty(e);
                    },
                    header: function (e) {
                      return Z.test(e.nodeName);
                    },
                    input: function (e) {
                      return K.test(e.nodeName);
                    },
                    button: function (e) {
                      var t = e.nodeName.toLowerCase();
                      return (
                        ("input" === t && "button" === e.type) || "button" === t
                      );
                    },
                    text: function (e) {
                      var t;
                      return (
                        "input" === e.nodeName.toLowerCase() &&
                        "text" === e.type &&
                        (null == (t = e.getAttribute("type")) ||
                          "text" === t.toLowerCase())
                      );
                    },
                    first: ve(function () {
                      return [0];
                    }),
                    last: ve(function (e, t) {
                      return [t - 1];
                    }),
                    eq: ve(function (e, t, n) {
                      return [n < 0 ? n + t : n];
                    }),
                    even: ve(function (e, t) {
                      for (var n = 0; n < t; n += 2) e.push(n);
                      return e;
                    }),
                    odd: ve(function (e, t) {
                      for (var n = 1; n < t; n += 2) e.push(n);
                      return e;
                    }),
                    lt: ve(function (e, t, n) {
                      for (var i = n < 0 ? n + t : n > t ? t : n; --i >= 0; )
                        e.push(i);
                      return e;
                    }),
                    gt: ve(function (e, t, n) {
                      for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                      return e;
                    }),
                  },
                }),
              (i.pseudos.nth = i.pseudos.eq),
              { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                i.pseudos[t] = he(t);
              for (t in { submit: !0, reset: !0 }) i.pseudos[t] = fe(t);
              function ge() {}
              function xe(e) {
                for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
                return i;
              }
              function be(e, t, n) {
                var i = t.dir,
                  r = t.next,
                  s = r || i,
                  a = n && "parentNode" === s,
                  o = C++;
                return t.first
                  ? function (t, n, r) {
                      for (; (t = t[i]); )
                        if (1 === t.nodeType || a) return e(t, n, r);
                      return !1;
                    }
                  : function (t, n, l) {
                      var c,
                        d,
                        u,
                        p = [S, o];
                      if (l) {
                        for (; (t = t[i]); )
                          if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
                      } else
                        for (; (t = t[i]); )
                          if (1 === t.nodeType || a)
                            if (
                              ((d =
                                (u = t[b] || (t[b] = {}))[t.uniqueID] ||
                                (u[t.uniqueID] = {})),
                              r && r === t.nodeName.toLowerCase())
                            )
                              t = t[i] || t;
                            else {
                              if ((c = d[s]) && c[0] === S && c[1] === o)
                                return (p[2] = c[2]);
                              if (((d[s] = p), (p[2] = e(t, n, l)))) return !0;
                            }
                      return !1;
                    };
              }
              function we(e) {
                return e.length > 1
                  ? function (t, n, i) {
                      for (var r = e.length; r--; ) if (!e[r](t, n, i)) return !1;
                      return !0;
                    }
                  : e[0];
              }
              function Se(e, t, n, i, r) {
                for (
                  var s, a = [], o = 0, l = e.length, c = null != t;
                  o < l;
                  o++
                )
                  (s = e[o]) &&
                    ((n && !n(s, i, r)) || (a.push(s), c && t.push(o)));
                return a;
              }
              function Ce(e, t, n, i, r, s) {
                return (
                  i && !i[b] && (i = Ce(i)),
                  r && !r[b] && (r = Ce(r, s)),
                  ce(function (s, a, o, l) {
                    var c,
                      d,
                      u,
                      p = [],
                      h = [],
                      f = a.length,
                      m =
                        s ||
                        (function (e, t, n) {
                          for (var i = 0, r = t.length; i < r; i++)
                            oe(e, t[i], n);
                          return n;
                        })(t || "*", o.nodeType ? [o] : o, []),
                      v = !e || (!s && t) ? m : Se(m, p, e, o, l),
                      y = n ? (r || (s ? e : f || i) ? [] : a) : v;
                    if ((n && n(v, y, o, l), i))
                      for (c = Se(y, h), i(c, [], o, l), d = c.length; d--; )
                        (u = c[d]) && (y[h[d]] = !(v[h[d]] = u));
                    if (s) {
                      if (r || e) {
                        if (r) {
                          for (c = [], d = y.length; d--; )
                            (u = y[d]) && c.push((v[d] = u));
                          r(null, (y = []), c, l);
                        }
                        for (d = y.length; d--; )
                          (u = y[d]) &&
                            (c = r ? P(s, u) : p[d]) > -1 &&
                            (s[c] = !(a[c] = u));
                      }
                    } else (y = Se(y === a ? y.splice(f, y.length) : y)), r ? r(null, a, y, l) : I.apply(a, y);
                  })
                );
              }
              function Te(e) {
                for (
                  var t,
                    n,
                    r,
                    s = e.length,
                    a = i.relative[e[0].type],
                    o = a || i.relative[" "],
                    l = a ? 1 : 0,
                    d = be(
                      function (e) {
                        return e === t;
                      },
                      o,
                      !0
                    ),
                    u = be(
                      function (e) {
                        return P(t, e) > -1;
                      },
                      o,
                      !0
                    ),
                    p = [
                      function (e, n, i) {
                        var r =
                          (!a && (i || n !== c)) ||
                          ((t = n).nodeType ? d(e, n, i) : u(e, n, i));
                        return (t = null), r;
                      },
                    ];
                  l < s;
                  l++
                )
                  if ((n = i.relative[e[l].type])) p = [be(we(p), n)];
                  else {
                    if ((n = i.filter[e[l].type].apply(null, e[l].matches))[b]) {
                      for (r = ++l; r < s && !i.relative[e[r].type]; r++);
                      return Ce(
                        l > 1 && we(p),
                        l > 1 &&
                          xe(
                            e
                              .slice(0, l - 1)
                              .concat({ value: " " === e[l - 2].type ? "*" : "" })
                          ).replace(B, "$1"),
                        n,
                        l < r && Te(e.slice(l, r)),
                        r < s && Te((e = e.slice(r))),
                        r < s && xe(e)
                      );
                    }
                    p.push(n);
                  }
                return we(p);
              }
              return (
                (ge.prototype = i.filters = i.pseudos),
                (i.setFilters = new ge()),
                (a = oe.tokenize =
                  function (e, t) {
                    var n,
                      r,
                      s,
                      a,
                      o,
                      l,
                      c,
                      d = _[e + " "];
                    if (d) return t ? 0 : d.slice(0);
                    for (o = e, l = [], c = i.preFilter; o; ) {
                      for (a in ((n && !(r = W.exec(o))) ||
                        (r && (o = o.slice(r[0].length) || o), l.push((s = []))),
                      (n = !1),
                      (r = R.exec(o)) &&
                        ((n = r.shift()),
                        s.push({ value: n, type: r[0].replace(B, " ") }),
                        (o = o.slice(n.length))),
                      i.filter))
                        !(r = Y[a].exec(o)) ||
                          (c[a] && !(r = c[a](r))) ||
                          ((n = r.shift()),
                          s.push({ value: n, type: a, matches: r }),
                          (o = o.slice(n.length)));
                      if (!n) break;
                    }
                    return t ? o.length : o ? oe.error(e) : _(e, l).slice(0);
                  }),
                (o = oe.compile =
                  function (e, t) {
                    var n,
                      r = [],
                      s = [],
                      o = E[e + " "];
                    if (!o) {
                      for (t || (t = a(e)), n = t.length; n--; )
                        (o = Te(t[n]))[b] ? r.push(o) : s.push(o);
                      (o = E(
                        e,
                        (function (e, t) {
                          var n = t.length > 0,
                            r = e.length > 0,
                            s = function (s, a, o, l, d) {
                              var u,
                                f,
                                v,
                                y = 0,
                                g = "0",
                                x = s && [],
                                b = [],
                                w = c,
                                C = s || (r && i.find.TAG("*", d)),
                                T = (S += null == w ? 1 : Math.random() || 0.1),
                                _ = C.length;
                              for (
                                d && (c = a == h || a || d);
                                g !== _ && null != (u = C[g]);
                                g++
                              ) {
                                if (r && u) {
                                  for (
                                    f = 0,
                                      a ||
                                        u.ownerDocument == h ||
                                        (p(u), (o = !m));
                                    (v = e[f++]);
  
                                  )
                                    if (v(u, a || h, o)) {
                                      l.push(u);
                                      break;
                                    }
                                  d && (S = T);
                                }
                                n && ((u = !v && u) && y--, s && x.push(u));
                              }
                              if (((y += g), n && g !== y)) {
                                for (f = 0; (v = t[f++]); ) v(x, b, a, o);
                                if (s) {
                                  if (y > 0)
                                    for (; g--; )
                                      x[g] || b[g] || (b[g] = A.call(l));
                                  b = Se(b);
                                }
                                I.apply(l, b),
                                  d &&
                                    !s &&
                                    b.length > 0 &&
                                    y + t.length > 1 &&
                                    oe.uniqueSort(l);
                              }
                              return d && ((S = T), (c = w)), x;
                            };
                          return n ? ce(s) : s;
                        })(s, r)
                      )),
                        (o.selector = e);
                    }
                    return o;
                  }),
                (l = oe.select =
                  function (e, t, n, r) {
                    var s,
                      l,
                      c,
                      d,
                      u,
                      p = "function" == typeof e && e,
                      h = !r && a((e = p.selector || e));
                    if (((n = n || []), 1 === h.length)) {
                      if (
                        (l = h[0] = h[0].slice(0)).length > 2 &&
                        "ID" === (c = l[0]).type &&
                        9 === t.nodeType &&
                        m &&
                        i.relative[l[1].type]
                      ) {
                        if (
                          !(t = (i.find.ID(c.matches[0].replace(te, ne), t) ||
                            [])[0])
                        )
                          return n;
                        p && (t = t.parentNode),
                          (e = e.slice(l.shift().value.length));
                      }
                      for (
                        s = Y.needsContext.test(e) ? 0 : l.length;
                        s-- && ((c = l[s]), !i.relative[(d = c.type)]);
  
                      )
                        if (
                          (u = i.find[d]) &&
                          (r = u(
                            c.matches[0].replace(te, ne),
                            (ee.test(l[0].type) && ye(t.parentNode)) || t
                          ))
                        ) {
                          if ((l.splice(s, 1), !(e = r.length && xe(l))))
                            return I.apply(n, r), n;
                          break;
                        }
                    }
                    return (
                      (p || o(e, h))(
                        r,
                        t,
                        !m,
                        n,
                        !t || (ee.test(e) && ye(t.parentNode)) || t
                      ),
                      n
                    );
                  }),
                (n.sortStable = b.split("").sort($).join("") === b),
                (n.detectDuplicates = !!u),
                p(),
                (n.sortDetached = de(function (e) {
                  return (
                    1 & e.compareDocumentPosition(h.createElement("fieldset"))
                  );
                })),
                de(function (e) {
                  return (
                    (e.innerHTML = "<a href='#'></a>"),
                    "#" === e.firstChild.getAttribute("href")
                  );
                }) ||
                  ue("type|href|height|width", function (e, t, n) {
                    if (!n)
                      return e.getAttribute(
                        t,
                        "type" === t.toLowerCase() ? 1 : 2
                      );
                  }),
                (n.attributes &&
                  de(function (e) {
                    return (
                      (e.innerHTML = "<input/>"),
                      e.firstChild.setAttribute("value", ""),
                      "" === e.firstChild.getAttribute("value")
                    );
                  })) ||
                  ue("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase())
                      return e.defaultValue;
                  }),
                de(function (e) {
                  return null == e.getAttribute("disabled");
                }) ||
                  ue(D, function (e, t, n) {
                    var i;
                    if (!n)
                      return !0 === e[t]
                        ? t.toLowerCase()
                        : (i = e.getAttributeNode(t)) && i.specified
                        ? i.value
                        : null;
                  }),
                oe
              );
            })(i);
            (T.find = E),
              (T.expr = E.selectors),
              (T.expr[":"] = T.expr.pseudos),
              (T.uniqueSort = T.unique = E.uniqueSort),
              (T.text = E.getText),
              (T.isXMLDoc = E.isXML),
              (T.contains = E.contains),
              (T.escapeSelector = E.escape);
            var k = function (e, t, n) {
                for (
                  var i = [], r = void 0 !== n;
                  (e = e[t]) && 9 !== e.nodeType;
  
                )
                  if (1 === e.nodeType) {
                    if (r && T(e).is(n)) break;
                    i.push(e);
                  }
                return i;
              },
              $ = function (e, t) {
                for (var n = []; e; e = e.nextSibling)
                  1 === e.nodeType && e !== t && n.push(e);
                return n;
              },
              M = T.expr.match.needsContext;
            function j(e, t) {
              return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
            }
            var A =
              /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
            function L(e, t, n) {
              return y(t)
                ? T.grep(e, function (e, i) {
                    return !!t.call(e, i, e) !== n;
                  })
                : t.nodeType
                ? T.grep(e, function (e) {
                    return (e === t) !== n;
                  })
                : "string" != typeof t
                ? T.grep(e, function (e) {
                    return d.call(t, e) > -1 !== n;
                  })
                : T.filter(t, e, n);
            }
            (T.filter = function (e, t, n) {
              var i = t[0];
              return (
                n && (e = ":not(" + e + ")"),
                1 === t.length && 1 === i.nodeType
                  ? T.find.matchesSelector(i, e)
                    ? [i]
                    : []
                  : T.find.matches(
                      e,
                      T.grep(t, function (e) {
                        return 1 === e.nodeType;
                      })
                    )
              );
            }),
              T.fn.extend({
                find: function (e) {
                  var t,
                    n,
                    i = this.length,
                    r = this;
                  if ("string" != typeof e)
                    return this.pushStack(
                      T(e).filter(function () {
                        for (t = 0; t < i; t++)
                          if (T.contains(r[t], this)) return !0;
                      })
                    );
                  for (n = this.pushStack([]), t = 0; t < i; t++)
                    T.find(e, r[t], n);
                  return i > 1 ? T.uniqueSort(n) : n;
                },
                filter: function (e) {
                  return this.pushStack(L(this, e || [], !1));
                },
                not: function (e) {
                  return this.pushStack(L(this, e || [], !0));
                },
                is: function (e) {
                  return !!L(
                    this,
                    "string" == typeof e && M.test(e) ? T(e) : e || [],
                    !1
                  ).length;
                },
              });
            var I,
              O = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
            ((T.fn.init = function (e, t, n) {
              var i, r;
              if (!e) return this;
              if (((n = n || I), "string" == typeof e)) {
                if (
                  !(i =
                    "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3
                      ? [null, e, null]
                      : O.exec(e)) ||
                  (!i[1] && t)
                )
                  return !t || t.jquery
                    ? (t || n).find(e)
                    : this.constructor(t).find(e);
                if (i[1]) {
                  if (
                    ((t = t instanceof T ? t[0] : t),
                    T.merge(
                      this,
                      T.parseHTML(
                        i[1],
                        t && t.nodeType ? t.ownerDocument || t : x,
                        !0
                      )
                    ),
                    A.test(i[1]) && T.isPlainObject(t))
                  )
                    for (i in t) y(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                  return this;
                }
                return (
                  (r = x.getElementById(i[2])) &&
                    ((this[0] = r), (this.length = 1)),
                  this
                );
              }
              return e.nodeType
                ? ((this[0] = e), (this.length = 1), this)
                : y(e)
                ? void 0 !== n.ready
                  ? n.ready(e)
                  : e(T)
                : T.makeArray(e, this);
            }).prototype = T.fn),
              (I = T(x));
            var P = /^(?:parents|prev(?:Until|All))/,
              D = { children: !0, contents: !0, next: !0, prev: !0 };
            function z(e, t) {
              for (; (e = e[t]) && 1 !== e.nodeType; );
              return e;
            }
            T.fn.extend({
              has: function (e) {
                var t = T(e, this),
                  n = t.length;
                return this.filter(function () {
                  for (var e = 0; e < n; e++)
                    if (T.contains(this, t[e])) return !0;
                });
              },
              closest: function (e, t) {
                var n,
                  i = 0,
                  r = this.length,
                  s = [],
                  a = "string" != typeof e && T(e);
                if (!M.test(e))
                  for (; i < r; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                      if (
                        n.nodeType < 11 &&
                        (a
                          ? a.index(n) > -1
                          : 1 === n.nodeType && T.find.matchesSelector(n, e))
                      ) {
                        s.push(n);
                        break;
                      }
                return this.pushStack(s.length > 1 ? T.uniqueSort(s) : s);
              },
              index: function (e) {
                return e
                  ? "string" == typeof e
                    ? d.call(T(e), this[0])
                    : d.call(this, e.jquery ? e[0] : e)
                  : this[0] && this[0].parentNode
                  ? this.first().prevAll().length
                  : -1;
              },
              add: function (e, t) {
                return this.pushStack(T.uniqueSort(T.merge(this.get(), T(e, t))));
              },
              addBack: function (e) {
                return this.add(
                  null == e ? this.prevObject : this.prevObject.filter(e)
                );
              },
            }),
              T.each(
                {
                  parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                  },
                  parents: function (e) {
                    return k(e, "parentNode");
                  },
                  parentsUntil: function (e, t, n) {
                    return k(e, "parentNode", n);
                  },
                  next: function (e) {
                    return z(e, "nextSibling");
                  },
                  prev: function (e) {
                    return z(e, "previousSibling");
                  },
                  nextAll: function (e) {
                    return k(e, "nextSibling");
                  },
                  prevAll: function (e) {
                    return k(e, "previousSibling");
                  },
                  nextUntil: function (e, t, n) {
                    return k(e, "nextSibling", n);
                  },
                  prevUntil: function (e, t, n) {
                    return k(e, "previousSibling", n);
                  },
                  siblings: function (e) {
                    return $((e.parentNode || {}).firstChild, e);
                  },
                  children: function (e) {
                    return $(e.firstChild);
                  },
                  contents: function (e) {
                    return null != e.contentDocument && a(e.contentDocument)
                      ? e.contentDocument
                      : (j(e, "template") && (e = e.content || e),
                        T.merge([], e.childNodes));
                  },
                },
                function (e, t) {
                  T.fn[e] = function (n, i) {
                    var r = T.map(this, t, n);
                    return (
                      "Until" !== e.slice(-5) && (i = n),
                      i && "string" == typeof i && (r = T.filter(i, r)),
                      this.length > 1 &&
                        (D[e] || T.uniqueSort(r), P.test(e) && r.reverse()),
                      this.pushStack(r)
                    );
                  };
                }
              );
            var N = /[^\x20\t\r\n\f]+/g;
            function q(e) {
              return e;
            }
            function H(e) {
              throw e;
            }
            function F(e, t, n, i) {
              var r;
              try {
                e && y((r = e.promise))
                  ? r.call(e).done(t).fail(n)
                  : e && y((r = e.then))
                  ? r.call(e, t, n)
                  : t.apply(void 0, [e].slice(i));
              } catch (e) {
                n.apply(void 0, [e]);
              }
            }
            (T.Callbacks = function (e) {
              e =
                "string" == typeof e
                  ? (function (e) {
                      var t = {};
                      return (
                        T.each(e.match(N) || [], function (e, n) {
                          t[n] = !0;
                        }),
                        t
                      );
                    })(e)
                  : T.extend({}, e);
              var t,
                n,
                i,
                r,
                s = [],
                a = [],
                o = -1,
                l = function () {
                  for (r = r || e.once, i = t = !0; a.length; o = -1)
                    for (n = a.shift(); ++o < s.length; )
                      !1 === s[o].apply(n[0], n[1]) &&
                        e.stopOnFalse &&
                        ((o = s.length), (n = !1));
                  e.memory || (n = !1), (t = !1), r && (s = n ? [] : "");
                },
                c = {
                  add: function () {
                    return (
                      s &&
                        (n && !t && ((o = s.length - 1), a.push(n)),
                        (function t(n) {
                          T.each(n, function (n, i) {
                            y(i)
                              ? (e.unique && c.has(i)) || s.push(i)
                              : i && i.length && "string" !== S(i) && t(i);
                          });
                        })(arguments),
                        n && !t && l()),
                      this
                    );
                  },
                  remove: function () {
                    return (
                      T.each(arguments, function (e, t) {
                        for (var n; (n = T.inArray(t, s, n)) > -1; )
                          s.splice(n, 1), n <= o && o--;
                      }),
                      this
                    );
                  },
                  has: function (e) {
                    return e ? T.inArray(e, s) > -1 : s.length > 0;
                  },
                  empty: function () {
                    return s && (s = []), this;
                  },
                  disable: function () {
                    return (r = a = []), (s = n = ""), this;
                  },
                  disabled: function () {
                    return !s;
                  },
                  lock: function () {
                    return (r = a = []), n || t || (s = n = ""), this;
                  },
                  locked: function () {
                    return !!r;
                  },
                  fireWith: function (e, n) {
                    return (
                      r ||
                        ((n = [e, (n = n || []).slice ? n.slice() : n]),
                        a.push(n),
                        t || l()),
                      this
                    );
                  },
                  fire: function () {
                    return c.fireWith(this, arguments), this;
                  },
                  fired: function () {
                    return !!i;
                  },
                };
              return c;
            }),
              T.extend({
                Deferred: function (e) {
                  var t = [
                      [
                        "notify",
                        "progress",
                        T.Callbacks("memory"),
                        T.Callbacks("memory"),
                        2,
                      ],
                      [
                        "resolve",
                        "done",
                        T.Callbacks("once memory"),
                        T.Callbacks("once memory"),
                        0,
                        "resolved",
                      ],
                      [
                        "reject",
                        "fail",
                        T.Callbacks("once memory"),
                        T.Callbacks("once memory"),
                        1,
                        "rejected",
                      ],
                    ],
                    n = "pending",
                    r = {
                      state: function () {
                        return n;
                      },
                      always: function () {
                        return s.done(arguments).fail(arguments), this;
                      },
                      catch: function (e) {
                        return r.then(null, e);
                      },
                      pipe: function () {
                        var e = arguments;
                        return T.Deferred(function (n) {
                          T.each(t, function (t, i) {
                            var r = y(e[i[4]]) && e[i[4]];
                            s[i[1]](function () {
                              var e = r && r.apply(this, arguments);
                              e && y(e.promise)
                                ? e
                                    .promise()
                                    .progress(n.notify)
                                    .done(n.resolve)
                                    .fail(n.reject)
                                : n[i[0] + "With"](this, r ? [e] : arguments);
                            });
                          }),
                            (e = null);
                        }).promise();
                      },
                      then: function (e, n, r) {
                        var s = 0;
                        function a(e, t, n, r) {
                          return function () {
                            var o = this,
                              l = arguments,
                              c = function () {
                                var i, c;
                                if (!(e < s)) {
                                  if ((i = n.apply(o, l)) === t.promise())
                                    throw new TypeError(
                                      "Thenable self-resolution"
                                    );
                                  (c =
                                    i &&
                                    ("object" == typeof i ||
                                      "function" == typeof i) &&
                                    i.then),
                                    y(c)
                                      ? r
                                        ? c.call(i, a(s, t, q, r), a(s, t, H, r))
                                        : (s++,
                                          c.call(
                                            i,
                                            a(s, t, q, r),
                                            a(s, t, H, r),
                                            a(s, t, q, t.notifyWith)
                                          ))
                                      : (n !== q && ((o = void 0), (l = [i])),
                                        (r || t.resolveWith)(o, l));
                                }
                              },
                              d = r
                                ? c
                                : function () {
                                    try {
                                      c();
                                    } catch (i) {
                                      T.Deferred.exceptionHook &&
                                        T.Deferred.exceptionHook(i, d.stackTrace),
                                        e + 1 >= s &&
                                          (n !== H && ((o = void 0), (l = [i])),
                                          t.rejectWith(o, l));
                                    }
                                  };
                            e
                              ? d()
                              : (T.Deferred.getStackHook &&
                                  (d.stackTrace = T.Deferred.getStackHook()),
                                i.setTimeout(d));
                          };
                        }
                        return T.Deferred(function (i) {
                          t[0][3].add(a(0, i, y(r) ? r : q, i.notifyWith)),
                            t[1][3].add(a(0, i, y(e) ? e : q)),
                            t[2][3].add(a(0, i, y(n) ? n : H));
                        }).promise();
                      },
                      promise: function (e) {
                        return null != e ? T.extend(e, r) : r;
                      },
                    },
                    s = {};
                  return (
                    T.each(t, function (e, i) {
                      var a = i[2],
                        o = i[5];
                      (r[i[1]] = a.add),
                        o &&
                          a.add(
                            function () {
                              n = o;
                            },
                            t[3 - e][2].disable,
                            t[3 - e][3].disable,
                            t[0][2].lock,
                            t[0][3].lock
                          ),
                        a.add(i[3].fire),
                        (s[i[0]] = function () {
                          return (
                            s[i[0] + "With"](
                              this === s ? void 0 : this,
                              arguments
                            ),
                            this
                          );
                        }),
                        (s[i[0] + "With"] = a.fireWith);
                    }),
                    r.promise(s),
                    e && e.call(s, s),
                    s
                  );
                },
                when: function (e) {
                  var t = arguments.length,
                    n = t,
                    i = Array(n),
                    r = o.call(arguments),
                    s = T.Deferred(),
                    a = function (e) {
                      return function (n) {
                        (i[e] = this),
                          (r[e] = arguments.length > 1 ? o.call(arguments) : n),
                          --t || s.resolveWith(i, r);
                      };
                    };
                  if (
                    t <= 1 &&
                    (F(e, s.done(a(n)).resolve, s.reject, !t),
                    "pending" === s.state() || y(r[n] && r[n].then))
                  )
                    return s.then();
                  for (; n--; ) F(r[n], a(n), s.reject);
                  return s.promise();
                },
              });
            var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
            (T.Deferred.exceptionHook = function (e, t) {
              i.console &&
                i.console.warn &&
                e &&
                B.test(e.name) &&
                i.console.warn(
                  "jQuery.Deferred exception: " + e.message,
                  e.stack,
                  t
                );
            }),
              (T.readyException = function (e) {
                i.setTimeout(function () {
                  throw e;
                });
              });
            var W = T.Deferred();
            function R() {
              x.removeEventListener("DOMContentLoaded", R),
                i.removeEventListener("load", R),
                T.ready();
            }
            (T.fn.ready = function (e) {
              return (
                W.then(e).catch(function (e) {
                  T.readyException(e);
                }),
                this
              );
            }),
              T.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (e) {
                  (!0 === e ? --T.readyWait : T.isReady) ||
                    ((T.isReady = !0),
                    (!0 !== e && --T.readyWait > 0) || W.resolveWith(x, [T]));
                },
              }),
              (T.ready.then = W.then),
              "complete" === x.readyState ||
              ("loading" !== x.readyState && !x.documentElement.doScroll)
                ? i.setTimeout(T.ready)
                : (x.addEventListener("DOMContentLoaded", R),
                  i.addEventListener("load", R));
            var V = function (e, t, n, i, r, s, a) {
                var o = 0,
                  l = e.length,
                  c = null == n;
                if ("object" === S(n))
                  for (o in ((r = !0), n)) V(e, t, o, n[o], !0, s, a);
                else if (
                  void 0 !== i &&
                  ((r = !0),
                  y(i) || (a = !0),
                  c &&
                    (a
                      ? (t.call(e, i), (t = null))
                      : ((c = t),
                        (t = function (e, t, n) {
                          return c.call(T(e), n);
                        }))),
                  t)
                )
                  for (; o < l; o++)
                    t(e[o], n, a ? i : i.call(e[o], o, t(e[o], n)));
                return r ? e : c ? t.call(e) : l ? t(e[0], n) : s;
              },
              G = /^-ms-/,
              X = /-([a-z])/g;
            function Y(e, t) {
              return t.toUpperCase();
            }
            function U(e) {
              return e.replace(G, "ms-").replace(X, Y);
            }
            var K = function (e) {
              return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
            };
            function Z() {
              this.expando = T.expando + Z.uid++;
            }
            (Z.uid = 1),
              (Z.prototype = {
                cache: function (e) {
                  var t = e[this.expando];
                  return (
                    t ||
                      ((t = {}),
                      K(e) &&
                        (e.nodeType
                          ? (e[this.expando] = t)
                          : Object.defineProperty(e, this.expando, {
                              value: t,
                              configurable: !0,
                            }))),
                    t
                  );
                },
                set: function (e, t, n) {
                  var i,
                    r = this.cache(e);
                  if ("string" == typeof t) r[U(t)] = n;
                  else for (i in t) r[U(i)] = t[i];
                  return r;
                },
                get: function (e, t) {
                  return void 0 === t
                    ? this.cache(e)
                    : e[this.expando] && e[this.expando][U(t)];
                },
                access: function (e, t, n) {
                  return void 0 === t ||
                    (t && "string" == typeof t && void 0 === n)
                    ? this.get(e, t)
                    : (this.set(e, t, n), void 0 !== n ? n : t);
                },
                remove: function (e, t) {
                  var n,
                    i = e[this.expando];
                  if (void 0 !== i) {
                    if (void 0 !== t) {
                      n = (t = Array.isArray(t)
                        ? t.map(U)
                        : (t = U(t)) in i
                        ? [t]
                        : t.match(N) || []).length;
                      for (; n--; ) delete i[t[n]];
                    }
                    (void 0 === t || T.isEmptyObject(i)) &&
                      (e.nodeType
                        ? (e[this.expando] = void 0)
                        : delete e[this.expando]);
                  }
                },
                hasData: function (e) {
                  var t = e[this.expando];
                  return void 0 !== t && !T.isEmptyObject(t);
                },
              });
            var Q = new Z(),
              J = new Z(),
              ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
              te = /[A-Z]/g;
            function ne(e, t, n) {
              var i;
              if (void 0 === n && 1 === e.nodeType)
                if (
                  ((i = "data-" + t.replace(te, "-$&").toLowerCase()),
                  "string" == typeof (n = e.getAttribute(i)))
                ) {
                  try {
                    n = (function (e) {
                      return (
                        "true" === e ||
                        ("false" !== e &&
                          ("null" === e
                            ? null
                            : e === +e + ""
                            ? +e
                            : ee.test(e)
                            ? JSON.parse(e)
                            : e))
                      );
                    })(n);
                  } catch (e) {}
                  J.set(e, t, n);
                } else n = void 0;
              return n;
            }
            T.extend({
              hasData: function (e) {
                return J.hasData(e) || Q.hasData(e);
              },
              data: function (e, t, n) {
                return J.access(e, t, n);
              },
              removeData: function (e, t) {
                J.remove(e, t);
              },
              _data: function (e, t, n) {
                return Q.access(e, t, n);
              },
              _removeData: function (e, t) {
                Q.remove(e, t);
              },
            }),
              T.fn.extend({
                data: function (e, t) {
                  var n,
                    i,
                    r,
                    s = this[0],
                    a = s && s.attributes;
                  if (void 0 === e) {
                    if (
                      this.length &&
                      ((r = J.get(s)),
                      1 === s.nodeType && !Q.get(s, "hasDataAttrs"))
                    ) {
                      for (n = a.length; n--; )
                        a[n] &&
                          0 === (i = a[n].name).indexOf("data-") &&
                          ((i = U(i.slice(5))), ne(s, i, r[i]));
                      Q.set(s, "hasDataAttrs", !0);
                    }
                    return r;
                  }
                  return "object" == typeof e
                    ? this.each(function () {
                        J.set(this, e);
                      })
                    : V(
                        this,
                        function (t) {
                          var n;
                          if (s && void 0 === t)
                            return void 0 !== (n = J.get(s, e)) ||
                              void 0 !== (n = ne(s, e))
                              ? n
                              : void 0;
                          this.each(function () {
                            J.set(this, e, t);
                          });
                        },
                        null,
                        t,
                        arguments.length > 1,
                        null,
                        !0
                      );
                },
                removeData: function (e) {
                  return this.each(function () {
                    J.remove(this, e);
                  });
                },
              }),
              T.extend({
                queue: function (e, t, n) {
                  var i;
                  if (e)
                    return (
                      (t = (t || "fx") + "queue"),
                      (i = Q.get(e, t)),
                      n &&
                        (!i || Array.isArray(n)
                          ? (i = Q.access(e, t, T.makeArray(n)))
                          : i.push(n)),
                      i || []
                    );
                },
                dequeue: function (e, t) {
                  t = t || "fx";
                  var n = T.queue(e, t),
                    i = n.length,
                    r = n.shift(),
                    s = T._queueHooks(e, t);
                  "inprogress" === r && ((r = n.shift()), i--),
                    r &&
                      ("fx" === t && n.unshift("inprogress"),
                      delete s.stop,
                      r.call(
                        e,
                        function () {
                          T.dequeue(e, t);
                        },
                        s
                      )),
                    !i && s && s.empty.fire();
                },
                _queueHooks: function (e, t) {
                  var n = t + "queueHooks";
                  return (
                    Q.get(e, n) ||
                    Q.access(e, n, {
                      empty: T.Callbacks("once memory").add(function () {
                        Q.remove(e, [t + "queue", n]);
                      }),
                    })
                  );
                },
              }),
              T.fn.extend({
                queue: function (e, t) {
                  var n = 2;
                  return (
                    "string" != typeof e && ((t = e), (e = "fx"), n--),
                    arguments.length < n
                      ? T.queue(this[0], e)
                      : void 0 === t
                      ? this
                      : this.each(function () {
                          var n = T.queue(this, e, t);
                          T._queueHooks(this, e),
                            "fx" === e &&
                              "inprogress" !== n[0] &&
                              T.dequeue(this, e);
                        })
                  );
                },
                dequeue: function (e) {
                  return this.each(function () {
                    T.dequeue(this, e);
                  });
                },
                clearQueue: function (e) {
                  return this.queue(e || "fx", []);
                },
                promise: function (e, t) {
                  var n,
                    i = 1,
                    r = T.Deferred(),
                    s = this,
                    a = this.length,
                    o = function () {
                      --i || r.resolveWith(s, [s]);
                    };
                  for (
                    "string" != typeof e && ((t = e), (e = void 0)),
                      e = e || "fx";
                    a--;
  
                  )
                    (n = Q.get(s[a], e + "queueHooks")) &&
                      n.empty &&
                      (i++, n.empty.add(o));
                  return o(), r.promise(t);
                },
              });
            var ie = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
              re = new RegExp("^(?:([+-])=|)(" + ie + ")([a-z%]*)$", "i"),
              se = ["Top", "Right", "Bottom", "Left"],
              ae = x.documentElement,
              oe = function (e) {
                return T.contains(e.ownerDocument, e);
              },
              le = { composed: !0 };
            ae.getRootNode &&
              (oe = function (e) {
                return (
                  T.contains(e.ownerDocument, e) ||
                  e.getRootNode(le) === e.ownerDocument
                );
              });
            var ce = function (e, t) {
              return (
                "none" === (e = t || e).style.display ||
                ("" === e.style.display &&
                  oe(e) &&
                  "none" === T.css(e, "display"))
              );
            };
            function de(e, t, n, i) {
              var r,
                s,
                a = 20,
                o = i
                  ? function () {
                      return i.cur();
                    }
                  : function () {
                      return T.css(e, t, "");
                    },
                l = o(),
                c = (n && n[3]) || (T.cssNumber[t] ? "" : "px"),
                d =
                  e.nodeType &&
                  (T.cssNumber[t] || ("px" !== c && +l)) &&
                  re.exec(T.css(e, t));
              if (d && d[3] !== c) {
                for (l /= 2, c = c || d[3], d = +l || 1; a--; )
                  T.style(e, t, d + c),
                    (1 - s) * (1 - (s = o() / l || 0.5)) <= 0 && (a = 0),
                    (d /= s);
                (d *= 2), T.style(e, t, d + c), (n = n || []);
              }
              return (
                n &&
                  ((d = +d || +l || 0),
                  (r = n[1] ? d + (n[1] + 1) * n[2] : +n[2]),
                  i && ((i.unit = c), (i.start = d), (i.end = r))),
                r
              );
            }
            var ue = {};
            function pe(e) {
              var t,
                n = e.ownerDocument,
                i = e.nodeName,
                r = ue[i];
              return (
                r ||
                ((t = n.body.appendChild(n.createElement(i))),
                (r = T.css(t, "display")),
                t.parentNode.removeChild(t),
                "none" === r && (r = "block"),
                (ue[i] = r),
                r)
              );
            }
            function he(e, t) {
              for (var n, i, r = [], s = 0, a = e.length; s < a; s++)
                (i = e[s]).style &&
                  ((n = i.style.display),
                  t
                    ? ("none" === n &&
                        ((r[s] = Q.get(i, "display") || null),
                        r[s] || (i.style.display = "")),
                      "" === i.style.display && ce(i) && (r[s] = pe(i)))
                    : "none" !== n && ((r[s] = "none"), Q.set(i, "display", n)));
              for (s = 0; s < a; s++) null != r[s] && (e[s].style.display = r[s]);
              return e;
            }
            T.fn.extend({
              show: function () {
                return he(this, !0);
              },
              hide: function () {
                return he(this);
              },
              toggle: function (e) {
                return "boolean" == typeof e
                  ? e
                    ? this.show()
                    : this.hide()
                  : this.each(function () {
                      ce(this) ? T(this).show() : T(this).hide();
                    });
              },
            });
            var fe,
              me,
              ve = /^(?:checkbox|radio)$/i,
              ye = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
              ge = /^$|^module$|\/(?:java|ecma)script/i;
            (fe = x.createDocumentFragment().appendChild(x.createElement("div"))),
              (me = x.createElement("input")).setAttribute("type", "radio"),
              me.setAttribute("checked", "checked"),
              me.setAttribute("name", "t"),
              fe.appendChild(me),
              (v.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked),
              (fe.innerHTML = "<textarea>x</textarea>"),
              (v.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue),
              (fe.innerHTML = "<option></option>"),
              (v.option = !!fe.lastChild);
            var xe = {
              thead: [1, "<table>", "</table>"],
              col: [2, "<table><colgroup>", "</colgroup></table>"],
              tr: [2, "<table><tbody>", "</tbody></table>"],
              td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
              _default: [0, "", ""],
            };
            function be(e, t) {
              var n;
              return (
                (n =
                  void 0 !== e.getElementsByTagName
                    ? e.getElementsByTagName(t || "*")
                    : void 0 !== e.querySelectorAll
                    ? e.querySelectorAll(t || "*")
                    : []),
                void 0 === t || (t && j(e, t)) ? T.merge([e], n) : n
              );
            }
            function we(e, t) {
              for (var n = 0, i = e.length; n < i; n++)
                Q.set(e[n], "globalEval", !t || Q.get(t[n], "globalEval"));
            }
            (xe.tbody = xe.tfoot = xe.colgroup = xe.caption = xe.thead),
              (xe.th = xe.td),
              v.option ||
                (xe.optgroup = xe.option =
                  [1, "<select multiple='multiple'>", "</select>"]);
            var Se = /<|&#?\w+;/;
            function Ce(e, t, n, i, r) {
              for (
                var s,
                  a,
                  o,
                  l,
                  c,
                  d,
                  u = t.createDocumentFragment(),
                  p = [],
                  h = 0,
                  f = e.length;
                h < f;
                h++
              )
                if ((s = e[h]) || 0 === s)
                  if ("object" === S(s)) T.merge(p, s.nodeType ? [s] : s);
                  else if (Se.test(s)) {
                    for (
                      a = a || u.appendChild(t.createElement("div")),
                        o = (ye.exec(s) || ["", ""])[1].toLowerCase(),
                        l = xe[o] || xe._default,
                        a.innerHTML = l[1] + T.htmlPrefilter(s) + l[2],
                        d = l[0];
                      d--;
  
                    )
                      a = a.lastChild;
                    T.merge(p, a.childNodes),
                      ((a = u.firstChild).textContent = "");
                  } else p.push(t.createTextNode(s));
              for (u.textContent = "", h = 0; (s = p[h++]); )
                if (i && T.inArray(s, i) > -1) r && r.push(s);
                else if (
                  ((c = oe(s)),
                  (a = be(u.appendChild(s), "script")),
                  c && we(a),
                  n)
                )
                  for (d = 0; (s = a[d++]); ) ge.test(s.type || "") && n.push(s);
              return u;
            }
            var Te = /^([^.]*)(?:\.(.+)|)/;
            function _e() {
              return !0;
            }
            function Ee() {
              return !1;
            }
            function ke(e, t) {
              return (
                (e ===
                  (function () {
                    try {
                      return x.activeElement;
                    } catch (e) {}
                  })()) ==
                ("focus" === t)
              );
            }
            function $e(e, t, n, i, r, s) {
              var a, o;
              if ("object" == typeof t) {
                for (o in ("string" != typeof n && ((i = i || n), (n = void 0)),
                t))
                  $e(e, o, n, i, t[o], s);
                return e;
              }
              if (
                (null == i && null == r
                  ? ((r = n), (i = n = void 0))
                  : null == r &&
                    ("string" == typeof n
                      ? ((r = i), (i = void 0))
                      : ((r = i), (i = n), (n = void 0))),
                !1 === r)
              )
                r = Ee;
              else if (!r) return e;
              return (
                1 === s &&
                  ((a = r),
                  (r = function (e) {
                    return T().off(e), a.apply(this, arguments);
                  }),
                  (r.guid = a.guid || (a.guid = T.guid++))),
                e.each(function () {
                  T.event.add(this, t, r, i, n);
                })
              );
            }
            function Me(e, t, n) {
              n
                ? (Q.set(e, t, !1),
                  T.event.add(e, t, {
                    namespace: !1,
                    handler: function (e) {
                      var i,
                        r,
                        s = Q.get(this, t);
                      if (1 & e.isTrigger && this[t]) {
                        if (s.length)
                          (T.event.special[t] || {}).delegateType &&
                            e.stopPropagation();
                        else if (
                          ((s = o.call(arguments)),
                          Q.set(this, t, s),
                          (i = n(this, t)),
                          this[t](),
                          s !== (r = Q.get(this, t)) || i
                            ? Q.set(this, t, !1)
                            : (r = {}),
                          s !== r)
                        )
                          return (
                            e.stopImmediatePropagation(),
                            e.preventDefault(),
                            r && r.value
                          );
                      } else
                        s.length &&
                          (Q.set(this, t, {
                            value: T.event.trigger(
                              T.extend(s[0], T.Event.prototype),
                              s.slice(1),
                              this
                            ),
                          }),
                          e.stopImmediatePropagation());
                    },
                  }))
                : void 0 === Q.get(e, t) && T.event.add(e, t, _e);
            }
            (T.event = {
              global: {},
              add: function (e, t, n, i, r) {
                var s,
                  a,
                  o,
                  l,
                  c,
                  d,
                  u,
                  p,
                  h,
                  f,
                  m,
                  v = Q.get(e);
                if (K(e))
                  for (
                    n.handler && ((n = (s = n).handler), (r = s.selector)),
                      r && T.find.matchesSelector(ae, r),
                      n.guid || (n.guid = T.guid++),
                      (l = v.events) || (l = v.events = Object.create(null)),
                      (a = v.handle) ||
                        (a = v.handle =
                          function (t) {
                            return void 0 !== T && T.event.triggered !== t.type
                              ? T.event.dispatch.apply(e, arguments)
                              : void 0;
                          }),
                      c = (t = (t || "").match(N) || [""]).length;
                    c--;
  
                  )
                    (h = m = (o = Te.exec(t[c]) || [])[1]),
                      (f = (o[2] || "").split(".").sort()),
                      h &&
                        ((u = T.event.special[h] || {}),
                        (h = (r ? u.delegateType : u.bindType) || h),
                        (u = T.event.special[h] || {}),
                        (d = T.extend(
                          {
                            type: h,
                            origType: m,
                            data: i,
                            handler: n,
                            guid: n.guid,
                            selector: r,
                            needsContext: r && T.expr.match.needsContext.test(r),
                            namespace: f.join("."),
                          },
                          s
                        )),
                        (p = l[h]) ||
                          (((p = l[h] = []).delegateCount = 0),
                          (u.setup && !1 !== u.setup.call(e, i, f, a)) ||
                            (e.addEventListener && e.addEventListener(h, a))),
                        u.add &&
                          (u.add.call(e, d),
                          d.handler.guid || (d.handler.guid = n.guid)),
                        r ? p.splice(p.delegateCount++, 0, d) : p.push(d),
                        (T.event.global[h] = !0));
              },
              remove: function (e, t, n, i, r) {
                var s,
                  a,
                  o,
                  l,
                  c,
                  d,
                  u,
                  p,
                  h,
                  f,
                  m,
                  v = Q.hasData(e) && Q.get(e);
                if (v && (l = v.events)) {
                  for (c = (t = (t || "").match(N) || [""]).length; c--; )
                    if (
                      ((h = m = (o = Te.exec(t[c]) || [])[1]),
                      (f = (o[2] || "").split(".").sort()),
                      h)
                    ) {
                      for (
                        u = T.event.special[h] || {},
                          p =
                            l[(h = (i ? u.delegateType : u.bindType) || h)] || [],
                          o =
                            o[2] &&
                            new RegExp(
                              "(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"
                            ),
                          a = s = p.length;
                        s--;
  
                      )
                        (d = p[s]),
                          (!r && m !== d.origType) ||
                            (n && n.guid !== d.guid) ||
                            (o && !o.test(d.namespace)) ||
                            (i &&
                              i !== d.selector &&
                              ("**" !== i || !d.selector)) ||
                            (p.splice(s, 1),
                            d.selector && p.delegateCount--,
                            u.remove && u.remove.call(e, d));
                      a &&
                        !p.length &&
                        ((u.teardown && !1 !== u.teardown.call(e, f, v.handle)) ||
                          T.removeEvent(e, h, v.handle),
                        delete l[h]);
                    } else for (h in l) T.event.remove(e, h + t[c], n, i, !0);
                  T.isEmptyObject(l) && Q.remove(e, "handle events");
                }
              },
              dispatch: function (e) {
                var t,
                  n,
                  i,
                  r,
                  s,
                  a,
                  o = new Array(arguments.length),
                  l = T.event.fix(e),
                  c =
                    (Q.get(this, "events") || Object.create(null))[l.type] || [],
                  d = T.event.special[l.type] || {};
                for (o[0] = l, t = 1; t < arguments.length; t++)
                  o[t] = arguments[t];
                if (
                  ((l.delegateTarget = this),
                  !d.preDispatch || !1 !== d.preDispatch.call(this, l))
                ) {
                  for (
                    a = T.event.handlers.call(this, l, c), t = 0;
                    (r = a[t++]) && !l.isPropagationStopped();
  
                  )
                    for (
                      l.currentTarget = r.elem, n = 0;
                      (s = r.handlers[n++]) && !l.isImmediatePropagationStopped();
  
                    )
                      (l.rnamespace &&
                        !1 !== s.namespace &&
                        !l.rnamespace.test(s.namespace)) ||
                        ((l.handleObj = s),
                        (l.data = s.data),
                        void 0 !==
                          (i = (
                            (T.event.special[s.origType] || {}).handle ||
                            s.handler
                          ).apply(r.elem, o)) &&
                          !1 === (l.result = i) &&
                          (l.preventDefault(), l.stopPropagation()));
                  return d.postDispatch && d.postDispatch.call(this, l), l.result;
                }
              },
              handlers: function (e, t) {
                var n,
                  i,
                  r,
                  s,
                  a,
                  o = [],
                  l = t.delegateCount,
                  c = e.target;
                if (l && c.nodeType && !("click" === e.type && e.button >= 1))
                  for (; c !== this; c = c.parentNode || this)
                    if (
                      1 === c.nodeType &&
                      ("click" !== e.type || !0 !== c.disabled)
                    ) {
                      for (s = [], a = {}, n = 0; n < l; n++)
                        void 0 === a[(r = (i = t[n]).selector + " ")] &&
                          (a[r] = i.needsContext
                            ? T(r, this).index(c) > -1
                            : T.find(r, this, null, [c]).length),
                          a[r] && s.push(i);
                      s.length && o.push({ elem: c, handlers: s });
                    }
                return (
                  (c = this),
                  l < t.length && o.push({ elem: c, handlers: t.slice(l) }),
                  o
                );
              },
              addProp: function (e, t) {
                Object.defineProperty(T.Event.prototype, e, {
                  enumerable: !0,
                  configurable: !0,
                  get: y(t)
                    ? function () {
                        if (this.originalEvent) return t(this.originalEvent);
                      }
                    : function () {
                        if (this.originalEvent) return this.originalEvent[e];
                      },
                  set: function (t) {
                    Object.defineProperty(this, e, {
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                      value: t,
                    });
                  },
                });
              },
              fix: function (e) {
                return e[T.expando] ? e : new T.Event(e);
              },
              special: {
                load: { noBubble: !0 },
                click: {
                  setup: function (e) {
                    var t = this || e;
                    return (
                      ve.test(t.type) &&
                        t.click &&
                        j(t, "input") &&
                        Me(t, "click", _e),
                      !1
                    );
                  },
                  trigger: function (e) {
                    var t = this || e;
                    return (
                      ve.test(t.type) &&
                        t.click &&
                        j(t, "input") &&
                        Me(t, "click"),
                      !0
                    );
                  },
                  _default: function (e) {
                    var t = e.target;
                    return (
                      (ve.test(t.type) &&
                        t.click &&
                        j(t, "input") &&
                        Q.get(t, "click")) ||
                      j(t, "a")
                    );
                  },
                },
                beforeunload: {
                  postDispatch: function (e) {
                    void 0 !== e.result &&
                      e.originalEvent &&
                      (e.originalEvent.returnValue = e.result);
                  },
                },
              },
            }),
              (T.removeEvent = function (e, t, n) {
                e.removeEventListener && e.removeEventListener(t, n);
              }),
              (T.Event = function (e, t) {
                if (!(this instanceof T.Event)) return new T.Event(e, t);
                e && e.type
                  ? ((this.originalEvent = e),
                    (this.type = e.type),
                    (this.isDefaultPrevented =
                      e.defaultPrevented ||
                      (void 0 === e.defaultPrevented && !1 === e.returnValue)
                        ? _e
                        : Ee),
                    (this.target =
                      e.target && 3 === e.target.nodeType
                        ? e.target.parentNode
                        : e.target),
                    (this.currentTarget = e.currentTarget),
                    (this.relatedTarget = e.relatedTarget))
                  : (this.type = e),
                  t && T.extend(this, t),
                  (this.timeStamp = (e && e.timeStamp) || Date.now()),
                  (this[T.expando] = !0);
              }),
              (T.Event.prototype = {
                constructor: T.Event,
                isDefaultPrevented: Ee,
                isPropagationStopped: Ee,
                isImmediatePropagationStopped: Ee,
                isSimulated: !1,
                preventDefault: function () {
                  var e = this.originalEvent;
                  (this.isDefaultPrevented = _e),
                    e && !this.isSimulated && e.preventDefault();
                },
                stopPropagation: function () {
                  var e = this.originalEvent;
                  (this.isPropagationStopped = _e),
                    e && !this.isSimulated && e.stopPropagation();
                },
                stopImmediatePropagation: function () {
                  var e = this.originalEvent;
                  (this.isImmediatePropagationStopped = _e),
                    e && !this.isSimulated && e.stopImmediatePropagation(),
                    this.stopPropagation();
                },
              }),
              T.each(
                {
                  altKey: !0,
                  bubbles: !0,
                  cancelable: !0,
                  changedTouches: !0,
                  ctrlKey: !0,
                  detail: !0,
                  eventPhase: !0,
                  metaKey: !0,
                  pageX: !0,
                  pageY: !0,
                  shiftKey: !0,
                  view: !0,
                  char: !0,
                  code: !0,
                  charCode: !0,
                  key: !0,
                  keyCode: !0,
                  button: !0,
                  buttons: !0,
                  clientX: !0,
                  clientY: !0,
                  offsetX: !0,
                  offsetY: !0,
                  pointerId: !0,
                  pointerType: !0,
                  screenX: !0,
                  screenY: !0,
                  targetTouches: !0,
                  toElement: !0,
                  touches: !0,
                  which: !0,
                },
                T.event.addProp
              ),
              T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                T.event.special[e] = {
                  setup: function () {
                    return Me(this, e, ke), !1;
                  },
                  trigger: function () {
                    return Me(this, e), !0;
                  },
                  _default: function () {
                    return !0;
                  },
                  delegateType: t,
                };
              }),
              T.each(
                {
                  mouseenter: "mouseover",
                  mouseleave: "mouseout",
                  pointerenter: "pointerover",
                  pointerleave: "pointerout",
                },
                function (e, t) {
                  T.event.special[e] = {
                    delegateType: t,
                    bindType: t,
                    handle: function (e) {
                      var n,
                        i = this,
                        r = e.relatedTarget,
                        s = e.handleObj;
                      return (
                        (r && (r === i || T.contains(i, r))) ||
                          ((e.type = s.origType),
                          (n = s.handler.apply(this, arguments)),
                          (e.type = t)),
                        n
                      );
                    },
                  };
                }
              ),
              T.fn.extend({
                on: function (e, t, n, i) {
                  return $e(this, e, t, n, i);
                },
                one: function (e, t, n, i) {
                  return $e(this, e, t, n, i, 1);
                },
                off: function (e, t, n) {
                  var i, r;
                  if (e && e.preventDefault && e.handleObj)
                    return (
                      (i = e.handleObj),
                      T(e.delegateTarget).off(
                        i.namespace ? i.origType + "." + i.namespace : i.origType,
                        i.selector,
                        i.handler
                      ),
                      this
                    );
                  if ("object" == typeof e) {
                    for (r in e) this.off(r, t, e[r]);
                    return this;
                  }
                  return (
                    (!1 !== t && "function" != typeof t) ||
                      ((n = t), (t = void 0)),
                    !1 === n && (n = Ee),
                    this.each(function () {
                      T.event.remove(this, e, n, t);
                    })
                  );
                },
              });
            var je = /<script|<style|<link/i,
              Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
              Le = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
            function Ie(e, t) {
              return (
                (j(e, "table") &&
                  j(11 !== t.nodeType ? t : t.firstChild, "tr") &&
                  T(e).children("tbody")[0]) ||
                e
              );
            }
            function Oe(e) {
              return (
                (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e
              );
            }
            function Pe(e) {
              return (
                "true/" === (e.type || "").slice(0, 5)
                  ? (e.type = e.type.slice(5))
                  : e.removeAttribute("type"),
                e
              );
            }
            function De(e, t) {
              var n, i, r, s, a, o;
              if (1 === t.nodeType) {
                if (Q.hasData(e) && (o = Q.get(e).events))
                  for (r in (Q.remove(t, "handle events"), o))
                    for (n = 0, i = o[r].length; n < i; n++)
                      T.event.add(t, r, o[r][n]);
                J.hasData(e) &&
                  ((s = J.access(e)), (a = T.extend({}, s)), J.set(t, a));
              }
            }
            function ze(e, t) {
              var n = t.nodeName.toLowerCase();
              "input" === n && ve.test(e.type)
                ? (t.checked = e.checked)
                : ("input" !== n && "textarea" !== n) ||
                  (t.defaultValue = e.defaultValue);
            }
            function Ne(e, t, n, i) {
              t = l(t);
              var r,
                s,
                a,
                o,
                c,
                d,
                u = 0,
                p = e.length,
                h = p - 1,
                f = t[0],
                m = y(f);
              if (
                m ||
                (p > 1 && "string" == typeof f && !v.checkClone && Ae.test(f))
              )
                return e.each(function (r) {
                  var s = e.eq(r);
                  m && (t[0] = f.call(this, r, s.html())), Ne(s, t, n, i);
                });
              if (
                p &&
                ((s = (r = Ce(t, e[0].ownerDocument, !1, e, i)).firstChild),
                1 === r.childNodes.length && (r = s),
                s || i)
              ) {
                for (o = (a = T.map(be(r, "script"), Oe)).length; u < p; u++)
                  (c = r),
                    u !== h &&
                      ((c = T.clone(c, !0, !0)),
                      o && T.merge(a, be(c, "script"))),
                    n.call(e[u], c, u);
                if (o)
                  for (
                    d = a[a.length - 1].ownerDocument, T.map(a, Pe), u = 0;
                    u < o;
                    u++
                  )
                    (c = a[u]),
                      ge.test(c.type || "") &&
                        !Q.access(c, "globalEval") &&
                        T.contains(d, c) &&
                        (c.src && "module" !== (c.type || "").toLowerCase()
                          ? T._evalUrl &&
                            !c.noModule &&
                            T._evalUrl(
                              c.src,
                              { nonce: c.nonce || c.getAttribute("nonce") },
                              d
                            )
                          : w(c.textContent.replace(Le, ""), c, d));
              }
              return e;
            }
            function qe(e, t, n) {
              for (
                var i, r = t ? T.filter(t, e) : e, s = 0;
                null != (i = r[s]);
                s++
              )
                n || 1 !== i.nodeType || T.cleanData(be(i)),
                  i.parentNode &&
                    (n && oe(i) && we(be(i, "script")),
                    i.parentNode.removeChild(i));
              return e;
            }
            T.extend({
              htmlPrefilter: function (e) {
                return e;
              },
              clone: function (e, t, n) {
                var i,
                  r,
                  s,
                  a,
                  o = e.cloneNode(!0),
                  l = oe(e);
                if (
                  !(
                    v.noCloneChecked ||
                    (1 !== e.nodeType && 11 !== e.nodeType) ||
                    T.isXMLDoc(e)
                  )
                )
                  for (a = be(o), i = 0, r = (s = be(e)).length; i < r; i++)
                    ze(s[i], a[i]);
                if (t)
                  if (n)
                    for (
                      s = s || be(e), a = a || be(o), i = 0, r = s.length;
                      i < r;
                      i++
                    )
                      De(s[i], a[i]);
                  else De(e, o);
                return (
                  (a = be(o, "script")).length > 0 &&
                    we(a, !l && be(e, "script")),
                  o
                );
              },
              cleanData: function (e) {
                for (
                  var t, n, i, r = T.event.special, s = 0;
                  void 0 !== (n = e[s]);
                  s++
                )
                  if (K(n)) {
                    if ((t = n[Q.expando])) {
                      if (t.events)
                        for (i in t.events)
                          r[i]
                            ? T.event.remove(n, i)
                            : T.removeEvent(n, i, t.handle);
                      n[Q.expando] = void 0;
                    }
                    n[J.expando] && (n[J.expando] = void 0);
                  }
              },
            }),
              T.fn.extend({
                detach: function (e) {
                  return qe(this, e, !0);
                },
                remove: function (e) {
                  return qe(this, e);
                },
                text: function (e) {
                  return V(
                    this,
                    function (e) {
                      return void 0 === e
                        ? T.text(this)
                        : this.empty().each(function () {
                            (1 !== this.nodeType &&
                              11 !== this.nodeType &&
                              9 !== this.nodeType) ||
                              (this.textContent = e);
                          });
                    },
                    null,
                    e,
                    arguments.length
                  );
                },
                append: function () {
                  return Ne(this, arguments, function (e) {
                    (1 !== this.nodeType &&
                      11 !== this.nodeType &&
                      9 !== this.nodeType) ||
                      Ie(this, e).appendChild(e);
                  });
                },
                prepend: function () {
                  return Ne(this, arguments, function (e) {
                    if (
                      1 === this.nodeType ||
                      11 === this.nodeType ||
                      9 === this.nodeType
                    ) {
                      var t = Ie(this, e);
                      t.insertBefore(e, t.firstChild);
                    }
                  });
                },
                before: function () {
                  return Ne(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                  });
                },
                after: function () {
                  return Ne(this, arguments, function (e) {
                    this.parentNode &&
                      this.parentNode.insertBefore(e, this.nextSibling);
                  });
                },
                empty: function () {
                  for (var e, t = 0; null != (e = this[t]); t++)
                    1 === e.nodeType &&
                      (T.cleanData(be(e, !1)), (e.textContent = ""));
                  return this;
                },
                clone: function (e, t) {
                  return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                      return T.clone(this, e, t);
                    })
                  );
                },
                html: function (e) {
                  return V(
                    this,
                    function (e) {
                      var t = this[0] || {},
                        n = 0,
                        i = this.length;
                      if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                      if (
                        "string" == typeof e &&
                        !je.test(e) &&
                        !xe[(ye.exec(e) || ["", ""])[1].toLowerCase()]
                      ) {
                        e = T.htmlPrefilter(e);
                        try {
                          for (; n < i; n++)
                            1 === (t = this[n] || {}).nodeType &&
                              (T.cleanData(be(t, !1)), (t.innerHTML = e));
                          t = 0;
                        } catch (e) {}
                      }
                      t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                  );
                },
                replaceWith: function () {
                  var e = [];
                  return Ne(
                    this,
                    arguments,
                    function (t) {
                      var n = this.parentNode;
                      T.inArray(this, e) < 0 &&
                        (T.cleanData(be(this)), n && n.replaceChild(t, this));
                    },
                    e
                  );
                },
              }),
              T.each(
                {
                  appendTo: "append",
                  prependTo: "prepend",
                  insertBefore: "before",
                  insertAfter: "after",
                  replaceAll: "replaceWith",
                },
                function (e, t) {
                  T.fn[e] = function (e) {
                    for (
                      var n, i = [], r = T(e), s = r.length - 1, a = 0;
                      a <= s;
                      a++
                    )
                      (n = a === s ? this : this.clone(!0)),
                        T(r[a])[t](n),
                        c.apply(i, n.get());
                    return this.pushStack(i);
                  };
                }
              );
            var He = new RegExp("^(" + ie + ")(?!px)[a-z%]+$", "i"),
              Fe = function (e) {
                var t = e.ownerDocument.defaultView;
                return (t && t.opener) || (t = i), t.getComputedStyle(e);
              },
              Be = function (e, t, n) {
                var i,
                  r,
                  s = {};
                for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
                for (r in ((i = n.call(e)), t)) e.style[r] = s[r];
                return i;
              },
              We = new RegExp(se.join("|"), "i");
            function Re(e, t, n) {
              var i,
                r,
                s,
                a,
                o = e.style;
              return (
                (n = n || Fe(e)) &&
                  ("" !== (a = n.getPropertyValue(t) || n[t]) ||
                    oe(e) ||
                    (a = T.style(e, t)),
                  !v.pixelBoxStyles() &&
                    He.test(a) &&
                    We.test(t) &&
                    ((i = o.width),
                    (r = o.minWidth),
                    (s = o.maxWidth),
                    (o.minWidth = o.maxWidth = o.width = a),
                    (a = n.width),
                    (o.width = i),
                    (o.minWidth = r),
                    (o.maxWidth = s))),
                void 0 !== a ? a + "" : a
              );
            }
            function Ve(e, t) {
              return {
                get: function () {
                  if (!e()) return (this.get = t).apply(this, arguments);
                  delete this.get;
                },
              };
            }
            !(function () {
              function e() {
                if (d) {
                  (c.style.cssText =
                    "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (d.style.cssText =
                      "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    ae.appendChild(c).appendChild(d);
                  var e = i.getComputedStyle(d);
                  (n = "1%" !== e.top),
                    (l = 12 === t(e.marginLeft)),
                    (d.style.right = "60%"),
                    (a = 36 === t(e.right)),
                    (r = 36 === t(e.width)),
                    (d.style.position = "absolute"),
                    (s = 12 === t(d.offsetWidth / 3)),
                    ae.removeChild(c),
                    (d = null);
                }
              }
              function t(e) {
                return Math.round(parseFloat(e));
              }
              var n,
                r,
                s,
                a,
                o,
                l,
                c = x.createElement("div"),
                d = x.createElement("div");
              d.style &&
                ((d.style.backgroundClip = "content-box"),
                (d.cloneNode(!0).style.backgroundClip = ""),
                (v.clearCloneStyle = "content-box" === d.style.backgroundClip),
                T.extend(v, {
                  boxSizingReliable: function () {
                    return e(), r;
                  },
                  pixelBoxStyles: function () {
                    return e(), a;
                  },
                  pixelPosition: function () {
                    return e(), n;
                  },
                  reliableMarginLeft: function () {
                    return e(), l;
                  },
                  scrollboxSize: function () {
                    return e(), s;
                  },
                  reliableTrDimensions: function () {
                    var e, t, n, r;
                    return (
                      null == o &&
                        ((e = x.createElement("table")),
                        (t = x.createElement("tr")),
                        (n = x.createElement("div")),
                        (e.style.cssText =
                          "position:absolute;left:-11111px;border-collapse:separate"),
                        (t.style.cssText = "border:1px solid"),
                        (t.style.height = "1px"),
                        (n.style.height = "9px"),
                        (n.style.display = "block"),
                        ae.appendChild(e).appendChild(t).appendChild(n),
                        (r = i.getComputedStyle(t)),
                        (o =
                          parseInt(r.height, 10) +
                            parseInt(r.borderTopWidth, 10) +
                            parseInt(r.borderBottomWidth, 10) ===
                          t.offsetHeight),
                        ae.removeChild(e)),
                      o
                    );
                  },
                }));
            })();
            var Ge = ["Webkit", "Moz", "ms"],
              Xe = x.createElement("div").style,
              Ye = {};
            function Ue(e) {
              var t = T.cssProps[e] || Ye[e];
              return (
                t ||
                (e in Xe
                  ? e
                  : (Ye[e] =
                      (function (e) {
                        for (
                          var t = e[0].toUpperCase() + e.slice(1), n = Ge.length;
                          n--;
  
                        )
                          if ((e = Ge[n] + t) in Xe) return e;
                      })(e) || e))
              );
            }
            var Ke = /^(none|table(?!-c[ea]).+)/,
              Ze = /^--/,
              Qe = {
                position: "absolute",
                visibility: "hidden",
                display: "block",
              },
              Je = { letterSpacing: "0", fontWeight: "400" };
            function et(e, t, n) {
              var i = re.exec(t);
              return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
            }
            function tt(e, t, n, i, r, s) {
              var a = "width" === t ? 1 : 0,
                o = 0,
                l = 0;
              if (n === (i ? "border" : "content")) return 0;
              for (; a < 4; a += 2)
                "margin" === n && (l += T.css(e, n + se[a], !0, r)),
                  i
                    ? ("content" === n &&
                        (l -= T.css(e, "padding" + se[a], !0, r)),
                      "margin" !== n &&
                        (l -= T.css(e, "border" + se[a] + "Width", !0, r)))
                    : ((l += T.css(e, "padding" + se[a], !0, r)),
                      "padding" !== n
                        ? (l += T.css(e, "border" + se[a] + "Width", !0, r))
                        : (o += T.css(e, "border" + se[a] + "Width", !0, r)));
              return (
                !i &&
                  s >= 0 &&
                  (l +=
                    Math.max(
                      0,
                      Math.ceil(
                        e["offset" + t[0].toUpperCase() + t.slice(1)] -
                          s -
                          l -
                          o -
                          0.5
                      )
                    ) || 0),
                l
              );
            }
            function nt(e, t, n) {
              var i = Fe(e),
                r =
                  (!v.boxSizingReliable() || n) &&
                  "border-box" === T.css(e, "boxSizing", !1, i),
                s = r,
                a = Re(e, t, i),
                o = "offset" + t[0].toUpperCase() + t.slice(1);
              if (He.test(a)) {
                if (!n) return a;
                a = "auto";
              }
              return (
                ((!v.boxSizingReliable() && r) ||
                  (!v.reliableTrDimensions() && j(e, "tr")) ||
                  "auto" === a ||
                  (!parseFloat(a) && "inline" === T.css(e, "display", !1, i))) &&
                  e.getClientRects().length &&
                  ((r = "border-box" === T.css(e, "boxSizing", !1, i)),
                  (s = o in e) && (a = e[o])),
                (a = parseFloat(a) || 0) +
                  tt(e, t, n || (r ? "border" : "content"), s, i, a) +
                  "px"
              );
            }
            function it(e, t, n, i, r) {
              return new it.prototype.init(e, t, n, i, r);
            }
            T.extend({
              cssHooks: {
                opacity: {
                  get: function (e, t) {
                    if (t) {
                      var n = Re(e, "opacity");
                      return "" === n ? "1" : n;
                    }
                  },
                },
              },
              cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
              },
              cssProps: {},
              style: function (e, t, n, i) {
                if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                  var r,
                    s,
                    a,
                    o = U(t),
                    l = Ze.test(t),
                    c = e.style;
                  if (
                    (l || (t = Ue(o)),
                    (a = T.cssHooks[t] || T.cssHooks[o]),
                    void 0 === n)
                  )
                    return a && "get" in a && void 0 !== (r = a.get(e, !1, i))
                      ? r
                      : c[t];
                  "string" === (s = typeof n) &&
                    (r = re.exec(n)) &&
                    r[1] &&
                    ((n = de(e, t, r)), (s = "number")),
                    null != n &&
                      n == n &&
                      ("number" !== s ||
                        l ||
                        (n += (r && r[3]) || (T.cssNumber[o] ? "" : "px")),
                      v.clearCloneStyle ||
                        "" !== n ||
                        0 !== t.indexOf("background") ||
                        (c[t] = "inherit"),
                      (a && "set" in a && void 0 === (n = a.set(e, n, i))) ||
                        (l ? c.setProperty(t, n) : (c[t] = n)));
                }
              },
              css: function (e, t, n, i) {
                var r,
                  s,
                  a,
                  o = U(t);
                return (
                  Ze.test(t) || (t = Ue(o)),
                  (a = T.cssHooks[t] || T.cssHooks[o]) &&
                    "get" in a &&
                    (r = a.get(e, !0, n)),
                  void 0 === r && (r = Re(e, t, i)),
                  "normal" === r && t in Je && (r = Je[t]),
                  "" === n || n
                    ? ((s = parseFloat(r)), !0 === n || isFinite(s) ? s || 0 : r)
                    : r
                );
              },
            }),
              T.each(["height", "width"], function (e, t) {
                T.cssHooks[t] = {
                  get: function (e, n, i) {
                    if (n)
                      return !Ke.test(T.css(e, "display")) ||
                        (e.getClientRects().length &&
                          e.getBoundingClientRect().width)
                        ? nt(e, t, i)
                        : Be(e, Qe, function () {
                            return nt(e, t, i);
                          });
                  },
                  set: function (e, n, i) {
                    var r,
                      s = Fe(e),
                      a = !v.scrollboxSize() && "absolute" === s.position,
                      o =
                        (a || i) && "border-box" === T.css(e, "boxSizing", !1, s),
                      l = i ? tt(e, t, i, o, s) : 0;
                    return (
                      o &&
                        a &&
                        (l -= Math.ceil(
                          e["offset" + t[0].toUpperCase() + t.slice(1)] -
                            parseFloat(s[t]) -
                            tt(e, t, "border", !1, s) -
                            0.5
                        )),
                      l &&
                        (r = re.exec(n)) &&
                        "px" !== (r[3] || "px") &&
                        ((e.style[t] = n), (n = T.css(e, t))),
                      et(0, n, l)
                    );
                  },
                };
              }),
              (T.cssHooks.marginLeft = Ve(v.reliableMarginLeft, function (e, t) {
                if (t)
                  return (
                    (parseFloat(Re(e, "marginLeft")) ||
                      e.getBoundingClientRect().left -
                        Be(e, { marginLeft: 0 }, function () {
                          return e.getBoundingClientRect().left;
                        })) + "px"
                  );
              })),
              T.each(
                { margin: "", padding: "", border: "Width" },
                function (e, t) {
                  (T.cssHooks[e + t] = {
                    expand: function (n) {
                      for (
                        var i = 0,
                          r = {},
                          s = "string" == typeof n ? n.split(" ") : [n];
                        i < 4;
                        i++
                      )
                        r[e + se[i] + t] = s[i] || s[i - 2] || s[0];
                      return r;
                    },
                  }),
                    "margin" !== e && (T.cssHooks[e + t].set = et);
                }
              ),
              T.fn.extend({
                css: function (e, t) {
                  return V(
                    this,
                    function (e, t, n) {
                      var i,
                        r,
                        s = {},
                        a = 0;
                      if (Array.isArray(t)) {
                        for (i = Fe(e), r = t.length; a < r; a++)
                          s[t[a]] = T.css(e, t[a], !1, i);
                        return s;
                      }
                      return void 0 !== n ? T.style(e, t, n) : T.css(e, t);
                    },
                    e,
                    t,
                    arguments.length > 1
                  );
                },
              }),
              (T.Tween = it),
              (it.prototype = {
                constructor: it,
                init: function (e, t, n, i, r, s) {
                  (this.elem = e),
                    (this.prop = n),
                    (this.easing = r || T.easing._default),
                    (this.options = t),
                    (this.start = this.now = this.cur()),
                    (this.end = i),
                    (this.unit = s || (T.cssNumber[n] ? "" : "px"));
                },
                cur: function () {
                  var e = it.propHooks[this.prop];
                  return e && e.get
                    ? e.get(this)
                    : it.propHooks._default.get(this);
                },
                run: function (e) {
                  var t,
                    n = it.propHooks[this.prop];
                  return (
                    this.options.duration
                      ? (this.pos = t =
                          T.easing[this.easing](
                            e,
                            this.options.duration * e,
                            0,
                            1,
                            this.options.duration
                          ))
                      : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step &&
                      this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : it.propHooks._default.set(this),
                    this
                  );
                },
              }),
              (it.prototype.init.prototype = it.prototype),
              (it.propHooks = {
                _default: {
                  get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType ||
                      (null != e.elem[e.prop] && null == e.elem.style[e.prop])
                      ? e.elem[e.prop]
                      : (t = T.css(e.elem, e.prop, "")) && "auto" !== t
                      ? t
                      : 0;
                  },
                  set: function (e) {
                    T.fx.step[e.prop]
                      ? T.fx.step[e.prop](e)
                      : 1 !== e.elem.nodeType ||
                        (!T.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)])
                      ? (e.elem[e.prop] = e.now)
                      : T.style(e.elem, e.prop, e.now + e.unit);
                  },
                },
              }),
              (it.propHooks.scrollTop = it.propHooks.scrollLeft =
                {
                  set: function (e) {
                    e.elem.nodeType &&
                      e.elem.parentNode &&
                      (e.elem[e.prop] = e.now);
                  },
                }),
              (T.easing = {
                linear: function (e) {
                  return e;
                },
                swing: function (e) {
                  return 0.5 - Math.cos(e * Math.PI) / 2;
                },
                _default: "swing",
              }),
              (T.fx = it.prototype.init),
              (T.fx.step = {});
            var rt,
              st,
              at = /^(?:toggle|show|hide)$/,
              ot = /queueHooks$/;
            function lt() {
              st &&
                (!1 === x.hidden && i.requestAnimationFrame
                  ? i.requestAnimationFrame(lt)
                  : i.setTimeout(lt, T.fx.interval),
                T.fx.tick());
            }
            function ct() {
              return (
                i.setTimeout(function () {
                  rt = void 0;
                }),
                (rt = Date.now())
              );
            }
            function dt(e, t) {
              var n,
                i = 0,
                r = { height: e };
              for (t = t ? 1 : 0; i < 4; i += 2 - t)
                r["margin" + (n = se[i])] = r["padding" + n] = e;
              return t && (r.opacity = r.width = e), r;
            }
            function ut(e, t, n) {
              for (
                var i,
                  r = (pt.tweeners[t] || []).concat(pt.tweeners["*"]),
                  s = 0,
                  a = r.length;
                s < a;
                s++
              )
                if ((i = r[s].call(n, t, e))) return i;
            }
            function pt(e, t, n) {
              var i,
                r,
                s = 0,
                a = pt.prefilters.length,
                o = T.Deferred().always(function () {
                  delete l.elem;
                }),
                l = function () {
                  if (r) return !1;
                  for (
                    var t = rt || ct(),
                      n = Math.max(0, c.startTime + c.duration - t),
                      i = 1 - (n / c.duration || 0),
                      s = 0,
                      a = c.tweens.length;
                    s < a;
                    s++
                  )
                    c.tweens[s].run(i);
                  return (
                    o.notifyWith(e, [c, i, n]),
                    i < 1 && a
                      ? n
                      : (a || o.notifyWith(e, [c, 1, 0]),
                        o.resolveWith(e, [c]),
                        !1)
                  );
                },
                c = o.promise({
                  elem: e,
                  props: T.extend({}, t),
                  opts: T.extend(
                    !0,
                    { specialEasing: {}, easing: T.easing._default },
                    n
                  ),
                  originalProperties: t,
                  originalOptions: n,
                  startTime: rt || ct(),
                  duration: n.duration,
                  tweens: [],
                  createTween: function (t, n) {
                    var i = T.Tween(
                      e,
                      c.opts,
                      t,
                      n,
                      c.opts.specialEasing[t] || c.opts.easing
                    );
                    return c.tweens.push(i), i;
                  },
                  stop: function (t) {
                    var n = 0,
                      i = t ? c.tweens.length : 0;
                    if (r) return this;
                    for (r = !0; n < i; n++) c.tweens[n].run(1);
                    return (
                      t
                        ? (o.notifyWith(e, [c, 1, 0]), o.resolveWith(e, [c, t]))
                        : o.rejectWith(e, [c, t]),
                      this
                    );
                  },
                }),
                d = c.props;
              for (
                !(function (e, t) {
                  var n, i, r, s, a;
                  for (n in e)
                    if (
                      ((r = t[(i = U(n))]),
                      (s = e[n]),
                      Array.isArray(s) && ((r = s[1]), (s = e[n] = s[0])),
                      n !== i && ((e[i] = s), delete e[n]),
                      (a = T.cssHooks[i]) && ("expand" in a))
                    )
                      for (n in ((s = a.expand(s)), delete e[i], s))
                        (n in e) || ((e[n] = s[n]), (t[n] = r));
                    else t[i] = r;
                })(d, c.opts.specialEasing);
                s < a;
                s++
              )
                if ((i = pt.prefilters[s].call(c, e, d, c.opts)))
                  return (
                    y(i.stop) &&
                      (T._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)),
                    i
                  );
              return (
                T.map(d, ut, c),
                y(c.opts.start) && c.opts.start.call(e, c),
                c
                  .progress(c.opts.progress)
                  .done(c.opts.done, c.opts.complete)
                  .fail(c.opts.fail)
                  .always(c.opts.always),
                T.fx.timer(
                  T.extend(l, { elem: e, anim: c, queue: c.opts.queue })
                ),
                c
              );
            }
            (T.Animation = T.extend(pt, {
              tweeners: {
                "*": [
                  function (e, t) {
                    var n = this.createTween(e, t);
                    return de(n.elem, e, re.exec(t), n), n;
                  },
                ],
              },
              tweener: function (e, t) {
                y(e) ? ((t = e), (e = ["*"])) : (e = e.match(N));
                for (var n, i = 0, r = e.length; i < r; i++)
                  (n = e[i]),
                    (pt.tweeners[n] = pt.tweeners[n] || []),
                    pt.tweeners[n].unshift(t);
              },
              prefilters: [
                function (e, t, n) {
                  var i,
                    r,
                    s,
                    a,
                    o,
                    l,
                    c,
                    d,
                    u = "width" in t || "height" in t,
                    p = this,
                    h = {},
                    f = e.style,
                    m = e.nodeType && ce(e),
                    v = Q.get(e, "fxshow");
                  for (i in (n.queue ||
                    (null == (a = T._queueHooks(e, "fx")).unqueued &&
                      ((a.unqueued = 0),
                      (o = a.empty.fire),
                      (a.empty.fire = function () {
                        a.unqueued || o();
                      })),
                    a.unqueued++,
                    p.always(function () {
                      p.always(function () {
                        a.unqueued--, T.queue(e, "fx").length || a.empty.fire();
                      });
                    })),
                  t))
                    if (((r = t[i]), at.test(r))) {
                      if (
                        (delete t[i],
                        (s = s || "toggle" === r),
                        r === (m ? "hide" : "show"))
                      ) {
                        if ("show" !== r || !v || void 0 === v[i]) continue;
                        m = !0;
                      }
                      h[i] = (v && v[i]) || T.style(e, i);
                    }
                  if ((l = !T.isEmptyObject(t)) || !T.isEmptyObject(h))
                    for (i in (u &&
                      1 === e.nodeType &&
                      ((n.overflow = [f.overflow, f.overflowX, f.overflowY]),
                      null == (c = v && v.display) && (c = Q.get(e, "display")),
                      "none" === (d = T.css(e, "display")) &&
                        (c
                          ? (d = c)
                          : (he([e], !0),
                            (c = e.style.display || c),
                            (d = T.css(e, "display")),
                            he([e]))),
                      ("inline" === d || ("inline-block" === d && null != c)) &&
                        "none" === T.css(e, "float") &&
                        (l ||
                          (p.done(function () {
                            f.display = c;
                          }),
                          null == c &&
                            ((d = f.display), (c = "none" === d ? "" : d))),
                        (f.display = "inline-block"))),
                    n.overflow &&
                      ((f.overflow = "hidden"),
                      p.always(function () {
                        (f.overflow = n.overflow[0]),
                          (f.overflowX = n.overflow[1]),
                          (f.overflowY = n.overflow[2]);
                      })),
                    (l = !1),
                    h))
                      l ||
                        (v
                          ? "hidden" in v && (m = v.hidden)
                          : (v = Q.access(e, "fxshow", { display: c })),
                        s && (v.hidden = !m),
                        m && he([e], !0),
                        p.done(function () {
                          for (i in (m || he([e]), Q.remove(e, "fxshow"), h))
                            T.style(e, i, h[i]);
                        })),
                        (l = ut(m ? v[i] : 0, i, p)),
                        i in v ||
                          ((v[i] = l.start),
                          m && ((l.end = l.start), (l.start = 0)));
                },
              ],
              prefilter: function (e, t) {
                t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
              },
            })),
              (T.speed = function (e, t, n) {
                var i =
                  e && "object" == typeof e
                    ? T.extend({}, e)
                    : {
                        complete: n || (!n && t) || (y(e) && e),
                        duration: e,
                        easing: (n && t) || (t && !y(t) && t),
                      };
                return (
                  T.fx.off
                    ? (i.duration = 0)
                    : "number" != typeof i.duration &&
                      (i.duration in T.fx.speeds
                        ? (i.duration = T.fx.speeds[i.duration])
                        : (i.duration = T.fx.speeds._default)),
                  (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                  (i.old = i.complete),
                  (i.complete = function () {
                    y(i.old) && i.old.call(this),
                      i.queue && T.dequeue(this, i.queue);
                  }),
                  i
                );
              }),
              T.fn.extend({
                fadeTo: function (e, t, n, i) {
                  return this.filter(ce)
                    .css("opacity", 0)
                    .show()
                    .end()
                    .animate({ opacity: t }, e, n, i);
                },
                animate: function (e, t, n, i) {
                  var r = T.isEmptyObject(e),
                    s = T.speed(t, n, i),
                    a = function () {
                      var t = pt(this, T.extend({}, e), s);
                      (r || Q.get(this, "finish")) && t.stop(!0);
                    };
                  return (
                    (a.finish = a),
                    r || !1 === s.queue ? this.each(a) : this.queue(s.queue, a)
                  );
                },
                stop: function (e, t, n) {
                  var i = function (e) {
                    var t = e.stop;
                    delete e.stop, t(n);
                  };
                  return (
                    "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                    t && this.queue(e || "fx", []),
                    this.each(function () {
                      var t = !0,
                        r = null != e && e + "queueHooks",
                        s = T.timers,
                        a = Q.get(this);
                      if (r) a[r] && a[r].stop && i(a[r]);
                      else
                        for (r in a) a[r] && a[r].stop && ot.test(r) && i(a[r]);
                      for (r = s.length; r--; )
                        s[r].elem !== this ||
                          (null != e && s[r].queue !== e) ||
                          (s[r].anim.stop(n), (t = !1), s.splice(r, 1));
                      (!t && n) || T.dequeue(this, e);
                    })
                  );
                },
                finish: function (e) {
                  return (
                    !1 !== e && (e = e || "fx"),
                    this.each(function () {
                      var t,
                        n = Q.get(this),
                        i = n[e + "queue"],
                        r = n[e + "queueHooks"],
                        s = T.timers,
                        a = i ? i.length : 0;
                      for (
                        n.finish = !0,
                          T.queue(this, e, []),
                          r && r.stop && r.stop.call(this, !0),
                          t = s.length;
                        t--;
  
                      )
                        s[t].elem === this &&
                          s[t].queue === e &&
                          (s[t].anim.stop(!0), s.splice(t, 1));
                      for (t = 0; t < a; t++)
                        i[t] && i[t].finish && i[t].finish.call(this);
                      delete n.finish;
                    })
                  );
                },
              }),
              T.each(["toggle", "show", "hide"], function (e, t) {
                var n = T.fn[t];
                T.fn[t] = function (e, i, r) {
                  return null == e || "boolean" == typeof e
                    ? n.apply(this, arguments)
                    : this.animate(dt(t, !0), e, i, r);
                };
              }),
              T.each(
                {
                  slideDown: dt("show"),
                  slideUp: dt("hide"),
                  slideToggle: dt("toggle"),
                  fadeIn: { opacity: "show" },
                  fadeOut: { opacity: "hide" },
                  fadeToggle: { opacity: "toggle" },
                },
                function (e, t) {
                  T.fn[e] = function (e, n, i) {
                    return this.animate(t, e, n, i);
                  };
                }
              ),
              (T.timers = []),
              (T.fx.tick = function () {
                var e,
                  t = 0,
                  n = T.timers;
                for (rt = Date.now(); t < n.length; t++)
                  (e = n[t])() || n[t] !== e || n.splice(t--, 1);
                n.length || T.fx.stop(), (rt = void 0);
              }),
              (T.fx.timer = function (e) {
                T.timers.push(e), T.fx.start();
              }),
              (T.fx.interval = 13),
              (T.fx.start = function () {
                st || ((st = !0), lt());
              }),
              (T.fx.stop = function () {
                st = null;
              }),
              (T.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
              (T.fn.delay = function (e, t) {
                return (
                  (e = (T.fx && T.fx.speeds[e]) || e),
                  (t = t || "fx"),
                  this.queue(t, function (t, n) {
                    var r = i.setTimeout(t, e);
                    n.stop = function () {
                      i.clearTimeout(r);
                    };
                  })
                );
              }),
              (function () {
                var e = x.createElement("input"),
                  t = x
                    .createElement("select")
                    .appendChild(x.createElement("option"));
                (e.type = "checkbox"),
                  (v.checkOn = "" !== e.value),
                  (v.optSelected = t.selected),
                  ((e = x.createElement("input")).value = "t"),
                  (e.type = "radio"),
                  (v.radioValue = "t" === e.value);
              })();
            var ht,
              ft = T.expr.attrHandle;
            T.fn.extend({
              attr: function (e, t) {
                return V(this, T.attr, e, t, arguments.length > 1);
              },
              removeAttr: function (e) {
                return this.each(function () {
                  T.removeAttr(this, e);
                });
              },
            }),
              T.extend({
                attr: function (e, t, n) {
                  var i,
                    r,
                    s = e.nodeType;
                  if (3 !== s && 8 !== s && 2 !== s)
                    return void 0 === e.getAttribute
                      ? T.prop(e, t, n)
                      : ((1 === s && T.isXMLDoc(e)) ||
                          (r =
                            T.attrHooks[t.toLowerCase()] ||
                            (T.expr.match.bool.test(t) ? ht : void 0)),
                        void 0 !== n
                          ? null === n
                            ? void T.removeAttr(e, t)
                            : r && "set" in r && void 0 !== (i = r.set(e, n, t))
                            ? i
                            : (e.setAttribute(t, n + ""), n)
                          : r && "get" in r && null !== (i = r.get(e, t))
                          ? i
                          : null == (i = T.find.attr(e, t))
                          ? void 0
                          : i);
                },
                attrHooks: {
                  type: {
                    set: function (e, t) {
                      if (!v.radioValue && "radio" === t && j(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t;
                      }
                    },
                  },
                },
                removeAttr: function (e, t) {
                  var n,
                    i = 0,
                    r = t && t.match(N);
                  if (r && 1 === e.nodeType)
                    for (; (n = r[i++]); ) e.removeAttribute(n);
                },
              }),
              (ht = {
                set: function (e, t, n) {
                  return !1 === t ? T.removeAttr(e, n) : e.setAttribute(n, n), n;
                },
              }),
              T.each(T.expr.match.bool.source.match(/\w+/g), function (e, t) {
                var n = ft[t] || T.find.attr;
                ft[t] = function (e, t, i) {
                  var r,
                    s,
                    a = t.toLowerCase();
                  return (
                    i ||
                      ((s = ft[a]),
                      (ft[a] = r),
                      (r = null != n(e, t, i) ? a : null),
                      (ft[a] = s)),
                    r
                  );
                };
              });
            var mt = /^(?:input|select|textarea|button)$/i,
              vt = /^(?:a|area)$/i;
            function yt(e) {
              return (e.match(N) || []).join(" ");
            }
            function gt(e) {
              return (e.getAttribute && e.getAttribute("class")) || "";
            }
            function xt(e) {
              return Array.isArray(e)
                ? e
                : ("string" == typeof e && e.match(N)) || [];
            }
            T.fn.extend({
              prop: function (e, t) {
                return V(this, T.prop, e, t, arguments.length > 1);
              },
              removeProp: function (e) {
                return this.each(function () {
                  delete this[T.propFix[e] || e];
                });
              },
            }),
              T.extend({
                prop: function (e, t, n) {
                  var i,
                    r,
                    s = e.nodeType;
                  if (3 !== s && 8 !== s && 2 !== s)
                    return (
                      (1 === s && T.isXMLDoc(e)) ||
                        ((t = T.propFix[t] || t), (r = T.propHooks[t])),
                      void 0 !== n
                        ? r && "set" in r && void 0 !== (i = r.set(e, n, t))
                          ? i
                          : (e[t] = n)
                        : r && "get" in r && null !== (i = r.get(e, t))
                        ? i
                        : e[t]
                    );
                },
                propHooks: {
                  tabIndex: {
                    get: function (e) {
                      var t = T.find.attr(e, "tabindex");
                      return t
                        ? parseInt(t, 10)
                        : mt.test(e.nodeName) || (vt.test(e.nodeName) && e.href)
                        ? 0
                        : -1;
                    },
                  },
                },
                propFix: { for: "htmlFor", class: "className" },
              }),
              v.optSelected ||
                (T.propHooks.selected = {
                  get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                  },
                  set: function (e) {
                    var t = e.parentNode;
                    t &&
                      (t.selectedIndex,
                      t.parentNode && t.parentNode.selectedIndex);
                  },
                }),
              T.each(
                [
                  "tabIndex",
                  "readOnly",
                  "maxLength",
                  "cellSpacing",
                  "cellPadding",
                  "rowSpan",
                  "colSpan",
                  "useMap",
                  "frameBorder",
                  "contentEditable",
                ],
                function () {
                  T.propFix[this.toLowerCase()] = this;
                }
              ),
              T.fn.extend({
                addClass: function (e) {
                  var t,
                    n,
                    i,
                    r,
                    s,
                    a,
                    o,
                    l = 0;
                  if (y(e))
                    return this.each(function (t) {
                      T(this).addClass(e.call(this, t, gt(this)));
                    });
                  if ((t = xt(e)).length)
                    for (; (n = this[l++]); )
                      if (
                        ((r = gt(n)), (i = 1 === n.nodeType && " " + yt(r) + " "))
                      ) {
                        for (a = 0; (s = t[a++]); )
                          i.indexOf(" " + s + " ") < 0 && (i += s + " ");
                        r !== (o = yt(i)) && n.setAttribute("class", o);
                      }
                  return this;
                },
                removeClass: function (e) {
                  var t,
                    n,
                    i,
                    r,
                    s,
                    a,
                    o,
                    l = 0;
                  if (y(e))
                    return this.each(function (t) {
                      T(this).removeClass(e.call(this, t, gt(this)));
                    });
                  if (!arguments.length) return this.attr("class", "");
                  if ((t = xt(e)).length)
                    for (; (n = this[l++]); )
                      if (
                        ((r = gt(n)), (i = 1 === n.nodeType && " " + yt(r) + " "))
                      ) {
                        for (a = 0; (s = t[a++]); )
                          for (; i.indexOf(" " + s + " ") > -1; )
                            i = i.replace(" " + s + " ", " ");
                        r !== (o = yt(i)) && n.setAttribute("class", o);
                      }
                  return this;
                },
                toggleClass: function (e, t) {
                  var n = typeof e,
                    i = "string" === n || Array.isArray(e);
                  return "boolean" == typeof t && i
                    ? t
                      ? this.addClass(e)
                      : this.removeClass(e)
                    : y(e)
                    ? this.each(function (n) {
                        T(this).toggleClass(e.call(this, n, gt(this), t), t);
                      })
                    : this.each(function () {
                        var t, r, s, a;
                        if (i)
                          for (r = 0, s = T(this), a = xt(e); (t = a[r++]); )
                            s.hasClass(t) ? s.removeClass(t) : s.addClass(t);
                        else
                          (void 0 !== e && "boolean" !== n) ||
                            ((t = gt(this)) && Q.set(this, "__className__", t),
                            this.setAttribute &&
                              this.setAttribute(
                                "class",
                                t || !1 === e
                                  ? ""
                                  : Q.get(this, "__className__") || ""
                              ));
                      });
                },
                hasClass: function (e) {
                  var t,
                    n,
                    i = 0;
                  for (t = " " + e + " "; (n = this[i++]); )
                    if (
                      1 === n.nodeType &&
                      (" " + yt(gt(n)) + " ").indexOf(t) > -1
                    )
                      return !0;
                  return !1;
                },
              });
            var bt = /\r/g;
            T.fn.extend({
              val: function (e) {
                var t,
                  n,
                  i,
                  r = this[0];
                return arguments.length
                  ? ((i = y(e)),
                    this.each(function (n) {
                      var r;
                      1 === this.nodeType &&
                        (null == (r = i ? e.call(this, n, T(this).val()) : e)
                          ? (r = "")
                          : "number" == typeof r
                          ? (r += "")
                          : Array.isArray(r) &&
                            (r = T.map(r, function (e) {
                              return null == e ? "" : e + "";
                            })),
                        ((t =
                          T.valHooks[this.type] ||
                          T.valHooks[this.nodeName.toLowerCase()]) &&
                          "set" in t &&
                          void 0 !== t.set(this, r, "value")) ||
                          (this.value = r));
                    }))
                  : r
                  ? (t =
                      T.valHooks[r.type] ||
                      T.valHooks[r.nodeName.toLowerCase()]) &&
                    "get" in t &&
                    void 0 !== (n = t.get(r, "value"))
                    ? n
                    : "string" == typeof (n = r.value)
                    ? n.replace(bt, "")
                    : null == n
                    ? ""
                    : n
                  : void 0;
              },
            }),
              T.extend({
                valHooks: {
                  option: {
                    get: function (e) {
                      var t = T.find.attr(e, "value");
                      return null != t ? t : yt(T.text(e));
                    },
                  },
                  select: {
                    get: function (e) {
                      var t,
                        n,
                        i,
                        r = e.options,
                        s = e.selectedIndex,
                        a = "select-one" === e.type,
                        o = a ? null : [],
                        l = a ? s + 1 : r.length;
                      for (i = s < 0 ? l : a ? s : 0; i < l; i++)
                        if (
                          ((n = r[i]).selected || i === s) &&
                          !n.disabled &&
                          (!n.parentNode.disabled || !j(n.parentNode, "optgroup"))
                        ) {
                          if (((t = T(n).val()), a)) return t;
                          o.push(t);
                        }
                      return o;
                    },
                    set: function (e, t) {
                      for (
                        var n, i, r = e.options, s = T.makeArray(t), a = r.length;
                        a--;
  
                      )
                        ((i = r[a]).selected =
                          T.inArray(T.valHooks.option.get(i), s) > -1) &&
                          (n = !0);
                      return n || (e.selectedIndex = -1), s;
                    },
                  },
                },
              }),
              T.each(["radio", "checkbox"], function () {
                (T.valHooks[this] = {
                  set: function (e, t) {
                    if (Array.isArray(t))
                      return (e.checked = T.inArray(T(e).val(), t) > -1);
                  },
                }),
                  v.checkOn ||
                    (T.valHooks[this].get = function (e) {
                      return null === e.getAttribute("value") ? "on" : e.value;
                    });
              }),
              (v.focusin = "onfocusin" in i);
            var wt = /^(?:focusinfocus|focusoutblur)$/,
              St = function (e) {
                e.stopPropagation();
              };
            T.extend(T.event, {
              trigger: function (e, t, n, r) {
                var s,
                  a,
                  o,
                  l,
                  c,
                  d,
                  u,
                  p,
                  f = [n || x],
                  m = h.call(e, "type") ? e.type : e,
                  v = h.call(e, "namespace") ? e.namespace.split(".") : [];
                if (
                  ((a = p = o = n = n || x),
                  3 !== n.nodeType &&
                    8 !== n.nodeType &&
                    !wt.test(m + T.event.triggered) &&
                    (m.indexOf(".") > -1 &&
                      ((v = m.split(".")), (m = v.shift()), v.sort()),
                    (c = m.indexOf(":") < 0 && "on" + m),
                    ((e = e[T.expando]
                      ? e
                      : new T.Event(m, "object" == typeof e && e)).isTrigger = r
                      ? 2
                      : 3),
                    (e.namespace = v.join(".")),
                    (e.rnamespace = e.namespace
                      ? new RegExp(
                          "(^|\\.)" + v.join("\\.(?:.*\\.|)") + "(\\.|$)"
                        )
                      : null),
                    (e.result = void 0),
                    e.target || (e.target = n),
                    (t = null == t ? [e] : T.makeArray(t, [e])),
                    (u = T.event.special[m] || {}),
                    r || !u.trigger || !1 !== u.trigger.apply(n, t)))
                ) {
                  if (!r && !u.noBubble && !g(n)) {
                    for (
                      l = u.delegateType || m,
                        wt.test(l + m) || (a = a.parentNode);
                      a;
                      a = a.parentNode
                    )
                      f.push(a), (o = a);
                    o === (n.ownerDocument || x) &&
                      f.push(o.defaultView || o.parentWindow || i);
                  }
                  for (s = 0; (a = f[s++]) && !e.isPropagationStopped(); )
                    (p = a),
                      (e.type = s > 1 ? l : u.bindType || m),
                      (d =
                        (Q.get(a, "events") || Object.create(null))[e.type] &&
                        Q.get(a, "handle")) && d.apply(a, t),
                      (d = c && a[c]) &&
                        d.apply &&
                        K(a) &&
                        ((e.result = d.apply(a, t)),
                        !1 === e.result && e.preventDefault());
                  return (
                    (e.type = m),
                    r ||
                      e.isDefaultPrevented() ||
                      (u._default && !1 !== u._default.apply(f.pop(), t)) ||
                      !K(n) ||
                      (c &&
                        y(n[m]) &&
                        !g(n) &&
                        ((o = n[c]) && (n[c] = null),
                        (T.event.triggered = m),
                        e.isPropagationStopped() && p.addEventListener(m, St),
                        n[m](),
                        e.isPropagationStopped() && p.removeEventListener(m, St),
                        (T.event.triggered = void 0),
                        o && (n[c] = o))),
                    e.result
                  );
                }
              },
              simulate: function (e, t, n) {
                var i = T.extend(new T.Event(), n, { type: e, isSimulated: !0 });
                T.event.trigger(i, null, t);
              },
            }),
              T.fn.extend({
                trigger: function (e, t) {
                  return this.each(function () {
                    T.event.trigger(e, t, this);
                  });
                },
                triggerHandler: function (e, t) {
                  var n = this[0];
                  if (n) return T.event.trigger(e, t, n, !0);
                },
              }),
              v.focusin ||
                T.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                  var n = function (e) {
                    T.event.simulate(t, e.target, T.event.fix(e));
                  };
                  T.event.special[t] = {
                    setup: function () {
                      var i = this.ownerDocument || this.document || this,
                        r = Q.access(i, t);
                      r || i.addEventListener(e, n, !0),
                        Q.access(i, t, (r || 0) + 1);
                    },
                    teardown: function () {
                      var i = this.ownerDocument || this.document || this,
                        r = Q.access(i, t) - 1;
                      r
                        ? Q.access(i, t, r)
                        : (i.removeEventListener(e, n, !0), Q.remove(i, t));
                    },
                  };
                });
            var Ct = i.location,
              Tt = { guid: Date.now() },
              _t = /\?/;
            T.parseXML = function (e) {
              var t, n;
              if (!e || "string" != typeof e) return null;
              try {
                t = new i.DOMParser().parseFromString(e, "text/xml");
              } catch (e) {}
              return (
                (n = t && t.getElementsByTagName("parsererror")[0]),
                (t && !n) ||
                  T.error(
                    "Invalid XML: " +
                      (n
                        ? T.map(n.childNodes, function (e) {
                            return e.textContent;
                          }).join("\n")
                        : e)
                  ),
                t
              );
            };
            var Et = /\[\]$/,
              kt = /\r?\n/g,
              $t = /^(?:submit|button|image|reset|file)$/i,
              Mt = /^(?:input|select|textarea|keygen)/i;
            function jt(e, t, n, i) {
              var r;
              if (Array.isArray(t))
                T.each(t, function (t, r) {
                  n || Et.test(e)
                    ? i(e, r)
                    : jt(
                        e +
                          "[" +
                          ("object" == typeof r && null != r ? t : "") +
                          "]",
                        r,
                        n,
                        i
                      );
                });
              else if (n || "object" !== S(t)) i(e, t);
              else for (r in t) jt(e + "[" + r + "]", t[r], n, i);
            }
            (T.param = function (e, t) {
              var n,
                i = [],
                r = function (e, t) {
                  var n = y(t) ? t() : t;
                  i[i.length] =
                    encodeURIComponent(e) +
                    "=" +
                    encodeURIComponent(null == n ? "" : n);
                };
              if (null == e) return "";
              if (Array.isArray(e) || (e.jquery && !T.isPlainObject(e)))
                T.each(e, function () {
                  r(this.name, this.value);
                });
              else for (n in e) jt(n, e[n], t, r);
              return i.join("&");
            }),
              T.fn.extend({
                serialize: function () {
                  return T.param(this.serializeArray());
                },
                serializeArray: function () {
                  return this.map(function () {
                    var e = T.prop(this, "elements");
                    return e ? T.makeArray(e) : this;
                  })
                    .filter(function () {
                      var e = this.type;
                      return (
                        this.name &&
                        !T(this).is(":disabled") &&
                        Mt.test(this.nodeName) &&
                        !$t.test(e) &&
                        (this.checked || !ve.test(e))
                      );
                    })
                    .map(function (e, t) {
                      var n = T(this).val();
                      return null == n
                        ? null
                        : Array.isArray(n)
                        ? T.map(n, function (e) {
                            return { name: t.name, value: e.replace(kt, "\r\n") };
                          })
                        : { name: t.name, value: n.replace(kt, "\r\n") };
                    })
                    .get();
                },
              });
            var At = /%20/g,
              Lt = /#.*$/,
              It = /([?&])_=[^&]*/,
              Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
              Pt = /^(?:GET|HEAD)$/,
              Dt = /^\/\//,
              zt = {},
              Nt = {},
              qt = "*/".concat("*"),
              Ht = x.createElement("a");
            function Ft(e) {
              return function (t, n) {
                "string" != typeof t && ((n = t), (t = "*"));
                var i,
                  r = 0,
                  s = t.toLowerCase().match(N) || [];
                if (y(n))
                  for (; (i = s[r++]); )
                    "+" === i[0]
                      ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n))
                      : (e[i] = e[i] || []).push(n);
              };
            }
            function Bt(e, t, n, i) {
              var r = {},
                s = e === Nt;
              function a(o) {
                var l;
                return (
                  (r[o] = !0),
                  T.each(e[o] || [], function (e, o) {
                    var c = o(t, n, i);
                    return "string" != typeof c || s || r[c]
                      ? s
                        ? !(l = c)
                        : void 0
                      : (t.dataTypes.unshift(c), a(c), !1);
                  }),
                  l
                );
              }
              return a(t.dataTypes[0]) || (!r["*"] && a("*"));
            }
            function Wt(e, t) {
              var n,
                i,
                r = T.ajaxSettings.flatOptions || {};
              for (n in t)
                void 0 !== t[n] && ((r[n] ? e : i || (i = {}))[n] = t[n]);
              return i && T.extend(!0, e, i), e;
            }
            (Ht.href = Ct.href),
              T.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                  url: Ct.href,
                  type: "GET",
                  isLocal:
                    /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
                      Ct.protocol
                    ),
                  global: !0,
                  processData: !0,
                  async: !0,
                  contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                  accepts: {
                    "*": qt,
                    text: "text/plain",
                    html: "text/html",
                    xml: "application/xml, text/xml",
                    json: "application/json, text/javascript",
                  },
                  contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                  responseFields: {
                    xml: "responseXML",
                    text: "responseText",
                    json: "responseJSON",
                  },
                  converters: {
                    "* text": String,
                    "text html": !0,
                    "text json": JSON.parse,
                    "text xml": T.parseXML,
                  },
                  flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (e, t) {
                  return t ? Wt(Wt(e, T.ajaxSettings), t) : Wt(T.ajaxSettings, e);
                },
                ajaxPrefilter: Ft(zt),
                ajaxTransport: Ft(Nt),
                ajax: function (e, t) {
                  "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
                  var n,
                    r,
                    s,
                    a,
                    o,
                    l,
                    c,
                    d,
                    u,
                    p,
                    h = T.ajaxSetup({}, t),
                    f = h.context || h,
                    m = h.context && (f.nodeType || f.jquery) ? T(f) : T.event,
                    v = T.Deferred(),
                    y = T.Callbacks("once memory"),
                    g = h.statusCode || {},
                    b = {},
                    w = {},
                    S = "canceled",
                    C = {
                      readyState: 0,
                      getResponseHeader: function (e) {
                        var t;
                        if (c) {
                          if (!a)
                            for (a = {}; (t = Ot.exec(s)); )
                              a[t[1].toLowerCase() + " "] = (
                                a[t[1].toLowerCase() + " "] || []
                              ).concat(t[2]);
                          t = a[e.toLowerCase() + " "];
                        }
                        return null == t ? null : t.join(", ");
                      },
                      getAllResponseHeaders: function () {
                        return c ? s : null;
                      },
                      setRequestHeader: function (e, t) {
                        return (
                          null == c &&
                            ((e = w[e.toLowerCase()] = w[e.toLowerCase()] || e),
                            (b[e] = t)),
                          this
                        );
                      },
                      overrideMimeType: function (e) {
                        return null == c && (h.mimeType = e), this;
                      },
                      statusCode: function (e) {
                        var t;
                        if (e)
                          if (c) C.always(e[C.status]);
                          else for (t in e) g[t] = [g[t], e[t]];
                        return this;
                      },
                      abort: function (e) {
                        var t = e || S;
                        return n && n.abort(t), _(0, t), this;
                      },
                    };
                  if (
                    (v.promise(C),
                    (h.url = ((e || h.url || Ct.href) + "").replace(
                      Dt,
                      Ct.protocol + "//"
                    )),
                    (h.type = t.method || t.type || h.method || h.type),
                    (h.dataTypes = (h.dataType || "*").toLowerCase().match(N) || [
                      "",
                    ]),
                    null == h.crossDomain)
                  ) {
                    l = x.createElement("a");
                    try {
                      (l.href = h.url),
                        (l.href = l.href),
                        (h.crossDomain =
                          Ht.protocol + "//" + Ht.host !=
                          l.protocol + "//" + l.host);
                    } catch (e) {
                      h.crossDomain = !0;
                    }
                  }
                  if (
                    (h.data &&
                      h.processData &&
                      "string" != typeof h.data &&
                      (h.data = T.param(h.data, h.traditional)),
                    Bt(zt, h, t, C),
                    c)
                  )
                    return C;
                  for (u in ((d = T.event && h.global) &&
                    0 == T.active++ &&
                    T.event.trigger("ajaxStart"),
                  (h.type = h.type.toUpperCase()),
                  (h.hasContent = !Pt.test(h.type)),
                  (r = h.url.replace(Lt, "")),
                  h.hasContent
                    ? h.data &&
                      h.processData &&
                      0 ===
                        (h.contentType || "").indexOf(
                          "application/x-www-form-urlencoded"
                        ) &&
                      (h.data = h.data.replace(At, "+"))
                    : ((p = h.url.slice(r.length)),
                      h.data &&
                        (h.processData || "string" == typeof h.data) &&
                        ((r += (_t.test(r) ? "&" : "?") + h.data), delete h.data),
                      !1 === h.cache &&
                        ((r = r.replace(It, "$1")),
                        (p = (_t.test(r) ? "&" : "?") + "_=" + Tt.guid++ + p)),
                      (h.url = r + p)),
                  h.ifModified &&
                    (T.lastModified[r] &&
                      C.setRequestHeader("If-Modified-Since", T.lastModified[r]),
                    T.etag[r] && C.setRequestHeader("If-None-Match", T.etag[r])),
                  ((h.data && h.hasContent && !1 !== h.contentType) ||
                    t.contentType) &&
                    C.setRequestHeader("Content-Type", h.contentType),
                  C.setRequestHeader(
                    "Accept",
                    h.dataTypes[0] && h.accepts[h.dataTypes[0]]
                      ? h.accepts[h.dataTypes[0]] +
                          ("*" !== h.dataTypes[0] ? ", " + qt + "; q=0.01" : "")
                      : h.accepts["*"]
                  ),
                  h.headers))
                    C.setRequestHeader(u, h.headers[u]);
                  if (h.beforeSend && (!1 === h.beforeSend.call(f, C, h) || c))
                    return C.abort();
                  if (
                    ((S = "abort"),
                    y.add(h.complete),
                    C.done(h.success),
                    C.fail(h.error),
                    (n = Bt(Nt, h, t, C)))
                  ) {
                    if (
                      ((C.readyState = 1), d && m.trigger("ajaxSend", [C, h]), c)
                    )
                      return C;
                    h.async &&
                      h.timeout > 0 &&
                      (o = i.setTimeout(function () {
                        C.abort("timeout");
                      }, h.timeout));
                    try {
                      (c = !1), n.send(b, _);
                    } catch (e) {
                      if (c) throw e;
                      _(-1, e);
                    }
                  } else _(-1, "No Transport");
                  function _(e, t, a, l) {
                    var u,
                      p,
                      x,
                      b,
                      w,
                      S = t;
                    c ||
                      ((c = !0),
                      o && i.clearTimeout(o),
                      (n = void 0),
                      (s = l || ""),
                      (C.readyState = e > 0 ? 4 : 0),
                      (u = (e >= 200 && e < 300) || 304 === e),
                      a &&
                        (b = (function (e, t, n) {
                          for (
                            var i, r, s, a, o = e.contents, l = e.dataTypes;
                            "*" === l[0];
  
                          )
                            l.shift(),
                              void 0 === i &&
                                (i =
                                  e.mimeType ||
                                  t.getResponseHeader("Content-Type"));
                          if (i)
                            for (r in o)
                              if (o[r] && o[r].test(i)) {
                                l.unshift(r);
                                break;
                              }
                          if (l[0] in n) s = l[0];
                          else {
                            for (r in n) {
                              if (!l[0] || e.converters[r + " " + l[0]]) {
                                s = r;
                                break;
                              }
                              a || (a = r);
                            }
                            s = s || a;
                          }
                          if (s) return s !== l[0] && l.unshift(s), n[s];
                        })(h, C, a)),
                      !u &&
                        T.inArray("script", h.dataTypes) > -1 &&
                        T.inArray("json", h.dataTypes) < 0 &&
                        (h.converters["text script"] = function () {}),
                      (b = (function (e, t, n, i) {
                        var r,
                          s,
                          a,
                          o,
                          l,
                          c = {},
                          d = e.dataTypes.slice();
                        if (d[1])
                          for (a in e.converters)
                            c[a.toLowerCase()] = e.converters[a];
                        for (s = d.shift(); s; )
                          if (
                            (e.responseFields[s] && (n[e.responseFields[s]] = t),
                            !l &&
                              i &&
                              e.dataFilter &&
                              (t = e.dataFilter(t, e.dataType)),
                            (l = s),
                            (s = d.shift()))
                          )
                            if ("*" === s) s = l;
                            else if ("*" !== l && l !== s) {
                              if (!(a = c[l + " " + s] || c["* " + s]))
                                for (r in c)
                                  if (
                                    (o = r.split(" "))[1] === s &&
                                    (a = c[l + " " + o[0]] || c["* " + o[0]])
                                  ) {
                                    !0 === a
                                      ? (a = c[r])
                                      : !0 !== c[r] &&
                                        ((s = o[0]), d.unshift(o[1]));
                                    break;
                                  }
                              if (!0 !== a)
                                if (a && e.throws) t = a(t);
                                else
                                  try {
                                    t = a(t);
                                  } catch (e) {
                                    return {
                                      state: "parsererror",
                                      error: a
                                        ? e
                                        : "No conversion from " + l + " to " + s,
                                    };
                                  }
                            }
                        return { state: "success", data: t };
                      })(h, b, C, u)),
                      u
                        ? (h.ifModified &&
                            ((w = C.getResponseHeader("Last-Modified")) &&
                              (T.lastModified[r] = w),
                            (w = C.getResponseHeader("etag")) && (T.etag[r] = w)),
                          204 === e || "HEAD" === h.type
                            ? (S = "nocontent")
                            : 304 === e
                            ? (S = "notmodified")
                            : ((S = b.state), (p = b.data), (u = !(x = b.error))))
                        : ((x = S),
                          (!e && S) || ((S = "error"), e < 0 && (e = 0))),
                      (C.status = e),
                      (C.statusText = (t || S) + ""),
                      u
                        ? v.resolveWith(f, [p, S, C])
                        : v.rejectWith(f, [C, S, x]),
                      C.statusCode(g),
                      (g = void 0),
                      d &&
                        m.trigger(u ? "ajaxSuccess" : "ajaxError", [
                          C,
                          h,
                          u ? p : x,
                        ]),
                      y.fireWith(f, [C, S]),
                      d &&
                        (m.trigger("ajaxComplete", [C, h]),
                        --T.active || T.event.trigger("ajaxStop")));
                  }
                  return C;
                },
                getJSON: function (e, t, n) {
                  return T.get(e, t, n, "json");
                },
                getScript: function (e, t) {
                  return T.get(e, void 0, t, "script");
                },
              }),
              T.each(["get", "post"], function (e, t) {
                T[t] = function (e, n, i, r) {
                  return (
                    y(n) && ((r = r || i), (i = n), (n = void 0)),
                    T.ajax(
                      T.extend(
                        { url: e, type: t, dataType: r, data: n, success: i },
                        T.isPlainObject(e) && e
                      )
                    )
                  );
                };
              }),
              T.ajaxPrefilter(function (e) {
                var t;
                for (t in e.headers)
                  "content-type" === t.toLowerCase() &&
                    (e.contentType = e.headers[t] || "");
              }),
              (T._evalUrl = function (e, t, n) {
                return T.ajax({
                  url: e,
                  type: "GET",
                  dataType: "script",
                  cache: !0,
                  async: !1,
                  global: !1,
                  converters: { "text script": function () {} },
                  dataFilter: function (e) {
                    T.globalEval(e, t, n);
                  },
                });
              }),
              T.fn.extend({
                wrapAll: function (e) {
                  var t;
                  return (
                    this[0] &&
                      (y(e) && (e = e.call(this[0])),
                      (t = T(e, this[0].ownerDocument).eq(0).clone(!0)),
                      this[0].parentNode && t.insertBefore(this[0]),
                      t
                        .map(function () {
                          for (var e = this; e.firstElementChild; )
                            e = e.firstElementChild;
                          return e;
                        })
                        .append(this)),
                    this
                  );
                },
                wrapInner: function (e) {
                  return y(e)
                    ? this.each(function (t) {
                        T(this).wrapInner(e.call(this, t));
                      })
                    : this.each(function () {
                        var t = T(this),
                          n = t.contents();
                        n.length ? n.wrapAll(e) : t.append(e);
                      });
                },
                wrap: function (e) {
                  var t = y(e);
                  return this.each(function (n) {
                    T(this).wrapAll(t ? e.call(this, n) : e);
                  });
                },
                unwrap: function (e) {
                  return (
                    this.parent(e)
                      .not("body")
                      .each(function () {
                        T(this).replaceWith(this.childNodes);
                      }),
                    this
                  );
                },
              }),
              (T.expr.pseudos.hidden = function (e) {
                return !T.expr.pseudos.visible(e);
              }),
              (T.expr.pseudos.visible = function (e) {
                return !!(
                  e.offsetWidth ||
                  e.offsetHeight ||
                  e.getClientRects().length
                );
              }),
              (T.ajaxSettings.xhr = function () {
                try {
                  return new i.XMLHttpRequest();
                } catch (e) {}
              });
            var Rt = { 0: 200, 1223: 204 },
              Vt = T.ajaxSettings.xhr();
            (v.cors = !!Vt && "withCredentials" in Vt),
              (v.ajax = Vt = !!Vt),
              T.ajaxTransport(function (e) {
                var t, n;
                if (v.cors || (Vt && !e.crossDomain))
                  return {
                    send: function (r, s) {
                      var a,
                        o = e.xhr();
                      if (
                        (o.open(e.type, e.url, e.async, e.username, e.password),
                        e.xhrFields)
                      )
                        for (a in e.xhrFields) o[a] = e.xhrFields[a];
                      for (a in (e.mimeType &&
                        o.overrideMimeType &&
                        o.overrideMimeType(e.mimeType),
                      e.crossDomain ||
                        r["X-Requested-With"] ||
                        (r["X-Requested-With"] = "XMLHttpRequest"),
                      r))
                        o.setRequestHeader(a, r[a]);
                      (t = function (e) {
                        return function () {
                          t &&
                            ((t =
                              n =
                              o.onload =
                              o.onerror =
                              o.onabort =
                              o.ontimeout =
                              o.onreadystatechange =
                                null),
                            "abort" === e
                              ? o.abort()
                              : "error" === e
                              ? "number" != typeof o.status
                                ? s(0, "error")
                                : s(o.status, o.statusText)
                              : s(
                                  Rt[o.status] || o.status,
                                  o.statusText,
                                  "text" !== (o.responseType || "text") ||
                                    "string" != typeof o.responseText
                                    ? { binary: o.response }
                                    : { text: o.responseText },
                                  o.getAllResponseHeaders()
                                ));
                        };
                      }),
                        (o.onload = t()),
                        (n = o.onerror = o.ontimeout = t("error")),
                        void 0 !== o.onabort
                          ? (o.onabort = n)
                          : (o.onreadystatechange = function () {
                              4 === o.readyState &&
                                i.setTimeout(function () {
                                  t && n();
                                });
                            }),
                        (t = t("abort"));
                      try {
                        o.send((e.hasContent && e.data) || null);
                      } catch (e) {
                        if (t) throw e;
                      }
                    },
                    abort: function () {
                      t && t();
                    },
                  };
              }),
              T.ajaxPrefilter(function (e) {
                e.crossDomain && (e.contents.script = !1);
              }),
              T.ajaxSetup({
                accepts: {
                  script:
                    "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
                },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                  "text script": function (e) {
                    return T.globalEval(e), e;
                  },
                },
              }),
              T.ajaxPrefilter("script", function (e) {
                void 0 === e.cache && (e.cache = !1),
                  e.crossDomain && (e.type = "GET");
              }),
              T.ajaxTransport("script", function (e) {
                var t, n;
                if (e.crossDomain || e.scriptAttrs)
                  return {
                    send: function (i, r) {
                      (t = T("<script>")
                        .attr(e.scriptAttrs || {})
                        .prop({ charset: e.scriptCharset, src: e.url })
                        .on(
                          "load error",
                          (n = function (e) {
                            t.remove(),
                              (n = null),
                              e && r("error" === e.type ? 404 : 200, e.type);
                          })
                        )),
                        x.head.appendChild(t[0]);
                    },
                    abort: function () {
                      n && n();
                    },
                  };
              });
            var Gt,
              Xt = [],
              Yt = /(=)\?(?=&|$)|\?\?/;
            T.ajaxSetup({
              jsonp: "callback",
              jsonpCallback: function () {
                var e = Xt.pop() || T.expando + "_" + Tt.guid++;
                return (this[e] = !0), e;
              },
            }),
              T.ajaxPrefilter("json jsonp", function (e, t, n) {
                var r,
                  s,
                  a,
                  o =
                    !1 !== e.jsonp &&
                    (Yt.test(e.url)
                      ? "url"
                      : "string" == typeof e.data &&
                        0 ===
                          (e.contentType || "").indexOf(
                            "application/x-www-form-urlencoded"
                          ) &&
                        Yt.test(e.data) &&
                        "data");
                if (o || "jsonp" === e.dataTypes[0])
                  return (
                    (r = e.jsonpCallback =
                      y(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                    o
                      ? (e[o] = e[o].replace(Yt, "$1" + r))
                      : !1 !== e.jsonp &&
                        (e.url +=
                          (_t.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
                    (e.converters["script json"] = function () {
                      return a || T.error(r + " was not called"), a[0];
                    }),
                    (e.dataTypes[0] = "json"),
                    (s = i[r]),
                    (i[r] = function () {
                      a = arguments;
                    }),
                    n.always(function () {
                      void 0 === s ? T(i).removeProp(r) : (i[r] = s),
                        e[r] && ((e.jsonpCallback = t.jsonpCallback), Xt.push(r)),
                        a && y(s) && s(a[0]),
                        (a = s = void 0);
                    }),
                    "script"
                  );
              }),
              (v.createHTMLDocument =
                (((Gt = x.implementation.createHTMLDocument("").body).innerHTML =
                  "<form></form><form></form>"),
                2 === Gt.childNodes.length)),
              (T.parseHTML = function (e, t, n) {
                return "string" != typeof e
                  ? []
                  : ("boolean" == typeof t && ((n = t), (t = !1)),
                    t ||
                      (v.createHTMLDocument
                        ? (((i = (t =
                            x.implementation.createHTMLDocument(
                              ""
                            )).createElement("base")).href = x.location.href),
                          t.head.appendChild(i))
                        : (t = x)),
                    (s = !n && []),
                    (r = A.exec(e))
                      ? [t.createElement(r[1])]
                      : ((r = Ce([e], t, s)),
                        s && s.length && T(s).remove(),
                        T.merge([], r.childNodes)));
                var i, r, s;
              }),
              (T.fn.load = function (e, t, n) {
                var i,
                  r,
                  s,
                  a = this,
                  o = e.indexOf(" ");
                return (
                  o > -1 && ((i = yt(e.slice(o))), (e = e.slice(0, o))),
                  y(t)
                    ? ((n = t), (t = void 0))
                    : t && "object" == typeof t && (r = "POST"),
                  a.length > 0 &&
                    T.ajax({
                      url: e,
                      type: r || "GET",
                      dataType: "html",
                      data: t,
                    })
                      .done(function (e) {
                        (s = arguments),
                          a.html(
                            i ? T("<div>").append(T.parseHTML(e)).find(i) : e
                          );
                      })
                      .always(
                        n &&
                          function (e, t) {
                            a.each(function () {
                              n.apply(this, s || [e.responseText, t, e]);
                            });
                          }
                      ),
                  this
                );
              }),
              (T.expr.pseudos.animated = function (e) {
                return T.grep(T.timers, function (t) {
                  return e === t.elem;
                }).length;
              }),
              (T.offset = {
                setOffset: function (e, t, n) {
                  var i,
                    r,
                    s,
                    a,
                    o,
                    l,
                    c = T.css(e, "position"),
                    d = T(e),
                    u = {};
                  "static" === c && (e.style.position = "relative"),
                    (o = d.offset()),
                    (s = T.css(e, "top")),
                    (l = T.css(e, "left")),
                    ("absolute" === c || "fixed" === c) &&
                    (s + l).indexOf("auto") > -1
                      ? ((a = (i = d.position()).top), (r = i.left))
                      : ((a = parseFloat(s) || 0), (r = parseFloat(l) || 0)),
                    y(t) && (t = t.call(e, n, T.extend({}, o))),
                    null != t.top && (u.top = t.top - o.top + a),
                    null != t.left && (u.left = t.left - o.left + r),
                    "using" in t ? t.using.call(e, u) : d.css(u);
                },
              }),
              T.fn.extend({
                offset: function (e) {
                  if (arguments.length)
                    return void 0 === e
                      ? this
                      : this.each(function (t) {
                          T.offset.setOffset(this, e, t);
                        });
                  var t,
                    n,
                    i = this[0];
                  return i
                    ? i.getClientRects().length
                      ? ((t = i.getBoundingClientRect()),
                        (n = i.ownerDocument.defaultView),
                        {
                          top: t.top + n.pageYOffset,
                          left: t.left + n.pageXOffset,
                        })
                      : { top: 0, left: 0 }
                    : void 0;
                },
                position: function () {
                  if (this[0]) {
                    var e,
                      t,
                      n,
                      i = this[0],
                      r = { top: 0, left: 0 };
                    if ("fixed" === T.css(i, "position"))
                      t = i.getBoundingClientRect();
                    else {
                      for (
                        t = this.offset(),
                          n = i.ownerDocument,
                          e = i.offsetParent || n.documentElement;
                        e &&
                        (e === n.body || e === n.documentElement) &&
                        "static" === T.css(e, "position");
  
                      )
                        e = e.parentNode;
                      e &&
                        e !== i &&
                        1 === e.nodeType &&
                        (((r = T(e).offset()).top += T.css(
                          e,
                          "borderTopWidth",
                          !0
                        )),
                        (r.left += T.css(e, "borderLeftWidth", !0)));
                    }
                    return {
                      top: t.top - r.top - T.css(i, "marginTop", !0),
                      left: t.left - r.left - T.css(i, "marginLeft", !0),
                    };
                  }
                },
                offsetParent: function () {
                  return this.map(function () {
                    for (
                      var e = this.offsetParent;
                      e && "static" === T.css(e, "position");
  
                    )
                      e = e.offsetParent;
                    return e || ae;
                  });
                },
              }),
              T.each(
                { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
                function (e, t) {
                  var n = "pageYOffset" === t;
                  T.fn[e] = function (i) {
                    return V(
                      this,
                      function (e, i, r) {
                        var s;
                        if (
                          (g(e)
                            ? (s = e)
                            : 9 === e.nodeType && (s = e.defaultView),
                          void 0 === r)
                        )
                          return s ? s[t] : e[i];
                        s
                          ? s.scrollTo(
                              n ? s.pageXOffset : r,
                              n ? r : s.pageYOffset
                            )
                          : (e[i] = r);
                      },
                      e,
                      i,
                      arguments.length
                    );
                  };
                }
              ),
              T.each(["top", "left"], function (e, t) {
                T.cssHooks[t] = Ve(v.pixelPosition, function (e, n) {
                  if (n)
                    return (
                      (n = Re(e, t)), He.test(n) ? T(e).position()[t] + "px" : n
                    );
                });
              }),
              T.each({ Height: "height", Width: "width" }, function (e, t) {
                T.each(
                  { padding: "inner" + e, content: t, "": "outer" + e },
                  function (n, i) {
                    T.fn[i] = function (r, s) {
                      var a = arguments.length && (n || "boolean" != typeof r),
                        o = n || (!0 === r || !0 === s ? "margin" : "border");
                      return V(
                        this,
                        function (t, n, r) {
                          var s;
                          return g(t)
                            ? 0 === i.indexOf("outer")
                              ? t["inner" + e]
                              : t.document.documentElement["client" + e]
                            : 9 === t.nodeType
                            ? ((s = t.documentElement),
                              Math.max(
                                t.body["scroll" + e],
                                s["scroll" + e],
                                t.body["offset" + e],
                                s["offset" + e],
                                s["client" + e]
                              ))
                            : void 0 === r
                            ? T.css(t, n, o)
                            : T.style(t, n, r, o);
                        },
                        t,
                        a ? r : void 0,
                        a
                      );
                    };
                  }
                );
              }),
              T.each(
                [
                  "ajaxStart",
                  "ajaxStop",
                  "ajaxComplete",
                  "ajaxError",
                  "ajaxSuccess",
                  "ajaxSend",
                ],
                function (e, t) {
                  T.fn[t] = function (e) {
                    return this.on(t, e);
                  };
                }
              ),
              T.fn.extend({
                bind: function (e, t, n) {
                  return this.on(e, null, t, n);
                },
                unbind: function (e, t) {
                  return this.off(e, null, t);
                },
                delegate: function (e, t, n, i) {
                  return this.on(t, e, n, i);
                },
                undelegate: function (e, t, n) {
                  return 1 === arguments.length
                    ? this.off(e, "**")
                    : this.off(t, e || "**", n);
                },
                hover: function (e, t) {
                  return this.mouseenter(e).mouseleave(t || e);
                },
              }),
              T.each(
                "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                  " "
                ),
                function (e, t) {
                  T.fn[t] = function (e, n) {
                    return arguments.length > 0
                      ? this.on(t, null, e, n)
                      : this.trigger(t);
                  };
                }
              );
            var Ut = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            (T.proxy = function (e, t) {
              var n, i, r;
              if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), y(e)))
                return (
                  (i = o.call(arguments, 2)),
                  (r = function () {
                    return e.apply(t || this, i.concat(o.call(arguments)));
                  }),
                  (r.guid = e.guid = e.guid || T.guid++),
                  r
                );
            }),
              (T.holdReady = function (e) {
                e ? T.readyWait++ : T.ready(!0);
              }),
              (T.isArray = Array.isArray),
              (T.parseJSON = JSON.parse),
              (T.nodeName = j),
              (T.isFunction = y),
              (T.isWindow = g),
              (T.camelCase = U),
              (T.type = S),
              (T.now = Date.now),
              (T.isNumeric = function (e) {
                var t = T.type(e);
                return (
                  ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
                );
              }),
              (T.trim = function (e) {
                return null == e ? "" : (e + "").replace(Ut, "");
              }),
              void 0 ===
                (n = function () {
                  return T;
                }.apply(t, [])) || (e.exports = n);
            var Kt = i.jQuery,
              Zt = i.$;
            return (
              (T.noConflict = function (e) {
                return (
                  i.$ === T && (i.$ = Zt),
                  e && i.jQuery === T && (i.jQuery = Kt),
                  T
                );
              }),
              void 0 === r && (i.jQuery = i.$ = T),
              T
            );
          });
        },
        933: (e, t, n) => {
          "use strict";
          var i,
            r,
            s,
            a = n(816),
            o = n(626),
            l = !1,
            c = window.document,
            d = c.documentElement,
            u = window.navigator.msPointerEnabled,
            p = {
              start: u ? "MSPointerDown" : "touchstart",
              move: u ? "MSPointerMove" : "touchmove",
              end: u ? "MSPointerUp" : "touchend",
            },
            h = (function () {
              var e = /^(Webkit|Khtml|Moz|ms|O)(?=[A-Z])/,
                t = c.getElementsByTagName("script")[0].style;
              for (var n in t)
                if (e.test(n)) return "-" + n.match(e)[0].toLowerCase() + "-";
              return "WebkitOpacity" in t
                ? "-webkit-"
                : "KhtmlOpacity" in t
                ? "-khtml-"
                : "";
            })();
          function f(e) {
            (e = e || {}),
              (this._startOffsetX = 0),
              (this._currentOffsetX = 0),
              (this._opening = !1),
              (this._moved = !1),
              (this._opened = !1),
              (this._preventOpen = !1),
              (this._touch = (void 0 === e.touch || e.touch) && !0),
              (this._side = e.side || "left"),
              (this.panel = e.panel),
              (this.menu = e.menu),
              this.panel.classList.contains("slideout-panel") ||
                this.panel.classList.add("slideout-panel"),
              this.panel.classList.contains("slideout-panel-" + this._side) ||
                this.panel.classList.add("slideout-panel-" + this._side),
              this.menu.classList.contains("slideout-menu") ||
                this.menu.classList.add("slideout-menu"),
              this.menu.classList.contains("slideout-menu-" + this._side) ||
                this.menu.classList.add("slideout-menu-" + this._side),
              (this._fx = e.fx || "ease"),
              (this._duration = parseInt(e.duration, 10) || 300),
              (this._tolerance = parseInt(e.tolerance, 10) || 70),
              (this._padding = this._translateTo =
                parseInt(e.padding, 10) || 256),
              (this._orientation = "right" === this._side ? -1 : 1),
              (this._translateTo *= this._orientation),
              this._touch && this._initTouchEvents();
          }
          (s = o),
            ((r = f).prototype = (function (e, t) {
              for (var n in t) t[n] && (e[n] = t[n]);
              return e;
            })(r.prototype || {}, s.prototype)),
            (f.prototype.open = function () {
              var e = this;
              return (
                this.emit("beforeopen"),
                d.classList.contains("slideout-open") ||
                  d.classList.add("slideout-open"),
                this._setTransition(),
                this._translateXTo(this._translateTo),
                (this._opened = !0),
                setTimeout(function () {
                  (e.panel.style.transition = e.panel.style[
                    "-webkit-transition"
                  ] =
                    ""),
                    e.emit("open");
                }, this._duration + 50),
                this
              );
            }),
            (f.prototype.close = function () {
              var e = this;
              return this.isOpen() || this._opening
                ? (this.emit("beforeclose"),
                  this._setTransition(),
                  this._translateXTo(0),
                  (this._opened = !1),
                  setTimeout(function () {
                    d.classList.remove("slideout-open"),
                      (e.panel.style.transition =
                        e.panel.style["-webkit-transition"] =
                        e.panel.style[h + "transform"] =
                        e.panel.style.transform =
                          ""),
                      e.emit("close");
                  }, this._duration + 50),
                  this)
                : this;
            }),
            (f.prototype.toggle = function () {
              return this.isOpen() ? this.close() : this.open();
            }),
            (f.prototype.isOpen = function () {
              return this._opened;
            }),
            (f.prototype._translateXTo = function (e) {
              return (
                (this._currentOffsetX = e),
                (this.panel.style[h + "transform"] = this.panel.style.transform =
                  "translateX(" + e + "px)"),
                this
              );
            }),
            (f.prototype._setTransition = function () {
              return (
                (this.panel.style[h + "transition"] =
                  this.panel.style.transition =
                    h + "transform " + this._duration + "ms " + this._fx),
                this
              );
            }),
            (f.prototype._initTouchEvents = function () {
              var e = this;
              return (
                (this._onScrollFn = a(c, "scroll", function () {
                  e._moved ||
                    (clearTimeout(i),
                    (l = !0),
                    (i = setTimeout(function () {
                      l = !1;
                    }, 250)));
                })),
                (this._preventMove = function (t) {
                  e._moved && t.preventDefault();
                }),
                c.addEventListener(p.move, this._preventMove),
                (this._resetTouchFn = function (t) {
                  void 0 !== t.touches &&
                    ((e._moved = !1),
                    (e._opening = !1),
                    (e._startOffsetX = t.touches[0].pageX),
                    (e._preventOpen =
                      !e._touch || (!e.isOpen() && 0 !== e.menu.clientWidth)));
                }),
                this.panel.addEventListener(p.start, this._resetTouchFn),
                (this._onTouchCancelFn = function () {
                  (e._moved = !1), (e._opening = !1);
                }),
                this.panel.addEventListener("touchcancel", this._onTouchCancelFn),
                (this._onTouchEndFn = function () {
                  e._moved &&
                    (e.emit("translateend"),
                    e._opening && Math.abs(e._currentOffsetX) > e._tolerance
                      ? e.open()
                      : e.close()),
                    (e._moved = !1);
                }),
                this.panel.addEventListener(p.end, this._onTouchEndFn),
                (this._onTouchMoveFn = function (t) {
                  if (
                    !(
                      l ||
                      e._preventOpen ||
                      void 0 === t.touches ||
                      (function (e) {
                        for (; e.parentNode; ) {
                          if (null !== e.getAttribute("data-slideout-ignore"))
                            return e;
                          e = e.parentNode;
                        }
                        return null;
                      })(t.target)
                    )
                  ) {
                    var n = t.touches[0].clientX - e._startOffsetX,
                      i = (e._currentOffsetX = n);
                    if (!(Math.abs(i) > e._padding) && Math.abs(n) > 20) {
                      e._opening = !0;
                      var r = n * e._orientation;
                      if ((e._opened && r > 0) || (!e._opened && r < 0)) return;
                      e._moved || e.emit("translatestart"),
                        r <= 0 &&
                          ((i = n + e._padding * e._orientation),
                          (e._opening = !1)),
                        (e._moved && d.classList.contains("slideout-open")) ||
                          d.classList.add("slideout-open"),
                        (e.panel.style[h + "transform"] =
                          e.panel.style.transform =
                            "translateX(" + i + "px)"),
                        e.emit("translate", i),
                        (e._moved = !0);
                    }
                  }
                }),
                this.panel.addEventListener(p.move, this._onTouchMoveFn),
                this
              );
            }),
            (f.prototype.enableTouch = function () {
              return (this._touch = !0), this;
            }),
            (f.prototype.disableTouch = function () {
              return (this._touch = !1), this;
            }),
            (f.prototype.destroy = function () {
              return (
                this.close(),
                c.removeEventListener(p.move, this._preventMove),
                this.panel.removeEventListener(p.start, this._resetTouchFn),
                this.panel.removeEventListener(
                  "touchcancel",
                  this._onTouchCancelFn
                ),
                this.panel.removeEventListener(p.end, this._onTouchEndFn),
                this.panel.removeEventListener(p.move, this._onTouchMoveFn),
                c.removeEventListener("scroll", this._onScrollFn),
                (this.open = this.close = function () {}),
                this
              );
            }),
            (e.exports = f);
        },
        630: function (e, t) {
          var n, i, r;
          (i = [e, t]),
            (n = function (e, t) {
              "use strict";
              var n, i;
              function r(e, t) {
                if (!(e instanceof t))
                  throw new TypeError("Cannot call a class as a function");
              }
              Object.defineProperty(t, "__esModule", { value: !0 });
              var s = (function () {
                function e(e, t) {
                  for (var n = 0; n < t.length; n++) {
                    var i = t[n];
                    (i.enumerable = i.enumerable || !1),
                      (i.configurable = !0),
                      "value" in i && (i.writable = !0),
                      Object.defineProperty(e, i.key, i);
                  }
                }
                return function (t, n, i) {
                  return n && e(t.prototype, n), i && e(t, i), t;
                };
              })();
              function a(e, t) {
                return t.indexOf(e) >= 0;
              }
              function o(e, t) {
                for (var n in t)
                  if (null == e[n]) {
                    var i = t[n];
                    e[n] = i;
                  }
                return e;
              }
              function l(e) {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  e
                );
              }
              function c(e) {
                var t =
                    !(arguments.length <= 1 || void 0 === arguments[1]) &&
                    arguments[1],
                  n =
                    !(arguments.length <= 2 || void 0 === arguments[2]) &&
                    arguments[2],
                  i =
                    arguments.length <= 3 || void 0 === arguments[3]
                      ? null
                      : arguments[3],
                  r = void 0;
                return (
                  null != document.createEvent
                    ? (r = document.createEvent("CustomEvent")).initCustomEvent(
                        e,
                        t,
                        n,
                        i
                      )
                    : null != document.createEventObject
                    ? ((r = document.createEventObject()).eventType = e)
                    : (r.eventName = e),
                  r
                );
              }
              function d(e, t) {
                null != e.dispatchEvent
                  ? e.dispatchEvent(t)
                  : t in (null != e)
                  ? e[t]()
                  : "on" + t in (null != e) && e["on" + t]();
              }
              function u(e, t, n) {
                null != e.addEventListener
                  ? e.addEventListener(t, n, !1)
                  : null != e.attachEvent
                  ? e.attachEvent("on" + t, n)
                  : (e[t] = n);
              }
              function p(e, t, n) {
                null != e.removeEventListener
                  ? e.removeEventListener(t, n, !1)
                  : null != e.detachEvent
                  ? e.detachEvent("on" + t, n)
                  : delete e[t];
              }
              function h() {
                return "innerHeight" in window
                  ? window.innerHeight
                  : document.documentElement.clientHeight;
              }
              var f =
                  window.WeakMap ||
                  window.MozWeakMap ||
                  (function () {
                    function e() {
                      r(this, e), (this.keys = []), (this.values = []);
                    }
                    return (
                      s(e, [
                        {
                          key: "get",
                          value: function (e) {
                            for (var t = 0; t < this.keys.length; t++)
                              if (this.keys[t] === e) return this.values[t];
                          },
                        },
                        {
                          key: "set",
                          value: function (e, t) {
                            for (var n = 0; n < this.keys.length; n++)
                              if (this.keys[n] === e)
                                return (this.values[n] = t), this;
                            return this.keys.push(e), this.values.push(t), this;
                          },
                        },
                      ]),
                      e
                    );
                  })(),
                m =
                  window.MutationObserver ||
                  window.WebkitMutationObserver ||
                  window.MozMutationObserver ||
                  ((i = n =
                    (function () {
                      function e() {
                        r(this, e),
                          "undefined" != typeof console &&
                            null !== console &&
                            (console.warn(
                              "MutationObserver is not supported by your browser."
                            ),
                            console.warn(
                              "WOW.js cannot detect dom mutations, please call .sync() after loading new content."
                            ));
                      }
                      return s(e, [{ key: "observe", value: function () {} }]), e;
                    })()),
                  (n.notSupported = !0),
                  i),
                v =
                  window.getComputedStyle ||
                  function (e) {
                    var t = /(\-([a-z]){1})/g;
                    return {
                      getPropertyValue: function (n) {
                        "float" === n && (n = "styleFloat"),
                          t.test(n) &&
                            n.replace(t, function (e, t) {
                              return t.toUpperCase();
                            });
                        var i = e.currentStyle;
                        return (null != i ? i[n] : void 0) || null;
                      },
                    };
                  },
                y = (function () {
                  function e() {
                    var t =
                      arguments.length <= 0 || void 0 === arguments[0]
                        ? {}
                        : arguments[0];
                    r(this, e),
                      (this.defaults = {
                        boxClass: "wow",
                        animateClass: "animated",
                        offset: 0,
                        mobile: !0,
                        live: !0,
                        callback: null,
                        scrollContainer: null,
                      }),
                      (this.animate =
                        "requestAnimationFrame" in window
                          ? function (e) {
                              return window.requestAnimationFrame(e);
                            }
                          : function (e) {
                              return e();
                            }),
                      (this.vendors = ["moz", "webkit"]),
                      (this.start = this.start.bind(this)),
                      (this.resetAnimation = this.resetAnimation.bind(this)),
                      (this.scrollHandler = this.scrollHandler.bind(this)),
                      (this.scrollCallback = this.scrollCallback.bind(this)),
                      (this.scrolled = !0),
                      (this.config = o(t, this.defaults)),
                      null != t.scrollContainer &&
                        (this.config.scrollContainer = document.querySelector(
                          t.scrollContainer
                        )),
                      (this.animationNameCache = new f()),
                      (this.wowEvent = c(this.config.boxClass));
                  }
                  return (
                    s(e, [
                      {
                        key: "init",
                        value: function () {
                          (this.element = window.document.documentElement),
                            a(document.readyState, ["interactive", "complete"])
                              ? this.start()
                              : u(document, "DOMContentLoaded", this.start),
                            (this.finished = []);
                        },
                      },
                      {
                        key: "start",
                        value: function () {
                          var e = this;
                          if (
                            ((this.stopped = !1),
                            (this.boxes = [].slice.call(
                              this.element.querySelectorAll(
                                "." + this.config.boxClass
                              )
                            )),
                            (this.all = this.boxes.slice(0)),
                            this.boxes.length)
                          )
                            if (this.disabled()) this.resetStyle();
                            else
                              for (var t = 0; t < this.boxes.length; t++) {
                                var n = this.boxes[t];
                                this.applyStyle(n, !0);
                              }
                          this.disabled() ||
                            (u(
                              this.config.scrollContainer || window,
                              "scroll",
                              this.scrollHandler
                            ),
                            u(window, "resize", this.scrollHandler),
                            (this.interval = setInterval(
                              this.scrollCallback,
                              50
                            ))),
                            this.config.live &&
                              new m(function (t) {
                                for (var n = 0; n < t.length; n++)
                                  for (
                                    var i = t[n], r = 0;
                                    r < i.addedNodes.length;
                                    r++
                                  ) {
                                    var s = i.addedNodes[r];
                                    e.doSync(s);
                                  }
                              }).observe(document.body, {
                                childList: !0,
                                subtree: !0,
                              });
                        },
                      },
                      {
                        key: "stop",
                        value: function () {
                          (this.stopped = !0),
                            p(
                              this.config.scrollContainer || window,
                              "scroll",
                              this.scrollHandler
                            ),
                            p(window, "resize", this.scrollHandler),
                            null != this.interval && clearInterval(this.interval);
                        },
                      },
                      {
                        key: "sync",
                        value: function () {
                          m.notSupported && this.doSync(this.element);
                        },
                      },
                      {
                        key: "doSync",
                        value: function (e) {
                          if ((null == e && (e = this.element), 1 === e.nodeType))
                            for (
                              var t = (e = e.parentNode || e).querySelectorAll(
                                  "." + this.config.boxClass
                                ),
                                n = 0;
                              n < t.length;
                              n++
                            ) {
                              var i = t[n];
                              a(i, this.all) ||
                                (this.boxes.push(i),
                                this.all.push(i),
                                this.stopped || this.disabled()
                                  ? this.resetStyle()
                                  : this.applyStyle(i, !0),
                                (this.scrolled = !0));
                            }
                        },
                      },
                      {
                        key: "show",
                        value: function (e) {
                          return (
                            this.applyStyle(e),
                            (e.className =
                              e.className + " " + this.config.animateClass),
                            null != this.config.callback &&
                              this.config.callback(e),
                            d(e, this.wowEvent),
                            u(e, "animationend", this.resetAnimation),
                            u(e, "oanimationend", this.resetAnimation),
                            u(e, "webkitAnimationEnd", this.resetAnimation),
                            u(e, "MSAnimationEnd", this.resetAnimation),
                            e
                          );
                        },
                      },
                      {
                        key: "applyStyle",
                        value: function (e, t) {
                          var n = this,
                            i = e.getAttribute("data-wow-duration"),
                            r = e.getAttribute("data-wow-delay"),
                            s = e.getAttribute("data-wow-iteration");
                          return this.animate(function () {
                            return n.customStyle(e, t, i, r, s);
                          });
                        },
                      },
                      {
                        key: "resetStyle",
                        value: function () {
                          for (var e = 0; e < this.boxes.length; e++)
                            this.boxes[e].style.visibility = "visible";
                        },
                      },
                      {
                        key: "resetAnimation",
                        value: function (e) {
                          if (e.type.toLowerCase().indexOf("animationend") >= 0) {
                            var t = e.target || e.srcElement;
                            t.className = t.className
                              .replace(this.config.animateClass, "")
                              .trim();
                          }
                        },
                      },
                      {
                        key: "customStyle",
                        value: function (e, t, n, i, r) {
                          return (
                            t && this.cacheAnimationName(e),
                            (e.style.visibility = t ? "hidden" : "visible"),
                            n &&
                              this.vendorSet(e.style, { animationDuration: n }),
                            i && this.vendorSet(e.style, { animationDelay: i }),
                            r &&
                              this.vendorSet(e.style, {
                                animationIterationCount: r,
                              }),
                            this.vendorSet(e.style, {
                              animationName: t
                                ? "none"
                                : this.cachedAnimationName(e),
                            }),
                            e
                          );
                        },
                      },
                      {
                        key: "vendorSet",
                        value: function (e, t) {
                          for (var n in t)
                            if (t.hasOwnProperty(n)) {
                              var i = t[n];
                              e["" + n] = i;
                              for (var r = 0; r < this.vendors.length; r++)
                                e[
                                  "" +
                                    this.vendors[r] +
                                    n.charAt(0).toUpperCase() +
                                    n.substr(1)
                                ] = i;
                            }
                        },
                      },
                      {
                        key: "vendorCSS",
                        value: function (e, t) {
                          for (
                            var n = v(e), i = n.getPropertyCSSValue(t), r = 0;
                            r < this.vendors.length;
                            r++
                          ) {
                            var s = this.vendors[r];
                            i = i || n.getPropertyCSSValue("-" + s + "-" + t);
                          }
                          return i;
                        },
                      },
                      {
                        key: "animationName",
                        value: function (e) {
                          var t = void 0;
                          try {
                            t = this.vendorCSS(e, "animation-name").cssText;
                          } catch (n) {
                            t = v(e).getPropertyValue("animation-name");
                          }
                          return "none" === t ? "" : t;
                        },
                      },
                      {
                        key: "cacheAnimationName",
                        value: function (e) {
                          return this.animationNameCache.set(
                            e,
                            this.animationName(e)
                          );
                        },
                      },
                      {
                        key: "cachedAnimationName",
                        value: function (e) {
                          return this.animationNameCache.get(e);
                        },
                      },
                      {
                        key: "scrollHandler",
                        value: function () {
                          this.scrolled = !0;
                        },
                      },
                      {
                        key: "scrollCallback",
                        value: function () {
                          if (this.scrolled) {
                            this.scrolled = !1;
                            for (var e = [], t = 0; t < this.boxes.length; t++) {
                              var n = this.boxes[t];
                              if (n) {
                                if (this.isVisible(n)) {
                                  this.show(n);
                                  continue;
                                }
                                e.push(n);
                              }
                            }
                            (this.boxes = e),
                              this.boxes.length ||
                                this.config.live ||
                                this.stop();
                          }
                        },
                      },
                      {
                        key: "offsetTop",
                        value: function (e) {
                          for (; void 0 === e.offsetTop; ) e = e.parentNode;
                          for (var t = e.offsetTop; e.offsetParent; )
                            t += (e = e.offsetParent).offsetTop;
                          return t;
                        },
                      },
                      {
                        key: "isVisible",
                        value: function (e) {
                          var t =
                              e.getAttribute("data-wow-offset") ||
                              this.config.offset,
                            n =
                              (this.config.scrollContainer &&
                                this.config.scrollContainer.scrollTop) ||
                              window.pageYOffset,
                            i = n + Math.min(this.element.clientHeight, h()) - t,
                            r = this.offsetTop(e),
                            s = r + e.clientHeight;
                          return r <= i && s >= n;
                        },
                      },
                      {
                        key: "disabled",
                        value: function () {
                          return !this.config.mobile && l(navigator.userAgent);
                        },
                      },
                    ]),
                    e
                  );
                })();
              (t.default = y), (e.exports = t.default);
            }),
            void 0 === (r = "function" == typeof n ? n.apply(t, i) : n) ||
              (e.exports = r);
        },
      },
      t = {};
    function n(i) {
      var r = t[i];
      if (void 0 !== r) return r.exports;
      var s = (t[i] = { exports: {} });
      return e[i].call(s.exports, s, s.exports, n), s.exports;
    }
    (n.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return n.d(t, { a: t }), t;
    }),
      (n.d = (e, t) => {
        for (var i in t)
          n.o(t, i) &&
            !n.o(e, i) &&
            Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
      }),
      (n.g = (function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e) {
          if ("object" == typeof window) return window;
        }
      })()),
      (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
      (() => {
        "use strict";
        var e = n(755),
          t = n.n(e),
          i = n(630),
          r = n.n(i),
          s = Object.freeze({});
        function a(e) {
          return null == e;
        }
        function o(e) {
          return null != e;
        }
        function l(e) {
          return !0 === e;
        }
        function c(e) {
          return (
            "string" == typeof e ||
            "number" == typeof e ||
            "symbol" == typeof e ||
            "boolean" == typeof e
          );
        }
        function d(e) {
          return null !== e && "object" == typeof e;
        }
        var u = Object.prototype.toString;
        function p(e) {
          return "[object Object]" === u.call(e);
        }
        function h(e) {
          return "[object RegExp]" === u.call(e);
        }
        function f(e) {
          var t = parseFloat(String(e));
          return t >= 0 && Math.floor(t) === t && isFinite(e);
        }
        function m(e) {
          return (
            o(e) && "function" == typeof e.then && "function" == typeof e.catch
          );
        }
        function v(e) {
          return null == e
            ? ""
            : Array.isArray(e) || (p(e) && e.toString === u)
            ? JSON.stringify(e, null, 2)
            : String(e);
        }
        function y(e) {
          var t = parseFloat(e);
          return isNaN(t) ? e : t;
        }
        function g(e, t) {
          for (
            var n = Object.create(null), i = e.split(","), r = 0;
            r < i.length;
            r++
          )
            n[i[r]] = !0;
          return t
            ? function (e) {
                return n[e.toLowerCase()];
              }
            : function (e) {
                return n[e];
              };
        }
        g("slot,component", !0);
        var x = g("key,ref,slot,slot-scope,is");
        function b(e, t) {
          if (e.length) {
            var n = e.indexOf(t);
            if (n > -1) return e.splice(n, 1);
          }
        }
        var w = Object.prototype.hasOwnProperty;
        function S(e, t) {
          return w.call(e, t);
        }
        function C(e) {
          var t = Object.create(null);
          return function (n) {
            return t[n] || (t[n] = e(n));
          };
        }
        var T = /-(\w)/g,
          _ = C(function (e) {
            return e.replace(T, function (e, t) {
              return t ? t.toUpperCase() : "";
            });
          }),
          E = C(function (e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          }),
          k = /\B([A-Z])/g,
          $ = C(function (e) {
            return e.replace(k, "-$1").toLowerCase();
          });
        var M = Function.prototype.bind
          ? function (e, t) {
              return e.bind(t);
            }
          : function (e, t) {
              function n(n) {
                var i = arguments.length;
                return i
                  ? i > 1
                    ? e.apply(t, arguments)
                    : e.call(t, n)
                  : e.call(t);
              }
              return (n._length = e.length), n;
            };
        function j(e, t) {
          t = t || 0;
          for (var n = e.length - t, i = new Array(n); n--; ) i[n] = e[n + t];
          return i;
        }
        function A(e, t) {
          for (var n in t) e[n] = t[n];
          return e;
        }
        function L(e) {
          for (var t = {}, n = 0; n < e.length; n++) e[n] && A(t, e[n]);
          return t;
        }
        function I(e, t, n) {}
        var O = function (e, t, n) {
            return !1;
          },
          P = function (e) {
            return e;
          };
        function D(e, t) {
          if (e === t) return !0;
          var n = d(e),
            i = d(t);
          if (!n || !i) return !n && !i && String(e) === String(t);
          try {
            var r = Array.isArray(e),
              s = Array.isArray(t);
            if (r && s)
              return (
                e.length === t.length &&
                e.every(function (e, n) {
                  return D(e, t[n]);
                })
              );
            if (e instanceof Date && t instanceof Date)
              return e.getTime() === t.getTime();
            if (r || s) return !1;
            var a = Object.keys(e),
              o = Object.keys(t);
            return (
              a.length === o.length &&
              a.every(function (n) {
                return D(e[n], t[n]);
              })
            );
          } catch (e) {
            return !1;
          }
        }
        function z(e, t) {
          for (var n = 0; n < e.length; n++) if (D(e[n], t)) return n;
          return -1;
        }
        function N(e) {
          var t = !1;
          return function () {
            t || ((t = !0), e.apply(this, arguments));
          };
        }
        var q = "data-server-rendered",
          H = ["component", "directive", "filter"],
          F = [
            "beforeCreate",
            "created",
            "beforeMount",
            "mounted",
            "beforeUpdate",
            "updated",
            "beforeDestroy",
            "destroyed",
            "activated",
            "deactivated",
            "errorCaptured",
            "serverPrefetch",
          ],
          B = {
            optionMergeStrategies: Object.create(null),
            silent: !1,
            productionTip: !1,
            devtools: !1,
            performance: !1,
            errorHandler: null,
            warnHandler: null,
            ignoredElements: [],
            keyCodes: Object.create(null),
            isReservedTag: O,
            isReservedAttr: O,
            isUnknownElement: O,
            getTagNamespace: I,
            parsePlatformTagName: P,
            mustUseProp: O,
            async: !0,
            _lifecycleHooks: F,
          },
          W =
            /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
        function R(e) {
          var t = (e + "").charCodeAt(0);
          return 36 === t || 95 === t;
        }
        function V(e, t, n, i) {
          Object.defineProperty(e, t, {
            value: n,
            enumerable: !!i,
            writable: !0,
            configurable: !0,
          });
        }
        var G = new RegExp("[^" + W.source + ".$_\\d]");
        var X,
          Y = "__proto__" in {},
          U = "undefined" != typeof window,
          K = "undefined" != typeof WXEnvironment && !!WXEnvironment.platform,
          Z = K && WXEnvironment.platform.toLowerCase(),
          Q = U && window.navigator.userAgent.toLowerCase(),
          J = Q && /msie|trident/.test(Q),
          ee = Q && Q.indexOf("msie 9.0") > 0,
          te = Q && Q.indexOf("edge/") > 0,
          ne =
            (Q && Q.indexOf("android"),
            (Q && /iphone|ipad|ipod|ios/.test(Q)) || "ios" === Z),
          ie =
            (Q && /chrome\/\d+/.test(Q),
            Q && /phantomjs/.test(Q),
            Q && Q.match(/firefox\/(\d+)/)),
          re = {}.watch,
          se = !1;
        if (U)
          try {
            var ae = {};
            Object.defineProperty(ae, "passive", {
              get: function () {
                se = !0;
              },
            }),
              window.addEventListener("test-passive", null, ae);
          } catch (e) {}
        var oe = function () {
            return (
              void 0 === X &&
                (X =
                  !U &&
                  !K &&
                  void 0 !== n.g &&
                  n.g.process &&
                  "server" === n.g.process.env.VUE_ENV),
              X
            );
          },
          le = U && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
        function ce(e) {
          return "function" == typeof e && /native code/.test(e.toString());
        }
        var de,
          ue =
            "undefined" != typeof Symbol &&
            ce(Symbol) &&
            "undefined" != typeof Reflect &&
            ce(Reflect.ownKeys);
        de =
          "undefined" != typeof Set && ce(Set)
            ? Set
            : (function () {
                function e() {
                  this.set = Object.create(null);
                }
                return (
                  (e.prototype.has = function (e) {
                    return !0 === this.set[e];
                  }),
                  (e.prototype.add = function (e) {
                    this.set[e] = !0;
                  }),
                  (e.prototype.clear = function () {
                    this.set = Object.create(null);
                  }),
                  e
                );
              })();
        var pe = I,
          he = 0,
          fe = function () {
            (this.id = he++), (this.subs = []);
          };
        (fe.prototype.addSub = function (e) {
          this.subs.push(e);
        }),
          (fe.prototype.removeSub = function (e) {
            b(this.subs, e);
          }),
          (fe.prototype.depend = function () {
            fe.target && fe.target.addDep(this);
          }),
          (fe.prototype.notify = function () {
            var e = this.subs.slice();
            for (var t = 0, n = e.length; t < n; t++) e[t].update();
          }),
          (fe.target = null);
        var me = [];
        function ve(e) {
          me.push(e), (fe.target = e);
        }
        function ye() {
          me.pop(), (fe.target = me[me.length - 1]);
        }
        var ge = function (e, t, n, i, r, s, a, o) {
            (this.tag = e),
              (this.data = t),
              (this.children = n),
              (this.text = i),
              (this.elm = r),
              (this.ns = void 0),
              (this.context = s),
              (this.fnContext = void 0),
              (this.fnOptions = void 0),
              (this.fnScopeId = void 0),
              (this.key = t && t.key),
              (this.componentOptions = a),
              (this.componentInstance = void 0),
              (this.parent = void 0),
              (this.raw = !1),
              (this.isStatic = !1),
              (this.isRootInsert = !0),
              (this.isComment = !1),
              (this.isCloned = !1),
              (this.isOnce = !1),
              (this.asyncFactory = o),
              (this.asyncMeta = void 0),
              (this.isAsyncPlaceholder = !1);
          },
          xe = { child: { configurable: !0 } };
        (xe.child.get = function () {
          return this.componentInstance;
        }),
          Object.defineProperties(ge.prototype, xe);
        var be = function (e) {
          void 0 === e && (e = "");
          var t = new ge();
          return (t.text = e), (t.isComment = !0), t;
        };
        function we(e) {
          return new ge(void 0, void 0, void 0, String(e));
        }
        function Se(e) {
          var t = new ge(
            e.tag,
            e.data,
            e.children && e.children.slice(),
            e.text,
            e.elm,
            e.context,
            e.componentOptions,
            e.asyncFactory
          );
          return (
            (t.ns = e.ns),
            (t.isStatic = e.isStatic),
            (t.key = e.key),
            (t.isComment = e.isComment),
            (t.fnContext = e.fnContext),
            (t.fnOptions = e.fnOptions),
            (t.fnScopeId = e.fnScopeId),
            (t.asyncMeta = e.asyncMeta),
            (t.isCloned = !0),
            t
          );
        }
        var Ce = Array.prototype,
          Te = Object.create(Ce);
        ["push", "pop", "shift", "unshift", "splice", "sort", "reverse"].forEach(
          function (e) {
            var t = Ce[e];
            V(Te, e, function () {
              for (var n = [], i = arguments.length; i--; ) n[i] = arguments[i];
              var r,
                s = t.apply(this, n),
                a = this.__ob__;
              switch (e) {
                case "push":
                case "unshift":
                  r = n;
                  break;
                case "splice":
                  r = n.slice(2);
              }
              return r && a.observeArray(r), a.dep.notify(), s;
            });
          }
        );
        var _e = Object.getOwnPropertyNames(Te),
          Ee = !0;
        function ke(e) {
          Ee = e;
        }
        var $e = function (e) {
          (this.value = e),
            (this.dep = new fe()),
            (this.vmCount = 0),
            V(e, "__ob__", this),
            Array.isArray(e)
              ? (Y
                  ? (function (e, t) {
                      e.__proto__ = t;
                    })(e, Te)
                  : (function (e, t, n) {
                      for (var i = 0, r = n.length; i < r; i++) {
                        var s = n[i];
                        V(e, s, t[s]);
                      }
                    })(e, Te, _e),
                this.observeArray(e))
              : this.walk(e);
        };
        function Me(e, t) {
          var n;
          if (d(e) && !(e instanceof ge))
            return (
              S(e, "__ob__") && e.__ob__ instanceof $e
                ? (n = e.__ob__)
                : Ee &&
                  !oe() &&
                  (Array.isArray(e) || p(e)) &&
                  Object.isExtensible(e) &&
                  !e._isVue &&
                  (n = new $e(e)),
              t && n && n.vmCount++,
              n
            );
        }
        function je(e, t, n, i, r) {
          var s = new fe(),
            a = Object.getOwnPropertyDescriptor(e, t);
          if (!a || !1 !== a.configurable) {
            var o = a && a.get,
              l = a && a.set;
            (o && !l) || 2 !== arguments.length || (n = e[t]);
            var c = !r && Me(n);
            Object.defineProperty(e, t, {
              enumerable: !0,
              configurable: !0,
              get: function () {
                var t = o ? o.call(e) : n;
                return (
                  fe.target &&
                    (s.depend(),
                    c && (c.dep.depend(), Array.isArray(t) && Ie(t))),
                  t
                );
              },
              set: function (t) {
                var i = o ? o.call(e) : n;
                t === i ||
                  (t != t && i != i) ||
                  (o && !l) ||
                  (l ? l.call(e, t) : (n = t), (c = !r && Me(t)), s.notify());
              },
            });
          }
        }
        function Ae(e, t, n) {
          if (Array.isArray(e) && f(t))
            return (e.length = Math.max(e.length, t)), e.splice(t, 1, n), n;
          if (t in e && !(t in Object.prototype)) return (e[t] = n), n;
          var i = e.__ob__;
          return e._isVue || (i && i.vmCount)
            ? n
            : i
            ? (je(i.value, t, n), i.dep.notify(), n)
            : ((e[t] = n), n);
        }
        function Le(e, t) {
          if (Array.isArray(e) && f(t)) e.splice(t, 1);
          else {
            var n = e.__ob__;
            e._isVue ||
              (n && n.vmCount) ||
              (S(e, t) && (delete e[t], n && n.dep.notify()));
          }
        }
        function Ie(e) {
          for (var t = void 0, n = 0, i = e.length; n < i; n++)
            (t = e[n]) && t.__ob__ && t.__ob__.dep.depend(),
              Array.isArray(t) && Ie(t);
        }
        ($e.prototype.walk = function (e) {
          for (var t = Object.keys(e), n = 0; n < t.length; n++) je(e, t[n]);
        }),
          ($e.prototype.observeArray = function (e) {
            for (var t = 0, n = e.length; t < n; t++) Me(e[t]);
          });
        var Oe = B.optionMergeStrategies;
        function Pe(e, t) {
          if (!t) return e;
          for (
            var n, i, r, s = ue ? Reflect.ownKeys(t) : Object.keys(t), a = 0;
            a < s.length;
            a++
          )
            "__ob__" !== (n = s[a]) &&
              ((i = e[n]),
              (r = t[n]),
              S(e, n) ? i !== r && p(i) && p(r) && Pe(i, r) : Ae(e, n, r));
          return e;
        }
        function De(e, t, n) {
          return n
            ? function () {
                var i = "function" == typeof t ? t.call(n, n) : t,
                  r = "function" == typeof e ? e.call(n, n) : e;
                return i ? Pe(i, r) : r;
              }
            : t
            ? e
              ? function () {
                  return Pe(
                    "function" == typeof t ? t.call(this, this) : t,
                    "function" == typeof e ? e.call(this, this) : e
                  );
                }
              : t
            : e;
        }
        function ze(e, t) {
          var n = t ? (e ? e.concat(t) : Array.isArray(t) ? t : [t]) : e;
          return n
            ? (function (e) {
                for (var t = [], n = 0; n < e.length; n++)
                  -1 === t.indexOf(e[n]) && t.push(e[n]);
                return t;
              })(n)
            : n;
        }
        function Ne(e, t, n, i) {
          var r = Object.create(e || null);
          return t ? A(r, t) : r;
        }
        (Oe.data = function (e, t, n) {
          return n ? De(e, t, n) : t && "function" != typeof t ? e : De(e, t);
        }),
          F.forEach(function (e) {
            Oe[e] = ze;
          }),
          H.forEach(function (e) {
            Oe[e + "s"] = Ne;
          }),
          (Oe.watch = function (e, t, n, i) {
            if ((e === re && (e = void 0), t === re && (t = void 0), !t))
              return Object.create(e || null);
            if (!e) return t;
            var r = {};
            for (var s in (A(r, e), t)) {
              var a = r[s],
                o = t[s];
              a && !Array.isArray(a) && (a = [a]),
                (r[s] = a ? a.concat(o) : Array.isArray(o) ? o : [o]);
            }
            return r;
          }),
          (Oe.props =
            Oe.methods =
            Oe.inject =
            Oe.computed =
              function (e, t, n, i) {
                if (!e) return t;
                var r = Object.create(null);
                return A(r, e), t && A(r, t), r;
              }),
          (Oe.provide = De);
        var qe = function (e, t) {
          return void 0 === t ? e : t;
        };
        function He(e, t, n) {
          if (
            ("function" == typeof t && (t = t.options),
            (function (e, t) {
              var n = e.props;
              if (n) {
                var i,
                  r,
                  s = {};
                if (Array.isArray(n))
                  for (i = n.length; i--; )
                    "string" == typeof (r = n[i]) && (s[_(r)] = { type: null });
                else if (p(n))
                  for (var a in n) (r = n[a]), (s[_(a)] = p(r) ? r : { type: r });
                e.props = s;
              }
            })(t),
            (function (e, t) {
              var n = e.inject;
              if (n) {
                var i = (e.inject = {});
                if (Array.isArray(n))
                  for (var r = 0; r < n.length; r++) i[n[r]] = { from: n[r] };
                else if (p(n))
                  for (var s in n) {
                    var a = n[s];
                    i[s] = p(a) ? A({ from: s }, a) : { from: a };
                  }
              }
            })(t),
            (function (e) {
              var t = e.directives;
              if (t)
                for (var n in t) {
                  var i = t[n];
                  "function" == typeof i && (t[n] = { bind: i, update: i });
                }
            })(t),
            !t._base && (t.extends && (e = He(e, t.extends, n)), t.mixins))
          )
            for (var i = 0, r = t.mixins.length; i < r; i++)
              e = He(e, t.mixins[i], n);
          var s,
            a = {};
          for (s in e) o(s);
          for (s in t) S(e, s) || o(s);
          function o(i) {
            var r = Oe[i] || qe;
            a[i] = r(e[i], t[i], n, i);
          }
          return a;
        }
        function Fe(e, t, n, i) {
          if ("string" == typeof n) {
            var r = e[t];
            if (S(r, n)) return r[n];
            var s = _(n);
            if (S(r, s)) return r[s];
            var a = E(s);
            return S(r, a) ? r[a] : r[n] || r[s] || r[a];
          }
        }
        function Be(e, t, n, i) {
          var r = t[e],
            s = !S(n, e),
            a = n[e],
            o = Ge(Boolean, r.type);
          if (o > -1)
            if (s && !S(r, "default")) a = !1;
            else if ("" === a || a === $(e)) {
              var l = Ge(String, r.type);
              (l < 0 || o < l) && (a = !0);
            }
          if (void 0 === a) {
            a = (function (e, t, n) {
              if (!S(t, "default")) return;
              var i = t.default;
              0;
              if (
                e &&
                e.$options.propsData &&
                void 0 === e.$options.propsData[n] &&
                void 0 !== e._props[n]
              )
                return e._props[n];
              return "function" == typeof i && "Function" !== Re(t.type)
                ? i.call(e)
                : i;
            })(i, r, e);
            var c = Ee;
            ke(!0), Me(a), ke(c);
          }
          return a;
        }
        var We = /^\s*function (\w+)/;
        function Re(e) {
          var t = e && e.toString().match(We);
          return t ? t[1] : "";
        }
        function Ve(e, t) {
          return Re(e) === Re(t);
        }
        function Ge(e, t) {
          if (!Array.isArray(t)) return Ve(t, e) ? 0 : -1;
          for (var n = 0, i = t.length; n < i; n++) if (Ve(t[n], e)) return n;
          return -1;
        }
        function Xe(e, t, n) {
          ve();
          try {
            if (t)
              for (var i = t; (i = i.$parent); ) {
                var r = i.$options.errorCaptured;
                if (r)
                  for (var s = 0; s < r.length; s++)
                    try {
                      if (!1 === r[s].call(i, e, t, n)) return;
                    } catch (e) {
                      Ue(e, i, "errorCaptured hook");
                    }
              }
            Ue(e, t, n);
          } finally {
            ye();
          }
        }
        function Ye(e, t, n, i, r) {
          var s;
          try {
            (s = n ? e.apply(t, n) : e.call(t)) &&
              !s._isVue &&
              m(s) &&
              !s._handled &&
              (s.catch(function (e) {
                return Xe(e, i, r + " (Promise/async)");
              }),
              (s._handled = !0));
          } catch (e) {
            Xe(e, i, r);
          }
          return s;
        }
        function Ue(e, t, n) {
          if (B.errorHandler)
            try {
              return B.errorHandler.call(null, e, t, n);
            } catch (t) {
              t !== e && Ke(t, null, "config.errorHandler");
            }
          Ke(e, t, n);
        }
        function Ke(e, t, n) {
          if ((!U && !K) || "undefined" == typeof console) throw e;
          console.error(e);
        }
        var Ze,
          Qe = !1,
          Je = [],
          et = !1;
        function tt() {
          et = !1;
          var e = Je.slice(0);
          Je.length = 0;
          for (var t = 0; t < e.length; t++) e[t]();
        }
        if ("undefined" != typeof Promise && ce(Promise)) {
          var nt = Promise.resolve();
          (Ze = function () {
            nt.then(tt), ne && setTimeout(I);
          }),
            (Qe = !0);
        } else if (
          J ||
          "undefined" == typeof MutationObserver ||
          (!ce(MutationObserver) &&
            "[object MutationObserverConstructor]" !==
              MutationObserver.toString())
        )
          Ze =
            "undefined" != typeof setImmediate && ce(setImmediate)
              ? function () {
                  setImmediate(tt);
                }
              : function () {
                  setTimeout(tt, 0);
                };
        else {
          var it = 1,
            rt = new MutationObserver(tt),
            st = document.createTextNode(String(it));
          rt.observe(st, { characterData: !0 }),
            (Ze = function () {
              (it = (it + 1) % 2), (st.data = String(it));
            }),
            (Qe = !0);
        }
        function at(e, t) {
          var n;
          if (
            (Je.push(function () {
              if (e)
                try {
                  e.call(t);
                } catch (e) {
                  Xe(e, t, "nextTick");
                }
              else n && n(t);
            }),
            et || ((et = !0), Ze()),
            !e && "undefined" != typeof Promise)
          )
            return new Promise(function (e) {
              n = e;
            });
        }
        var ot = new de();
        function lt(e) {
          ct(e, ot), ot.clear();
        }
        function ct(e, t) {
          var n,
            i,
            r = Array.isArray(e);
          if (!((!r && !d(e)) || Object.isFrozen(e) || e instanceof ge)) {
            if (e.__ob__) {
              var s = e.__ob__.dep.id;
              if (t.has(s)) return;
              t.add(s);
            }
            if (r) for (n = e.length; n--; ) ct(e[n], t);
            else for (n = (i = Object.keys(e)).length; n--; ) ct(e[i[n]], t);
          }
        }
        var dt = C(function (e) {
          var t = "&" === e.charAt(0),
            n = "~" === (e = t ? e.slice(1) : e).charAt(0),
            i = "!" === (e = n ? e.slice(1) : e).charAt(0);
          return {
            name: (e = i ? e.slice(1) : e),
            once: n,
            capture: i,
            passive: t,
          };
        });
        function ut(e, t) {
          function n() {
            var e = arguments,
              i = n.fns;
            if (!Array.isArray(i))
              return Ye(i, null, arguments, t, "v-on handler");
            for (var r = i.slice(), s = 0; s < r.length; s++)
              Ye(r[s], null, e, t, "v-on handler");
          }
          return (n.fns = e), n;
        }
        function pt(e, t, n, i, r, s) {
          var o, c, d, u;
          for (o in e)
            (c = e[o]),
              (d = t[o]),
              (u = dt(o)),
              a(c) ||
                (a(d)
                  ? (a(c.fns) && (c = e[o] = ut(c, s)),
                    l(u.once) && (c = e[o] = r(u.name, c, u.capture)),
                    n(u.name, c, u.capture, u.passive, u.params))
                  : c !== d && ((d.fns = c), (e[o] = d)));
          for (o in t) a(e[o]) && i((u = dt(o)).name, t[o], u.capture);
        }
        function ht(e, t, n) {
          var i;
          e instanceof ge && (e = e.data.hook || (e.data.hook = {}));
          var r = e[t];
          function s() {
            n.apply(this, arguments), b(i.fns, s);
          }
          a(r)
            ? (i = ut([s]))
            : o(r.fns) && l(r.merged)
            ? (i = r).fns.push(s)
            : (i = ut([r, s])),
            (i.merged = !0),
            (e[t] = i);
        }
        function ft(e, t, n, i, r) {
          if (o(t)) {
            if (S(t, n)) return (e[n] = t[n]), r || delete t[n], !0;
            if (S(t, i)) return (e[n] = t[i]), r || delete t[i], !0;
          }
          return !1;
        }
        function mt(e) {
          return c(e) ? [we(e)] : Array.isArray(e) ? yt(e) : void 0;
        }
        function vt(e) {
          return o(e) && o(e.text) && !1 === e.isComment;
        }
        function yt(e, t) {
          var n,
            i,
            r,
            s,
            d = [];
          for (n = 0; n < e.length; n++)
            a((i = e[n])) ||
              "boolean" == typeof i ||
              ((s = d[(r = d.length - 1)]),
              Array.isArray(i)
                ? i.length > 0 &&
                  (vt((i = yt(i, (t || "") + "_" + n))[0]) &&
                    vt(s) &&
                    ((d[r] = we(s.text + i[0].text)), i.shift()),
                  d.push.apply(d, i))
                : c(i)
                ? vt(s)
                  ? (d[r] = we(s.text + i))
                  : "" !== i && d.push(we(i))
                : vt(i) && vt(s)
                ? (d[r] = we(s.text + i.text))
                : (l(e._isVList) &&
                    o(i.tag) &&
                    a(i.key) &&
                    o(t) &&
                    (i.key = "__vlist" + t + "_" + n + "__"),
                  d.push(i)));
          return d;
        }
        function gt(e, t) {
          if (e) {
            for (
              var n = Object.create(null),
                i = ue ? Reflect.ownKeys(e) : Object.keys(e),
                r = 0;
              r < i.length;
              r++
            ) {
              var s = i[r];
              if ("__ob__" !== s) {
                for (var a = e[s].from, o = t; o; ) {
                  if (o._provided && S(o._provided, a)) {
                    n[s] = o._provided[a];
                    break;
                  }
                  o = o.$parent;
                }
                if (!o)
                  if ("default" in e[s]) {
                    var l = e[s].default;
                    n[s] = "function" == typeof l ? l.call(t) : l;
                  } else 0;
              }
            }
            return n;
          }
        }
        function xt(e, t) {
          if (!e || !e.length) return {};
          for (var n = {}, i = 0, r = e.length; i < r; i++) {
            var s = e[i],
              a = s.data;
            if (
              (a && a.attrs && a.attrs.slot && delete a.attrs.slot,
              (s.context !== t && s.fnContext !== t) || !a || null == a.slot)
            )
              (n.default || (n.default = [])).push(s);
            else {
              var o = a.slot,
                l = n[o] || (n[o] = []);
              "template" === s.tag
                ? l.push.apply(l, s.children || [])
                : l.push(s);
            }
          }
          for (var c in n) n[c].every(bt) && delete n[c];
          return n;
        }
        function bt(e) {
          return (e.isComment && !e.asyncFactory) || " " === e.text;
        }
        function wt(e) {
          return e.isComment && e.asyncFactory;
        }
        function St(e, t, n) {
          var i,
            r = Object.keys(t).length > 0,
            a = e ? !!e.$stable : !r,
            o = e && e.$key;
          if (e) {
            if (e._normalized) return e._normalized;
            if (a && n && n !== s && o === n.$key && !r && !n.$hasNormal)
              return n;
            for (var l in ((i = {}), e))
              e[l] && "$" !== l[0] && (i[l] = Ct(t, l, e[l]));
          } else i = {};
          for (var c in t) c in i || (i[c] = Tt(t, c));
          return (
            e && Object.isExtensible(e) && (e._normalized = i),
            V(i, "$stable", a),
            V(i, "$key", o),
            V(i, "$hasNormal", r),
            i
          );
        }
        function Ct(e, t, n) {
          var i = function () {
            var e = arguments.length ? n.apply(null, arguments) : n({}),
              t =
                (e =
                  e && "object" == typeof e && !Array.isArray(e) ? [e] : mt(e)) &&
                e[0];
            return e && (!t || (1 === e.length && t.isComment && !wt(t)))
              ? void 0
              : e;
          };
          return (
            n.proxy &&
              Object.defineProperty(e, t, {
                get: i,
                enumerable: !0,
                configurable: !0,
              }),
            i
          );
        }
        function Tt(e, t) {
          return function () {
            return e[t];
          };
        }
        function _t(e, t) {
          var n, i, r, s, a;
          if (Array.isArray(e) || "string" == typeof e)
            for (n = new Array(e.length), i = 0, r = e.length; i < r; i++)
              n[i] = t(e[i], i);
          else if ("number" == typeof e)
            for (n = new Array(e), i = 0; i < e; i++) n[i] = t(i + 1, i);
          else if (d(e))
            if (ue && e[Symbol.iterator]) {
              n = [];
              for (var l = e[Symbol.iterator](), c = l.next(); !c.done; )
                n.push(t(c.value, n.length)), (c = l.next());
            } else
              for (
                s = Object.keys(e), n = new Array(s.length), i = 0, r = s.length;
                i < r;
                i++
              )
                (a = s[i]), (n[i] = t(e[a], a, i));
          return o(n) || (n = []), (n._isVList = !0), n;
        }
        function Et(e, t, n, i) {
          var r,
            s = this.$scopedSlots[e];
          s
            ? ((n = n || {}),
              i && (n = A(A({}, i), n)),
              (r = s(n) || ("function" == typeof t ? t() : t)))
            : (r = this.$slots[e] || ("function" == typeof t ? t() : t));
          var a = n && n.slot;
          return a ? this.$createElement("template", { slot: a }, r) : r;
        }
        function kt(e) {
          return Fe(this.$options, "filters", e) || P;
        }
        function $t(e, t) {
          return Array.isArray(e) ? -1 === e.indexOf(t) : e !== t;
        }
        function Mt(e, t, n, i, r) {
          var s = B.keyCodes[t] || n;
          return r && i && !B.keyCodes[t]
            ? $t(r, i)
            : s
            ? $t(s, e)
            : i
            ? $(i) !== t
            : void 0 === e;
        }
        function jt(e, t, n, i, r) {
          if (n)
            if (d(n)) {
              var s;
              Array.isArray(n) && (n = L(n));
              var a = function (a) {
                if ("class" === a || "style" === a || x(a)) s = e;
                else {
                  var o = e.attrs && e.attrs.type;
                  s =
                    i || B.mustUseProp(t, o, a)
                      ? e.domProps || (e.domProps = {})
                      : e.attrs || (e.attrs = {});
                }
                var l = _(a),
                  c = $(a);
                l in s ||
                  c in s ||
                  ((s[a] = n[a]),
                  r &&
                    ((e.on || (e.on = {}))["update:" + a] = function (e) {
                      n[a] = e;
                    }));
              };
              for (var o in n) a(o);
            } else;
          return e;
        }
        function At(e, t) {
          var n = this._staticTrees || (this._staticTrees = []),
            i = n[e];
          return (
            (i && !t) ||
              It(
                (i = n[e] =
                  this.$options.staticRenderFns[e].call(
                    this._renderProxy,
                    null,
                    this
                  )),
                "__static__" + e,
                !1
              ),
            i
          );
        }
        function Lt(e, t, n) {
          return It(e, "__once__" + t + (n ? "_" + n : ""), !0), e;
        }
        function It(e, t, n) {
          if (Array.isArray(e))
            for (var i = 0; i < e.length; i++)
              e[i] && "string" != typeof e[i] && Ot(e[i], t + "_" + i, n);
          else Ot(e, t, n);
        }
        function Ot(e, t, n) {
          (e.isStatic = !0), (e.key = t), (e.isOnce = n);
        }
        function Pt(e, t) {
          if (t)
            if (p(t)) {
              var n = (e.on = e.on ? A({}, e.on) : {});
              for (var i in t) {
                var r = n[i],
                  s = t[i];
                n[i] = r ? [].concat(r, s) : s;
              }
            } else;
          return e;
        }
        function Dt(e, t, n, i) {
          t = t || { $stable: !n };
          for (var r = 0; r < e.length; r++) {
            var s = e[r];
            Array.isArray(s)
              ? Dt(s, t, n)
              : s && (s.proxy && (s.fn.proxy = !0), (t[s.key] = s.fn));
          }
          return i && (t.$key = i), t;
        }
        function zt(e, t) {
          for (var n = 0; n < t.length; n += 2) {
            var i = t[n];
            "string" == typeof i && i && (e[t[n]] = t[n + 1]);
          }
          return e;
        }
        function Nt(e, t) {
          return "string" == typeof e ? t + e : e;
        }
        function qt(e) {
          (e._o = Lt),
            (e._n = y),
            (e._s = v),
            (e._l = _t),
            (e._t = Et),
            (e._q = D),
            (e._i = z),
            (e._m = At),
            (e._f = kt),
            (e._k = Mt),
            (e._b = jt),
            (e._v = we),
            (e._e = be),
            (e._u = Dt),
            (e._g = Pt),
            (e._d = zt),
            (e._p = Nt);
        }
        function Ht(e, t, n, i, r) {
          var a,
            o = this,
            c = r.options;
          S(i, "_uid")
            ? ((a = Object.create(i))._original = i)
            : ((a = i), (i = i._original));
          var d = l(c._compiled),
            u = !d;
          (this.data = e),
            (this.props = t),
            (this.children = n),
            (this.parent = i),
            (this.listeners = e.on || s),
            (this.injections = gt(c.inject, i)),
            (this.slots = function () {
              return (
                o.$slots || St(e.scopedSlots, (o.$slots = xt(n, i))), o.$slots
              );
            }),
            Object.defineProperty(this, "scopedSlots", {
              enumerable: !0,
              get: function () {
                return St(e.scopedSlots, this.slots());
              },
            }),
            d &&
              ((this.$options = c),
              (this.$slots = this.slots()),
              (this.$scopedSlots = St(e.scopedSlots, this.$slots))),
            c._scopeId
              ? (this._c = function (e, t, n, r) {
                  var s = Xt(a, e, t, n, r, u);
                  return (
                    s &&
                      !Array.isArray(s) &&
                      ((s.fnScopeId = c._scopeId), (s.fnContext = i)),
                    s
                  );
                })
              : (this._c = function (e, t, n, i) {
                  return Xt(a, e, t, n, i, u);
                });
        }
        function Ft(e, t, n, i, r) {
          var s = Se(e);
          return (
            (s.fnContext = n),
            (s.fnOptions = i),
            t.slot && ((s.data || (s.data = {})).slot = t.slot),
            s
          );
        }
        function Bt(e, t) {
          for (var n in t) e[_(n)] = t[n];
        }
        qt(Ht.prototype);
        var Wt = {
            init: function (e, t) {
              if (
                e.componentInstance &&
                !e.componentInstance._isDestroyed &&
                e.data.keepAlive
              ) {
                var n = e;
                Wt.prepatch(n, n);
              } else {
                (e.componentInstance = (function (e, t) {
                  var n = { _isComponent: !0, _parentVnode: e, parent: t },
                    i = e.data.inlineTemplate;
                  o(i) &&
                    ((n.render = i.render),
                    (n.staticRenderFns = i.staticRenderFns));
                  return new e.componentOptions.Ctor(n);
                })(e, rn)).$mount(t ? e.elm : void 0, t);
              }
            },
            prepatch: function (e, t) {
              var n = t.componentOptions;
              !(function (e, t, n, i, r) {
                0;
                var a = i.data.scopedSlots,
                  o = e.$scopedSlots,
                  l = !!(
                    (a && !a.$stable) ||
                    (o !== s && !o.$stable) ||
                    (a && e.$scopedSlots.$key !== a.$key) ||
                    (!a && e.$scopedSlots.$key)
                  ),
                  c = !!(r || e.$options._renderChildren || l);
                (e.$options._parentVnode = i),
                  (e.$vnode = i),
                  e._vnode && (e._vnode.parent = i);
                if (
                  ((e.$options._renderChildren = r),
                  (e.$attrs = i.data.attrs || s),
                  (e.$listeners = n || s),
                  t && e.$options.props)
                ) {
                  ke(!1);
                  for (
                    var d = e._props, u = e.$options._propKeys || [], p = 0;
                    p < u.length;
                    p++
                  ) {
                    var h = u[p],
                      f = e.$options.props;
                    d[h] = Be(h, f, t, e);
                  }
                  ke(!0), (e.$options.propsData = t);
                }
                n = n || s;
                var m = e.$options._parentListeners;
                (e.$options._parentListeners = n),
                  nn(e, n, m),
                  c && ((e.$slots = xt(r, i.context)), e.$forceUpdate());
                0;
              })(
                (t.componentInstance = e.componentInstance),
                n.propsData,
                n.listeners,
                t,
                n.children
              );
            },
            insert: function (e) {
              var t,
                n = e.context,
                i = e.componentInstance;
              i._isMounted || ((i._isMounted = !0), cn(i, "mounted")),
                e.data.keepAlive &&
                  (n._isMounted
                    ? (((t = i)._inactive = !1), un.push(t))
                    : on(i, !0));
            },
            destroy: function (e) {
              var t = e.componentInstance;
              t._isDestroyed || (e.data.keepAlive ? ln(t, !0) : t.$destroy());
            },
          },
          Rt = Object.keys(Wt);
        function Vt(e, t, n, i, r) {
          if (!a(e)) {
            var c = n.$options._base;
            if ((d(e) && (e = c.extend(e)), "function" == typeof e)) {
              var u;
              if (
                a(e.cid) &&
                ((e = (function (e, t) {
                  if (l(e.error) && o(e.errorComp)) return e.errorComp;
                  if (o(e.resolved)) return e.resolved;
                  var n = Kt;
                  n &&
                    o(e.owners) &&
                    -1 === e.owners.indexOf(n) &&
                    e.owners.push(n);
                  if (l(e.loading) && o(e.loadingComp)) return e.loadingComp;
                  if (n && !o(e.owners)) {
                    var i = (e.owners = [n]),
                      r = !0,
                      s = null,
                      c = null;
                    n.$on("hook:destroyed", function () {
                      return b(i, n);
                    });
                    var u = function (e) {
                        for (var t = 0, n = i.length; t < n; t++)
                          i[t].$forceUpdate();
                        e &&
                          ((i.length = 0),
                          null !== s && (clearTimeout(s), (s = null)),
                          null !== c && (clearTimeout(c), (c = null)));
                      },
                      p = N(function (n) {
                        (e.resolved = Zt(n, t)), r ? (i.length = 0) : u(!0);
                      }),
                      h = N(function (t) {
                        o(e.errorComp) && ((e.error = !0), u(!0));
                      }),
                      f = e(p, h);
                    return (
                      d(f) &&
                        (m(f)
                          ? a(e.resolved) && f.then(p, h)
                          : m(f.component) &&
                            (f.component.then(p, h),
                            o(f.error) && (e.errorComp = Zt(f.error, t)),
                            o(f.loading) &&
                              ((e.loadingComp = Zt(f.loading, t)),
                              0 === f.delay
                                ? (e.loading = !0)
                                : (s = setTimeout(function () {
                                    (s = null),
                                      a(e.resolved) &&
                                        a(e.error) &&
                                        ((e.loading = !0), u(!1));
                                  }, f.delay || 200))),
                            o(f.timeout) &&
                              (c = setTimeout(function () {
                                (c = null), a(e.resolved) && h(null);
                              }, f.timeout)))),
                      (r = !1),
                      e.loading ? e.loadingComp : e.resolved
                    );
                  }
                })((u = e), c)),
                void 0 === e)
              )
                return (function (e, t, n, i, r) {
                  var s = be();
                  return (
                    (s.asyncFactory = e),
                    (s.asyncMeta = { data: t, context: n, children: i, tag: r }),
                    s
                  );
                })(u, t, n, i, r);
              (t = t || {}),
                An(e),
                o(t.model) &&
                  (function (e, t) {
                    var n = (e.model && e.model.prop) || "value",
                      i = (e.model && e.model.event) || "input";
                    (t.attrs || (t.attrs = {}))[n] = t.model.value;
                    var r = t.on || (t.on = {}),
                      s = r[i],
                      a = t.model.callback;
                    o(s)
                      ? (Array.isArray(s) ? -1 === s.indexOf(a) : s !== a) &&
                        (r[i] = [a].concat(s))
                      : (r[i] = a);
                  })(e.options, t);
              var p = (function (e, t, n) {
                var i = t.options.props;
                if (!a(i)) {
                  var r = {},
                    s = e.attrs,
                    l = e.props;
                  if (o(s) || o(l))
                    for (var c in i) {
                      var d = $(c);
                      ft(r, l, c, d, !0) || ft(r, s, c, d, !1);
                    }
                  return r;
                }
              })(t, e);
              if (l(e.options.functional))
                return (function (e, t, n, i, r) {
                  var a = e.options,
                    l = {},
                    c = a.props;
                  if (o(c)) for (var d in c) l[d] = Be(d, c, t || s);
                  else o(n.attrs) && Bt(l, n.attrs), o(n.props) && Bt(l, n.props);
                  var u = new Ht(n, l, r, i, e),
                    p = a.render.call(null, u._c, u);
                  if (p instanceof ge) return Ft(p, n, u.parent, a);
                  if (Array.isArray(p)) {
                    for (
                      var h = mt(p) || [], f = new Array(h.length), m = 0;
                      m < h.length;
                      m++
                    )
                      f[m] = Ft(h[m], n, u.parent, a);
                    return f;
                  }
                })(e, p, t, n, i);
              var h = t.on;
              if (((t.on = t.nativeOn), l(e.options.abstract))) {
                var f = t.slot;
                (t = {}), f && (t.slot = f);
              }
              !(function (e) {
                for (var t = e.hook || (e.hook = {}), n = 0; n < Rt.length; n++) {
                  var i = Rt[n],
                    r = t[i],
                    s = Wt[i];
                  r === s || (r && r._merged) || (t[i] = r ? Gt(s, r) : s);
                }
              })(t);
              var v = e.options.name || r;
              return new ge(
                "vue-component-" + e.cid + (v ? "-" + v : ""),
                t,
                void 0,
                void 0,
                void 0,
                n,
                { Ctor: e, propsData: p, listeners: h, tag: r, children: i },
                u
              );
            }
          }
        }
        function Gt(e, t) {
          var n = function (n, i) {
            e(n, i), t(n, i);
          };
          return (n._merged = !0), n;
        }
        function Xt(e, t, n, i, r, s) {
          return (
            (Array.isArray(n) || c(n)) && ((r = i), (i = n), (n = void 0)),
            l(s) && (r = 2),
            (function (e, t, n, i, r) {
              if (o(n) && o(n.__ob__)) return be();
              o(n) && o(n.is) && (t = n.is);
              if (!t) return be();
              0;
              Array.isArray(i) &&
                "function" == typeof i[0] &&
                (((n = n || {}).scopedSlots = { default: i[0] }), (i.length = 0));
              2 === r
                ? (i = mt(i))
                : 1 === r &&
                  (i = (function (e) {
                    for (var t = 0; t < e.length; t++)
                      if (Array.isArray(e[t]))
                        return Array.prototype.concat.apply([], e);
                    return e;
                  })(i));
              var s, a;
              if ("string" == typeof t) {
                var l;
                (a = (e.$vnode && e.$vnode.ns) || B.getTagNamespace(t)),
                  (s = B.isReservedTag(t)
                    ? new ge(B.parsePlatformTagName(t), n, i, void 0, void 0, e)
                    : (n && n.pre) || !o((l = Fe(e.$options, "components", t)))
                    ? new ge(t, n, i, void 0, void 0, e)
                    : Vt(l, n, e, i, t));
              } else s = Vt(t, n, e, i);
              return Array.isArray(s)
                ? s
                : o(s)
                ? (o(a) && Yt(s, a),
                  o(n) &&
                    (function (e) {
                      d(e.style) && lt(e.style);
                      d(e.class) && lt(e.class);
                    })(n),
                  s)
                : be();
            })(e, t, n, i, r)
          );
        }
        function Yt(e, t, n) {
          if (
            ((e.ns = t),
            "foreignObject" === e.tag && ((t = void 0), (n = !0)),
            o(e.children))
          )
            for (var i = 0, r = e.children.length; i < r; i++) {
              var s = e.children[i];
              o(s.tag) && (a(s.ns) || (l(n) && "svg" !== s.tag)) && Yt(s, t, n);
            }
        }
        var Ut,
          Kt = null;
        function Zt(e, t) {
          return (
            (e.__esModule || (ue && "Module" === e[Symbol.toStringTag])) &&
              (e = e.default),
            d(e) ? t.extend(e) : e
          );
        }
        function Qt(e) {
          if (Array.isArray(e))
            for (var t = 0; t < e.length; t++) {
              var n = e[t];
              if (o(n) && (o(n.componentOptions) || wt(n))) return n;
            }
        }
        function Jt(e, t) {
          Ut.$on(e, t);
        }
        function en(e, t) {
          Ut.$off(e, t);
        }
        function tn(e, t) {
          var n = Ut;
          return function i() {
            var r = t.apply(null, arguments);
            null !== r && n.$off(e, i);
          };
        }
        function nn(e, t, n) {
          (Ut = e), pt(t, n || {}, Jt, en, tn, e), (Ut = void 0);
        }
        var rn = null;
        function sn(e) {
          var t = rn;
          return (
            (rn = e),
            function () {
              rn = t;
            }
          );
        }
        function an(e) {
          for (; e && (e = e.$parent); ) if (e._inactive) return !0;
          return !1;
        }
        function on(e, t) {
          if (t) {
            if (((e._directInactive = !1), an(e))) return;
          } else if (e._directInactive) return;
          if (e._inactive || null === e._inactive) {
            e._inactive = !1;
            for (var n = 0; n < e.$children.length; n++) on(e.$children[n]);
            cn(e, "activated");
          }
        }
        function ln(e, t) {
          if (!((t && ((e._directInactive = !0), an(e))) || e._inactive)) {
            e._inactive = !0;
            for (var n = 0; n < e.$children.length; n++) ln(e.$children[n]);
            cn(e, "deactivated");
          }
        }
        function cn(e, t) {
          ve();
          var n = e.$options[t],
            i = t + " hook";
          if (n)
            for (var r = 0, s = n.length; r < s; r++) Ye(n[r], e, null, e, i);
          e._hasHookEvent && e.$emit("hook:" + t), ye();
        }
        var dn = [],
          un = [],
          pn = {},
          hn = !1,
          fn = !1,
          mn = 0;
        var vn = 0,
          yn = Date.now;
        if (U && !J) {
          var gn = window.performance;
          gn &&
            "function" == typeof gn.now &&
            yn() > document.createEvent("Event").timeStamp &&
            (yn = function () {
              return gn.now();
            });
        }
        function xn() {
          var e, t;
          for (
            vn = yn(),
              fn = !0,
              dn.sort(function (e, t) {
                return e.id - t.id;
              }),
              mn = 0;
            mn < dn.length;
            mn++
          )
            (e = dn[mn]).before && e.before(),
              (t = e.id),
              (pn[t] = null),
              e.run();
          var n = un.slice(),
            i = dn.slice();
          (mn = dn.length = un.length = 0),
            (pn = {}),
            (hn = fn = !1),
            (function (e) {
              for (var t = 0; t < e.length; t++)
                (e[t]._inactive = !0), on(e[t], !0);
            })(n),
            (function (e) {
              var t = e.length;
              for (; t--; ) {
                var n = e[t],
                  i = n.vm;
                i._watcher === n &&
                  i._isMounted &&
                  !i._isDestroyed &&
                  cn(i, "updated");
              }
            })(i),
            le && B.devtools && le.emit("flush");
        }
        var bn = 0,
          wn = function (e, t, n, i, r) {
            (this.vm = e),
              r && (e._watcher = this),
              e._watchers.push(this),
              i
                ? ((this.deep = !!i.deep),
                  (this.user = !!i.user),
                  (this.lazy = !!i.lazy),
                  (this.sync = !!i.sync),
                  (this.before = i.before))
                : (this.deep = this.user = this.lazy = this.sync = !1),
              (this.cb = n),
              (this.id = ++bn),
              (this.active = !0),
              (this.dirty = this.lazy),
              (this.deps = []),
              (this.newDeps = []),
              (this.depIds = new de()),
              (this.newDepIds = new de()),
              (this.expression = ""),
              "function" == typeof t
                ? (this.getter = t)
                : ((this.getter = (function (e) {
                    if (!G.test(e)) {
                      var t = e.split(".");
                      return function (e) {
                        for (var n = 0; n < t.length; n++) {
                          if (!e) return;
                          e = e[t[n]];
                        }
                        return e;
                      };
                    }
                  })(t)),
                  this.getter || (this.getter = I)),
              (this.value = this.lazy ? void 0 : this.get());
          };
        (wn.prototype.get = function () {
          var e;
          ve(this);
          var t = this.vm;
          try {
            e = this.getter.call(t, t);
          } catch (e) {
            if (!this.user) throw e;
            Xe(e, t, 'getter for watcher "' + this.expression + '"');
          } finally {
            this.deep && lt(e), ye(), this.cleanupDeps();
          }
          return e;
        }),
          (wn.prototype.addDep = function (e) {
            var t = e.id;
            this.newDepIds.has(t) ||
              (this.newDepIds.add(t),
              this.newDeps.push(e),
              this.depIds.has(t) || e.addSub(this));
          }),
          (wn.prototype.cleanupDeps = function () {
            for (var e = this.deps.length; e--; ) {
              var t = this.deps[e];
              this.newDepIds.has(t.id) || t.removeSub(this);
            }
            var n = this.depIds;
            (this.depIds = this.newDepIds),
              (this.newDepIds = n),
              this.newDepIds.clear(),
              (n = this.deps),
              (this.deps = this.newDeps),
              (this.newDeps = n),
              (this.newDeps.length = 0);
          }),
          (wn.prototype.update = function () {
            this.lazy
              ? (this.dirty = !0)
              : this.sync
              ? this.run()
              : (function (e) {
                  var t = e.id;
                  if (null == pn[t]) {
                    if (((pn[t] = !0), fn)) {
                      for (var n = dn.length - 1; n > mn && dn[n].id > e.id; )
                        n--;
                      dn.splice(n + 1, 0, e);
                    } else dn.push(e);
                    hn || ((hn = !0), at(xn));
                  }
                })(this);
          }),
          (wn.prototype.run = function () {
            if (this.active) {
              var e = this.get();
              if (e !== this.value || d(e) || this.deep) {
                var t = this.value;
                if (((this.value = e), this.user)) {
                  var n = 'callback for watcher "' + this.expression + '"';
                  Ye(this.cb, this.vm, [e, t], this.vm, n);
                } else this.cb.call(this.vm, e, t);
              }
            }
          }),
          (wn.prototype.evaluate = function () {
            (this.value = this.get()), (this.dirty = !1);
          }),
          (wn.prototype.depend = function () {
            for (var e = this.deps.length; e--; ) this.deps[e].depend();
          }),
          (wn.prototype.teardown = function () {
            if (this.active) {
              this.vm._isBeingDestroyed || b(this.vm._watchers, this);
              for (var e = this.deps.length; e--; ) this.deps[e].removeSub(this);
              this.active = !1;
            }
          });
        var Sn = { enumerable: !0, configurable: !0, get: I, set: I };
        function Cn(e, t, n) {
          (Sn.get = function () {
            return this[t][n];
          }),
            (Sn.set = function (e) {
              this[t][n] = e;
            }),
            Object.defineProperty(e, n, Sn);
        }
        function Tn(e) {
          e._watchers = [];
          var t = e.$options;
          t.props &&
            (function (e, t) {
              var n = e.$options.propsData || {},
                i = (e._props = {}),
                r = (e.$options._propKeys = []);
              e.$parent && ke(!1);
              var s = function (s) {
                r.push(s);
                var a = Be(s, t, n, e);
                je(i, s, a), s in e || Cn(e, "_props", s);
              };
              for (var a in t) s(a);
              ke(!0);
            })(e, t.props),
            t.methods &&
              (function (e, t) {
                e.$options.props;
                for (var n in t)
                  e[n] = "function" != typeof t[n] ? I : M(t[n], e);
              })(e, t.methods),
            t.data
              ? (function (e) {
                  var t = e.$options.data;
                  p(
                    (t = e._data =
                      "function" == typeof t
                        ? (function (e, t) {
                            ve();
                            try {
                              return e.call(t, t);
                            } catch (e) {
                              return Xe(e, t, "data()"), {};
                            } finally {
                              ye();
                            }
                          })(t, e)
                        : t || {})
                  ) || (t = {});
                  var n = Object.keys(t),
                    i = e.$options.props,
                    r = (e.$options.methods, n.length);
                  for (; r--; ) {
                    var s = n[r];
                    0, (i && S(i, s)) || R(s) || Cn(e, "_data", s);
                  }
                  Me(t, !0);
                })(e)
              : Me((e._data = {}), !0),
            t.computed &&
              (function (e, t) {
                var n = (e._computedWatchers = Object.create(null)),
                  i = oe();
                for (var r in t) {
                  var s = t[r],
                    a = "function" == typeof s ? s : s.get;
                  0,
                    i || (n[r] = new wn(e, a || I, I, _n)),
                    r in e || En(e, r, s);
                }
              })(e, t.computed),
            t.watch &&
              t.watch !== re &&
              (function (e, t) {
                for (var n in t) {
                  var i = t[n];
                  if (Array.isArray(i))
                    for (var r = 0; r < i.length; r++) Mn(e, n, i[r]);
                  else Mn(e, n, i);
                }
              })(e, t.watch);
        }
        var _n = { lazy: !0 };
        function En(e, t, n) {
          var i = !oe();
          "function" == typeof n
            ? ((Sn.get = i ? kn(t) : $n(n)), (Sn.set = I))
            : ((Sn.get = n.get ? (i && !1 !== n.cache ? kn(t) : $n(n.get)) : I),
              (Sn.set = n.set || I)),
            Object.defineProperty(e, t, Sn);
        }
        function kn(e) {
          return function () {
            var t = this._computedWatchers && this._computedWatchers[e];
            if (t)
              return t.dirty && t.evaluate(), fe.target && t.depend(), t.value;
          };
        }
        function $n(e) {
          return function () {
            return e.call(this, this);
          };
        }
        function Mn(e, t, n, i) {
          return (
            p(n) && ((i = n), (n = n.handler)),
            "string" == typeof n && (n = e[n]),
            e.$watch(t, n, i)
          );
        }
        var jn = 0;
        function An(e) {
          var t = e.options;
          if (e.super) {
            var n = An(e.super);
            if (n !== e.superOptions) {
              e.superOptions = n;
              var i = (function (e) {
                var t,
                  n = e.options,
                  i = e.sealedOptions;
                for (var r in n) n[r] !== i[r] && (t || (t = {}), (t[r] = n[r]));
                return t;
              })(e);
              i && A(e.extendOptions, i),
                (t = e.options = He(n, e.extendOptions)).name &&
                  (t.components[t.name] = e);
            }
          }
          return t;
        }
        function Ln(e) {
          this._init(e);
        }
        function In(e) {
          e.cid = 0;
          var t = 1;
          e.extend = function (e) {
            e = e || {};
            var n = this,
              i = n.cid,
              r = e._Ctor || (e._Ctor = {});
            if (r[i]) return r[i];
            var s = e.name || n.options.name;
            var a = function (e) {
              this._init(e);
            };
            return (
              ((a.prototype = Object.create(n.prototype)).constructor = a),
              (a.cid = t++),
              (a.options = He(n.options, e)),
              (a.super = n),
              a.options.props &&
                (function (e) {
                  var t = e.options.props;
                  for (var n in t) Cn(e.prototype, "_props", n);
                })(a),
              a.options.computed &&
                (function (e) {
                  var t = e.options.computed;
                  for (var n in t) En(e.prototype, n, t[n]);
                })(a),
              (a.extend = n.extend),
              (a.mixin = n.mixin),
              (a.use = n.use),
              H.forEach(function (e) {
                a[e] = n[e];
              }),
              s && (a.options.components[s] = a),
              (a.superOptions = n.options),
              (a.extendOptions = e),
              (a.sealedOptions = A({}, a.options)),
              (r[i] = a),
              a
            );
          };
        }
        function On(e) {
          return e && (e.Ctor.options.name || e.tag);
        }
        function Pn(e, t) {
          return Array.isArray(e)
            ? e.indexOf(t) > -1
            : "string" == typeof e
            ? e.split(",").indexOf(t) > -1
            : !!h(e) && e.test(t);
        }
        function Dn(e, t) {
          var n = e.cache,
            i = e.keys,
            r = e._vnode;
          for (var s in n) {
            var a = n[s];
            if (a) {
              var o = a.name;
              o && !t(o) && zn(n, s, i, r);
            }
          }
        }
        function zn(e, t, n, i) {
          var r = e[t];
          !r || (i && r.tag === i.tag) || r.componentInstance.$destroy(),
            (e[t] = null),
            b(n, t);
        }
        !(function (e) {
          e.prototype._init = function (e) {
            var t = this;
            (t._uid = jn++),
              (t._isVue = !0),
              e && e._isComponent
                ? (function (e, t) {
                    var n = (e.$options = Object.create(e.constructor.options)),
                      i = t._parentVnode;
                    (n.parent = t.parent), (n._parentVnode = i);
                    var r = i.componentOptions;
                    (n.propsData = r.propsData),
                      (n._parentListeners = r.listeners),
                      (n._renderChildren = r.children),
                      (n._componentTag = r.tag),
                      t.render &&
                        ((n.render = t.render),
                        (n.staticRenderFns = t.staticRenderFns));
                  })(t, e)
                : (t.$options = He(An(t.constructor), e || {}, t)),
              (t._renderProxy = t),
              (t._self = t),
              (function (e) {
                var t = e.$options,
                  n = t.parent;
                if (n && !t.abstract) {
                  for (; n.$options.abstract && n.$parent; ) n = n.$parent;
                  n.$children.push(e);
                }
                (e.$parent = n),
                  (e.$root = n ? n.$root : e),
                  (e.$children = []),
                  (e.$refs = {}),
                  (e._watcher = null),
                  (e._inactive = null),
                  (e._directInactive = !1),
                  (e._isMounted = !1),
                  (e._isDestroyed = !1),
                  (e._isBeingDestroyed = !1);
              })(t),
              (function (e) {
                (e._events = Object.create(null)), (e._hasHookEvent = !1);
                var t = e.$options._parentListeners;
                t && nn(e, t);
              })(t),
              (function (e) {
                (e._vnode = null), (e._staticTrees = null);
                var t = e.$options,
                  n = (e.$vnode = t._parentVnode),
                  i = n && n.context;
                (e.$slots = xt(t._renderChildren, i)),
                  (e.$scopedSlots = s),
                  (e._c = function (t, n, i, r) {
                    return Xt(e, t, n, i, r, !1);
                  }),
                  (e.$createElement = function (t, n, i, r) {
                    return Xt(e, t, n, i, r, !0);
                  });
                var r = n && n.data;
                je(e, "$attrs", (r && r.attrs) || s, null, !0),
                  je(e, "$listeners", t._parentListeners || s, null, !0);
              })(t),
              cn(t, "beforeCreate"),
              (function (e) {
                var t = gt(e.$options.inject, e);
                t &&
                  (ke(!1),
                  Object.keys(t).forEach(function (n) {
                    je(e, n, t[n]);
                  }),
                  ke(!0));
              })(t),
              Tn(t),
              (function (e) {
                var t = e.$options.provide;
                t && (e._provided = "function" == typeof t ? t.call(e) : t);
              })(t),
              cn(t, "created"),
              t.$options.el && t.$mount(t.$options.el);
          };
        })(Ln),
          (function (e) {
            var t = {
                get: function () {
                  return this._data;
                },
              },
              n = {
                get: function () {
                  return this._props;
                },
              };
            Object.defineProperty(e.prototype, "$data", t),
              Object.defineProperty(e.prototype, "$props", n),
              (e.prototype.$set = Ae),
              (e.prototype.$delete = Le),
              (e.prototype.$watch = function (e, t, n) {
                var i = this;
                if (p(t)) return Mn(i, e, t, n);
                (n = n || {}).user = !0;
                var r = new wn(i, e, t, n);
                if (n.immediate) {
                  var s = 'callback for immediate watcher "' + r.expression + '"';
                  ve(), Ye(t, i, [r.value], i, s), ye();
                }
                return function () {
                  r.teardown();
                };
              });
          })(Ln),
          (function (e) {
            var t = /^hook:/;
            (e.prototype.$on = function (e, n) {
              var i = this;
              if (Array.isArray(e))
                for (var r = 0, s = e.length; r < s; r++) i.$on(e[r], n);
              else
                (i._events[e] || (i._events[e] = [])).push(n),
                  t.test(e) && (i._hasHookEvent = !0);
              return i;
            }),
              (e.prototype.$once = function (e, t) {
                var n = this;
                function i() {
                  n.$off(e, i), t.apply(n, arguments);
                }
                return (i.fn = t), n.$on(e, i), n;
              }),
              (e.prototype.$off = function (e, t) {
                var n = this;
                if (!arguments.length)
                  return (n._events = Object.create(null)), n;
                if (Array.isArray(e)) {
                  for (var i = 0, r = e.length; i < r; i++) n.$off(e[i], t);
                  return n;
                }
                var s,
                  a = n._events[e];
                if (!a) return n;
                if (!t) return (n._events[e] = null), n;
                for (var o = a.length; o--; )
                  if ((s = a[o]) === t || s.fn === t) {
                    a.splice(o, 1);
                    break;
                  }
                return n;
              }),
              (e.prototype.$emit = function (e) {
                var t = this,
                  n = t._events[e];
                if (n) {
                  n = n.length > 1 ? j(n) : n;
                  for (
                    var i = j(arguments, 1),
                      r = 'event handler for "' + e + '"',
                      s = 0,
                      a = n.length;
                    s < a;
                    s++
                  )
                    Ye(n[s], t, i, t, r);
                }
                return t;
              });
          })(Ln),
          (function (e) {
            (e.prototype._update = function (e, t) {
              var n = this,
                i = n.$el,
                r = n._vnode,
                s = sn(n);
              (n._vnode = e),
                (n.$el = r ? n.__patch__(r, e) : n.__patch__(n.$el, e, t, !1)),
                s(),
                i && (i.__vue__ = null),
                n.$el && (n.$el.__vue__ = n),
                n.$vnode &&
                  n.$parent &&
                  n.$vnode === n.$parent._vnode &&
                  (n.$parent.$el = n.$el);
            }),
              (e.prototype.$forceUpdate = function () {
                this._watcher && this._watcher.update();
              }),
              (e.prototype.$destroy = function () {
                var e = this;
                if (!e._isBeingDestroyed) {
                  cn(e, "beforeDestroy"), (e._isBeingDestroyed = !0);
                  var t = e.$parent;
                  !t ||
                    t._isBeingDestroyed ||
                    e.$options.abstract ||
                    b(t.$children, e),
                    e._watcher && e._watcher.teardown();
                  for (var n = e._watchers.length; n--; )
                    e._watchers[n].teardown();
                  e._data.__ob__ && e._data.__ob__.vmCount--,
                    (e._isDestroyed = !0),
                    e.__patch__(e._vnode, null),
                    cn(e, "destroyed"),
                    e.$off(),
                    e.$el && (e.$el.__vue__ = null),
                    e.$vnode && (e.$vnode.parent = null);
                }
              });
          })(Ln),
          (function (e) {
            qt(e.prototype),
              (e.prototype.$nextTick = function (e) {
                return at(e, this);
              }),
              (e.prototype._render = function () {
                var e,
                  t = this,
                  n = t.$options,
                  i = n.render,
                  r = n._parentVnode;
                r &&
                  (t.$scopedSlots = St(
                    r.data.scopedSlots,
                    t.$slots,
                    t.$scopedSlots
                  )),
                  (t.$vnode = r);
                try {
                  (Kt = t), (e = i.call(t._renderProxy, t.$createElement));
                } catch (n) {
                  Xe(n, t, "render"), (e = t._vnode);
                } finally {
                  Kt = null;
                }
                return (
                  Array.isArray(e) && 1 === e.length && (e = e[0]),
                  e instanceof ge || (e = be()),
                  (e.parent = r),
                  e
                );
              });
          })(Ln);
        var Nn = [String, RegExp, Array],
          qn = {
            name: "keep-alive",
            abstract: !0,
            props: { include: Nn, exclude: Nn, max: [String, Number] },
            methods: {
              cacheVNode: function () {
                var e = this,
                  t = e.cache,
                  n = e.keys,
                  i = e.vnodeToCache,
                  r = e.keyToCache;
                if (i) {
                  var s = i.tag,
                    a = i.componentInstance,
                    o = i.componentOptions;
                  (t[r] = { name: On(o), tag: s, componentInstance: a }),
                    n.push(r),
                    this.max &&
                      n.length > parseInt(this.max) &&
                      zn(t, n[0], n, this._vnode),
                    (this.vnodeToCache = null);
                }
              },
            },
            created: function () {
              (this.cache = Object.create(null)), (this.keys = []);
            },
            destroyed: function () {
              for (var e in this.cache) zn(this.cache, e, this.keys);
            },
            mounted: function () {
              var e = this;
              this.cacheVNode(),
                this.$watch("include", function (t) {
                  Dn(e, function (e) {
                    return Pn(t, e);
                  });
                }),
                this.$watch("exclude", function (t) {
                  Dn(e, function (e) {
                    return !Pn(t, e);
                  });
                });
            },
            updated: function () {
              this.cacheVNode();
            },
            render: function () {
              var e = this.$slots.default,
                t = Qt(e),
                n = t && t.componentOptions;
              if (n) {
                var i = On(n),
                  r = this.include,
                  s = this.exclude;
                if ((r && (!i || !Pn(r, i))) || (s && i && Pn(s, i))) return t;
                var a = this.cache,
                  o = this.keys,
                  l =
                    null == t.key
                      ? n.Ctor.cid + (n.tag ? "::" + n.tag : "")
                      : t.key;
                a[l]
                  ? ((t.componentInstance = a[l].componentInstance),
                    b(o, l),
                    o.push(l))
                  : ((this.vnodeToCache = t), (this.keyToCache = l)),
                  (t.data.keepAlive = !0);
              }
              return t || (e && e[0]);
            },
          },
          Hn = { KeepAlive: qn };
        !(function (e) {
          var t = {
            get: function () {
              return B;
            },
          };
          Object.defineProperty(e, "config", t),
            (e.util = {
              warn: pe,
              extend: A,
              mergeOptions: He,
              defineReactive: je,
            }),
            (e.set = Ae),
            (e.delete = Le),
            (e.nextTick = at),
            (e.observable = function (e) {
              return Me(e), e;
            }),
            (e.options = Object.create(null)),
            H.forEach(function (t) {
              e.options[t + "s"] = Object.create(null);
            }),
            (e.options._base = e),
            A(e.options.components, Hn),
            (function (e) {
              e.use = function (e) {
                var t = this._installedPlugins || (this._installedPlugins = []);
                if (t.indexOf(e) > -1) return this;
                var n = j(arguments, 1);
                return (
                  n.unshift(this),
                  "function" == typeof e.install
                    ? e.install.apply(e, n)
                    : "function" == typeof e && e.apply(null, n),
                  t.push(e),
                  this
                );
              };
            })(e),
            (function (e) {
              e.mixin = function (e) {
                return (this.options = He(this.options, e)), this;
              };
            })(e),
            In(e),
            (function (e) {
              H.forEach(function (t) {
                e[t] = function (e, n) {
                  return n
                    ? ("component" === t &&
                        p(n) &&
                        ((n.name = n.name || e),
                        (n = this.options._base.extend(n))),
                      "directive" === t &&
                        "function" == typeof n &&
                        (n = { bind: n, update: n }),
                      (this.options[t + "s"][e] = n),
                      n)
                    : this.options[t + "s"][e];
                };
              });
            })(e);
        })(Ln),
          Object.defineProperty(Ln.prototype, "$isServer", { get: oe }),
          Object.defineProperty(Ln.prototype, "$ssrContext", {
            get: function () {
              return this.$vnode && this.$vnode.ssrContext;
            },
          }),
          Object.defineProperty(Ln, "FunctionalRenderContext", { value: Ht }),
          (Ln.version = "2.6.14");
        var Fn = g("style,class"),
          Bn = g("input,textarea,option,select,progress"),
          Wn = g("contenteditable,draggable,spellcheck"),
          Rn = g("events,caret,typing,plaintext-only"),
          Vn = g(
            "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"
          ),
          Gn = "http://www.w3.org/1999/xlink",
          Xn = function (e) {
            return ":" === e.charAt(5) && "xlink" === e.slice(0, 5);
          },
          Yn = function (e) {
            return Xn(e) ? e.slice(6, e.length) : "";
          },
          Un = function (e) {
            return null == e || !1 === e;
          };
        function Kn(e) {
          for (var t = e.data, n = e, i = e; o(i.componentInstance); )
            (i = i.componentInstance._vnode) && i.data && (t = Zn(i.data, t));
          for (; o((n = n.parent)); ) n && n.data && (t = Zn(t, n.data));
          return (function (e, t) {
            if (o(e) || o(t)) return Qn(e, Jn(t));
            return "";
          })(t.staticClass, t.class);
        }
        function Zn(e, t) {
          return {
            staticClass: Qn(e.staticClass, t.staticClass),
            class: o(e.class) ? [e.class, t.class] : t.class,
          };
        }
        function Qn(e, t) {
          return e ? (t ? e + " " + t : e) : t || "";
        }
        function Jn(e) {
          return Array.isArray(e)
            ? (function (e) {
                for (var t, n = "", i = 0, r = e.length; i < r; i++)
                  o((t = Jn(e[i]))) && "" !== t && (n && (n += " "), (n += t));
                return n;
              })(e)
            : d(e)
            ? (function (e) {
                var t = "";
                for (var n in e) e[n] && (t && (t += " "), (t += n));
                return t;
              })(e)
            : "string" == typeof e
            ? e
            : "";
        }
        var ei = {
            svg: "http://www.w3.org/2000/svg",
            math: "http://www.w3.org/1998/Math/MathML",
          },
          ti = g(
            "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"
          ),
          ni = g(
            "svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",
            !0
          ),
          ii = function (e) {
            return ti(e) || ni(e);
          };
        var ri = Object.create(null);
        var si = g("text,number,password,search,email,tel,url");
        var ai = Object.freeze({
            createElement: function (e, t) {
              var n = document.createElement(e);
              return (
                "select" !== e ||
                  (t.data &&
                    t.data.attrs &&
                    void 0 !== t.data.attrs.multiple &&
                    n.setAttribute("multiple", "multiple")),
                n
              );
            },
            createElementNS: function (e, t) {
              return document.createElementNS(ei[e], t);
            },
            createTextNode: function (e) {
              return document.createTextNode(e);
            },
            createComment: function (e) {
              return document.createComment(e);
            },
            insertBefore: function (e, t, n) {
              e.insertBefore(t, n);
            },
            removeChild: function (e, t) {
              e.removeChild(t);
            },
            appendChild: function (e, t) {
              e.appendChild(t);
            },
            parentNode: function (e) {
              return e.parentNode;
            },
            nextSibling: function (e) {
              return e.nextSibling;
            },
            tagName: function (e) {
              return e.tagName;
            },
            setTextContent: function (e, t) {
              e.textContent = t;
            },
            setStyleScope: function (e, t) {
              e.setAttribute(t, "");
            },
          }),
          oi = {
            create: function (e, t) {
              li(t);
            },
            update: function (e, t) {
              e.data.ref !== t.data.ref && (li(e, !0), li(t));
            },
            destroy: function (e) {
              li(e, !0);
            },
          };
        function li(e, t) {
          var n = e.data.ref;
          if (o(n)) {
            var i = e.context,
              r = e.componentInstance || e.elm,
              s = i.$refs;
            t
              ? Array.isArray(s[n])
                ? b(s[n], r)
                : s[n] === r && (s[n] = void 0)
              : e.data.refInFor
              ? Array.isArray(s[n])
                ? s[n].indexOf(r) < 0 && s[n].push(r)
                : (s[n] = [r])
              : (s[n] = r);
          }
        }
        var ci = new ge("", {}, []),
          di = ["create", "activate", "update", "remove", "destroy"];
        function ui(e, t) {
          return (
            e.key === t.key &&
            e.asyncFactory === t.asyncFactory &&
            ((e.tag === t.tag &&
              e.isComment === t.isComment &&
              o(e.data) === o(t.data) &&
              (function (e, t) {
                if ("input" !== e.tag) return !0;
                var n,
                  i = o((n = e.data)) && o((n = n.attrs)) && n.type,
                  r = o((n = t.data)) && o((n = n.attrs)) && n.type;
                return i === r || (si(i) && si(r));
              })(e, t)) ||
              (l(e.isAsyncPlaceholder) && a(t.asyncFactory.error)))
          );
        }
        function pi(e, t, n) {
          var i,
            r,
            s = {};
          for (i = t; i <= n; ++i) o((r = e[i].key)) && (s[r] = i);
          return s;
        }
        var hi = {
          create: fi,
          update: fi,
          destroy: function (e) {
            fi(e, ci);
          },
        };
        function fi(e, t) {
          (e.data.directives || t.data.directives) &&
            (function (e, t) {
              var n,
                i,
                r,
                s = e === ci,
                a = t === ci,
                o = vi(e.data.directives, e.context),
                l = vi(t.data.directives, t.context),
                c = [],
                d = [];
              for (n in l)
                (i = o[n]),
                  (r = l[n]),
                  i
                    ? ((r.oldValue = i.value),
                      (r.oldArg = i.arg),
                      gi(r, "update", t, e),
                      r.def && r.def.componentUpdated && d.push(r))
                    : (gi(r, "bind", t, e), r.def && r.def.inserted && c.push(r));
              if (c.length) {
                var u = function () {
                  for (var n = 0; n < c.length; n++) gi(c[n], "inserted", t, e);
                };
                s ? ht(t, "insert", u) : u();
              }
              d.length &&
                ht(t, "postpatch", function () {
                  for (var n = 0; n < d.length; n++)
                    gi(d[n], "componentUpdated", t, e);
                });
              if (!s) for (n in o) l[n] || gi(o[n], "unbind", e, e, a);
            })(e, t);
        }
        var mi = Object.create(null);
        function vi(e, t) {
          var n,
            i,
            r = Object.create(null);
          if (!e) return r;
          for (n = 0; n < e.length; n++)
            (i = e[n]).modifiers || (i.modifiers = mi),
              (r[yi(i)] = i),
              (i.def = Fe(t.$options, "directives", i.name));
          return r;
        }
        function yi(e) {
          return (
            e.rawName || e.name + "." + Object.keys(e.modifiers || {}).join(".")
          );
        }
        function gi(e, t, n, i, r) {
          var s = e.def && e.def[t];
          if (s)
            try {
              s(n.elm, e, n, i, r);
            } catch (i) {
              Xe(i, n.context, "directive " + e.name + " " + t + " hook");
            }
        }
        var xi = [oi, hi];
        function bi(e, t) {
          var n = t.componentOptions;
          if (
            !(
              (o(n) && !1 === n.Ctor.options.inheritAttrs) ||
              (a(e.data.attrs) && a(t.data.attrs))
            )
          ) {
            var i,
              r,
              s = t.elm,
              l = e.data.attrs || {},
              c = t.data.attrs || {};
            for (i in (o(c.__ob__) && (c = t.data.attrs = A({}, c)), c))
              (r = c[i]), l[i] !== r && wi(s, i, r, t.data.pre);
            for (i in ((J || te) &&
              c.value !== l.value &&
              wi(s, "value", c.value),
            l))
              a(c[i]) &&
                (Xn(i)
                  ? s.removeAttributeNS(Gn, Yn(i))
                  : Wn(i) || s.removeAttribute(i));
          }
        }
        function wi(e, t, n, i) {
          i || e.tagName.indexOf("-") > -1
            ? Si(e, t, n)
            : Vn(t)
            ? Un(n)
              ? e.removeAttribute(t)
              : ((n =
                  "allowfullscreen" === t && "EMBED" === e.tagName ? "true" : t),
                e.setAttribute(t, n))
            : Wn(t)
            ? e.setAttribute(
                t,
                (function (e, t) {
                  return Un(t) || "false" === t
                    ? "false"
                    : "contenteditable" === e && Rn(t)
                    ? t
                    : "true";
                })(t, n)
              )
            : Xn(t)
            ? Un(n)
              ? e.removeAttributeNS(Gn, Yn(t))
              : e.setAttributeNS(Gn, t, n)
            : Si(e, t, n);
        }
        function Si(e, t, n) {
          if (Un(n)) e.removeAttribute(t);
          else {
            if (
              J &&
              !ee &&
              "TEXTAREA" === e.tagName &&
              "placeholder" === t &&
              "" !== n &&
              !e.__ieph
            ) {
              var i = function (t) {
                t.stopImmediatePropagation(), e.removeEventListener("input", i);
              };
              e.addEventListener("input", i), (e.__ieph = !0);
            }
            e.setAttribute(t, n);
          }
        }
        var Ci = { create: bi, update: bi };
        function Ti(e, t) {
          var n = t.elm,
            i = t.data,
            r = e.data;
          if (
            !(
              a(i.staticClass) &&
              a(i.class) &&
              (a(r) || (a(r.staticClass) && a(r.class)))
            )
          ) {
            var s = Kn(t),
              l = n._transitionClasses;
            o(l) && (s = Qn(s, Jn(l))),
              s !== n._prevClass &&
                (n.setAttribute("class", s), (n._prevClass = s));
          }
        }
        var _i,
          Ei = { create: Ti, update: Ti };
        function ki(e, t, n) {
          var i = _i;
          return function r() {
            var s = t.apply(null, arguments);
            null !== s && ji(e, r, n, i);
          };
        }
        var $i = Qe && !(ie && Number(ie[1]) <= 53);
        function Mi(e, t, n, i) {
          if ($i) {
            var r = vn,
              s = t;
            t = s._wrapper = function (e) {
              if (
                e.target === e.currentTarget ||
                e.timeStamp >= r ||
                e.timeStamp <= 0 ||
                e.target.ownerDocument !== document
              )
                return s.apply(this, arguments);
            };
          }
          _i.addEventListener(e, t, se ? { capture: n, passive: i } : n);
        }
        function ji(e, t, n, i) {
          (i || _i).removeEventListener(e, t._wrapper || t, n);
        }
        function Ai(e, t) {
          if (!a(e.data.on) || !a(t.data.on)) {
            var n = t.data.on || {},
              i = e.data.on || {};
            (_i = t.elm),
              (function (e) {
                if (o(e.__r)) {
                  var t = J ? "change" : "input";
                  (e[t] = [].concat(e.__r, e[t] || [])), delete e.__r;
                }
                o(e.__c) &&
                  ((e.change = [].concat(e.__c, e.change || [])), delete e.__c);
              })(n),
              pt(n, i, Mi, ji, ki, t.context),
              (_i = void 0);
          }
        }
        var Li,
          Ii = { create: Ai, update: Ai };
        function Oi(e, t) {
          if (!a(e.data.domProps) || !a(t.data.domProps)) {
            var n,
              i,
              r = t.elm,
              s = e.data.domProps || {},
              l = t.data.domProps || {};
            for (n in (o(l.__ob__) && (l = t.data.domProps = A({}, l)), s))
              n in l || (r[n] = "");
            for (n in l) {
              if (((i = l[n]), "textContent" === n || "innerHTML" === n)) {
                if ((t.children && (t.children.length = 0), i === s[n])) continue;
                1 === r.childNodes.length && r.removeChild(r.childNodes[0]);
              }
              if ("value" === n && "PROGRESS" !== r.tagName) {
                r._value = i;
                var c = a(i) ? "" : String(i);
                Pi(r, c) && (r.value = c);
              } else if ("innerHTML" === n && ni(r.tagName) && a(r.innerHTML)) {
                (Li = Li || document.createElement("div")).innerHTML =
                  "<svg>" + i + "</svg>";
                for (var d = Li.firstChild; r.firstChild; )
                  r.removeChild(r.firstChild);
                for (; d.firstChild; ) r.appendChild(d.firstChild);
              } else if (i !== s[n])
                try {
                  r[n] = i;
                } catch (e) {}
            }
          }
        }
        function Pi(e, t) {
          return (
            !e.composing &&
            ("OPTION" === e.tagName ||
              (function (e, t) {
                var n = !0;
                try {
                  n = document.activeElement !== e;
                } catch (e) {}
                return n && e.value !== t;
              })(e, t) ||
              (function (e, t) {
                var n = e.value,
                  i = e._vModifiers;
                if (o(i)) {
                  if (i.number) return y(n) !== y(t);
                  if (i.trim) return n.trim() !== t.trim();
                }
                return n !== t;
              })(e, t))
          );
        }
        var Di = { create: Oi, update: Oi },
          zi = C(function (e) {
            var t = {},
              n = /:(.+)/;
            return (
              e.split(/;(?![^(]*\))/g).forEach(function (e) {
                if (e) {
                  var i = e.split(n);
                  i.length > 1 && (t[i[0].trim()] = i[1].trim());
                }
              }),
              t
            );
          });
        function Ni(e) {
          var t = qi(e.style);
          return e.staticStyle ? A(e.staticStyle, t) : t;
        }
        function qi(e) {
          return Array.isArray(e) ? L(e) : "string" == typeof e ? zi(e) : e;
        }
        var Hi,
          Fi = /^--/,
          Bi = /\s*!important$/,
          Wi = function (e, t, n) {
            if (Fi.test(t)) e.style.setProperty(t, n);
            else if (Bi.test(n))
              e.style.setProperty($(t), n.replace(Bi, ""), "important");
            else {
              var i = Vi(t);
              if (Array.isArray(n))
                for (var r = 0, s = n.length; r < s; r++) e.style[i] = n[r];
              else e.style[i] = n;
            }
          },
          Ri = ["Webkit", "Moz", "ms"],
          Vi = C(function (e) {
            if (
              ((Hi = Hi || document.createElement("div").style),
              "filter" !== (e = _(e)) && e in Hi)
            )
              return e;
            for (
              var t = e.charAt(0).toUpperCase() + e.slice(1), n = 0;
              n < Ri.length;
              n++
            ) {
              var i = Ri[n] + t;
              if (i in Hi) return i;
            }
          });
        function Gi(e, t) {
          var n = t.data,
            i = e.data;
          if (
            !(a(n.staticStyle) && a(n.style) && a(i.staticStyle) && a(i.style))
          ) {
            var r,
              s,
              l = t.elm,
              c = i.staticStyle,
              d = i.normalizedStyle || i.style || {},
              u = c || d,
              p = qi(t.data.style) || {};
            t.data.normalizedStyle = o(p.__ob__) ? A({}, p) : p;
            var h = (function (e, t) {
              var n,
                i = {};
              if (t)
                for (var r = e; r.componentInstance; )
                  (r = r.componentInstance._vnode) &&
                    r.data &&
                    (n = Ni(r.data)) &&
                    A(i, n);
              (n = Ni(e.data)) && A(i, n);
              for (var s = e; (s = s.parent); )
                s.data && (n = Ni(s.data)) && A(i, n);
              return i;
            })(t, !0);
            for (s in u) a(h[s]) && Wi(l, s, "");
            for (s in h) (r = h[s]) !== u[s] && Wi(l, s, null == r ? "" : r);
          }
        }
        var Xi = { create: Gi, update: Gi },
          Yi = /\s+/;
        function Ui(e, t) {
          if (t && (t = t.trim()))
            if (e.classList)
              t.indexOf(" ") > -1
                ? t.split(Yi).forEach(function (t) {
                    return e.classList.add(t);
                  })
                : e.classList.add(t);
            else {
              var n = " " + (e.getAttribute("class") || "") + " ";
              n.indexOf(" " + t + " ") < 0 &&
                e.setAttribute("class", (n + t).trim());
            }
        }
        function Ki(e, t) {
          if (t && (t = t.trim()))
            if (e.classList)
              t.indexOf(" ") > -1
                ? t.split(Yi).forEach(function (t) {
                    return e.classList.remove(t);
                  })
                : e.classList.remove(t),
                e.classList.length || e.removeAttribute("class");
            else {
              for (
                var n = " " + (e.getAttribute("class") || "") + " ",
                  i = " " + t + " ";
                n.indexOf(i) >= 0;
  
              )
                n = n.replace(i, " ");
              (n = n.trim())
                ? e.setAttribute("class", n)
                : e.removeAttribute("class");
            }
        }
        function Zi(e) {
          if (e) {
            if ("object" == typeof e) {
              var t = {};
              return !1 !== e.css && A(t, Qi(e.name || "v")), A(t, e), t;
            }
            return "string" == typeof e ? Qi(e) : void 0;
          }
        }
        var Qi = C(function (e) {
            return {
              enterClass: e + "-enter",
              enterToClass: e + "-enter-to",
              enterActiveClass: e + "-enter-active",
              leaveClass: e + "-leave",
              leaveToClass: e + "-leave-to",
              leaveActiveClass: e + "-leave-active",
            };
          }),
          Ji = U && !ee,
          er = "transition",
          tr = "animation",
          nr = "transition",
          ir = "transitionend",
          rr = "animation",
          sr = "animationend";
        Ji &&
          (void 0 === window.ontransitionend &&
            void 0 !== window.onwebkittransitionend &&
            ((nr = "WebkitTransition"), (ir = "webkitTransitionEnd")),
          void 0 === window.onanimationend &&
            void 0 !== window.onwebkitanimationend &&
            ((rr = "WebkitAnimation"), (sr = "webkitAnimationEnd")));
        var ar = U
          ? window.requestAnimationFrame
            ? window.requestAnimationFrame.bind(window)
            : setTimeout
          : function (e) {
              return e();
            };
        function or(e) {
          ar(function () {
            ar(e);
          });
        }
        function lr(e, t) {
          var n = e._transitionClasses || (e._transitionClasses = []);
          n.indexOf(t) < 0 && (n.push(t), Ui(e, t));
        }
        function cr(e, t) {
          e._transitionClasses && b(e._transitionClasses, t), Ki(e, t);
        }
        function dr(e, t, n) {
          var i = pr(e, t),
            r = i.type,
            s = i.timeout,
            a = i.propCount;
          if (!r) return n();
          var o = r === er ? ir : sr,
            l = 0,
            c = function () {
              e.removeEventListener(o, d), n();
            },
            d = function (t) {
              t.target === e && ++l >= a && c();
            };
          setTimeout(function () {
            l < a && c();
          }, s + 1),
            e.addEventListener(o, d);
        }
        var ur = /\b(transform|all)(,|$)/;
        function pr(e, t) {
          var n,
            i = window.getComputedStyle(e),
            r = (i[nr + "Delay"] || "").split(", "),
            s = (i[nr + "Duration"] || "").split(", "),
            a = hr(r, s),
            o = (i[rr + "Delay"] || "").split(", "),
            l = (i[rr + "Duration"] || "").split(", "),
            c = hr(o, l),
            d = 0,
            u = 0;
          return (
            t === er
              ? a > 0 && ((n = er), (d = a), (u = s.length))
              : t === tr
              ? c > 0 && ((n = tr), (d = c), (u = l.length))
              : (u = (n = (d = Math.max(a, c)) > 0 ? (a > c ? er : tr) : null)
                  ? n === er
                    ? s.length
                    : l.length
                  : 0),
            {
              type: n,
              timeout: d,
              propCount: u,
              hasTransform: n === er && ur.test(i[nr + "Property"]),
            }
          );
        }
        function hr(e, t) {
          for (; e.length < t.length; ) e = e.concat(e);
          return Math.max.apply(
            null,
            t.map(function (t, n) {
              return fr(t) + fr(e[n]);
            })
          );
        }
        function fr(e) {
          return 1e3 * Number(e.slice(0, -1).replace(",", "."));
        }
        function mr(e, t) {
          var n = e.elm;
          o(n._leaveCb) && ((n._leaveCb.cancelled = !0), n._leaveCb());
          var i = Zi(e.data.transition);
          if (!a(i) && !o(n._enterCb) && 1 === n.nodeType) {
            for (
              var r = i.css,
                s = i.type,
                l = i.enterClass,
                c = i.enterToClass,
                u = i.enterActiveClass,
                p = i.appearClass,
                h = i.appearToClass,
                f = i.appearActiveClass,
                m = i.beforeEnter,
                v = i.enter,
                g = i.afterEnter,
                x = i.enterCancelled,
                b = i.beforeAppear,
                w = i.appear,
                S = i.afterAppear,
                C = i.appearCancelled,
                T = i.duration,
                _ = rn,
                E = rn.$vnode;
              E && E.parent;
  
            )
              (_ = E.context), (E = E.parent);
            var k = !_._isMounted || !e.isRootInsert;
            if (!k || w || "" === w) {
              var $ = k && p ? p : l,
                M = k && f ? f : u,
                j = k && h ? h : c,
                A = (k && b) || m,
                L = k && "function" == typeof w ? w : v,
                I = (k && S) || g,
                O = (k && C) || x,
                P = y(d(T) ? T.enter : T);
              0;
              var D = !1 !== r && !ee,
                z = gr(L),
                q = (n._enterCb = N(function () {
                  D && (cr(n, j), cr(n, M)),
                    q.cancelled ? (D && cr(n, $), O && O(n)) : I && I(n),
                    (n._enterCb = null);
                }));
              e.data.show ||
                ht(e, "insert", function () {
                  var t = n.parentNode,
                    i = t && t._pending && t._pending[e.key];
                  i && i.tag === e.tag && i.elm._leaveCb && i.elm._leaveCb(),
                    L && L(n, q);
                }),
                A && A(n),
                D &&
                  (lr(n, $),
                  lr(n, M),
                  or(function () {
                    cr(n, $),
                      q.cancelled ||
                        (lr(n, j), z || (yr(P) ? setTimeout(q, P) : dr(n, s, q)));
                  })),
                e.data.show && (t && t(), L && L(n, q)),
                D || z || q();
            }
          }
        }
        function vr(e, t) {
          var n = e.elm;
          o(n._enterCb) && ((n._enterCb.cancelled = !0), n._enterCb());
          var i = Zi(e.data.transition);
          if (a(i) || 1 !== n.nodeType) return t();
          if (!o(n._leaveCb)) {
            var r = i.css,
              s = i.type,
              l = i.leaveClass,
              c = i.leaveToClass,
              u = i.leaveActiveClass,
              p = i.beforeLeave,
              h = i.leave,
              f = i.afterLeave,
              m = i.leaveCancelled,
              v = i.delayLeave,
              g = i.duration,
              x = !1 !== r && !ee,
              b = gr(h),
              w = y(d(g) ? g.leave : g);
            0;
            var S = (n._leaveCb = N(function () {
              n.parentNode &&
                n.parentNode._pending &&
                (n.parentNode._pending[e.key] = null),
                x && (cr(n, c), cr(n, u)),
                S.cancelled ? (x && cr(n, l), m && m(n)) : (t(), f && f(n)),
                (n._leaveCb = null);
            }));
            v ? v(C) : C();
          }
          function C() {
            S.cancelled ||
              (!e.data.show &&
                n.parentNode &&
                ((n.parentNode._pending || (n.parentNode._pending = {}))[e.key] =
                  e),
              p && p(n),
              x &&
                (lr(n, l),
                lr(n, u),
                or(function () {
                  cr(n, l),
                    S.cancelled ||
                      (lr(n, c), b || (yr(w) ? setTimeout(S, w) : dr(n, s, S)));
                })),
              h && h(n, S),
              x || b || S());
          }
        }
        function yr(e) {
          return "number" == typeof e && !isNaN(e);
        }
        function gr(e) {
          if (a(e)) return !1;
          var t = e.fns;
          return o(t)
            ? gr(Array.isArray(t) ? t[0] : t)
            : (e._length || e.length) > 1;
        }
        function xr(e, t) {
          !0 !== t.data.show && mr(t);
        }
        var br = (function (e) {
          var t,
            n,
            i = {},
            r = e.modules,
            s = e.nodeOps;
          for (t = 0; t < di.length; ++t)
            for (i[di[t]] = [], n = 0; n < r.length; ++n)
              o(r[n][di[t]]) && i[di[t]].push(r[n][di[t]]);
          function d(e) {
            var t = s.parentNode(e);
            o(t) && s.removeChild(t, e);
          }
          function u(e, t, n, r, a, c, d) {
            if (
              (o(e.elm) && o(c) && (e = c[d] = Se(e)),
              (e.isRootInsert = !a),
              !(function (e, t, n, r) {
                var s = e.data;
                if (o(s)) {
                  var a = o(e.componentInstance) && s.keepAlive;
                  if (
                    (o((s = s.hook)) && o((s = s.init)) && s(e, !1),
                    o(e.componentInstance))
                  )
                    return (
                      p(e, t),
                      h(n, e.elm, r),
                      l(a) &&
                        (function (e, t, n, r) {
                          var s,
                            a = e;
                          for (; a.componentInstance; )
                            if (
                              o((s = (a = a.componentInstance._vnode).data)) &&
                              o((s = s.transition))
                            ) {
                              for (s = 0; s < i.activate.length; ++s)
                                i.activate[s](ci, a);
                              t.push(a);
                              break;
                            }
                          h(n, e.elm, r);
                        })(e, t, n, r),
                      !0
                    );
                }
              })(e, t, n, r))
            ) {
              var u = e.data,
                m = e.children,
                g = e.tag;
              o(g)
                ? ((e.elm = e.ns
                    ? s.createElementNS(e.ns, g)
                    : s.createElement(g, e)),
                  y(e),
                  f(e, m, t),
                  o(u) && v(e, t),
                  h(n, e.elm, r))
                : l(e.isComment)
                ? ((e.elm = s.createComment(e.text)), h(n, e.elm, r))
                : ((e.elm = s.createTextNode(e.text)), h(n, e.elm, r));
            }
          }
          function p(e, t) {
            o(e.data.pendingInsert) &&
              (t.push.apply(t, e.data.pendingInsert),
              (e.data.pendingInsert = null)),
              (e.elm = e.componentInstance.$el),
              m(e) ? (v(e, t), y(e)) : (li(e), t.push(e));
          }
          function h(e, t, n) {
            o(e) &&
              (o(n)
                ? s.parentNode(n) === e && s.insertBefore(e, t, n)
                : s.appendChild(e, t));
          }
          function f(e, t, n) {
            if (Array.isArray(t)) {
              0;
              for (var i = 0; i < t.length; ++i)
                u(t[i], n, e.elm, null, !0, t, i);
            } else
              c(e.text) && s.appendChild(e.elm, s.createTextNode(String(e.text)));
          }
          function m(e) {
            for (; e.componentInstance; ) e = e.componentInstance._vnode;
            return o(e.tag);
          }
          function v(e, n) {
            for (var r = 0; r < i.create.length; ++r) i.create[r](ci, e);
            o((t = e.data.hook)) &&
              (o(t.create) && t.create(ci, e), o(t.insert) && n.push(e));
          }
          function y(e) {
            var t;
            if (o((t = e.fnScopeId))) s.setStyleScope(e.elm, t);
            else
              for (var n = e; n; )
                o((t = n.context)) &&
                  o((t = t.$options._scopeId)) &&
                  s.setStyleScope(e.elm, t),
                  (n = n.parent);
            o((t = rn)) &&
              t !== e.context &&
              t !== e.fnContext &&
              o((t = t.$options._scopeId)) &&
              s.setStyleScope(e.elm, t);
          }
          function x(e, t, n, i, r, s) {
            for (; i <= r; ++i) u(n[i], s, e, t, !1, n, i);
          }
          function b(e) {
            var t,
              n,
              r = e.data;
            if (o(r))
              for (
                o((t = r.hook)) && o((t = t.destroy)) && t(e), t = 0;
                t < i.destroy.length;
                ++t
              )
                i.destroy[t](e);
            if (o((t = e.children)))
              for (n = 0; n < e.children.length; ++n) b(e.children[n]);
          }
          function w(e, t, n) {
            for (; t <= n; ++t) {
              var i = e[t];
              o(i) && (o(i.tag) ? (S(i), b(i)) : d(i.elm));
            }
          }
          function S(e, t) {
            if (o(t) || o(e.data)) {
              var n,
                r = i.remove.length + 1;
              for (
                o(t)
                  ? (t.listeners += r)
                  : (t = (function (e, t) {
                      function n() {
                        0 == --n.listeners && d(e);
                      }
                      return (n.listeners = t), n;
                    })(e.elm, r)),
                  o((n = e.componentInstance)) &&
                    o((n = n._vnode)) &&
                    o(n.data) &&
                    S(n, t),
                  n = 0;
                n < i.remove.length;
                ++n
              )
                i.remove[n](e, t);
              o((n = e.data.hook)) && o((n = n.remove)) ? n(e, t) : t();
            } else d(e.elm);
          }
          function C(e, t, n, i) {
            for (var r = n; r < i; r++) {
              var s = t[r];
              if (o(s) && ui(e, s)) return r;
            }
          }
          function T(e, t, n, r, c, d) {
            if (e !== t) {
              o(t.elm) && o(r) && (t = r[c] = Se(t));
              var p = (t.elm = e.elm);
              if (l(e.isAsyncPlaceholder))
                o(t.asyncFactory.resolved)
                  ? k(e.elm, t, n)
                  : (t.isAsyncPlaceholder = !0);
              else if (
                l(t.isStatic) &&
                l(e.isStatic) &&
                t.key === e.key &&
                (l(t.isCloned) || l(t.isOnce))
              )
                t.componentInstance = e.componentInstance;
              else {
                var h,
                  f = t.data;
                o(f) && o((h = f.hook)) && o((h = h.prepatch)) && h(e, t);
                var v = e.children,
                  y = t.children;
                if (o(f) && m(t)) {
                  for (h = 0; h < i.update.length; ++h) i.update[h](e, t);
                  o((h = f.hook)) && o((h = h.update)) && h(e, t);
                }
                a(t.text)
                  ? o(v) && o(y)
                    ? v !== y &&
                      (function (e, t, n, i, r) {
                        var l,
                          c,
                          d,
                          p = 0,
                          h = 0,
                          f = t.length - 1,
                          m = t[0],
                          v = t[f],
                          y = n.length - 1,
                          g = n[0],
                          b = n[y],
                          S = !r;
                        for (; p <= f && h <= y; )
                          a(m)
                            ? (m = t[++p])
                            : a(v)
                            ? (v = t[--f])
                            : ui(m, g)
                            ? (T(m, g, i, n, h), (m = t[++p]), (g = n[++h]))
                            : ui(v, b)
                            ? (T(v, b, i, n, y), (v = t[--f]), (b = n[--y]))
                            : ui(m, b)
                            ? (T(m, b, i, n, y),
                              S && s.insertBefore(e, m.elm, s.nextSibling(v.elm)),
                              (m = t[++p]),
                              (b = n[--y]))
                            : ui(v, g)
                            ? (T(v, g, i, n, h),
                              S && s.insertBefore(e, v.elm, m.elm),
                              (v = t[--f]),
                              (g = n[++h]))
                            : (a(l) && (l = pi(t, p, f)),
                              a((c = o(g.key) ? l[g.key] : C(g, t, p, f)))
                                ? u(g, i, e, m.elm, !1, n, h)
                                : ui((d = t[c]), g)
                                ? (T(d, g, i, n, h),
                                  (t[c] = void 0),
                                  S && s.insertBefore(e, d.elm, m.elm))
                                : u(g, i, e, m.elm, !1, n, h),
                              (g = n[++h]));
                        p > f
                          ? x(e, a(n[y + 1]) ? null : n[y + 1].elm, n, h, y, i)
                          : h > y && w(t, p, f);
                      })(p, v, y, n, d)
                    : o(y)
                    ? (o(e.text) && s.setTextContent(p, ""),
                      x(p, null, y, 0, y.length - 1, n))
                    : o(v)
                    ? w(v, 0, v.length - 1)
                    : o(e.text) && s.setTextContent(p, "")
                  : e.text !== t.text && s.setTextContent(p, t.text),
                  o(f) && o((h = f.hook)) && o((h = h.postpatch)) && h(e, t);
              }
            }
          }
          function _(e, t, n) {
            if (l(n) && o(e.parent)) e.parent.data.pendingInsert = t;
            else for (var i = 0; i < t.length; ++i) t[i].data.hook.insert(t[i]);
          }
          var E = g("attrs,class,staticClass,staticStyle,key");
          function k(e, t, n, i) {
            var r,
              s = t.tag,
              a = t.data,
              c = t.children;
            if (
              ((i = i || (a && a.pre)),
              (t.elm = e),
              l(t.isComment) && o(t.asyncFactory))
            )
              return (t.isAsyncPlaceholder = !0), !0;
            if (
              o(a) &&
              (o((r = a.hook)) && o((r = r.init)) && r(t, !0),
              o((r = t.componentInstance)))
            )
              return p(t, n), !0;
            if (o(s)) {
              if (o(c))
                if (e.hasChildNodes())
                  if (o((r = a)) && o((r = r.domProps)) && o((r = r.innerHTML))) {
                    if (r !== e.innerHTML) return !1;
                  } else {
                    for (var d = !0, u = e.firstChild, h = 0; h < c.length; h++) {
                      if (!u || !k(u, c[h], n, i)) {
                        d = !1;
                        break;
                      }
                      u = u.nextSibling;
                    }
                    if (!d || u) return !1;
                  }
                else f(t, c, n);
              if (o(a)) {
                var m = !1;
                for (var y in a)
                  if (!E(y)) {
                    (m = !0), v(t, n);
                    break;
                  }
                !m && a.class && lt(a.class);
              }
            } else e.data !== t.text && (e.data = t.text);
            return !0;
          }
          return function (e, t, n, r) {
            if (!a(t)) {
              var c,
                d = !1,
                p = [];
              if (a(e)) (d = !0), u(t, p);
              else {
                var h = o(e.nodeType);
                if (!h && ui(e, t)) T(e, t, p, null, null, r);
                else {
                  if (h) {
                    if (
                      (1 === e.nodeType &&
                        e.hasAttribute(q) &&
                        (e.removeAttribute(q), (n = !0)),
                      l(n) && k(e, t, p))
                    )
                      return _(t, p, !0), e;
                    (c = e),
                      (e = new ge(s.tagName(c).toLowerCase(), {}, [], void 0, c));
                  }
                  var f = e.elm,
                    v = s.parentNode(f);
                  if (
                    (u(t, p, f._leaveCb ? null : v, s.nextSibling(f)),
                    o(t.parent))
                  )
                    for (var y = t.parent, g = m(t); y; ) {
                      for (var x = 0; x < i.destroy.length; ++x) i.destroy[x](y);
                      if (((y.elm = t.elm), g)) {
                        for (var S = 0; S < i.create.length; ++S)
                          i.create[S](ci, y);
                        var C = y.data.hook.insert;
                        if (C.merged)
                          for (var E = 1; E < C.fns.length; E++) C.fns[E]();
                      } else li(y);
                      y = y.parent;
                    }
                  o(v) ? w([e], 0, 0) : o(e.tag) && b(e);
                }
              }
              return _(t, p, d), t.elm;
            }
            o(e) && b(e);
          };
        })({
          nodeOps: ai,
          modules: [
            Ci,
            Ei,
            Ii,
            Di,
            Xi,
            U
              ? {
                  create: xr,
                  activate: xr,
                  remove: function (e, t) {
                    !0 !== e.data.show ? vr(e, t) : t();
                  },
                }
              : {},
          ].concat(xi),
        });
        ee &&
          document.addEventListener("selectionchange", function () {
            var e = document.activeElement;
            e && e.vmodel && $r(e, "input");
          });
        var wr = {
          inserted: function (e, t, n, i) {
            "select" === n.tag
              ? (i.elm && !i.elm._vOptions
                  ? ht(n, "postpatch", function () {
                      wr.componentUpdated(e, t, n);
                    })
                  : Sr(e, t, n.context),
                (e._vOptions = [].map.call(e.options, _r)))
              : ("textarea" === n.tag || si(e.type)) &&
                ((e._vModifiers = t.modifiers),
                t.modifiers.lazy ||
                  (e.addEventListener("compositionstart", Er),
                  e.addEventListener("compositionend", kr),
                  e.addEventListener("change", kr),
                  ee && (e.vmodel = !0)));
          },
          componentUpdated: function (e, t, n) {
            if ("select" === n.tag) {
              Sr(e, t, n.context);
              var i = e._vOptions,
                r = (e._vOptions = [].map.call(e.options, _r));
              if (
                r.some(function (e, t) {
                  return !D(e, i[t]);
                })
              )
                (e.multiple
                  ? t.value.some(function (e) {
                      return Tr(e, r);
                    })
                  : t.value !== t.oldValue && Tr(t.value, r)) && $r(e, "change");
            }
          },
        };
        function Sr(e, t, n) {
          Cr(e, t, n),
            (J || te) &&
              setTimeout(function () {
                Cr(e, t, n);
              }, 0);
        }
        function Cr(e, t, n) {
          var i = t.value,
            r = e.multiple;
          if (!r || Array.isArray(i)) {
            for (var s, a, o = 0, l = e.options.length; o < l; o++)
              if (((a = e.options[o]), r))
                (s = z(i, _r(a)) > -1), a.selected !== s && (a.selected = s);
              else if (D(_r(a), i))
                return void (e.selectedIndex !== o && (e.selectedIndex = o));
            r || (e.selectedIndex = -1);
          }
        }
        function Tr(e, t) {
          return t.every(function (t) {
            return !D(t, e);
          });
        }
        function _r(e) {
          return "_value" in e ? e._value : e.value;
        }
        function Er(e) {
          e.target.composing = !0;
        }
        function kr(e) {
          e.target.composing &&
            ((e.target.composing = !1), $r(e.target, "input"));
        }
        function $r(e, t) {
          var n = document.createEvent("HTMLEvents");
          n.initEvent(t, !0, !0), e.dispatchEvent(n);
        }
        function Mr(e) {
          return !e.componentInstance || (e.data && e.data.transition)
            ? e
            : Mr(e.componentInstance._vnode);
        }
        var jr = {
            bind: function (e, t, n) {
              var i = t.value,
                r = (n = Mr(n)).data && n.data.transition,
                s = (e.__vOriginalDisplay =
                  "none" === e.style.display ? "" : e.style.display);
              i && r
                ? ((n.data.show = !0),
                  mr(n, function () {
                    e.style.display = s;
                  }))
                : (e.style.display = i ? s : "none");
            },
            update: function (e, t, n) {
              var i = t.value;
              !i != !t.oldValue &&
                ((n = Mr(n)).data && n.data.transition
                  ? ((n.data.show = !0),
                    i
                      ? mr(n, function () {
                          e.style.display = e.__vOriginalDisplay;
                        })
                      : vr(n, function () {
                          e.style.display = "none";
                        }))
                  : (e.style.display = i ? e.__vOriginalDisplay : "none"));
            },
            unbind: function (e, t, n, i, r) {
              r || (e.style.display = e.__vOriginalDisplay);
            },
          },
          Ar = { model: wr, show: jr },
          Lr = {
            name: String,
            appear: Boolean,
            css: Boolean,
            mode: String,
            type: String,
            enterClass: String,
            leaveClass: String,
            enterToClass: String,
            leaveToClass: String,
            enterActiveClass: String,
            leaveActiveClass: String,
            appearClass: String,
            appearActiveClass: String,
            appearToClass: String,
            duration: [Number, String, Object],
          };
        function Ir(e) {
          var t = e && e.componentOptions;
          return t && t.Ctor.options.abstract ? Ir(Qt(t.children)) : e;
        }
        function Or(e) {
          var t = {},
            n = e.$options;
          for (var i in n.propsData) t[i] = e[i];
          var r = n._parentListeners;
          for (var s in r) t[_(s)] = r[s];
          return t;
        }
        function Pr(e, t) {
          if (/\d-keep-alive$/.test(t.tag))
            return e("keep-alive", { props: t.componentOptions.propsData });
        }
        var Dr = function (e) {
            return e.tag || wt(e);
          },
          zr = function (e) {
            return "show" === e.name;
          },
          Nr = {
            name: "transition",
            props: Lr,
            abstract: !0,
            render: function (e) {
              var t = this,
                n = this.$slots.default;
              if (n && (n = n.filter(Dr)).length) {
                0;
                var i = this.mode;
                0;
                var r = n[0];
                if (
                  (function (e) {
                    for (; (e = e.parent); ) if (e.data.transition) return !0;
                  })(this.$vnode)
                )
                  return r;
                var s = Ir(r);
                if (!s) return r;
                if (this._leaving) return Pr(e, r);
                var a = "__transition-" + this._uid + "-";
                s.key =
                  null == s.key
                    ? s.isComment
                      ? a + "comment"
                      : a + s.tag
                    : c(s.key)
                    ? 0 === String(s.key).indexOf(a)
                      ? s.key
                      : a + s.key
                    : s.key;
                var o = ((s.data || (s.data = {})).transition = Or(this)),
                  l = this._vnode,
                  d = Ir(l);
                if (
                  (s.data.directives &&
                    s.data.directives.some(zr) &&
                    (s.data.show = !0),
                  d &&
                    d.data &&
                    !(function (e, t) {
                      return t.key === e.key && t.tag === e.tag;
                    })(s, d) &&
                    !wt(d) &&
                    (!d.componentInstance ||
                      !d.componentInstance._vnode.isComment))
                ) {
                  var u = (d.data.transition = A({}, o));
                  if ("out-in" === i)
                    return (
                      (this._leaving = !0),
                      ht(u, "afterLeave", function () {
                        (t._leaving = !1), t.$forceUpdate();
                      }),
                      Pr(e, r)
                    );
                  if ("in-out" === i) {
                    if (wt(s)) return l;
                    var p,
                      h = function () {
                        p();
                      };
                    ht(o, "afterEnter", h),
                      ht(o, "enterCancelled", h),
                      ht(u, "delayLeave", function (e) {
                        p = e;
                      });
                  }
                }
                return r;
              }
            },
          },
          qr = A({ tag: String, moveClass: String }, Lr);
        delete qr.mode;
        var Hr = {
          props: qr,
          beforeMount: function () {
            var e = this,
              t = this._update;
            this._update = function (n, i) {
              var r = sn(e);
              e.__patch__(e._vnode, e.kept, !1, !0),
                (e._vnode = e.kept),
                r(),
                t.call(e, n, i);
            };
          },
          render: function (e) {
            for (
              var t = this.tag || this.$vnode.data.tag || "span",
                n = Object.create(null),
                i = (this.prevChildren = this.children),
                r = this.$slots.default || [],
                s = (this.children = []),
                a = Or(this),
                o = 0;
              o < r.length;
              o++
            ) {
              var l = r[o];
              if (l.tag)
                if (null != l.key && 0 !== String(l.key).indexOf("__vlist"))
                  s.push(l),
                    (n[l.key] = l),
                    ((l.data || (l.data = {})).transition = a);
                else;
            }
            if (i) {
              for (var c = [], d = [], u = 0; u < i.length; u++) {
                var p = i[u];
                (p.data.transition = a),
                  (p.data.pos = p.elm.getBoundingClientRect()),
                  n[p.key] ? c.push(p) : d.push(p);
              }
              (this.kept = e(t, null, c)), (this.removed = d);
            }
            return e(t, null, s);
          },
          updated: function () {
            var e = this.prevChildren,
              t = this.moveClass || (this.name || "v") + "-move";
            e.length &&
              this.hasMove(e[0].elm, t) &&
              (e.forEach(Fr),
              e.forEach(Br),
              e.forEach(Wr),
              (this._reflow = document.body.offsetHeight),
              e.forEach(function (e) {
                if (e.data.moved) {
                  var n = e.elm,
                    i = n.style;
                  lr(n, t),
                    (i.transform = i.WebkitTransform = i.transitionDuration = ""),
                    n.addEventListener(
                      ir,
                      (n._moveCb = function e(i) {
                        (i && i.target !== n) ||
                          (i && !/transform$/.test(i.propertyName)) ||
                          (n.removeEventListener(ir, e),
                          (n._moveCb = null),
                          cr(n, t));
                      })
                    );
                }
              }));
          },
          methods: {
            hasMove: function (e, t) {
              if (!Ji) return !1;
              if (this._hasMove) return this._hasMove;
              var n = e.cloneNode();
              e._transitionClasses &&
                e._transitionClasses.forEach(function (e) {
                  Ki(n, e);
                }),
                Ui(n, t),
                (n.style.display = "none"),
                this.$el.appendChild(n);
              var i = pr(n);
              return this.$el.removeChild(n), (this._hasMove = i.hasTransform);
            },
          },
        };
        function Fr(e) {
          e.elm._moveCb && e.elm._moveCb(), e.elm._enterCb && e.elm._enterCb();
        }
        function Br(e) {
          e.data.newPos = e.elm.getBoundingClientRect();
        }
        function Wr(e) {
          var t = e.data.pos,
            n = e.data.newPos,
            i = t.left - n.left,
            r = t.top - n.top;
          if (i || r) {
            e.data.moved = !0;
            var s = e.elm.style;
            (s.transform = s.WebkitTransform =
              "translate(" + i + "px," + r + "px)"),
              (s.transitionDuration = "0s");
          }
        }
        var Rr = { Transition: Nr, TransitionGroup: Hr };
        (Ln.config.mustUseProp = function (e, t, n) {
          return (
            ("value" === n && Bn(e) && "button" !== t) ||
            ("selected" === n && "option" === e) ||
            ("checked" === n && "input" === e) ||
            ("muted" === n && "video" === e)
          );
        }),
          (Ln.config.isReservedTag = ii),
          (Ln.config.isReservedAttr = Fn),
          (Ln.config.getTagNamespace = function (e) {
            return ni(e) ? "svg" : "math" === e ? "math" : void 0;
          }),
          (Ln.config.isUnknownElement = function (e) {
            if (!U) return !0;
            if (ii(e)) return !1;
            if (((e = e.toLowerCase()), null != ri[e])) return ri[e];
            var t = document.createElement(e);
            return e.indexOf("-") > -1
              ? (ri[e] =
                  t.constructor === window.HTMLUnknownElement ||
                  t.constructor === window.HTMLElement)
              : (ri[e] = /HTMLUnknownElement/.test(t.toString()));
          }),
          A(Ln.options.directives, Ar),
          A(Ln.options.components, Rr),
          (Ln.prototype.__patch__ = U ? br : I),
          (Ln.prototype.$mount = function (e, t) {
            return (function (e, t, n) {
              var i;
              return (
                (e.$el = t),
                e.$options.render || (e.$options.render = be),
                cn(e, "beforeMount"),
                (i = function () {
                  e._update(e._render(), n);
                }),
                new wn(
                  e,
                  i,
                  I,
                  {
                    before: function () {
                      e._isMounted && !e._isDestroyed && cn(e, "beforeUpdate");
                    },
                  },
                  !0
                ),
                (n = !1),
                null == e.$vnode && ((e._isMounted = !0), cn(e, "mounted")),
                e
              );
            })(
              this,
              (e =
                e && U
                  ? (function (e) {
                      if ("string" == typeof e) {
                        return (
                          document.querySelector(e) ||
                          document.createElement("div")
                        );
                      }
                      return e;
                    })(e)
                  : void 0),
              t
            );
          }),
          U &&
            setTimeout(function () {
              B.devtools && le && le.emit("init", Ln);
            }, 0);
        const Vr = Ln;
        var Gr = n(508),
          Xr = n.n(Gr);
        const Yr = {
          xs: { min: 0, max: 575, name: "xs", order: 1 },
          sm: { min: 576, max: 767, name: "sm", order: 2 },
          md: { min: 768, max: 991, name: "md", order: 3 },
          lg: { min: 992, max: 1199, name: "lg", order: 4 },
          xl: { min: 1200, max: Number.POSITIVE_INFINITY, name: "xl", order: 5 },
        };
        class Ur {
          constructor() {
            (this.$ = void 0),
              (this.translations = void 0),
              (this.moneyFormat = void 0),
              (this.breakpoint = void 0),
              (this.formatMoney = (e, t) => {
                var n = this.moneyFormat;
                "string" == typeof e && (e = e.replace(".", ""));
                var i = "",
                  r = /\{\{\s*(\w+)\s*\}\}/,
                  s = t || n;
                function a(e, t, n, i) {
                  if (
                    (null == t && (t = 2),
                    (n = n || ","),
                    (i = i || "."),
                    isNaN(e) || null == e)
                  )
                    return 0;
                  var r = (e = (e / 100).toFixed(t)).split(".");
                  return (
                    r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
                    (r[1] ? i + r[1] : "")
                  );
                }
                switch (s.match(r)[1]) {
                  case "amount":
                    i = a(e, 2);
                    break;
                  case "amount_no_decimals":
                    i = a(e, 0);
                    break;
                  case "amount_with_comma_separator":
                    i = a(e, 2, ".", ",");
                    break;
                  case "amount_no_decimals_with_comma_separator":
                    i = a(e, 0, ".", ",");
                    break;
                  case "amount_no_decimals_with_space_separator":
                    i = a(e, 0, " ");
                }
                return (
                  `<span class="money"><span class="sr-only">${this.translations.cart_title} ${this.translations.cart_subtotal}</span>` +
                  s.replace(r, i) +
                  "</span>"
                );
              }),
              (this.getWindowWidth = () =>
                Math.max(
                  document.documentElement.clientWidth,
                  window.innerWidth || 0
                )),
              (this.getBreakpoint = (e) => {
                const t = null == e ? this.getWindowWidth() : e;
                let n;
                return (
                  Object.values(Yr).forEach((e) => {
                    t >= e.min && t <= e.max && (n = e);
                  }),
                  n
                );
              }),
              (this.loadIcons = (e = null) => {}),
              (this.loadDrawers = () => {}),
              (this.updateCartDrawer = (e) => {}),
              (this.loadYoutubeApi = () => {}),
              (this.loadVimeoApi = () => {}),
              (this.createScript = (e, t) => {}),
              (this.registerComponent = (e) => {});
          }
        }
        class Kr {
          constructor(e, t) {
            (this.onWindowResizeRaw = ({ width: e }) => {}),
              (this.onWindowResize = ({
                width: e,
                oldWidth: t,
                breakpoint: n,
              }) => {}),
              (this.onWindowResizeBreakpoint = ({
                width: e,
                breakpoint: t,
                oldBreakpoint: n,
              }) => {}),
              (this.theme = e),
              (this.element = t),
              e.registerComponent(this);
          }
        }
        class Zr extends Kr {
          constructor(e, t, n) {
            super(e, t),
              (this.onSectionSelect = ({
                element: e,
                sectionId: t,
                load: n,
              }) => {}),
              (this.onSectionDeselect = ({ element: e, sectionId: t }) => {}),
              (this.onSectionReorder = ({ element: e, sectionId: t }) => {}),
              (this.onBlockSelect = ({
                element: e,
                sectionId: t,
                blockId: n,
                load: i,
              }) => {}),
              (this.onBlockDeselect = ({
                element: e,
                sectionId: t,
                blockId: n,
              }) => {}),
              (this.destroy = ({ element: e }) => {}),
              (this.theme = e),
              (this.element = t);
          }
        }
        class Qr extends Kr {
          constructor(e, n) {
            super(e, n),
              (this.STORAGE_KEY = "wetheme-popup"),
              (this.load = () => {
                this.testMode
                  ? this.show()
                  : this.isExpiredOrNotSet() &&
                    setTimeout(() => {
                      this.setExpiry(this.popupSkipDays), this.show();
                    }, 1e3 * this.popupDelay),
                  t()(".popup--close-btn").on("click", this.hide);
              }),
              (this.isExpiredOrNotSet = () => {
                let e = !0;
                if (!this.isLocalStorageSupported(() => localStorage)) return e;
                const t = window.localStorage.getItem(this.STORAGE_KEY);
                if (t)
                  try {
                    Date.parse(JSON.parse(t).expiry) > Date.now() && (e = !1);
                  } catch (e) {
                    console.warn("Unable to read popup expiry date", e);
                  }
                return e;
              }),
              (this.setExpiry = (e) => {
                const t = new Date(Date.now() + 24 * e * 60 * 60 * 1e3);
                try {
                  localStorage.setItem(
                    this.STORAGE_KEY,
                    JSON.stringify({ expiry: t.toISOString() })
                  );
                } catch (e) {
                  console.warn("Unable to set popup expiry:", e);
                }
              }),
              (this.isLocalStorageSupported = (e) => {
                try {
                  const t = "__random_key_name___e__";
                  return e().setItem(t, t), e().removeItem(t), !0;
                } catch (e) {
                  return !1;
                }
              }),
              (this.show = () => {
                this.element.classList.add("visible"),
                  (this.lastFocus = document.activeElement),
                  setTimeout(this.trapFocus, 1e3);
              }),
              (this.hide = () => {
                this.element.classList.remove("visible");
              }),
              (this.trapFocus = () => {
                var e = this.element.querySelectorAll(
                    "input:not([type=hidden]), button, a"
                  ),
                  t = e[0],
                  n = e[e.length - 1],
                  i = this;
                this.element.querySelector(".popup__newsletter-form")
                  ? this.element.querySelector("#newsletter_text").focus()
                  : this.element.querySelector(".popup--close-btn").focus(),
                  n.addEventListener("keydown", function (e) {
                    9 !== e.keyCode ||
                      e.shiftKey ||
                      (e.preventDefault(), t.focus());
                  }),
                  t.addEventListener("keydown", function (e) {
                    13 == e.keyCode &&
                      (e.preventDefault(), i.hide(), i.focusable[0].focus()),
                      9 === e.keyCode &&
                        e.shiftKey &&
                        (e.preventDefault(), n.focus());
                  });
              }),
              (this.popupWrapper =
                this.element.querySelector(".popup-container")),
              (this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10)),
              (this.popupDelay = parseInt(this.element.dataset.popupDelay, 10)),
              (this.testMode = "true" === this.element.dataset.popupTestMode),
              (this.lastFocus = document.activeElement),
              (this.focusable = document.body.querySelectorAll("ul.nav li a")),
              this.load();
          }
        }
        class Jr {
          constructor(e, n) {
            (this.checkTerms = (e) => {
              const n = t()(e.currentTarget).closest("form");
              if (this.agree && !this.agree.checked)
                return (
                  alert(this.agree.dataset.termsAgree),
                  n.find(".cart-button-checkout-text").removeClass("hide"),
                  n.find(".cart-button-checkout-spinner").addClass("hide"),
                  e.preventDefault(),
                  !1
                );
            }),
              (this.theme = e),
              (this.element = n),
              (this.agree = this.element.querySelector("#agree"));
          }
        }
        class es extends Kr {
          constructor(e, n) {
            var i;
            super(e, n),
              (i = this),
              (this.FADE_OUT_ANIMATION_DURATION = 800),
              (this.updateCartDrawer = async function (e) {
                t()(".cart-error-box").text(""),
                  0 === e.items.length
                    ? (t()(".cart-empty-box").removeClass("hide"),
                      t()(".ajax-cart--bottom-wrapper").addClass("hide"))
                    : (t()(".cart-empty-box").addClass("hide"),
                      t()(".ajax-cart--bottom-wrapper").removeClass("hide"));
                var n = t()("#cart-item-template").html(),
                  r = t()(".cart-items");
                r.empty();
                var s = i,
                  a = t()(".js-cart-drawer-status"),
                  o = t()(".cart-drawer--title").text();
                let l;
                try {
                  const e = t()(".cart-drawer-form").data("language-url"),
                    n = e && "/" != e ? e : "",
                    i = await fetch(`${n}/cart?view=compare`);
                  l = await i.json();
                } catch (e) {
                  console.error("Cart fetch failed", e);
                }
                e.items.forEach((e, a) => {
                  var o = t()(n);
                  e.image
                    ? o
                        .find(".cart-item-image")
                        .attr({ src: e.image, alt: e.title })
                    : o.find(".cart-item-image").css("display", "none"),
                    o.find(".cart-item-link").attr({ href: e.url }),
                    o.find(".cart-item-product-title").text(e.product_title),
                    e.variant_title &&
                      o
                        .find(".cart-item-variant-title")
                        .removeClass("hide")
                        .text(e.variant_title),
                    o
                      .find(".cart-item-price")
                      .html(i.theme.formatMoney(e.final_line_price)),
                    e.unit_price_measurement
                      ? o
                          .find(".cart-item-price-per-unit")
                          .html(
                            '<span class="price">(' +
                              i.theme.formatMoney(e.unit_price) +
                              " / " +
                              (1 != e.unit_price_measurement.reference_value
                                ? e.unit_price_measurement.reference_value
                                : "") +
                              " " +
                              e.unit_price_measurement.reference_unit +
                              ")"
                          )
                      : o.find(".cart-item-price-per-unit").text(""),
                    (e.selling_plan_allocation
                      ? e.selling_plan_allocation.selling_plan.name
                      : null) &&
                      o
                        .find(".cart-item-selling-plan")
                        .removeClass("hide")
                        .html(e.selling_plan_allocation.selling_plan.name);
                  var c = o.find(".cart-item-price-original");
                  e.original_line_price > e.final_line_price
                    ? c.html(i.theme.formatMoney(e.original_line_price)).show()
                    : c.hide();
                  var d = o.find(".cart-item-quantity"),
                    u = d.closest(".cart-item--quantity-wrapper"),
                    p = u.parent(),
                    h = parseInt(l.items[a].stock_count),
                    f = l.items[a].stock_policy,
                    m = l.items[a].inventory_management;
                  u.attr("data-stock-count", h),
                    u.attr("data-inventory-policy", f),
                    u.attr("data-inventory-management", m);
                  var v = (e, t = 0) => {
                    u.addClass("cart-item-quantity-active");
                    var n = e <= 0,
                      r = n ? i.FADE_OUT_ANIMATION_DURATION : 0;
                    t > 0 && (r = t),
                      i.cartSetQuantity(r).always(() => {
                        u.removeClass("cart-item-quantity-active"),
                          n &&
                            (o.addClass("fadeOut animated fast"),
                            setTimeout(function () {
                              o.remove();
                            }, i.FADE_OUT_ANIMATION_DURATION));
                      });
                  };
                  d.on("change", function () {
                    let n = parseInt(t()(this).val().toString(), 10),
                      i = parseInt(t()(this).parent().data("stock-count"), 10),
                      r = t()(this).parent().data("inventory-policy"),
                      s = t()(this).parent().data("inventory-management");
                    n <= i || "continue" == r || "shopify" != s
                      ? (d.val(e.quantity),
                        v(n),
                        p.next(".errors").addClass("hide"))
                      : (d.val(i),
                        v(i, 3e3),
                        p
                          .next(".errors")
                          .removeClass("hide")
                          .text("You can't add more of this item to the cart"));
                  }),
                    d.val(e.quantity),
                    d.attr("name", "updates[]"),
                    o.find(".cart-item-quantity-button").on("click", function () {
                      let e = parseInt(d.val().toString(), 10),
                        n = parseInt(this.dataset.amount, 10),
                        i = e + n,
                        r = parseInt(t()(this).parent().data("stock-count"), 10),
                        a = t()(this).parent().data("inventory-policy"),
                        o = t()(this).parent().data("inventory-management");
                      (s.status_string =
                        n > 0
                          ? s.theme.translations.added_to_cart
                          : s.theme.translations.removed_from_cart),
                        i <= r || "continue" == a || "shopify" != o
                          ? (d.val(i), v(i), p.next(".errors").addClass("hide"))
                          : (d.val(r),
                            v(r, 3e3),
                            p
                              .next(".errors")
                              .removeClass("hide")
                              .text(
                                "You can't add more of this item to the cart"
                              ));
                    }),
                    o.find("#cart-item-remove-button").on("click", function () {
                      s.status_string = s.theme.translations.removed_from_cart;
                      d.val(0), v(0);
                    });
                  var y = o.find(".order-discount--cart-list").empty();
                  e.line_level_discount_allocations.forEach(function (e) {
                    var n = t()('<li class="order-discount--item"></li>');
                    t()('<span class="order-discount--item-title"></span>')
                      .text(e.discount_application.title)
                      .appendTo(n),
                      t()('<span class="order-discount--cart-amount"></span>')
                        .html(
                          '<span class="sr-only">' +
                            s.theme.translations.saving +
                            "</span> (-" +
                            s.theme.formatMoney(e.amount) +
                            ")"
                        )
                        .appendTo(n),
                      y.append(n);
                  }),
                    o.appendTo(r);
                }),
                  s.status_string &&
                    a
                      .html(
                        `<span>${s.theme.translations.cart_item} ${
                          s.status_string
                        } ${o}, ${i.theme.formatMoney(e.total_price)}</span>`
                      )
                      .appendTo(".cart-drawer__top"),
                  t()(".cart-item-count, .cart-item-count-header--quantity").text(
                    e.item_count
                  ),
                  t()(".cart-total-price, .cart-item-count-header--total").html(
                    i.theme.formatMoney(e.total_price)
                  );
                var c = t()(".cart-item-original-total-price");
                e.original_total_price > e.total_price
                  ? c.html(i.theme.formatMoney(e.original_total_price)).show()
                  : c.hide();
                var d = t()(".ajax-cart-discount-wrapper").empty();
                e.cart_level_discount_applications.forEach(function (e) {
                  var n = t()(
                    '<div class="cart--order-discount-wrapper--indiv"></div>'
                  );
                  t()('<span class="order-discount"></span>')
                    .html("-" + s.theme.formatMoney(e.total_allocated_amount))
                    .appendTo(n),
                    t()('<span class="order-discount--cart-title"></span>')
                      .text("(" + e.title + ")")
                      .appendTo(n),
                    d.append(n);
                });
              }),
              (this.cartSetQuantity = (e) => {
                var n = t().Deferred();
                return (
                  t()(".cart-error-box").text(""),
                  t()
                    .ajax({
                      type: "POST",
                      url: "/cart/update.js",
                      dataType: "json",
                      data: t()(".cart-drawer-form").serialize(),
                    })
                    .then((t) => {
                      n.resolve(),
                        setTimeout(() => {
                          this.updateCartDrawer(t);
                        }, e);
                    })
                    .fail((e, i, r) => {
                      n.reject(),
                        console.error("Cart error", i, e, r),
                        t()(".cart-error-box")
                          .empty()
                          .text("Unable to update item quantity");
                    }),
                  n
                );
              }),
              (this.status_string = "");
            const r = document.querySelector("#initial-cart");
            if (!r) return;
            const s = JSON.parse(r.textContent);
            this.updateCartDrawer(s),
              (this.cartTerms = new Jr(this.theme, this.element)),
              t()(".cart-button-checkout").on("click", (e) => {
                const n = t()(e.currentTarget);
                n.find(".cart-button-checkout-text").addClass("hide"),
                  n.find(".cart-button-checkout-spinner").removeClass("hide"),
                  this.cartTerms.checkTerms(e);
              });
          }
        }
        var ts = n(933),
          ns = n.n(ts),
          is = n(755);
        function rs(e, t) {
          var n = `#${e}`,
            i = document
              .getElementById(e)
              .querySelectorAll(
                `${n} input:not([type=hidden]), ${n} button:not([tabindex="-1"]), ${n} a:not([tabindex="-1"]), ${n} textarea`
              ),
            r = i[0],
            s = i[i.length - 1];
          t && is(r).focus(),
            s.addEventListener("keydown", function (e) {
              9 !== e.keyCode || e.shiftKey || (e.preventDefault(), r.focus());
            }),
            r.addEventListener("keydown", function (e) {
              9 === e.keyCode && e.shiftKey && (e.preventDefault(), s.focus());
            });
        }
        class ss extends Kr {
          constructor(e, n) {
            super(e, n),
              (this.MOBILE_DRAWER_SIZE = 300),
              (this.DESKTOP_DRAWER_SIZE = 390),
              (this.MOBILE_BREAKPOINT = Yr.sm),
              (this.DESKTOP_BREAKPOINT = Yr.sm),
              (this.load = () => {
                this.slideouts &&
                  this.slideouts.left &&
                  this.slideouts.left.close(),
                  this.slideouts &&
                    this.slideouts.right &&
                    this.slideouts.right.close();
                var e = t()("body > #theme-menu"),
                  n = t()("#main-body #theme-menu");
                n.length > 0 && (e.remove(), t()("body").append(n));
                var i,
                  r = document.querySelector("#main-body"),
                  s = document.querySelector("#theme-menu"),
                  a = document.querySelector("#cartSlideoutWrapper"),
                  o = document.querySelector("#slideout-overlay"),
                  l = this,
                  c = this.createDrawer("left", r, s, a, o);
                if (
                  (t()(".slide-menu-mobile")
                    .off("click")
                    .on("click", function () {
                      (i = l.slideouts.left.menu.id), c.toggle(), rs(i, true);
                    }),
                  t()(".mobile-menu-close")
                    .off("click")
                    .on("click", function () {
                      c.close();
                    }),
                  this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order &&
                    c.disableTouch(),
                  t()(s)
                    .on("mobile:toggle", c.toggle.bind(c))
                    .on("mobile:open", c.open.bind(c))
                    .on("mobile:close", c.close.bind(c)),
                  a)
                ) {
                  var d = this.createDrawer("right", r, a, s, o);
                  t()(".slide-menu-cart")
                    .off("click")
                    .on("click", function (e) {
                      return (
                        (i = l.slideouts.right.menu.id),
                        d.toggle(),
                        rs(i, true),
                        e.preventDefault(),
                        !1
                      );
                    }),
                    t()(".cart-menu-close").on("click", function (e) {
                      d.close();
                    }),
                    t()(a)
                      .on("cart:toggle", d.toggle.bind(d))
                      .on("cart:open", d.open.bind(d))
                      .on("cart:close", d.close.bind(d));
                }
              }),
              (this.onWindowResizeBreakpoint = ({
                breakpoint: e,
                oldBreakpoint: t,
              }) => {
                const n = this.isMobile;
                if (
                  ((this.isMobile = e.order <= this.MOBILE_BREAKPOINT.order),
                  (this.isDesktop = window.innerWidth > Yr.md.max),
                  this.isDesktop && this.slideouts.left.close(),
                  this.isMobile === n)
                )
                  return;
                if (
                  (this.isMobile
                    ? this.slideouts.left.disableTouch()
                    : this.slideouts.left.enableTouch(),
                  !this.slideouts.right)
                )
                  return;
                const i = this.slideouts.right,
                  r = this.isMobile
                    ? this.MOBILE_DRAWER_SIZE
                    : this.DESKTOP_DRAWER_SIZE;
                if (
                  ((i._translateTo = i._padding = r * i._orientation), i._opened)
                ) {
                  var s = "translateX(" + r * i._orientation + "px)";
                  (i.panel.style.webkitTransform = s),
                    (i.panel.style.transform = s);
                }
              }),
              (this.createDrawer = (e, n, i, r, s) => {
                var a = this.MOBILE_DRAWER_SIZE;
                "right" !== e || this.isMobile || (a = this.DESKTOP_DRAWER_SIZE);
                var o = new (ns())({
                    panel: n,
                    menu: i,
                    padding: a,
                    tolerance: 70,
                    side: e,
                    touch: !1,
                  }),
                  l = "right" === e ? -1 : 1;
                (this.slideouts[e] = o), i.classList.add("slideout-panel-hidden");
                var c = t()(s);
                s.addEventListener("click", o.close.bind(o));
                var d = null;
                s.addEventListener(
                  "touchstart",
                  function (e) {
                    o.isOpen() && (e.preventDefault(), (d = e.touches[0].pageX));
                  },
                  { passive: !0 }
                ),
                  s.addEventListener(
                    "touchmove",
                    function (e) {
                      if (o.isOpen()) {
                        var t = d - e.touches[0].pageX,
                          i = l * a - t;
                        Math.abs(i) > a && (i = l * a),
                          (n.style.webkitTransform = "translateX(" + i + "px)"),
                          (n.style.transform = "translateX(" + i + "px)");
                      }
                    },
                    { passive: !0 }
                  ),
                  s.addEventListener("touchend", function (e) {
                    if (o.isOpen()) {
                      var t = d - e.changedTouches[0].pageX;
                      0 === t || Math.abs(t) > 70
                        ? o.close()
                        : ((n.style.webkitTransform =
                            "translateX(" + l * a + "px)"),
                          (n.style.transform = "translateX(" + l * a + "px)"));
                    }
                  }),
                  o.on("beforeopen", function () {
                    i.classList.remove("slideout-panel-hidden"),
                      r && r.classList.add("slideout-panel-hidden"),
                      c.fadeIn();
                    var e = t()(".cart-menu-close"),
                      s = t()(".menu-close-icon");
                    e.length > 0 && e.focus(), s.length > 0 && s.focus();
                    var a = t()(window).scrollTop() + "px";
                    (n.style.position = "fixed"),
                      (n.style.marginTop = "-" + a),
                      t()(".sticky-header-wrapper.sticky").css({
                        "margin-top": a,
                        transform: "translateY(0)",
                      });
                  }),
                  o.on("beforeclose", function () {
                    c.fadeOut(), t()(".js-cart-drawer-status").text("");
                    var e = -parseInt(n.style.marginTop);
                    (n.style.position = ""),
                      (n.style.marginTop = ""),
                      t()(window).scrollTop(e);
                  });
                t()("#purchase");
                return (
                  o.on("close", function () {
                    t()(".sticky-header-wrapper").css({
                      "margin-top": 0,
                      transform: "",
                    }),
                      i.classList.add("slideout-panel-hidden");
                  }),
                  o.on("translate", function (t) {
                    var n = !1;
                    0 === t
                      ? (n = !0)
                      : "left" === e
                      ? (n = t <= 0)
                      : "right" === e && (n = t >= 0),
                      i.classList.toggle("slideout-panel-hidden", n),
                      r && r.classList.toggle("slideout-panel-hidden", !n);
                  }),
                  o
                );
              }),
              (this.slideouts = {}),
              (this.isMobile =
                this.theme.breakpoint.order <= this.MOBILE_BREAKPOINT.order),
              (this.isDesktop = window.innerWidth >= Yr.lg.min),
              (this.lastFocus = document.activeElement),
              this.load();
          }
        }
        class as extends Kr {
          constructor(e, n) {
            super(e, n),
              (this.STORAGE_KEY = "wetheme-age-check"),
              (this.load = () => {
                function e() {
                  setTimeout(function () {
                    if (document.querySelector(".verification-popup-container")) {
                      var e = t()(".verification-popup-container")
                          .find("button, a")
                          .filter(":visible"),
                        n = e.first(),
                        i = e.last();
                      t()(".verification-popup-container").focus(),
                        i.on("keydown", function (e) {
                          9 !== e.which ||
                            e.shiftKey ||
                            (e.preventDefault(), n.focus());
                        }),
                        n.on("keydown", function (e) {
                          9 === e.which &&
                            e.shiftKey &&
                            (e.preventDefault(), i.focus());
                        });
                    }
                  }, 1e3);
                }
                this.ageTestMode &&
                  (t()(".verification-popup-container").css("display", "block"),
                  e());
                const n = document.getElementById("button__enter"),
                  i = document.getElementById("button__exit"),
                  r = document.getElementById("button__return"),
                  s = document.querySelector(".verification-popup__close-button"),
                  a = document.querySelector(".modal-content__wrapper a");
                a && a.setAttribute("tabindex", "1"),
                  (function (e) {
                    for (
                      var t = e + "=", n = document.cookie.split(";"), i = 0;
                      i < n.length;
                      i++
                    ) {
                      for (var r = n[i]; " " == r.charAt(0); )
                        r = r.substring(1, r.length);
                      if (0 == r.indexOf(t))
                        return r.substring(t.length, r.length);
                    }
                    return null;
                  })("isAnAdult") ||
                    (t()(".verification-popup-container").css("display", "block"),
                    e()),
                  n &&
                    n.addEventListener("click", function () {
                      document.write(
                        "<style> #prompt__background { display: none; }</style>"
                      ),
                        (document.cookie = "isAnAdult=true; expires=0; path=/"),
                        location.reload();
                    }),
                  i &&
                    i.addEventListener("click", function () {
                      t()("#verification__prompt").scrollTop(0),
                        t()(".verification-popup__close-button").css(
                          "display",
                          "block"
                        );
                      const n = document.querySelector(".modal-deny-content"),
                        i = document.querySelector(".modal-initial-content");
                      n.classList.remove("hidden"),
                        i.classList.add("hidden"),
                        e();
                    }),
                  r &&
                    r.addEventListener("click", function () {
                      t()("#verification__prompt").scrollTop(0),
                        t()(".verification-popup__close-button").css(
                          "display",
                          "none"
                        );
                      const n = document.querySelector(".modal-deny-content"),
                        i = document.querySelector(".modal-initial-content");
                      n.classList.add("hidden"),
                        i.classList.remove("hidden"),
                        e();
                    }),
                  s &&
                    s.addEventListener("click", function () {
                      t()("#verification__prompt").scrollTop(0),
                        t()(".verification-popup__close-button").css(
                          "display",
                          "none"
                        );
                      const n = document.querySelector(".modal-deny-content"),
                        i = document.querySelector(".modal-initial-content");
                      n.classList.add("hidden"),
                        i.classList.remove("hidden"),
                        e();
                    });
              }),
              (this.ageSkipDays = parseInt(this.element.dataset.ageTime, 10)),
              (this.ageDelay = 0),
              (this.ageTestMode = "true" === this.element.dataset.ageTestMode),
              this.load();
          }
        }
        class os {
          constructor(e) {
            (this.loadPasswordRecover = () => {
              var e = t()(".recover-form");
              0 !== e.length &&
                (e.removeClass("no-js"),
                "#recover" !== window.location.hash && e.addClass("hide"),
                t()(".show-password-form").on("click", function (t) {
                  e.toggleClass("hide");
                }),
                t()(".show-password-form").keypress(function (t) {
                  if (13 == t.which) return e.toggleClass("hide"), !1;
                }));
            }),
              (this.theme = e),
              this.loadPasswordRecover(),
              t()("#forgot-password-box").on("click", function () {
                t()("#customer-login").hide(), t()("#recover-password").show();
              }),
              t()("#login-box-link").on("click", function () {
                t()("#customer-login").show(), t()("#recover-password").hide();
              }),
              document.querySelector(".resetSuccessful") &&
                t()("#resetSuccess").show();
          }
        }
        class ls {
          constructor(e, t) {
            (this.loadSearchPage = () => {
              const e = this.searchInput.value.replace(/\*$/, "");
              this.searchInput.value = e;
            }),
              (this.theme = e),
              (this.element = t),
              (this.searchForm = this.element.querySelector("#search-page-form")),
              (this.searchInput = this.element.querySelector("#search_text")),
              this.loadSearchPage();
          }
        }
        class cs {
          constructor(e, t) {
            (this.element = t),
              (this.addressTables =
                this.element.querySelectorAll(".address_table")),
              Array.prototype.forEach.call(this.addressTables, (e) => {
                e.addEventListener("click", (t) => {
                  t.target.classList.contains("action_edit") &&
                    t.target.setAttribute("aria-expanded", "true"),
                    t.target.classList.contains("action_cancel") &&
                      e
                        .querySelector(".action_edit")
                        .setAttribute("aria-expanded", "false");
                });
              });
          }
        }
        class ds extends Zr {
          constructor(e, n, i) {
            super(e, n, i),
              (this.MOBILE_BREAKPOINT = Yr.sm),
              (this.onBlockSelect = ({ element: e }) => {
                if (this.mobileSliderFlexslider) {
                  var t = Array.prototype.indexOf.call(
                    e.parentElement.children,
                    event.target
                  );
                  this.mobileSliderFlexslider.flexAnimate(t, !0);
                }
              }),
              (this.onBlockDeselect = () => {
                this.mobileSliderFlexslider && this.mobileSliderFlexslider.play();
              }),
              (this.onWindowResizeBreakpoint = ({
                breakpoint: e,
                oldBreakpoint: t,
              }) => {
                const n = e.order <= this.MOBILE_BREAKPOINT.order;
                n !== t.order <= this.MOBILE_BREAKPOINT.order &&
                  n &&
                  !this.mobileSliderFlexslider &&
                  this.loadMobileSlider();
              }),
              (this.loadMobileSlider = () => {
                this.$mobileSlider
                  .find(".slides li")
                  .css("width", this.element.clientWidth),
                  (this.mobileSliderFlexslider = this.$mobileSlider
                    .flexslider({
                      controlNav: !1,
                      directionNav: !1,
                      animation: "slide",
                    })
                    .data("flexslider"));
              }),
              (this.$element = t()(n)),
              (this.$mobileSlider = this.$element.find(
                ".mobile-homepage-text-adverts"
              )),
              (this.mobileSliderFlexslider = null);
            this.theme.getBreakpoint().order <= this.MOBILE_BREAKPOINT.order &&
              this.loadMobileSlider(),
              this.theme.loadIcons();
          }
        }
        class us {
          constructor(e, n) {
            (this.menuHandle = (e, t) =>
              e.hasClass("sub-topbar")
                ? this.menuStructureTopbar[t]
                : this.menuStructure[t]),
              (this.removeAllMenuTabindex = () => {
                t()(".mobile-menu")
                  .find(".mobile-menu-link")
                  .attr("tabindex", "-1");
              }),
              (this.setTabindex = (e, t) => {
                e.attr("tabindex", t);
              }),
              (this.makeLinksTabbable = (e, t) => {
                this.removeAllMenuTabindex(),
                  this.menuHasBackButton(e) &&
                    this.setTabindex(e.children(".mobile-menu-back"), "0"),
                  this.menuIsUl(e) &&
                    this.setTabindex(
                      e.children("li").children(".mobile-menu-link"),
                      "0"
                    ),
                  this.menuHasUlChild(e) &&
                    this.setTabindex(
                      e
                        .children("ul")
                        .children("li")
                        .children(".mobile-menu-link"),
                      "0"
                    ),
                  this.menuHasFieldsetChild(e) &&
                    this.setTabindex(
                      e
                        .children(".mobile-menu__fieldset")
                        .children(".mobile-menu-link"),
                      "0"
                    ),
                  t(this.themeMenuID);
              }),
              (this.menuIsUl = (e) => e.is("ul")),
              (this.menuHasUlChild = (e) => e.children("ul").length),
              (this.menuHasBackButton = (e) => e.children(".mobile-menu-back")),
              (this.menuHasFieldsetChild = (e) =>
                e.children(".mobile-menu__fieldset").length),
              (this.menuClick = (e, n) => {
                (this.$lastClickedItem = e),
                  t()(".mobile-menu.active").scrollTop(0),
                  t()(".mobile-menu").removeClass("active");
                var i = n.closest(".mobile-menu"),
                  r = e.data("link");
                if (
                  (e.attr("aria-expanded", "true"),
                  this.clearSubmenus(n),
                  "mobile-menu-currency" === r || "mobile-menu-locale" === r)
                )
                  return (
                    (i = t()(`#${r}`))
                      .removeClass("mobile-menu-hidden")
                      .addClass("active"),
                    void this.makeLinksTabbable(i, rs)
                  );
                i.addClass("active");
                var s = this.menuHandle(e, r);
                const a = e.hasClass("sub-topbar");
                s.links.forEach((i) => {
                  var r = this.menuHandle(e, i),
                    s = t()("<li></li>");
                  if (r.links.length > 0) {
                    var o = t()(
                      `<button class="alt-focus mobile-menu-sub mobile-menu-link">${r.title}<i data-feather="chevron-right" aria-hidden="true"></i></button>`
                    )
                      .attr("aria-expanded", "false")
                      .data("link", i)
                      .on("click", (e) => {
                        this.menuClick(t()(e.currentTarget), this.$submenu);
                      });
                    a && o.addClass("sub-topbar"), s.append(o);
                  } else {
                    var l = t()('<a class="alt-focus mobile-menu-link"></a>')
                      .attr("href", r.url)
                      .html(r.title);
                    s.append(l);
                  }
                  n.append(s);
                }),
                  n.find(".top-link").text(s.title).attr("href", s.url);
                var o,
                  l = this;
                ((o = new (t().Deferred)()),
                setTimeout(function () {
                  i
                    .insertAfter(e)
                    .find(".mobile-menu-back")
                    .off("click")
                    .on("click", (n) => l.backClick(t()(n.currentTarget), e)),
                    o.resolve();
                }, 100),
                o.promise()).then(function () {
                  l.makeLinksTabbable(i, rs), i.removeClass("mobile-menu-hidden");
                }),
                  this.theme.loadIcons();
              }),
              (this.clearSubmenus = (e) => {
                e.find("> li:not(:first)").remove();
              }),
              (this.backClick = (e, n) => {
                t()(".mobile-menu").removeClass("active"),
                  e.closest(".mobile-menu").addClass("mobile-menu-hidden"),
                  n.closest(".mobile-menu").addClass("active"),
                  n.attr("aria-expanded", !1),
                  this.makeLinksTabbable(n.closest(".mobile-menu"), rs),
                  this.$lastClickedItem.focus();
              }),
              (this.theme = e),
              (this.element = n),
              (this.$element = t()(n)),
              (this.menuStructure = JSON.parse(
                document.querySelector("#mobile-menu-data").textContent
              )),
              (this.menuStructureTopbar = JSON.parse(
                document.querySelector("#mobile-menu-data-topbar").textContent
              )),
              (this.themeMenuID = "theme-menu"),
              (this.$topmenu = this.$element.find("#mobile-menu--main-menu")),
              (this.$menu = this.$element.find("#mobile-menu")),
              (this.$submenu = this.$element.find("#mobile-submenu")),
              this.$element
                .find(".mobile-menu-sub")
                .off("click")
                .on("click", (e) =>
                  this.menuClick(t()(e.currentTarget), this.$menu)
                ),
              this.$element
                .find(".mobile-menu-back ")
                .off("click")
                .on("click", (e) =>
                  this.backClick(
                    t()(e.currentTarget),
                    this.$topmenu.children("li").children(".mobile-menu-link")
                  )
                ),
              (this.$lastClickedItem = null);
          }
        }
        var ps = n(755);
        class hs {
          constructor(e, t) {
            var n = this;
            (this.loadSearch = () => {
              const e = this;
              for (const e of this.searchIcons)
                e.addEventListener("click", this.searchOpen);
              for (const t of this.searchClear)
                t.addEventListener("click", this.searchClose),
                  t.addEventListener("keyup", function (t) {
                    13 === t.keyCode && e.searchClose();
                  });
              this.searchForm.addEventListener("submit", this.searchSubmit),
                this.searchWrapper.addEventListener(
                  "click",
                  this.backgroundSearchClose
                ),
                this.searchInput.addEventListener("keyup", this.searchChanged),
                document.addEventListener("click", function (t) {
                  t.target &&
                    t.target.classList.contains("search-results__meta-clear") &&
                    ((e.searchResultsNum = 0),
                    (e.searchHasResults = !1),
                    (e.searchResultsPanel.innerHTML = ""),
                    (e.searchInput.value = ""),
                    e.searchInput.focus(),
                    e.searchWrapper.classList.remove("has-results"));
                });
            }),
              (this.searchSubmit = (e) => {
                e.preventDefault(),
                  (window.location.href = this.getSearchPageUrlWithQuery());
              }),
              (this.searchOpen = (e) => (
                e.preventDefault(),
                this.lockScrolling(),
                (this.searchToggler = ps(e.target).closest(".search-show")),
                this.searchToggler.attr("aria-expanded", "true"),
                this.searchWrapper.classList.add("expanded"),
                this.searchInput.setAttribute("tabindex", "0"),
                this.SearchSubmitBtn.setAttribute("tabindex", "0"),
                this.searchClearBtn.setAttribute("tabindex", "0"),
                this.searchInput.setAttribute("aria-hidden", "false"),
                this.SearchSubmitBtn.setAttribute("aria-hidden", "false"),
                this.searchClearBtn.setAttribute("aria-hidden", "false"),
                this.moveCursorToEnd(this.searchInput),
                (this.lastFocus = document.activeElement),
                setTimeout(this.trapFocus, 500),
                !1
              )),
              (this.searchClose = (e) => (
                this.unlockScrolling(),
                this.searchToggler.attr("aria-expanded", "false"),
                this.searchWrapper.classList.remove("expanded"),
                this.searchInput.setAttribute("tabindex", "-1"),
                this.SearchSubmitBtn.setAttribute("tabindex", "-1"),
                this.searchClearBtn.setAttribute("tabindex", "-1"),
                this.searchInput.setAttribute("aria-hidden", "false"),
                this.SearchSubmitBtn.setAttribute("aria-hidden", "false"),
                this.searchClearBtn.setAttribute("aria-hidden", "false"),
                this.searchInput.blur(),
                !1
              )),
              (this.handleLastInputKeydown = (e, t) => {
                9 !== e.keyCode || e.shiftKey || (e.preventDefault(), t.focus());
              }),
              (this.handleFirstInputKeydown = (e, t) => {
                13 == e.keyCode &&
                  (e.preventDefault(), self.hide(), this.lastFocus.focus()),
                  9 === e.keyCode &&
                    e.shiftKey &&
                    (e.preventDefault(), t.focus());
              }),
              (this.resetCloseBtnKeydown = (e, t) => {
                9 !== e.keyCode || e.shiftKey || t.focus();
              }),
              (this.trapFocus = () => {
                var e = this.element.querySelectorAll(
                    `${this.searchWrapperID} input:not([type=hidden]), ${this.searchWrapperID} button, ${this.searchWrapperID} a, ${this.searchWrapperID} .search-clear`
                  ),
                  t = Array.from(e),
                  n = t.indexOf(t.find((e) => "search-bar--clear" == e.id)),
                  i = e[0],
                  r = e[e.length - 1],
                  s = this;
                this.element.querySelector(this.searchWrapperID) &&
                  this.initialLoad &&
                  this.element.querySelector("#search_text").focus(),
                  "search-bar--clear" != r.id &&
                    this.searchClearBtn.addEventListener("keydown", function (t) {
                      s.resetCloseBtnKeydown(t, e[n + 1]);
                    }),
                  r.addEventListener("keydown", function (e) {
                    s.handleLastInputKeydown(e, i);
                  }),
                  i.addEventListener("keydown", function (e) {
                    s.handleFirstInputKeydown(e, r);
                  }),
                  (this.initialLoad = !1);
              }),
              (this.backgroundSearchClose = (e) => {
                e.target === e.currentTarget && this.searchClose();
              }),
              (this.moveCursorToEnd = (e) => {
                if ((e.focus(), "number" == typeof e.selectionStart))
                  e.selectionStart = e.selectionEnd = e.value.length;
                else if (void 0 !== e.createTextRange) {
                  var t = e.createTextRange();
                  t.collapse(!1), t.select();
                }
              }),
              (this.searchChanged = (e) => {
                var t = e.target.value;
                this.isSearchPredictive &&
                  (t > ""
                    ? (this.searchChangeTimer &&
                        window.clearTimeout(this.searchChangeTimer),
                      (this.searchChangeTimer = window.setTimeout(() => {
                        this.performSearch(), (this.searchChangeTimer = null);
                      }, 250)))
                    : ((this.searchResultsNum = 0),
                      (this.searchHasResults = !1),
                      this.searchWrapper.classList.remove("has-results"),
                      (this.searchResultsPanel.innerHTML = "")));
              }),
              (this.hideLoading = () => {
                this.loadingIcon.classList.add("hide");
              }),
              (this.showLoading = () => {
                this.displayResults(!1),
                  this.loadingIcon.classList.remove("hide");
              }),
              (this.getSearchQuery = () =>
                `/search/suggest.json?q=${this.searchInput.value}&resources[type]=${this.searchTypes}`),
              (this.getSearchPageUrlWithQuery = () =>
                `/search?type=${this.searchTypes}&q=${encodeURIComponent(
                  this.searchInput.value
                )}*`),
              (this.lockScrolling = () => {
                const e = window.scrollY;
                (document.body.style.position = "fixed"),
                  e > 300 && (document.body.style.top = `-${e}px`);
              }),
              (this.unlockScrolling = () => {
                const e = document.body.style.top;
                (document.body.style.position = ""),
                  (document.body.style.top = ""),
                  window.scrollTo(0, -1 * parseInt(e || "0"));
              }),
              (this.performSearch = async function () {
                n.showLoading(),
                  (n.searchHasResults = !1),
                  (n.searchResultsNum = 0),
                  n.searchWrapper.classList.remove("has-results");
                var e = n.getSearchQuery();
                let t;
                try {
                  const i = await fetch(e);
                  if (!i.ok)
                    return (
                      console.error("Search failed", i),
                      void (window.location.href = n.getSearchPageUrlWithQuery())
                    );
                  t = await i.json();
                } catch (e) {
                  console.error("Search failed", e),
                    (window.location.href = n.getSearchPageUrlWithQuery());
                }
                const i = new Map();
                Object.keys(t.resources.results).forEach((e) => {
                  let r = i.get(e),
                    s = t.resources.results[e];
                  r ||
                    ((r = {
                      name: {
                        articles: n.theme.translations.articles,
                        pages: n.theme.translations.pages,
                        products: n.theme.translations.products,
                        collections: n.theme.translations.collections,
                      }[e],
                      results: [],
                    }),
                    i.set(e, r));
                  let a = s.map((e) => {
                      var t = Object.assign({}, e);
                      return (
                        t.price && (t.price = n.theme.formatMoney(t.price)), t
                      );
                    }),
                    o = 1;
                  1 == n.searchTypesNum
                    ? (o = 4)
                    : 2 == n.searchTypesNum
                    ? (o = 3)
                    : 3 == n.searchTypesNum && (o = 2),
                    "product" == e && o < 4 && (o = o++),
                    (r.results = a.slice(0, o)),
                    r.results &&
                      r.results.length > 0 &&
                      ((n.searchResultsNum += s.length),
                      (n.searchHasResults = !0));
                }),
                  !n.searchHasResults &&
                    n.searchInput.value > "" &&
                    (n.searchSummary.innerHTML = "");
                const r = Array.from(i.values());
                n.hideLoading(), n.displayResults(r, n.trapFocus);
              }),
              (this.displayResults = (e, t) => {
                if (!e || "" == this.searchInput.value)
                  return (
                    (this.searchResultsPanel.innerHTML = ""),
                    void this.searchWrapper.classList.remove("has-results")
                  );
                let n = this,
                  i = "";
                const r = this.theme.translations.soldOut;
                let s = this.getSearchPageUrlWithQuery();
                const a =
                    1 == this.searchResultsNum
                      ? this.theme.translations.search_result
                      : this.theme.translations.search_result_plural,
                  o =
                    0 == this.searchResultsNum
                      ? this.theme.translations.none_found
                      : "";
                (this.searchInput.value > "" || this.searchResultsNum > 0) &&
                  (i = i.concat('<div class="search-results__meta top">')),
                  this.searchInput.value > "" &&
                    (i = i.concat(
                      `\n              <button type="button" class="search-results__meta-clear" tabindex="0">${this.theme.translations.clear}</button>\n          `
                    )),
                  (i = i.concat(
                    `\n          <div class="search-results__status ${
                      o ? "" : "sr-only"
                    }" role="status">${o} ${a} ${
                      this.theme.translations.search_found
                    }.</div>\n      `
                  )),
                  this.searchResultsNum > 0 &&
                    (i = i.concat(
                      `\n              <div class="search-results__meta-view-all"><a href="${s}">${this.theme.translations.view_all}</a></div>\n          `
                    )),
                  (this.searchInput.value > "" || this.searchResultsNum > 0) &&
                    (i = i.concat("</div>")),
                  Object.keys(e).forEach(function (t) {
                    const s = e[t],
                      a = s.results;
                    a.length > 0 &&
                      ((i = i.concat('<div class="predictive-search-group">')),
                      (i = i.concat(
                        `  <h2 class="type-subheading type-subheading--1">${s.name}</h2>`
                      )),
                      (i = i.concat('  <div class="search--result-group">')),
                      Object.keys(a).forEach(function (e) {
                        const t = a[e];
                        let o = "col-12";
                        (i = i.concat('<article class="row">')),
                          t.featured_image &&
                            t.featured_image.url > "" &&
                            ((i = i.concat('<div class="col-3">')),
                            (i = i.concat(
                              `<a href="${t.url}"><img src="${t.featured_image.url}" alt="${t.featured_image.alt}" /></a>`
                            )),
                            (i = i.concat("</div>")),
                            (o = "col-9")),
                          (i = i.concat(`<div class="${o}">`)),
                          n.showVendor &&
                            t.vendor &&
                            (i = i.concat(
                              `<div class="search-vendor">${t.vendor}</div>`
                            )),
                          (i = i.concat(
                            ` <h5><a href="${t.url}">${t.title}</a></h5>`
                          )),
                          t.available ||
                            "Products" != s.name ||
                            (i = i.concat(`<div>${r}</div>`)),
                          n.showPrices &&
                            t.price &&
                            (i = i.concat(
                              ` <div class="search-price">${t.price}</div>`
                            )),
                          (i = i.concat("</div></article>")),
                          (i = i.concat(
                            '<span class="search-result-separator"><hr /></span>'
                          ));
                      }),
                      (i = i.concat("  </div>")),
                      (i = i.concat("</div>")));
                  }),
                  this.searchResultsNum > 0 &&
                    (i = i.concat(
                      `\n                <div class="search-results__meta bottom">\n                  <div class="search-results__meta-view-all"><a href="${s}">${this.theme.translations.view_all}</a></div>\n                </div>\n            `
                    )),
                  this.searchInput.value > ""
                    ? this.searchWrapper.classList.add("has-results")
                    : this.searchWrapper.classList.remove("has-results"),
                  (this.searchResultsPanel.innerHTML = i),
                  t();
              }),
              (this.theme = e),
              (this.element = t),
              (this.searchForm = this.element.querySelector("#search-page-form")),
              (this.searchWrapperID = "#top-search-wrapper"),
              (this.searchWrapper = this.element.querySelector(
                this.searchWrapperID
              )),
              (this.searchIcons = this.element.querySelectorAll(".search-show")),
              (this.searchClear = this.element.querySelectorAll(".search-clear")),
              (this.searchInput = this.element.querySelector("#search_text")),
              (this.SearchSubmitBtn =
                this.element.querySelector("#search_submit")),
              (this.searchClearBtn =
                this.element.querySelector("#search-bar--clear")),
              (this.loadingIcon = this.element.querySelector(
                ".predictive-loading"
              )),
              (this.searchSummary =
                this.element.querySelector(".search-summary")),
              (this.searchResultsPanel = this.element.querySelector(
                ".search-results-panel"
              )),
              (this.searchResultsStatus =
                this.element.querySelector(".search-status")),
              (this.searchChangeTimer = null),
              (this.searchToggler = null),
              (this.lastFocus = document.activeElement),
              (this.searchResultsNum = 0),
              (this.searchHasResults = !1),
              (this.searchTypes = !1),
              (this.searchTypesNum = 0),
              (this.isSearchPredictive = !1),
              (this.showPrices = !1),
              (this.showVendor = !1),
              (this.initialLoad = !0),
              this.searchInput &&
                ((this.searchTypes = this.searchInput.dataset.searchTypes.replace(
                  /,$/,
                  ""
                )),
                (this.searchTypesNum = this.searchTypes.split(",").length),
                (this.isSearchPredictive =
                  this.searchInput.classList.contains("is-predictive")),
                (this.showPrices = "true" == this.searchInput.dataset.showPrices),
                (this.showVendor = "true" == this.searchInput.dataset.showVendor),
                this.loadSearch());
          }
        }
        class fs extends Zr {
          constructor(e, n, i) {
            super(e, n, i),
              (this.onSectionSelect = ({ element: e, sectionId: t, load: n }) => {
                this.theme.loadDrawers();
              }),
              (this.onBlockSelect = ({ element: e }) => {
                if (
                  (this.element.classList.add("touch-hover"),
                  e.dataset.megaMenuBlockId)
                ) {
                  const n = t()(
                      `.header-menu-wrapper [data-mega-menu-block-id="${e.dataset.megaMenuBlockId}"]`
                    ).closest("li.dropdown > .mega-menu--dropdown-wrapper"),
                    i = n.find(".dropdown-envy-toggle");
                  this.openMenu(n, i, !0);
                }
              }),
              (this.onBlockDeselect = () => {
                this.element.classList.remove("touch-hover");
                var e = t()(".mega-menu--dropdown-wrapper.force-open");
                e
                  .children('a[aria-expanded="true"]')
                  .attr("aria-expanded", "false"),
                  e.removeClass("force-open");
              }),
              (this.updateStickyHeader = () => {
                const e = this.element.clientTop + this.element.clientHeight + 50,
                  t =
                    (document.documentElement.scrollTop ||
                      document.body.scrollTop) > e;
                this.$sticky.toggleClass("sticky", t),
                  t
                    ? (this.$sticky.parent().removeClass("unstuck"),
                      this.$sticky.parent().addClass("stuck"))
                    : (this.$sticky.parent().removeClass("stuck"),
                      this.$sticky.parent().addClass("unstuck"));
              }),
              (this.loadStickyHeader = () => {
                if (
                  ((this.$sticky = this.$element.find(".sticky-header-wrapper")),
                  0 === this.$sticky.length)
                )
                  return;
                var e = this.$sticky.find(".sticky-header-menu"),
                  n = this.$sticky.find(".sticky-header-icons");
                const i = t()("#main-navigation-wrapper"),
                  r = t()(".header-wrapper.js").find(".nav-bar__top-nav"),
                  s = i.length,
                  a = r.length;
                s ? i.clone().appendTo(e) : a && r.clone().appendTo(e),
                  t()(".cart-link li button, .cart-link li a").each(function () {
                    t()('<div class="sticky-header-icon"></div>')
                      .append(t()(this).clone())
                      .appendTo(n);
                  }),
                  t()(".mobile-header--wrapper")
                    .clone()
                    .appendTo(this.$sticky.find(".sticky-mobile-header"))
                    .find(".slide-menu-mobile")
                    .off("click")
                    .on("click", function () {
                      t()("#theme-menu").trigger("mobile:toggle");
                    }),
                  window.addEventListener("scroll", this.updateStickyHeader),
                  this.updateStickyHeader(),
                  this.$sticky
                    .find(".slide-menu-cart")
                    .off("click")
                    .on("click", function (e) {
                      return (
                        t()("#cartSlideoutWrapper").trigger("cart:toggle"),
                        e.preventDefault(),
                        !1
                      );
                    });
              }),
              (this.loadDropdownHover = () => {
                (this.dropdownTimeout = null),
                  (this.touchHoverTimeout = null),
                  this.dropdownHandle();
              }),
              (this.handleExternalLinks = () => {
                var e = this.element.querySelectorAll("a");
                for (let t = 0, n = e.length; t < n; t++)
                  e[t].hostname !== window.location.hostname &&
                    ((e[t].target = "_blank"),
                    (e[t].rel = "noreferrer noopener"));
              }),
              (this.openMenu = (e, n, i = !1) => {
                if (!n.is(".dropdown-envy-toggle")) return;
                this.closeAllDropdowns();
                let r = e[0].offsetHeight + e[0].offsetTop;
                e.find("> .dropdown-menu--standard").css("margin-top", r + "px"),
                  e
                    .find("> .dropdown-menu--mega")
                    .css("margin-top", r - 1 + "px");
                var s = t()(".header-wrapper");
                t()(".sticky").length > 0 && (s = t()(".sticky-header-wrapper"));
                let a = s.position().top + s.outerHeight() - 1;
                s.is(".header-wrapper--overlay.unstuck") &&
                  t()(".notification-bar").length &&
                  (a -= t()(".notification-bar").outerHeight()),
                  n.is("a") &&
                    n.next("ul").length &&
                    n.attr("aria-expanded", "true"),
                  e.addClass(i ? "force-open" : "open"),
                  e.attr("aria-expanded", "true"),
                  this.selectMenuDirection(e);
              }),
              (this.closeMenu = (e) => {
                e.find('a[aria-expanded="true"]').attr("aria-expanded", "false"),
                  e.removeClass("open");
              }),
              (this.getMenuFromHandler = (e) =>
                e.is(".dropdown-envy-toggle") ? e.parent() : e),
              (this.handleTouchend = (e, t) => {
                "touchend" === e.type &&
                  (this.touchHoverTimeout &&
                    (clearTimeout(this.touchHoverTimeout),
                    (this.touchHoverTimeout = null)),
                  this.element.classList.add("touch-hover"),
                  t.is(".dropdown-submenu,.mega-menu--dropdown-wrapper") &&
                    !t.hasClass("open") &&
                    e.preventDefault());
              }),
              (this.clearDropdownTimeout = () => {
                this.dropdownTimeout && clearTimeout(this.dropdownTimeout);
              }),
              (this.handleToggleOnEvents = (e) => {
                e.stopPropagation();
                const n = t()(e.currentTarget);
                let i = this.getMenuFromHandler(n);
                i.hasClass("dropdown-submenu__link") &&
                  (i.attr("aria-expanded", "true"),
                  (i = i.parent()),
                  i.addClass("open")),
                  this.handleTouchend(e, i);
                var r = i
                  .closest(".mega-menu--dropdown-wrapper")
                  .find(".open")
                  .not(i.closest(".dropdown-submenu"));
                r
                  .children('a[aria-expanded="true"]')
                  .attr("aria-expanded", "false"),
                  r.removeClass("open"),
                  this.clearDropdownTimeout(),
                  (this.dropdownTimeout = setTimeout(this.openMenu, 10, i, n));
              }),
              (this.handleToggleOffEvents = (e) => {
                const n = t()(e.currentTarget),
                  i = this.getMenuFromHandler(n);
                i.hasClass("dropdown-envy-toggle") && i.removeClass("open"),
                  i.hasClass("open") ||
                    (this.clearDropdownTimeout(),
                    (this.dropdownTimeout = setTimeout(this.closeMenu, 1500, i)));
              }),
              (this.dropdownHandle = () => {
                var e = this.$element.find(
                  ".dropdown-envy-toggle, .dropdown-menu > li, .dropdown-menu--mega, a.dropdown-submenu__link"
                );
                e
                  .off("mouseenter touchend focus")
                  .on("mouseenter touchend focus", (e) => {
                    this.handleToggleOnEvents(e);
                  }),
                  e.off("mouseleave blur").on("mouseleave blur", (e) => {
                    this.handleToggleOffEvents(e);
                  }),
                  t()(".nav-pills")
                    .off("mouseleave")
                    .on("mouseleave", this.navigatedFromMenu),
                  t()("body").on("touchstart", this.navigatedFromMenu);
              }),
              (this.headerLinkHandle = () => {
                this.$element
                  .find(".header-link")
                  .not(".dropdown-envy-toggle")
                  .off("mouseenter touchend focus")
                  .on("mouseenter touchend focus", (e) => {
                    this.closeAllDropdowns();
                  });
              }),
              (this.navigatedFromMenu = (e) => {
                this.touchHoverTimeout && clearTimeout(this.touchHoverTimeout),
                  (this.touchHoverTimeout = setTimeout(() => {
                    (this.touchHoverTimeout = null),
                      this.element.classList.remove("touch-hover");
                  }, 50)),
                  ("mouseleave" !== e.type &&
                    0 !==
                      t()(e.target).parents(
                        ".mega-menu--dropdown-wrapper.open, .dropdown-submenu.open"
                      ).length) ||
                    this.closeAllDropdowns();
              }),
              (this.closeAllDropdowns = () => {
                var e = t()(
                  ".mega-menu--dropdown-wrapper.open,.dropdown-submenu.open"
                );
                e.find('a[aria-expanded="true"]').attr("aria-expanded", "false"),
                  e.removeClass("open");
              }),
              (this.selectMenuDirection = (e) => {
                var n = e.find(".dropdown-menu .dropdown-menu").map(function () {
                    var e = t()(this),
                      n = e
                        .css({ display: "block", visibility: "hidden" })
                        .outerWidth();
                    return e.css({ display: "", visibility: "" }), n;
                  }),
                  i = Math.max.apply(null, n),
                  r = e.find("> .dropdown-menu");
                if (0 !== r.length) {
                  var s = r.offset().left,
                    a = s + r.outerWidth() + i > t()("body").width() && s - i > 0;
                  r.toggleClass("dropdown-submenu-left", a);
                }
              }),
              (this.fixHeaderHeight = () => {
                var e = t()("#shopify-section-announcement-bar").height(),
                  n = t()("#shopify-section-header").height(),
                  i = t()("#shopify-section-text-adverts").height(),
                  r = e + n + i,
                  s = e + i;
                t()(".slideshow--full-screen").length &&
                  (0 === t()(".header-wrapper--overlay").length
                    ? (t()(".slideshow--full-screen").css(
                        "height",
                        "calc(100vh - " + r + "px)"
                      ),
                      t()(".slideshow--full-screen ul.slides li").css(
                        "height",
                        "calc(100vh - " + r + "px)"
                      ))
                    : (t()(".slideshow--full-screen").css(
                        "height",
                        "calc(100vh - " + s + "px)"
                      ),
                      t()(".slideshow--full-screen ul.slides li").css(
                        "height",
                        "calc(100vh - " + s + "px)"
                      )));
              }),
              (this.$element = t()(n)),
              this.loadStickyHeader(),
              (this.mobileMenu = new us(
                e,
                document.querySelector(".mobile-menu-wrapper")
              )),
              (this.predictiveSearch = new hs(e, n)),
              this.loadDropdownHover(),
              this.headerLinkHandle(),
              this.fixHeaderHeight(),
              this.theme.loadIcons(),
              this.handleExternalLinks();
          }
        }
        n(65);
        class ms {
          constructor(e, n) {
            (this.initPlaypause = () => {
              (this.playpause.btn_index = this.$allFocusableEls.index(
                this.playpause.$btn
              )),
                (this.playpause.$nextFocusableEl =
                  this.$allFocusableEls[this.playpause.btn_index + 1]),
                (this.playpause.$prevFocusableEl =
                  this.$allFocusableEls[this.playpause.btn_index - 1]),
                this.playpause.$btn.attr("role", "button"),
                this.playpause.$btn.attr("aria-label", this.playpause.btn_label),
                this.playpause.$btn.attr(
                  "aria-pressed",
                  this.playpause.is_pressed
                );
            }),
              (this.playpauseHandleKeydown = (e) => {
                var n = 9 == e.keyCode,
                  i = 13 == e.keyCode;
                if (n)
                  e.shiftKey
                    ? this.playpause.$prevFocusableEl.focus()
                    : this.playpause.$nextFocusableEl.focus();
                else {
                  if (!i) return;
                  t()(e.target).trigger("click");
                }
              }),
              (this.setAriaPressed = (e) => {
                (this.playpause.is_pressed = e.hasClass("flex-pause")
                  ? "false"
                  : "true"),
                  e.attr("aria-pressed", this.playpause.is_pressed);
              }),
              (this.getSpeed = () =>
                parseInt(this.$element.data("sliderSlideTime"))),
              (this.getId = () => this.$element.data("sliderId")),
              (this.getSmoothHeightState = () => t()(window).width() < 767),
              (this.getAnimation = () => this.$element.data("sliderAnimation")),
              (this.getDots = () => this.$element.data("sliderDots")),
              (this.getArrows = () => this.$element.data("sliderArrows")),
              (this.getControls = () => this.$element.data("sliderControls")),
              (this.currentSlide = () =>
                this.$element.find(".flex-active-slide").data("slide-index")),
              (this.showSlide = (e) => {
                this.getSpeed() > 0 &&
                  (this.flexslider.pause(), (this.forcePause = !0)),
                  this.currentSlide() !== e && this.flexslider.flexAnimate(e);
              }),
              (this.startAnimation = () => {
                (this.forcePause = !1),
                  this.getSpeed() > 0 && this.flexslider.play();
              }),
              (this.onSlideChange = (e) => {
                var t = this.getSpeed();
                this.$element.find(".slides li a").attr("tabindex", "0"),
                  this.$element
                    .find(".slides li:not(.flex-active-slide) a")
                    .attr("tabindex", "-1"),
                  !this.forcePause &&
                    !e.playing &&
                    t > 0 &&
                    (clearTimeout(this.restartTimer),
                    (this.restartTimer = setTimeout(function () {
                      e.play();
                    }, Math.max(0, 6e3 - t))));
              }),
              (this.configure = (e) => {
                if (0 !== t()(window).width()) {
                  var n = this.getSpeed(),
                    i = this.getId(),
                    r = this.$element.find("ul.slides li").length,
                    s = t().extend(
                      {
                        pausePlay: r > 1 && this.getControls(),
                        pauseText: "",
                        playText: "",
                        directionNav: r > 1 ? this.getArrows() : "",
                        controlNav: r > 1 ? this.getDots() : "",
                        startAt: 0,
                        slideshowSpeed: n,
                        animation: this.getAnimation(),
                        controlsContainer: t()(
                          ".slider-pagination-container.slider--" + i
                        ),
                        customDirectionNav: t()(
                          ".flex-direction-nav.slider--" + i + " button"
                        ),
                        slideshow: n > 0 && r > 1,
                        touch: r > 1,
                        pauseOnAction: !0,
                        after: this.onSlideChange.bind(this),
                      },
                      e
                    );
                  return (
                    0 === t()(".slider-pagination-container.slider--" + i).length
                      ? (e.controlNav = !1)
                      : (e.controlNav = !0),
                    0 === t()(".flex-direction-nav.slider--" + i + " a").length
                      ? (e.directionNav = !1)
                      : (e.directionNav = !0),
                    this.$element.find("ul.slides").width("auto"),
                    this.$element.flexslider(s).data("flexslider")
                  );
                }
                setTimeout(this.configure.bind(this), 200);
              }),
              (this.theme = e),
              (this.element = n),
              (this.$element = t()(n)),
              (this.restartTimer = null),
              (this.forcePause = !1),
              this.$element
                .find(".slides li")
                .css("width", this.$element.width()),
              (this.flexslider = this.configure({})),
              t()(window).off("blur"),
              this.$element
                .find(".slides li:not(.flex-active-slide) a")
                .attr("tabindex", "-1");
            var i = t()(
                ".slider-pagination-container.slider--" + this.getId()
              ).find("a"),
              r = this;
            i.each(function () {
              t()(this).attr(
                "aria-label",
                `${r.theme.translations.slide} ${t()(this).text()}`
              );
            }),
              (this.$allFocusableEls = t()(
                "a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]"
              ).not('[tabindex=-1], [disabled], :hidden, [aria-hidden="true"]')),
              (this.playpause = {
                btn_label: r.theme.translations.pause,
                $btn: t()(".flex-pauseplay a"),
                is_pressed: "false",
              }),
              this.initPlaypause(),
              this.playpause.$btn.on("click", function (e) {
                r.setAriaPressed(t()(e.target));
              }),
              this.playpause.$btn.on("keydown", function (e) {
                e.preventDefault(), r.playpauseHandleKeydown(e);
              }),
              this.$element;
          }
        }
        class vs extends Zr {
          constructor(e, t, n) {
            super(e, t, n),
              (this.onBlockSelect = ({ element: e }) => {
                const t = parseInt(e.dataset.slideIndex, 10);
                this.slider.showSlide(t);
              }),
              (this.onBlockDeselect = () => {
                this.slider.startAnimation();
              }),
              (this.sliderElement = t.querySelector(".flexslider-homepage")),
              (this.slider = new ms(e, this.sliderElement));
          }
        }
        class ys extends Zr {
          constructor(e, t, n) {
            super(e, t, n),
              (this.onBlockSelect = ({ element: e }) => {
                const t = parseInt(e.dataset.slideIndex, 10);
                this.slider.showSlide(t);
              }),
              (this.onBlockDeselect = () => {
                this.slider.startAnimation();
              }),
              (this.sliderElement = t.querySelector(
                ".flexslider-homepage-testimonial"
              )),
              (this.slider = new ms(e, this.sliderElement)),
              (e.testimonials = e.testimonials || {}),
              (e.testimonials[t.dataset.sliderId] = this.slider);
          }
        }
        function gs(e) {
          return (
            null !== e &&
            "object" == typeof e &&
            "constructor" in e &&
            e.constructor === Object
          );
        }
        function xs(e, t) {
          void 0 === e && (e = {}),
            void 0 === t && (t = {}),
            Object.keys(t).forEach(function (n) {
              void 0 === e[n]
                ? (e[n] = t[n])
                : gs(t[n]) &&
                  gs(e[n]) &&
                  Object.keys(t[n]).length > 0 &&
                  xs(e[n], t[n]);
            });
        }
        var bs = "undefined" != typeof document ? document : {},
          ws = {
            body: {},
            addEventListener: function () {},
            removeEventListener: function () {},
            activeElement: { blur: function () {}, nodeName: "" },
            querySelector: function () {
              return null;
            },
            querySelectorAll: function () {
              return [];
            },
            getElementById: function () {
              return null;
            },
            createEvent: function () {
              return { initEvent: function () {} };
            },
            createElement: function () {
              return {
                children: [],
                childNodes: [],
                style: {},
                setAttribute: function () {},
                getElementsByTagName: function () {
                  return [];
                },
              };
            },
            createElementNS: function () {
              return {};
            },
            importNode: function () {
              return null;
            },
            location: {
              hash: "",
              host: "",
              hostname: "",
              href: "",
              origin: "",
              pathname: "",
              protocol: "",
              search: "",
            },
          };
        xs(bs, ws);
        var Ss = "undefined" != typeof window ? window : {};
        xs(Ss, {
          document: ws,
          navigator: { userAgent: "" },
          location: {
            hash: "",
            host: "",
            hostname: "",
            href: "",
            origin: "",
            pathname: "",
            protocol: "",
            search: "",
          },
          history: {
            replaceState: function () {},
            pushState: function () {},
            go: function () {},
            back: function () {},
          },
          CustomEvent: function () {
            return this;
          },
          addEventListener: function () {},
          removeEventListener: function () {},
          getComputedStyle: function () {
            return {
              getPropertyValue: function () {
                return "";
              },
            };
          },
          Image: function () {},
          Date: function () {},
          screen: {},
          setTimeout: function () {},
          clearTimeout: function () {},
          matchMedia: function () {
            return {};
          },
        });
        class Cs {
          constructor(e) {
            const t = this;
            for (let n = 0; n < e.length; n += 1) t[n] = e[n];
            return (t.length = e.length), this;
          }
        }
        function Ts(e, t) {
          const n = [];
          let i = 0;
          if (e && !t && e instanceof Cs) return e;
          if (e)
            if ("string" == typeof e) {
              let r, s;
              const a = e.trim();
              if (a.indexOf("<") >= 0 && a.indexOf(">") >= 0) {
                let e = "div";
                for (
                  0 === a.indexOf("<li") && (e = "ul"),
                    0 === a.indexOf("<tr") && (e = "tbody"),
                    (0 !== a.indexOf("<td") && 0 !== a.indexOf("<th")) ||
                      (e = "tr"),
                    0 === a.indexOf("<tbody") && (e = "table"),
                    0 === a.indexOf("<option") && (e = "select"),
                    s = bs.createElement(e),
                    s.innerHTML = a,
                    i = 0;
                  i < s.childNodes.length;
                  i += 1
                )
                  n.push(s.childNodes[i]);
              } else
                for (
                  r =
                    t || "#" !== e[0] || e.match(/[ .<>:~]/)
                      ? (t || bs).querySelectorAll(e.trim())
                      : [bs.getElementById(e.trim().split("#")[1])],
                    i = 0;
                  i < r.length;
                  i += 1
                )
                  r[i] && n.push(r[i]);
            } else if (e.nodeType || e === Ss || e === bs) n.push(e);
            else if (e.length > 0 && e[0].nodeType)
              for (i = 0; i < e.length; i += 1) n.push(e[i]);
          return new Cs(n);
        }
        function _s(e) {
          const t = [];
          for (let n = 0; n < e.length; n += 1)
            -1 === t.indexOf(e[n]) && t.push(e[n]);
          return t;
        }
        (Ts.fn = Cs.prototype), (Ts.Class = Cs), (Ts.Dom7 = Cs);
        "resize scroll".split(" ");
        const Es = {
          addClass: function (e) {
            if (void 0 === e) return this;
            const t = e.split(" ");
            for (let e = 0; e < t.length; e += 1)
              for (let n = 0; n < this.length; n += 1)
                void 0 !== this[n] &&
                  void 0 !== this[n].classList &&
                  this[n].classList.add(t[e]);
            return this;
          },
          removeClass: function (e) {
            const t = e.split(" ");
            for (let e = 0; e < t.length; e += 1)
              for (let n = 0; n < this.length; n += 1)
                void 0 !== this[n] &&
                  void 0 !== this[n].classList &&
                  this[n].classList.remove(t[e]);
            return this;
          },
          hasClass: function (e) {
            return !!this[0] && this[0].classList.contains(e);
          },
          toggleClass: function (e) {
            const t = e.split(" ");
            for (let e = 0; e < t.length; e += 1)
              for (let n = 0; n < this.length; n += 1)
                void 0 !== this[n] &&
                  void 0 !== this[n].classList &&
                  this[n].classList.toggle(t[e]);
            return this;
          },
          attr: function (e, t) {
            if (1 === arguments.length && "string" == typeof e)
              return this[0] ? this[0].getAttribute(e) : void 0;
            for (let n = 0; n < this.length; n += 1)
              if (2 === arguments.length) this[n].setAttribute(e, t);
              else
                for (const t in e)
                  (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
            return this;
          },
          removeAttr: function (e) {
            for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
            return this;
          },
          data: function (e, t) {
            let n;
            if (void 0 !== t) {
              for (let i = 0; i < this.length; i += 1)
                (n = this[i]),
                  n.dom7ElementDataStorage || (n.dom7ElementDataStorage = {}),
                  (n.dom7ElementDataStorage[e] = t);
              return this;
            }
            if (((n = this[0]), n)) {
              if (n.dom7ElementDataStorage && e in n.dom7ElementDataStorage)
                return n.dom7ElementDataStorage[e];
              const t = n.getAttribute(`data-${e}`);
              return t || void 0;
            }
          },
          transform: function (e) {
            for (let t = 0; t < this.length; t += 1) {
              const n = this[t].style;
              (n.webkitTransform = e), (n.transform = e);
            }
            return this;
          },
          transition: function (e) {
            "string" != typeof e && (e = `${e}ms`);
            for (let t = 0; t < this.length; t += 1) {
              const n = this[t].style;
              (n.webkitTransitionDuration = e), (n.transitionDuration = e);
            }
            return this;
          },
          on: function (...e) {
            let [t, n, i, r] = e;
            function s(e) {
              const t = e.target;
              if (!t) return;
              const r = e.target.dom7EventData || [];
              if ((r.indexOf(e) < 0 && r.unshift(e), Ts(t).is(n))) i.apply(t, r);
              else {
                const e = Ts(t).parents();
                for (let t = 0; t < e.length; t += 1)
                  Ts(e[t]).is(n) && i.apply(e[t], r);
              }
            }
            function a(e) {
              const t = (e && e.target && e.target.dom7EventData) || [];
              t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t);
            }
            "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
              r || (r = !1);
            const o = t.split(" ");
            let l;
            for (let e = 0; e < this.length; e += 1) {
              const t = this[e];
              if (n)
                for (l = 0; l < o.length; l += 1) {
                  const e = o[l];
                  t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                    t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                    t.dom7LiveListeners[e].push({
                      listener: i,
                      proxyListener: s,
                    }),
                    t.addEventListener(e, s, r);
                }
              else
                for (l = 0; l < o.length; l += 1) {
                  const e = o[l];
                  t.dom7Listeners || (t.dom7Listeners = {}),
                    t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                    t.dom7Listeners[e].push({ listener: i, proxyListener: a }),
                    t.addEventListener(e, a, r);
                }
            }
            return this;
          },
          off: function (...e) {
            let [t, n, i, r] = e;
            "function" == typeof e[1] && (([t, i, r] = e), (n = void 0)),
              r || (r = !1);
            const s = t.split(" ");
            for (let e = 0; e < s.length; e += 1) {
              const t = s[e];
              for (let e = 0; e < this.length; e += 1) {
                const s = this[e];
                let a;
                if (
                  (!n && s.dom7Listeners
                    ? (a = s.dom7Listeners[t])
                    : n && s.dom7LiveListeners && (a = s.dom7LiveListeners[t]),
                  a && a.length)
                )
                  for (let e = a.length - 1; e >= 0; e -= 1) {
                    const n = a[e];
                    (i && n.listener === i) ||
                    (i &&
                      n.listener &&
                      n.listener.dom7proxy &&
                      n.listener.dom7proxy === i)
                      ? (s.removeEventListener(t, n.proxyListener, r),
                        a.splice(e, 1))
                      : i ||
                        (s.removeEventListener(t, n.proxyListener, r),
                        a.splice(e, 1));
                  }
              }
            }
            return this;
          },
          trigger: function (...e) {
            const t = e[0].split(" "),
              n = e[1];
            for (let i = 0; i < t.length; i += 1) {
              const r = t[i];
              for (let t = 0; t < this.length; t += 1) {
                const i = this[t];
                let s;
                try {
                  s = new Ss.CustomEvent(r, {
                    detail: n,
                    bubbles: !0,
                    cancelable: !0,
                  });
                } catch (e) {
                  (s = bs.createEvent("Event")),
                    s.initEvent(r, !0, !0),
                    (s.detail = n);
                }
                (i.dom7EventData = e.filter((e, t) => t > 0)),
                  i.dispatchEvent(s),
                  (i.dom7EventData = []),
                  delete i.dom7EventData;
              }
            }
            return this;
          },
          transitionEnd: function (e) {
            const t = ["webkitTransitionEnd", "transitionend"],
              n = this;
            let i;
            function r(s) {
              if (s.target === this)
                for (e.call(this, s), i = 0; i < t.length; i += 1) n.off(t[i], r);
            }
            if (e) for (i = 0; i < t.length; i += 1) n.on(t[i], r);
            return this;
          },
          outerWidth: function (e) {
            if (this.length > 0) {
              if (e) {
                const e = this.styles();
                return (
                  this[0].offsetWidth +
                  parseFloat(e.getPropertyValue("margin-right")) +
                  parseFloat(e.getPropertyValue("margin-left"))
                );
              }
              return this[0].offsetWidth;
            }
            return null;
          },
          outerHeight: function (e) {
            if (this.length > 0) {
              if (e) {
                const e = this.styles();
                return (
                  this[0].offsetHeight +
                  parseFloat(e.getPropertyValue("margin-top")) +
                  parseFloat(e.getPropertyValue("margin-bottom"))
                );
              }
              return this[0].offsetHeight;
            }
            return null;
          },
          offset: function () {
            if (this.length > 0) {
              const e = this[0],
                t = e.getBoundingClientRect(),
                n = bs.body,
                i = e.clientTop || n.clientTop || 0,
                r = e.clientLeft || n.clientLeft || 0,
                s = e === Ss ? Ss.scrollY : e.scrollTop,
                a = e === Ss ? Ss.scrollX : e.scrollLeft;
              return { top: t.top + s - i, left: t.left + a - r };
            }
            return null;
          },
          css: function (e, t) {
            let n;
            if (1 === arguments.length) {
              if ("string" != typeof e) {
                for (n = 0; n < this.length; n += 1)
                  for (let t in e) this[n].style[t] = e[t];
                return this;
              }
              if (this[0])
                return Ss.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 === arguments.length && "string" == typeof e) {
              for (n = 0; n < this.length; n += 1) this[n].style[e] = t;
              return this;
            }
            return this;
          },
          each: function (e) {
            if (!e) return this;
            for (let t = 0; t < this.length; t += 1)
              if (!1 === e.call(this[t], t, this[t])) return this;
            return this;
          },
          html: function (e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
            return this;
          },
          text: function (e) {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
            return this;
          },
          is: function (e) {
            const t = this[0];
            let n, i;
            if (!t || void 0 === e) return !1;
            if ("string" == typeof e) {
              if (t.matches) return t.matches(e);
              if (t.webkitMatchesSelector) return t.webkitMatchesSelector(e);
              if (t.msMatchesSelector) return t.msMatchesSelector(e);
              for (n = Ts(e), i = 0; i < n.length; i += 1)
                if (n[i] === t) return !0;
              return !1;
            }
            if (e === bs) return t === bs;
            if (e === Ss) return t === Ss;
            if (e.nodeType || e instanceof Cs) {
              for (n = e.nodeType ? [e] : e, i = 0; i < n.length; i += 1)
                if (n[i] === t) return !0;
              return !1;
            }
            return !1;
          },
          index: function () {
            let e,
              t = this[0];
            if (t) {
              for (e = 0; null !== (t = t.previousSibling); )
                1 === t.nodeType && (e += 1);
              return e;
            }
          },
          eq: function (e) {
            if (void 0 === e) return this;
            const t = this.length;
            let n;
            return e > t - 1
              ? new Cs([])
              : e < 0
              ? ((n = t + e), new Cs(n < 0 ? [] : [this[n]]))
              : new Cs([this[e]]);
          },
          append: function (...e) {
            let t;
            for (let n = 0; n < e.length; n += 1) {
              t = e[n];
              for (let e = 0; e < this.length; e += 1)
                if ("string" == typeof t) {
                  const n = bs.createElement("div");
                  for (n.innerHTML = t; n.firstChild; )
                    this[e].appendChild(n.firstChild);
                } else if (t instanceof Cs)
                  for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
                else this[e].appendChild(t);
            }
            return this;
          },
          prepend: function (e) {
            let t, n;
            for (t = 0; t < this.length; t += 1)
              if ("string" == typeof e) {
                const i = bs.createElement("div");
                for (i.innerHTML = e, n = i.childNodes.length - 1; n >= 0; n -= 1)
                  this[t].insertBefore(i.childNodes[n], this[t].childNodes[0]);
              } else if (e instanceof Cs)
                for (n = 0; n < e.length; n += 1)
                  this[t].insertBefore(e[n], this[t].childNodes[0]);
              else this[t].insertBefore(e, this[t].childNodes[0]);
            return this;
          },
          next: function (e) {
            return this.length > 0
              ? e
                ? this[0].nextElementSibling &&
                  Ts(this[0].nextElementSibling).is(e)
                  ? new Cs([this[0].nextElementSibling])
                  : new Cs([])
                : this[0].nextElementSibling
                ? new Cs([this[0].nextElementSibling])
                : new Cs([])
              : new Cs([]);
          },
          nextAll: function (e) {
            const t = [];
            let n = this[0];
            if (!n) return new Cs([]);
            for (; n.nextElementSibling; ) {
              const i = n.nextElementSibling;
              e ? Ts(i).is(e) && t.push(i) : t.push(i), (n = i);
            }
            return new Cs(t);
          },
          prev: function (e) {
            if (this.length > 0) {
              const t = this[0];
              return e
                ? t.previousElementSibling && Ts(t.previousElementSibling).is(e)
                  ? new Cs([t.previousElementSibling])
                  : new Cs([])
                : t.previousElementSibling
                ? new Cs([t.previousElementSibling])
                : new Cs([]);
            }
            return new Cs([]);
          },
          prevAll: function (e) {
            const t = [];
            let n = this[0];
            if (!n) return new Cs([]);
            for (; n.previousElementSibling; ) {
              const i = n.previousElementSibling;
              e ? Ts(i).is(e) && t.push(i) : t.push(i), (n = i);
            }
            return new Cs(t);
          },
          parent: function (e) {
            const t = [];
            for (let n = 0; n < this.length; n += 1)
              null !== this[n].parentNode &&
                (e
                  ? Ts(this[n].parentNode).is(e) && t.push(this[n].parentNode)
                  : t.push(this[n].parentNode));
            return Ts(_s(t));
          },
          parents: function (e) {
            const t = [];
            for (let n = 0; n < this.length; n += 1) {
              let i = this[n].parentNode;
              for (; i; )
                e ? Ts(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode);
            }
            return Ts(_s(t));
          },
          closest: function (e) {
            let t = this;
            return void 0 === e
              ? new Cs([])
              : (t.is(e) || (t = t.parents(e).eq(0)), t);
          },
          find: function (e) {
            const t = [];
            for (let n = 0; n < this.length; n += 1) {
              const i = this[n].querySelectorAll(e);
              for (let e = 0; e < i.length; e += 1) t.push(i[e]);
            }
            return new Cs(t);
          },
          children: function (e) {
            const t = [];
            for (let n = 0; n < this.length; n += 1) {
              const i = this[n].childNodes;
              for (let n = 0; n < i.length; n += 1)
                e
                  ? 1 === i[n].nodeType && Ts(i[n]).is(e) && t.push(i[n])
                  : 1 === i[n].nodeType && t.push(i[n]);
            }
            return new Cs(_s(t));
          },
          filter: function (e) {
            const t = [],
              n = this;
            for (let i = 0; i < n.length; i += 1)
              e.call(n[i], i, n[i]) && t.push(n[i]);
            return new Cs(t);
          },
          remove: function () {
            for (let e = 0; e < this.length; e += 1)
              this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this;
          },
          add: function (...e) {
            const t = this;
            let n, i;
            for (n = 0; n < e.length; n += 1) {
              const r = Ts(e[n]);
              for (i = 0; i < r.length; i += 1)
                (t[t.length] = r[i]), (t.length += 1);
            }
            return t;
          },
          styles: function () {
            return this[0] ? Ss.getComputedStyle(this[0], null) : {};
          },
        };
        Object.keys(Es).forEach((e) => {
          Ts.fn[e] = Ts.fn[e] || Es[e];
        });
        const ks = {
            deleteProps(e) {
              const t = e;
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            },
            nextTick: (e, t = 0) => setTimeout(e, t),
            now: () => Date.now(),
            getTranslate(e, t = "x") {
              let n, i, r;
              const s = Ss.getComputedStyle(e, null);
              return (
                Ss.WebKitCSSMatrix
                  ? ((i = s.transform || s.webkitTransform),
                    i.split(",").length > 6 &&
                      (i = i
                        .split(", ")
                        .map((e) => e.replace(",", "."))
                        .join(", ")),
                    (r = new Ss.WebKitCSSMatrix("none" === i ? "" : i)))
                  : ((r =
                      s.MozTransform ||
                      s.OTransform ||
                      s.MsTransform ||
                      s.msTransform ||
                      s.transform ||
                      s
                        .getPropertyValue("transform")
                        .replace("translate(", "matrix(1, 0, 0, 1,")),
                    (n = r.toString().split(","))),
                "x" === t &&
                  (i = Ss.WebKitCSSMatrix
                    ? r.m41
                    : 16 === n.length
                    ? parseFloat(n[12])
                    : parseFloat(n[4])),
                "y" === t &&
                  (i = Ss.WebKitCSSMatrix
                    ? r.m42
                    : 16 === n.length
                    ? parseFloat(n[13])
                    : parseFloat(n[5])),
                i || 0
              );
            },
            parseUrlQuery(e) {
              const t = {};
              let n,
                i,
                r,
                s,
                a = e || Ss.location.href;
              if ("string" == typeof a && a.length)
                for (
                  a = a.indexOf("?") > -1 ? a.replace(/\S*\?/, "") : "",
                    i = a.split("&").filter((e) => "" !== e),
                    s = i.length,
                    n = 0;
                  n < s;
                  n += 1
                )
                  (r = i[n].replace(/#\S+/g, "").split("=")),
                    (t[decodeURIComponent(r[0])] =
                      void 0 === r[1] ? void 0 : decodeURIComponent(r[1]) || "");
              return t;
            },
            isObject: (e) =>
              "object" == typeof e &&
              null !== e &&
              e.constructor &&
              e.constructor === Object,
            extend(...e) {
              const t = Object(e[0]);
              for (let n = 1; n < e.length; n += 1) {
                const i = e[n];
                if (null != i) {
                  const e = Object.keys(Object(i));
                  for (let n = 0, r = e.length; n < r; n += 1) {
                    const r = e[n],
                      s = Object.getOwnPropertyDescriptor(i, r);
                    void 0 !== s &&
                      s.enumerable &&
                      (ks.isObject(t[r]) && ks.isObject(i[r])
                        ? ks.extend(t[r], i[r])
                        : !ks.isObject(t[r]) && ks.isObject(i[r])
                        ? ((t[r] = {}), ks.extend(t[r], i[r]))
                        : (t[r] = i[r]));
                  }
                }
              }
              return t;
            },
          },
          $s = {
            touch: !!(
              "ontouchstart" in Ss ||
              (Ss.DocumentTouch && bs instanceof Ss.DocumentTouch)
            ),
            pointerEvents:
              !!Ss.PointerEvent &&
              "maxTouchPoints" in Ss.navigator &&
              Ss.navigator.maxTouchPoints >= 0,
            observer: "MutationObserver" in Ss || "WebkitMutationObserver" in Ss,
            passiveListener: (function () {
              let e = !1;
              try {
                const t = Object.defineProperty({}, "passive", {
                  get() {
                    e = !0;
                  },
                });
                Ss.addEventListener("testPassiveListener", null, t);
              } catch (e) {}
              return e;
            })(),
            gestures: "ongesturestart" in Ss,
          };
        class Ms {
          constructor(e = {}) {
            const t = this;
            (t.params = e),
              (t.eventsListeners = {}),
              t.params &&
                t.params.on &&
                Object.keys(t.params.on).forEach((e) => {
                  t.on(e, t.params.on[e]);
                });
          }
          on(e, t, n) {
            const i = this;
            if ("function" != typeof t) return i;
            const r = n ? "unshift" : "push";
            return (
              e.split(" ").forEach((e) => {
                i.eventsListeners[e] || (i.eventsListeners[e] = []),
                  i.eventsListeners[e][r](t);
              }),
              i
            );
          }
          once(e, t, n) {
            const i = this;
            if ("function" != typeof t) return i;
            function r(...n) {
              i.off(e, r), r.f7proxy && delete r.f7proxy, t.apply(i, n);
            }
            return (r.f7proxy = t), i.on(e, r, n);
          }
          off(e, t) {
            const n = this;
            return n.eventsListeners
              ? (e.split(" ").forEach((e) => {
                  void 0 === t
                    ? (n.eventsListeners[e] = [])
                    : n.eventsListeners[e] &&
                      n.eventsListeners[e].length &&
                      n.eventsListeners[e].forEach((i, r) => {
                        (i === t || (i.f7proxy && i.f7proxy === t)) &&
                          n.eventsListeners[e].splice(r, 1);
                      });
                }),
                n)
              : n;
          }
          emit(...e) {
            const t = this;
            if (!t.eventsListeners) return t;
            let n, i, r;
            "string" == typeof e[0] || Array.isArray(e[0])
              ? ((n = e[0]), (i = e.slice(1, e.length)), (r = t))
              : ((n = e[0].events), (i = e[0].data), (r = e[0].context || t));
            return (
              (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
                if (t.eventsListeners && t.eventsListeners[e]) {
                  const n = [];
                  t.eventsListeners[e].forEach((e) => {
                    n.push(e);
                  }),
                    n.forEach((e) => {
                      e.apply(r, i);
                    });
                }
              }),
              t
            );
          }
          useModulesParams(e) {
            const t = this;
            t.modules &&
              Object.keys(t.modules).forEach((n) => {
                const i = t.modules[n];
                i.params && ks.extend(e, i.params);
              });
          }
          useModules(e = {}) {
            const t = this;
            t.modules &&
              Object.keys(t.modules).forEach((n) => {
                const i = t.modules[n],
                  r = e[n] || {};
                i.instance &&
                  Object.keys(i.instance).forEach((e) => {
                    const n = i.instance[e];
                    t[e] = "function" == typeof n ? n.bind(t) : n;
                  }),
                  i.on &&
                    t.on &&
                    Object.keys(i.on).forEach((e) => {
                      t.on(e, i.on[e]);
                    }),
                  i.create && i.create.bind(t)(r);
              });
          }
          static set components(e) {
            this.use && this.use(e);
          }
          static installModule(e, ...t) {
            const n = this;
            n.prototype.modules || (n.prototype.modules = {});
            const i =
              e.name || `${Object.keys(n.prototype.modules).length}_${ks.now()}`;
            return (
              (n.prototype.modules[i] = e),
              e.proto &&
                Object.keys(e.proto).forEach((t) => {
                  n.prototype[t] = e.proto[t];
                }),
              e.static &&
                Object.keys(e.static).forEach((t) => {
                  n[t] = e.static[t];
                }),
              e.install && e.install.apply(n, t),
              n
            );
          }
          static use(e, ...t) {
            const n = this;
            return Array.isArray(e)
              ? (e.forEach((e) => n.installModule(e)), n)
              : n.installModule(e, ...t);
          }
        }
        var js = {
          updateSize: function () {
            const e = this;
            let t, n;
            const i = e.$el;
            (t = void 0 !== e.params.width ? e.params.width : i[0].clientWidth),
              (n =
                void 0 !== e.params.height ? e.params.height : i[0].clientHeight),
              (0 === t && e.isHorizontal()) ||
                (0 === n && e.isVertical()) ||
                ((t =
                  t -
                  parseInt(i.css("padding-left"), 10) -
                  parseInt(i.css("padding-right"), 10)),
                (n =
                  n -
                  parseInt(i.css("padding-top"), 10) -
                  parseInt(i.css("padding-bottom"), 10)),
                ks.extend(e, {
                  width: t,
                  height: n,
                  size: e.isHorizontal() ? t : n,
                }));
          },
          updateSlides: function () {
            const e = this,
              t = e.params,
              { $wrapperEl: n, size: i, rtlTranslate: r, wrongRTL: s } = e,
              a = e.virtual && t.virtual.enabled,
              o = a ? e.virtual.slides.length : e.slides.length,
              l = n.children(`.${e.params.slideClass}`),
              c = a ? e.virtual.slides.length : l.length;
            let d = [];
            const u = [],
              p = [];
            function h(e) {
              return !t.cssMode || e !== l.length - 1;
            }
            let f = t.slidesOffsetBefore;
            "function" == typeof f && (f = t.slidesOffsetBefore.call(e));
            let m = t.slidesOffsetAfter;
            "function" == typeof m && (m = t.slidesOffsetAfter.call(e));
            const v = e.snapGrid.length,
              y = e.snapGrid.length;
            let g,
              x,
              b = t.spaceBetween,
              w = -f,
              S = 0,
              C = 0;
            if (void 0 === i) return;
            "string" == typeof b &&
              b.indexOf("%") >= 0 &&
              (b = (parseFloat(b.replace("%", "")) / 100) * i),
              (e.virtualSize = -b),
              r
                ? l.css({ marginLeft: "", marginTop: "" })
                : l.css({ marginRight: "", marginBottom: "" }),
              t.slidesPerColumn > 1 &&
                ((g =
                  Math.floor(c / t.slidesPerColumn) ===
                  c / e.params.slidesPerColumn
                    ? c
                    : Math.ceil(c / t.slidesPerColumn) * t.slidesPerColumn),
                "auto" !== t.slidesPerView &&
                  "row" === t.slidesPerColumnFill &&
                  (g = Math.max(g, t.slidesPerView * t.slidesPerColumn)));
            const T = t.slidesPerColumn,
              _ = g / T,
              E = Math.floor(c / t.slidesPerColumn);
            for (let n = 0; n < c; n += 1) {
              x = 0;
              const r = l.eq(n);
              if (t.slidesPerColumn > 1) {
                let i, s, a;
                if ("row" === t.slidesPerColumnFill && t.slidesPerGroup > 1) {
                  const e = Math.floor(
                      n / (t.slidesPerGroup * t.slidesPerColumn)
                    ),
                    o = n - t.slidesPerColumn * t.slidesPerGroup * e,
                    l =
                      0 === e
                        ? t.slidesPerGroup
                        : Math.min(
                            Math.ceil((c - e * T * t.slidesPerGroup) / T),
                            t.slidesPerGroup
                          );
                  (a = Math.floor(o / l)),
                    (s = o - a * l + e * t.slidesPerGroup),
                    (i = s + (a * g) / T),
                    r.css({
                      "-webkit-box-ordinal-group": i,
                      "-moz-box-ordinal-group": i,
                      "-ms-flex-order": i,
                      "-webkit-order": i,
                      order: i,
                    });
                } else
                  "column" === t.slidesPerColumnFill
                    ? ((s = Math.floor(n / T)),
                      (a = n - s * T),
                      (s > E || (s === E && a === T - 1)) &&
                        ((a += 1), a >= T && ((a = 0), (s += 1))))
                    : ((a = Math.floor(n / _)), (s = n - a * _));
                r.css(
                  "margin-" + (e.isHorizontal() ? "top" : "left"),
                  0 !== a && t.spaceBetween && `${t.spaceBetween}px`
                );
              }
              if ("none" !== r.css("display")) {
                if ("auto" === t.slidesPerView) {
                  const n = Ss.getComputedStyle(r[0], null),
                    i = r[0].style.transform,
                    s = r[0].style.webkitTransform;
                  if (
                    (i && (r[0].style.transform = "none"),
                    s && (r[0].style.webkitTransform = "none"),
                    t.roundLengths)
                  )
                    x = e.isHorizontal() ? r.outerWidth(!0) : r.outerHeight(!0);
                  else if (e.isHorizontal()) {
                    const e = parseFloat(n.getPropertyValue("width")),
                      t = parseFloat(n.getPropertyValue("padding-left")),
                      i = parseFloat(n.getPropertyValue("padding-right")),
                      r = parseFloat(n.getPropertyValue("margin-left")),
                      s = parseFloat(n.getPropertyValue("margin-right")),
                      a = n.getPropertyValue("box-sizing");
                    x = a && "border-box" === a ? e + r + s : e + t + i + r + s;
                  } else {
                    const e = parseFloat(n.getPropertyValue("height")),
                      t = parseFloat(n.getPropertyValue("padding-top")),
                      i = parseFloat(n.getPropertyValue("padding-bottom")),
                      r = parseFloat(n.getPropertyValue("margin-top")),
                      s = parseFloat(n.getPropertyValue("margin-bottom")),
                      a = n.getPropertyValue("box-sizing");
                    x = a && "border-box" === a ? e + r + s : e + t + i + r + s;
                  }
                  i && (r[0].style.transform = i),
                    s && (r[0].style.webkitTransform = s),
                    t.roundLengths && (x = Math.floor(x));
                } else
                  (x = (i - (t.slidesPerView - 1) * b) / t.slidesPerView),
                    t.roundLengths && (x = Math.floor(x)),
                    l[n] &&
                      (e.isHorizontal()
                        ? (l[n].style.width = `${x}px`)
                        : (l[n].style.height = `${x}px`));
                l[n] && (l[n].swiperSlideSize = x),
                  p.push(x),
                  t.centeredSlides
                    ? ((w = w + x / 2 + S / 2 + b),
                      0 === S && 0 !== n && (w = w - i / 2 - b),
                      0 === n && (w = w - i / 2 - b),
                      Math.abs(w) < 0.001 && (w = 0),
                      t.roundLengths && (w = Math.floor(w)),
                      C % t.slidesPerGroup == 0 && d.push(w),
                      u.push(w))
                    : (t.roundLengths && (w = Math.floor(w)),
                      (C - Math.min(e.params.slidesPerGroupSkip, C)) %
                        e.params.slidesPerGroup ==
                        0 && d.push(w),
                      u.push(w),
                      (w = w + x + b)),
                  (e.virtualSize += x + b),
                  (S = x),
                  (C += 1);
              }
            }
            let k;
            if (
              ((e.virtualSize = Math.max(e.virtualSize, i) + m),
              r &&
                s &&
                ("slide" === t.effect || "coverflow" === t.effect) &&
                n.css({ width: `${e.virtualSize + t.spaceBetween}px` }),
              t.setWrapperSize &&
                (e.isHorizontal()
                  ? n.css({ width: `${e.virtualSize + t.spaceBetween}px` })
                  : n.css({ height: `${e.virtualSize + t.spaceBetween}px` })),
              t.slidesPerColumn > 1 &&
                ((e.virtualSize = (x + t.spaceBetween) * g),
                (e.virtualSize =
                  Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween),
                e.isHorizontal()
                  ? n.css({ width: `${e.virtualSize + t.spaceBetween}px` })
                  : n.css({ height: `${e.virtualSize + t.spaceBetween}px` }),
                t.centeredSlides))
            ) {
              k = [];
              for (let n = 0; n < d.length; n += 1) {
                let i = d[n];
                t.roundLengths && (i = Math.floor(i)),
                  d[n] < e.virtualSize + d[0] && k.push(i);
              }
              d = k;
            }
            if (!t.centeredSlides) {
              k = [];
              for (let n = 0; n < d.length; n += 1) {
                let r = d[n];
                t.roundLengths && (r = Math.floor(r)),
                  d[n] <= e.virtualSize - i && k.push(r);
              }
              (d = k),
                Math.floor(e.virtualSize - i) - Math.floor(d[d.length - 1]) > 1 &&
                  d.push(e.virtualSize - i);
            }
            if (
              (0 === d.length && (d = [0]),
              0 !== t.spaceBetween &&
                (e.isHorizontal()
                  ? r
                    ? l.filter(h).css({ marginLeft: `${b}px` })
                    : l.filter(h).css({ marginRight: `${b}px` })
                  : l.filter(h).css({ marginBottom: `${b}px` })),
              t.centeredSlides && t.centeredSlidesBounds)
            ) {
              let e = 0;
              p.forEach((n) => {
                e += n + (t.spaceBetween ? t.spaceBetween : 0);
              }),
                (e -= t.spaceBetween);
              const n = e - i;
              d = d.map((e) => (e < 0 ? -f : e > n ? n + m : e));
            }
            if (t.centerInsufficientSlides) {
              let e = 0;
              if (
                (p.forEach((n) => {
                  e += n + (t.spaceBetween ? t.spaceBetween : 0);
                }),
                (e -= t.spaceBetween),
                e < i)
              ) {
                const t = (i - e) / 2;
                d.forEach((e, n) => {
                  d[n] = e - t;
                }),
                  u.forEach((e, n) => {
                    u[n] = e + t;
                  });
              }
            }
            ks.extend(e, {
              slides: l,
              snapGrid: d,
              slidesGrid: u,
              slidesSizesGrid: p,
            }),
              c !== o && e.emit("slidesLengthChange"),
              d.length !== v &&
                (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              u.length !== y && e.emit("slidesGridLengthChange"),
              (t.watchSlidesProgress || t.watchSlidesVisibility) &&
                e.updateSlidesOffset();
          },
          updateAutoHeight: function (e) {
            const t = this,
              n = [];
            let i,
              r = 0;
            if (
              ("number" == typeof e
                ? t.setTransition(e)
                : !0 === e && t.setTransition(t.params.speed),
              "auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
            )
              if (t.params.centeredSlides)
                t.visibleSlides.each((e, t) => {
                  n.push(t);
                });
              else
                for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                  const e = t.activeIndex + i;
                  if (e > t.slides.length) break;
                  n.push(t.slides.eq(e)[0]);
                }
            else n.push(t.slides.eq(t.activeIndex)[0]);
            for (i = 0; i < n.length; i += 1)
              if (void 0 !== n[i]) {
                const e = n[i].offsetHeight;
                r = e > r ? e : r;
              }
            r && t.$wrapperEl.css("height", `${r}px`);
          },
          updateSlidesOffset: function () {
            const e = this,
              t = e.slides;
            for (let n = 0; n < t.length; n += 1)
              t[n].swiperSlideOffset = e.isHorizontal()
                ? t[n].offsetLeft
                : t[n].offsetTop;
          },
          updateSlidesProgress: function (e = (this && this.translate) || 0) {
            const t = this,
              n = t.params,
              { slides: i, rtlTranslate: r } = t;
            if (0 === i.length) return;
            void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
            let s = -e;
            r && (s = e),
              i.removeClass(n.slideVisibleClass),
              (t.visibleSlidesIndexes = []),
              (t.visibleSlides = []);
            for (let e = 0; e < i.length; e += 1) {
              const a = i[e],
                o =
                  (s +
                    (n.centeredSlides ? t.minTranslate() : 0) -
                    a.swiperSlideOffset) /
                  (a.swiperSlideSize + n.spaceBetween);
              if (n.watchSlidesVisibility || (n.centeredSlides && n.autoHeight)) {
                const r = -(s - a.swiperSlideOffset),
                  o = r + t.slidesSizesGrid[e];
                ((r >= 0 && r < t.size - 1) ||
                  (o > 1 && o <= t.size) ||
                  (r <= 0 && o >= t.size)) &&
                  (t.visibleSlides.push(a),
                  t.visibleSlidesIndexes.push(e),
                  i.eq(e).addClass(n.slideVisibleClass));
              }
              a.progress = r ? -o : o;
            }
            t.visibleSlides = Ts(t.visibleSlides);
          },
          updateProgress: function (e) {
            const t = this;
            if (void 0 === e) {
              const n = t.rtlTranslate ? -1 : 1;
              e = (t && t.translate && t.translate * n) || 0;
            }
            const n = t.params,
              i = t.maxTranslate() - t.minTranslate();
            let { progress: r, isBeginning: s, isEnd: a } = t;
            const o = s,
              l = a;
            0 === i
              ? ((r = 0), (s = !0), (a = !0))
              : ((r = (e - t.minTranslate()) / i), (s = r <= 0), (a = r >= 1)),
              ks.extend(t, { progress: r, isBeginning: s, isEnd: a }),
              (n.watchSlidesProgress ||
                n.watchSlidesVisibility ||
                (n.centeredSlides && n.autoHeight)) &&
                t.updateSlidesProgress(e),
              s && !o && t.emit("reachBeginning toEdge"),
              a && !l && t.emit("reachEnd toEdge"),
              ((o && !s) || (l && !a)) && t.emit("fromEdge"),
              t.emit("progress", r);
          },
          updateSlidesClasses: function () {
            const e = this,
              {
                slides: t,
                params: n,
                $wrapperEl: i,
                activeIndex: r,
                realIndex: s,
              } = e,
              a = e.virtual && n.virtual.enabled;
            let o;
            t.removeClass(
              `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
            ),
              (o = a
                ? e.$wrapperEl.find(
                    `.${n.slideClass}[data-swiper-slide-index="${r}"]`
                  )
                : t.eq(r)),
              o.addClass(n.slideActiveClass),
              n.loop &&
                (o.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${s}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass)
                  : i
                      .children(
                        `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${s}"]`
                      )
                      .addClass(n.slideDuplicateActiveClass));
            let l = o
              .nextAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slideNextClass);
            n.loop &&
              0 === l.length &&
              ((l = t.eq(0)), l.addClass(n.slideNextClass));
            let c = o
              .prevAll(`.${n.slideClass}`)
              .eq(0)
              .addClass(n.slidePrevClass);
            n.loop &&
              0 === c.length &&
              ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
              n.loop &&
                (l.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${l.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicateNextClass),
                c.hasClass(n.slideDuplicateClass)
                  ? i
                      .children(
                        `.${n.slideClass}:not(.${
                          n.slideDuplicateClass
                        })[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass)
                  : i
                      .children(
                        `.${n.slideClass}.${
                          n.slideDuplicateClass
                        }[data-swiper-slide-index="${c.attr(
                          "data-swiper-slide-index"
                        )}"]`
                      )
                      .addClass(n.slideDuplicatePrevClass));
          },
          updateActiveIndex: function (e) {
            const t = this,
              n = t.rtlTranslate ? t.translate : -t.translate,
              {
                slidesGrid: i,
                snapGrid: r,
                params: s,
                activeIndex: a,
                realIndex: o,
                snapIndex: l,
              } = t;
            let c,
              d = e;
            if (void 0 === d) {
              for (let e = 0; e < i.length; e += 1)
                void 0 !== i[e + 1]
                  ? n >= i[e] && n < i[e + 1] - (i[e + 1] - i[e]) / 2
                    ? (d = e)
                    : n >= i[e] && n < i[e + 1] && (d = e + 1)
                  : n >= i[e] && (d = e);
              s.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
            }
            if (r.indexOf(n) >= 0) c = r.indexOf(n);
            else {
              const e = Math.min(s.slidesPerGroupSkip, d);
              c = e + Math.floor((d - e) / s.slidesPerGroup);
            }
            if ((c >= r.length && (c = r.length - 1), d === a))
              return void (
                c !== l && ((t.snapIndex = c), t.emit("snapIndexChange"))
              );
            const u = parseInt(
              t.slides.eq(d).attr("data-swiper-slide-index") || d,
              10
            );
            ks.extend(t, {
              snapIndex: c,
              realIndex: u,
              previousIndex: a,
              activeIndex: d,
            }),
              t.emit("activeIndexChange"),
              t.emit("snapIndexChange"),
              o !== u && t.emit("realIndexChange"),
              (t.initialized || t.params.runCallbacksOnInit) &&
                t.emit("slideChange");
          },
          updateClickedSlide: function (e) {
            const t = this,
              n = t.params,
              i = Ts(e.target).closest(`.${n.slideClass}`)[0];
            let r = !1;
            if (i)
              for (let e = 0; e < t.slides.length; e += 1)
                t.slides[e] === i && (r = !0);
            if (!i || !r)
              return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = i),
              t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(
                    Ts(i).attr("data-swiper-slide-index"),
                    10
                  ))
                : (t.clickedIndex = Ts(i).index()),
              n.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
          },
        };
        var As = {
          getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
            const {
              params: t,
              rtlTranslate: n,
              translate: i,
              $wrapperEl: r,
            } = this;
            if (t.virtualTranslate) return n ? -i : i;
            if (t.cssMode) return i;
            let s = ks.getTranslate(r[0], e);
            return n && (s = -s), s || 0;
          },
          setTranslate: function (e, t) {
            const n = this,
              {
                rtlTranslate: i,
                params: r,
                $wrapperEl: s,
                wrapperEl: a,
                progress: o,
              } = n;
            let l,
              c = 0,
              d = 0;
            n.isHorizontal() ? (c = i ? -e : e) : (d = e),
              r.roundLengths && ((c = Math.floor(c)), (d = Math.floor(d))),
              r.cssMode
                ? (a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                    n.isHorizontal() ? -c : -d)
                : r.virtualTranslate ||
                  s.transform(`translate3d(${c}px, ${d}px, 0px)`),
              (n.previousTranslate = n.translate),
              (n.translate = n.isHorizontal() ? c : d);
            const u = n.maxTranslate() - n.minTranslate();
            (l = 0 === u ? 0 : (e - n.minTranslate()) / u),
              l !== o && n.updateProgress(e),
              n.emit("setTranslate", n.translate, t);
          },
          minTranslate: function () {
            return -this.snapGrid[0];
          },
          maxTranslate: function () {
            return -this.snapGrid[this.snapGrid.length - 1];
          },
          translateTo: function (
            e = 0,
            t = this.params.speed,
            n = !0,
            i = !0,
            r
          ) {
            const s = this,
              { params: a, wrapperEl: o } = s;
            if (s.animating && a.preventInteractionOnTransition) return !1;
            const l = s.minTranslate(),
              c = s.maxTranslate();
            let d;
            if (
              ((d = i && e > l ? l : i && e < c ? c : e),
              s.updateProgress(d),
              a.cssMode)
            ) {
              const e = s.isHorizontal();
              return (
                0 === t
                  ? (o[e ? "scrollLeft" : "scrollTop"] = -d)
                  : o.scrollTo
                  ? o.scrollTo({ [e ? "left" : "top"]: -d, behavior: "smooth" })
                  : (o[e ? "scrollLeft" : "scrollTop"] = -d),
                !0
              );
            }
            return (
              0 === t
                ? (s.setTransition(0),
                  s.setTranslate(d),
                  n &&
                    (s.emit("beforeTransitionStart", t, r),
                    s.emit("transitionEnd")))
                : (s.setTransition(t),
                  s.setTranslate(d),
                  n &&
                    (s.emit("beforeTransitionStart", t, r),
                    s.emit("transitionStart")),
                  s.animating ||
                    ((s.animating = !0),
                    s.onTranslateToWrapperTransitionEnd ||
                      (s.onTranslateToWrapperTransitionEnd = function (e) {
                        s &&
                          !s.destroyed &&
                          e.target === this &&
                          (s.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          s.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            s.onTranslateToWrapperTransitionEnd
                          ),
                          (s.onTranslateToWrapperTransitionEnd = null),
                          delete s.onTranslateToWrapperTransitionEnd,
                          n && s.emit("transitionEnd"));
                      }),
                    s.$wrapperEl[0].addEventListener(
                      "transitionend",
                      s.onTranslateToWrapperTransitionEnd
                    ),
                    s.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      s.onTranslateToWrapperTransitionEnd
                    ))),
              !0
            );
          },
        };
        var Ls = {
          setTransition: function (e, t) {
            const n = this;
            n.params.cssMode || n.$wrapperEl.transition(e),
              n.emit("setTransition", e, t);
          },
          transitionStart: function (e = !0, t) {
            const n = this,
              { activeIndex: i, params: r, previousIndex: s } = n;
            if (r.cssMode) return;
            r.autoHeight && n.updateAutoHeight();
            let a = t;
            if (
              (a || (a = i > s ? "next" : i < s ? "prev" : "reset"),
              n.emit("transitionStart"),
              e && i !== s)
            ) {
              if ("reset" === a) return void n.emit("slideResetTransitionStart");
              n.emit("slideChangeTransitionStart"),
                "next" === a
                  ? n.emit("slideNextTransitionStart")
                  : n.emit("slidePrevTransitionStart");
            }
          },
          transitionEnd: function (e = !0, t) {
            const n = this,
              { activeIndex: i, previousIndex: r, params: s } = n;
            if (((n.animating = !1), s.cssMode)) return;
            n.setTransition(0);
            let a = t;
            if (
              (a || (a = i > r ? "next" : i < r ? "prev" : "reset"),
              n.emit("transitionEnd"),
              e && i !== r)
            ) {
              if ("reset" === a) return void n.emit("slideResetTransitionEnd");
              n.emit("slideChangeTransitionEnd"),
                "next" === a
                  ? n.emit("slideNextTransitionEnd")
                  : n.emit("slidePrevTransitionEnd");
            }
          },
        };
        var Is = {
          slideTo: function (e = 0, t = this.params.speed, n = !0, i) {
            const r = this;
            let s = e;
            s < 0 && (s = 0);
            const {
              params: a,
              snapGrid: o,
              slidesGrid: l,
              previousIndex: c,
              activeIndex: d,
              rtlTranslate: u,
              wrapperEl: p,
            } = r;
            if (r.animating && a.preventInteractionOnTransition) return !1;
            const h = Math.min(r.params.slidesPerGroupSkip, s);
            let f = h + Math.floor((s - h) / r.params.slidesPerGroup);
            f >= o.length && (f = o.length - 1),
              (d || a.initialSlide || 0) === (c || 0) &&
                n &&
                r.emit("beforeSlideChangeStart");
            const m = -o[f];
            if ((r.updateProgress(m), a.normalizeSlideIndex))
              for (let e = 0; e < l.length; e += 1)
                -Math.floor(100 * m) >= Math.floor(100 * l[e]) && (s = e);
            if (r.initialized && s !== d) {
              if (!r.allowSlideNext && m < r.translate && m < r.minTranslate())
                return !1;
              if (
                !r.allowSlidePrev &&
                m > r.translate &&
                m > r.maxTranslate() &&
                (d || 0) !== s
              )
                return !1;
            }
            let v;
            if (
              ((v = s > d ? "next" : s < d ? "prev" : "reset"),
              (u && -m === r.translate) || (!u && m === r.translate))
            )
              return (
                r.updateActiveIndex(s),
                a.autoHeight && r.updateAutoHeight(),
                r.updateSlidesClasses(),
                "slide" !== a.effect && r.setTranslate(m),
                "reset" !== v && (r.transitionStart(n, v), r.transitionEnd(n, v)),
                !1
              );
            if (a.cssMode) {
              const e = r.isHorizontal();
              let n = -m;
              return (
                u && (n = p.scrollWidth - p.offsetWidth - n),
                0 === t
                  ? (p[e ? "scrollLeft" : "scrollTop"] = n)
                  : p.scrollTo
                  ? p.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" })
                  : (p[e ? "scrollLeft" : "scrollTop"] = n),
                !0
              );
            }
            return (
              0 === t
                ? (r.setTransition(0),
                  r.setTranslate(m),
                  r.updateActiveIndex(s),
                  r.updateSlidesClasses(),
                  r.emit("beforeTransitionStart", t, i),
                  r.transitionStart(n, v),
                  r.transitionEnd(n, v))
                : (r.setTransition(t),
                  r.setTranslate(m),
                  r.updateActiveIndex(s),
                  r.updateSlidesClasses(),
                  r.emit("beforeTransitionStart", t, i),
                  r.transitionStart(n, v),
                  r.animating ||
                    ((r.animating = !0),
                    r.onSlideToWrapperTransitionEnd ||
                      (r.onSlideToWrapperTransitionEnd = function (e) {
                        r &&
                          !r.destroyed &&
                          e.target === this &&
                          (r.$wrapperEl[0].removeEventListener(
                            "transitionend",
                            r.onSlideToWrapperTransitionEnd
                          ),
                          r.$wrapperEl[0].removeEventListener(
                            "webkitTransitionEnd",
                            r.onSlideToWrapperTransitionEnd
                          ),
                          (r.onSlideToWrapperTransitionEnd = null),
                          delete r.onSlideToWrapperTransitionEnd,
                          r.transitionEnd(n, v));
                      }),
                    r.$wrapperEl[0].addEventListener(
                      "transitionend",
                      r.onSlideToWrapperTransitionEnd
                    ),
                    r.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      r.onSlideToWrapperTransitionEnd
                    ))),
              !0
            );
          },
          slideToLoop: function (e = 0, t = this.params.speed, n = !0, i) {
            const r = this;
            let s = e;
            return r.params.loop && (s += r.loopedSlides), r.slideTo(s, t, n, i);
          },
          slideNext: function (e = this.params.speed, t = !0, n) {
            const i = this,
              { params: r, animating: s } = i,
              a = i.activeIndex < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup;
            if (r.loop) {
              if (s) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }
            return i.slideTo(i.activeIndex + a, e, t, n);
          },
          slidePrev: function (e = this.params.speed, t = !0, n) {
            const i = this,
              {
                params: r,
                animating: s,
                snapGrid: a,
                slidesGrid: o,
                rtlTranslate: l,
              } = i;
            if (r.loop) {
              if (s) return !1;
              i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft);
            }
            function c(e) {
              return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            const d = c(l ? i.translate : -i.translate),
              u = a.map((e) => c(e));
            o.map((e) => c(e)), a[u.indexOf(d)];
            let p,
              h = a[u.indexOf(d) - 1];
            return (
              void 0 === h &&
                r.cssMode &&
                a.forEach((e) => {
                  !h && d >= e && (h = e);
                }),
              void 0 !== h &&
                ((p = o.indexOf(h)), p < 0 && (p = i.activeIndex - 1)),
              i.slideTo(p, e, t, n)
            );
          },
          slideReset: function (e = this.params.speed, t = !0, n) {
            return this.slideTo(this.activeIndex, e, t, n);
          },
          slideToClosest: function (e = this.params.speed, t = !0, n, i = 0.5) {
            const r = this;
            let s = r.activeIndex;
            const a = Math.min(r.params.slidesPerGroupSkip, s),
              o = a + Math.floor((s - a) / r.params.slidesPerGroup),
              l = r.rtlTranslate ? r.translate : -r.translate;
            if (l >= r.snapGrid[o]) {
              const e = r.snapGrid[o];
              l - e > (r.snapGrid[o + 1] - e) * i &&
                (s += r.params.slidesPerGroup);
            } else {
              const e = r.snapGrid[o - 1];
              l - e <= (r.snapGrid[o] - e) * i && (s -= r.params.slidesPerGroup);
            }
            return (
              (s = Math.max(s, 0)),
              (s = Math.min(s, r.slidesGrid.length - 1)),
              r.slideTo(s, e, t, n)
            );
          },
          slideToClickedSlide: function () {
            const e = this,
              { params: t, $wrapperEl: n } = e,
              i =
                "auto" === t.slidesPerView
                  ? e.slidesPerViewDynamic()
                  : t.slidesPerView;
            let r,
              s = e.clickedIndex;
            if (t.loop) {
              if (e.animating) return;
              (r = parseInt(
                Ts(e.clickedSlide).attr("data-swiper-slide-index"),
                10
              )),
                t.centeredSlides
                  ? s < e.loopedSlides - i / 2 ||
                    s > e.slides.length - e.loopedSlides + i / 2
                    ? (e.loopFix(),
                      (s = n
                        .children(
                          `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                        )
                        .eq(0)
                        .index()),
                      ks.nextTick(() => {
                        e.slideTo(s);
                      }))
                    : e.slideTo(s)
                  : s > e.slides.length - i
                  ? (e.loopFix(),
                    (s = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${r}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    ks.nextTick(() => {
                      e.slideTo(s);
                    }))
                  : e.slideTo(s);
            } else e.slideTo(s);
          },
        };
        var Os = {
          loopCreate: function () {
            const e = this,
              { params: t, $wrapperEl: n } = e;
            n.children(`.${t.slideClass}.${t.slideDuplicateClass}`).remove();
            let i = n.children(`.${t.slideClass}`);
            if (t.loopFillGroupWithBlank) {
              const e = t.slidesPerGroup - (i.length % t.slidesPerGroup);
              if (e !== t.slidesPerGroup) {
                for (let i = 0; i < e; i += 1) {
                  const e = Ts(bs.createElement("div")).addClass(
                    `${t.slideClass} ${t.slideBlankClass}`
                  );
                  n.append(e);
                }
                i = n.children(`.${t.slideClass}`);
              }
            }
            "auto" !== t.slidesPerView ||
              t.loopedSlides ||
              (t.loopedSlides = i.length),
              (e.loopedSlides = Math.ceil(
                parseFloat(t.loopedSlides || t.slidesPerView, 10)
              )),
              (e.loopedSlides += t.loopAdditionalSlides),
              e.loopedSlides > i.length && (e.loopedSlides = i.length);
            const r = [],
              s = [];
            i.each((t, n) => {
              const a = Ts(n);
              t < e.loopedSlides && s.push(n),
                t < i.length && t >= i.length - e.loopedSlides && r.push(n),
                a.attr("data-swiper-slide-index", t);
            });
            for (let e = 0; e < s.length; e += 1)
              n.append(Ts(s[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
            for (let e = r.length - 1; e >= 0; e -= 1)
              n.prepend(Ts(r[e].cloneNode(!0)).addClass(t.slideDuplicateClass));
          },
          loopFix: function () {
            const e = this;
            e.emit("beforeLoopFix");
            const {
              activeIndex: t,
              slides: n,
              loopedSlides: i,
              allowSlidePrev: r,
              allowSlideNext: s,
              snapGrid: a,
              rtlTranslate: o,
            } = e;
            let l;
            (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
            const c = -a[t] - e.getTranslate();
            if (t < i) {
              (l = n.length - 3 * i + t), (l += i);
              e.slideTo(l, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((o ? -e.translate : e.translate) - c);
            } else if (t >= n.length - i) {
              (l = -n.length + t + i), (l += i);
              e.slideTo(l, 0, !1, !0) &&
                0 !== c &&
                e.setTranslate((o ? -e.translate : e.translate) - c);
            }
            (e.allowSlidePrev = r), (e.allowSlideNext = s), e.emit("loopFix");
          },
          loopDestroy: function () {
            const { $wrapperEl: e, params: t, slides: n } = this;
            e
              .children(
                `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
              )
              .remove(),
              n.removeAttr("data-swiper-slide-index");
          },
        };
        var Ps = {
          setGrabCursor: function (e) {
            const t = this;
            if (
              $s.touch ||
              !t.params.simulateTouch ||
              (t.params.watchOverflow && t.isLocked) ||
              t.params.cssMode
            )
              return;
            const n = t.el;
            (n.style.cursor = "move"),
              (n.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
              (n.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
              (n.style.cursor = e ? "grabbing" : "grab");
          },
          unsetGrabCursor: function () {
            const e = this;
            $s.touch ||
              (e.params.watchOverflow && e.isLocked) ||
              e.params.cssMode ||
              (e.el.style.cursor = "");
          },
        };
        var Ds = {
          appendSlide: function (e) {
            const t = this,
              { $wrapperEl: n, params: i } = t;
            if (
              (i.loop && t.loopDestroy(), "object" == typeof e && "length" in e)
            )
              for (let t = 0; t < e.length; t += 1) e[t] && n.append(e[t]);
            else n.append(e);
            i.loop && t.loopCreate(), (i.observer && $s.observer) || t.update();
          },
          prependSlide: function (e) {
            const t = this,
              { params: n, $wrapperEl: i, activeIndex: r } = t;
            n.loop && t.loopDestroy();
            let s = r + 1;
            if ("object" == typeof e && "length" in e) {
              for (let t = 0; t < e.length; t += 1) e[t] && i.prepend(e[t]);
              s = r + e.length;
            } else i.prepend(e);
            n.loop && t.loopCreate(),
              (n.observer && $s.observer) || t.update(),
              t.slideTo(s, 0, !1);
          },
          addSlide: function (e, t) {
            const n = this,
              { $wrapperEl: i, params: r, activeIndex: s } = n;
            let a = s;
            r.loop &&
              ((a -= n.loopedSlides),
              n.loopDestroy(),
              (n.slides = i.children(`.${r.slideClass}`)));
            const o = n.slides.length;
            if (e <= 0) return void n.prependSlide(t);
            if (e >= o) return void n.appendSlide(t);
            let l = a > e ? a + 1 : a;
            const c = [];
            for (let t = o - 1; t >= e; t -= 1) {
              const e = n.slides.eq(t);
              e.remove(), c.unshift(e);
            }
            if ("object" == typeof t && "length" in t) {
              for (let e = 0; e < t.length; e += 1) t[e] && i.append(t[e]);
              l = a > e ? a + t.length : a;
            } else i.append(t);
            for (let e = 0; e < c.length; e += 1) i.append(c[e]);
            r.loop && n.loopCreate(),
              (r.observer && $s.observer) || n.update(),
              r.loop ? n.slideTo(l + n.loopedSlides, 0, !1) : n.slideTo(l, 0, !1);
          },
          removeSlide: function (e) {
            const t = this,
              { params: n, $wrapperEl: i, activeIndex: r } = t;
            let s = r;
            n.loop &&
              ((s -= t.loopedSlides),
              t.loopDestroy(),
              (t.slides = i.children(`.${n.slideClass}`)));
            let a,
              o = s;
            if ("object" == typeof e && "length" in e) {
              for (let n = 0; n < e.length; n += 1)
                (a = e[n]),
                  t.slides[a] && t.slides.eq(a).remove(),
                  a < o && (o -= 1);
              o = Math.max(o, 0);
            } else
              (a = e),
                t.slides[a] && t.slides.eq(a).remove(),
                a < o && (o -= 1),
                (o = Math.max(o, 0));
            n.loop && t.loopCreate(),
              (n.observer && $s.observer) || t.update(),
              n.loop ? t.slideTo(o + t.loopedSlides, 0, !1) : t.slideTo(o, 0, !1);
          },
          removeAllSlides: function () {
            const e = this,
              t = [];
            for (let n = 0; n < e.slides.length; n += 1) t.push(n);
            e.removeSlide(t);
          },
        };
        const zs = (function () {
          const e = Ss.navigator.platform,
            t = Ss.navigator.userAgent,
            n = {
              ios: !1,
              android: !1,
              androidChrome: !1,
              desktop: !1,
              iphone: !1,
              ipod: !1,
              ipad: !1,
              edge: !1,
              ie: !1,
              firefox: !1,
              macos: !1,
              windows: !1,
              cordova: !(!Ss.cordova && !Ss.phonegap),
              phonegap: !(!Ss.cordova && !Ss.phonegap),
              electron: !1,
            },
            i = Ss.screen.width,
            r = Ss.screen.height,
            s = t.match(/(Android);?[\s\/]+([\d.]+)?/);
          let a = t.match(/(iPad).*OS\s([\d_]+)/);
          const o = t.match(/(iPod)(.*OS\s([\d_]+))?/),
            l = !a && t.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            c = t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0,
            d = t.indexOf("Edge/") >= 0,
            u = t.indexOf("Gecko/") >= 0 && t.indexOf("Firefox/") >= 0,
            p = "Win32" === e,
            h = t.toLowerCase().indexOf("electron") >= 0;
          let f = "MacIntel" === e;
          return (
            !a &&
              f &&
              $s.touch &&
              ((1024 === i && 1366 === r) ||
                (834 === i && 1194 === r) ||
                (834 === i && 1112 === r) ||
                (768 === i && 1024 === r)) &&
              ((a = t.match(/(Version)\/([\d.]+)/)), (f = !1)),
            (n.ie = c),
            (n.edge = d),
            (n.firefox = u),
            s &&
              !p &&
              ((n.os = "android"),
              (n.osVersion = s[2]),
              (n.android = !0),
              (n.androidChrome = t.toLowerCase().indexOf("chrome") >= 0)),
            (a || l || o) && ((n.os = "ios"), (n.ios = !0)),
            l && !o && ((n.osVersion = l[2].replace(/_/g, ".")), (n.iphone = !0)),
            a && ((n.osVersion = a[2].replace(/_/g, ".")), (n.ipad = !0)),
            o &&
              ((n.osVersion = o[3] ? o[3].replace(/_/g, ".") : null),
              (n.ipod = !0)),
            n.ios &&
              n.osVersion &&
              t.indexOf("Version/") >= 0 &&
              "10" === n.osVersion.split(".")[0] &&
              (n.osVersion = t.toLowerCase().split("version/")[1].split(" ")[0]),
            (n.webView =
              !(
                !(l || a || o) ||
                (!t.match(/.*AppleWebKit(?!.*Safari)/i) &&
                  !Ss.navigator.standalone)
              ) ||
              (Ss.matchMedia &&
                Ss.matchMedia("(display-mode: standalone)").matches)),
            (n.webview = n.webView),
            (n.standalone = n.webView),
            (n.desktop = !(n.ios || n.android) || h),
            n.desktop &&
              ((n.electron = h),
              (n.macos = f),
              (n.windows = p),
              n.macos && (n.os = "macos"),
              n.windows && (n.os = "windows")),
            (n.pixelRatio = Ss.devicePixelRatio || 1),
            n
          );
        })();
        function Ns(e) {
          const t = this,
            n = t.touchEventsData,
            { params: i, touches: r } = t;
          if (t.animating && i.preventInteractionOnTransition) return;
          let s = e;
          s.originalEvent && (s = s.originalEvent);
          const a = Ts(s.target);
          if ("wrapper" === i.touchEventsTarget && !a.closest(t.wrapperEl).length)
            return;
          if (
            ((n.isTouchEvent = "touchstart" === s.type),
            !n.isTouchEvent && "which" in s && 3 === s.which)
          )
            return;
          if (!n.isTouchEvent && "button" in s && s.button > 0) return;
          if (n.isTouched && n.isMoved) return;
          if (
            i.noSwiping &&
            a.closest(
              i.noSwipingSelector ? i.noSwipingSelector : `.${i.noSwipingClass}`
            )[0]
          )
            return void (t.allowClick = !0);
          if (i.swipeHandler && !a.closest(i.swipeHandler)[0]) return;
          (r.currentX =
            "touchstart" === s.type ? s.targetTouches[0].pageX : s.pageX),
            (r.currentY =
              "touchstart" === s.type ? s.targetTouches[0].pageY : s.pageY);
          const o = r.currentX,
            l = r.currentY,
            c = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
            d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
          if (!c || !(o <= d || o >= Ss.screen.width - d)) {
            if (
              (ks.extend(n, {
                isTouched: !0,
                isMoved: !1,
                allowTouchCallbacks: !0,
                isScrolling: void 0,
                startMoving: void 0,
              }),
              (r.startX = o),
              (r.startY = l),
              (n.touchStartTime = ks.now()),
              (t.allowClick = !0),
              t.updateSize(),
              (t.swipeDirection = void 0),
              i.threshold > 0 && (n.allowThresholdMove = !1),
              "touchstart" !== s.type)
            ) {
              let e = !0;
              a.is(n.formElements) && (e = !1),
                bs.activeElement &&
                  Ts(bs.activeElement).is(n.formElements) &&
                  bs.activeElement !== a[0] &&
                  bs.activeElement.blur();
              const r = e && t.allowTouchMove && i.touchStartPreventDefault;
              (i.touchStartForcePreventDefault || r) && s.preventDefault();
            }
            t.emit("touchStart", s);
          }
        }
        function qs(e) {
          const t = this,
            n = t.touchEventsData,
            { params: i, touches: r, rtlTranslate: s } = t;
          let a = e;
          if ((a.originalEvent && (a = a.originalEvent), !n.isTouched))
            return void (
              n.startMoving &&
              n.isScrolling &&
              t.emit("touchMoveOpposite", a)
            );
          if (n.isTouchEvent && "touchmove" !== a.type) return;
          const o =
              "touchmove" === a.type &&
              a.targetTouches &&
              (a.targetTouches[0] || a.changedTouches[0]),
            l = "touchmove" === a.type ? o.pageX : a.pageX,
            c = "touchmove" === a.type ? o.pageY : a.pageY;
          if (a.preventedByNestedSwiper)
            return (r.startX = l), void (r.startY = c);
          if (!t.allowTouchMove)
            return (
              (t.allowClick = !1),
              void (
                n.isTouched &&
                (ks.extend(r, { startX: l, startY: c, currentX: l, currentY: c }),
                (n.touchStartTime = ks.now()))
              )
            );
          if (n.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
            if (t.isVertical()) {
              if (
                (c < r.startY && t.translate <= t.maxTranslate()) ||
                (c > r.startY && t.translate >= t.minTranslate())
              )
                return (n.isTouched = !1), void (n.isMoved = !1);
            } else if (
              (l < r.startX && t.translate <= t.maxTranslate()) ||
              (l > r.startX && t.translate >= t.minTranslate())
            )
              return;
          if (
            n.isTouchEvent &&
            bs.activeElement &&
            a.target === bs.activeElement &&
            Ts(a.target).is(n.formElements)
          )
            return (n.isMoved = !0), void (t.allowClick = !1);
          if (
            (n.allowTouchCallbacks && t.emit("touchMove", a),
            a.targetTouches && a.targetTouches.length > 1)
          )
            return;
          (r.currentX = l), (r.currentY = c);
          const d = r.currentX - r.startX,
            u = r.currentY - r.startY;
          if (
            t.params.threshold &&
            Math.sqrt(d ** 2 + u ** 2) < t.params.threshold
          )
            return;
          if (void 0 === n.isScrolling) {
            let e;
            (t.isHorizontal() && r.currentY === r.startY) ||
            (t.isVertical() && r.currentX === r.startX)
              ? (n.isScrolling = !1)
              : d * d + u * u >= 25 &&
                ((e = (180 * Math.atan2(Math.abs(u), Math.abs(d))) / Math.PI),
                (n.isScrolling = t.isHorizontal()
                  ? e > i.touchAngle
                  : 90 - e > i.touchAngle));
          }
          if (
            (n.isScrolling && t.emit("touchMoveOpposite", a),
            void 0 === n.startMoving &&
              ((r.currentX === r.startX && r.currentY === r.startY) ||
                (n.startMoving = !0)),
            n.isScrolling)
          )
            return void (n.isTouched = !1);
          if (!n.startMoving) return;
          (t.allowClick = !1),
            !i.cssMode && a.cancelable && a.preventDefault(),
            i.touchMoveStopPropagation && !i.nested && a.stopPropagation(),
            n.isMoved ||
              (i.loop && t.loopFix(),
              (n.startTranslate = t.getTranslate()),
              t.setTransition(0),
              t.animating &&
                t.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
              (n.allowMomentumBounce = !1),
              !i.grabCursor ||
                (!0 !== t.allowSlideNext && !0 !== t.allowSlidePrev) ||
                t.setGrabCursor(!0),
              t.emit("sliderFirstMove", a)),
            t.emit("sliderMove", a),
            (n.isMoved = !0);
          let p = t.isHorizontal() ? d : u;
          (r.diff = p),
            (p *= i.touchRatio),
            s && (p = -p),
            (t.swipeDirection = p > 0 ? "prev" : "next"),
            (n.currentTranslate = p + n.startTranslate);
          let h = !0,
            f = i.resistanceRatio;
          if (
            (i.touchReleaseOnEdges && (f = 0),
            p > 0 && n.currentTranslate > t.minTranslate()
              ? ((h = !1),
                i.resistance &&
                  (n.currentTranslate =
                    t.minTranslate() -
                    1 +
                    (-t.minTranslate() + n.startTranslate + p) ** f))
              : p < 0 &&
                n.currentTranslate < t.maxTranslate() &&
                ((h = !1),
                i.resistance &&
                  (n.currentTranslate =
                    t.maxTranslate() +
                    1 -
                    (t.maxTranslate() - n.startTranslate - p) ** f)),
            h && (a.preventedByNestedSwiper = !0),
            !t.allowSlideNext &&
              "next" === t.swipeDirection &&
              n.currentTranslate < n.startTranslate &&
              (n.currentTranslate = n.startTranslate),
            !t.allowSlidePrev &&
              "prev" === t.swipeDirection &&
              n.currentTranslate > n.startTranslate &&
              (n.currentTranslate = n.startTranslate),
            i.threshold > 0)
          ) {
            if (!(Math.abs(p) > i.threshold || n.allowThresholdMove))
              return void (n.currentTranslate = n.startTranslate);
            if (!n.allowThresholdMove)
              return (
                (n.allowThresholdMove = !0),
                (r.startX = r.currentX),
                (r.startY = r.currentY),
                (n.currentTranslate = n.startTranslate),
                void (r.diff = t.isHorizontal()
                  ? r.currentX - r.startX
                  : r.currentY - r.startY)
              );
          }
          i.followFinger &&
            !i.cssMode &&
            ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) &&
              (t.updateActiveIndex(), t.updateSlidesClasses()),
            i.freeMode &&
              (0 === n.velocities.length &&
                n.velocities.push({
                  position: r[t.isHorizontal() ? "startX" : "startY"],
                  time: n.touchStartTime,
                }),
              n.velocities.push({
                position: r[t.isHorizontal() ? "currentX" : "currentY"],
                time: ks.now(),
              })),
            t.updateProgress(n.currentTranslate),
            t.setTranslate(n.currentTranslate));
        }
        function Hs(e) {
          const t = this,
            n = t.touchEventsData,
            {
              params: i,
              touches: r,
              rtlTranslate: s,
              $wrapperEl: a,
              slidesGrid: o,
              snapGrid: l,
            } = t;
          let c = e;
          if (
            (c.originalEvent && (c = c.originalEvent),
            n.allowTouchCallbacks && t.emit("touchEnd", c),
            (n.allowTouchCallbacks = !1),
            !n.isTouched)
          )
            return (
              n.isMoved && i.grabCursor && t.setGrabCursor(!1),
              (n.isMoved = !1),
              void (n.startMoving = !1)
            );
          i.grabCursor &&
            n.isMoved &&
            n.isTouched &&
            (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
            t.setGrabCursor(!1);
          const d = ks.now(),
            u = d - n.touchStartTime;
          if (
            (t.allowClick &&
              (t.updateClickedSlide(c),
              t.emit("tap click", c),
              u < 300 &&
                d - n.lastClickTime < 300 &&
                t.emit("doubleTap doubleClick", c)),
            (n.lastClickTime = ks.now()),
            ks.nextTick(() => {
              t.destroyed || (t.allowClick = !0);
            }),
            !n.isTouched ||
              !n.isMoved ||
              !t.swipeDirection ||
              0 === r.diff ||
              n.currentTranslate === n.startTranslate)
          )
            return (
              (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
            );
          let p;
          if (
            ((n.isTouched = !1),
            (n.isMoved = !1),
            (n.startMoving = !1),
            (p = i.followFinger
              ? s
                ? t.translate
                : -t.translate
              : -n.currentTranslate),
            i.cssMode)
          )
            return;
          if (i.freeMode) {
            if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
            if (p > -t.maxTranslate())
              return void (t.slides.length < l.length
                ? t.slideTo(l.length - 1)
                : t.slideTo(t.slides.length - 1));
            if (i.freeModeMomentum) {
              if (n.velocities.length > 1) {
                const e = n.velocities.pop(),
                  r = n.velocities.pop(),
                  s = e.position - r.position,
                  a = e.time - r.time;
                (t.velocity = s / a),
                  (t.velocity /= 2),
                  Math.abs(t.velocity) < i.freeModeMinimumVelocity &&
                    (t.velocity = 0),
                  (a > 150 || ks.now() - e.time > 300) && (t.velocity = 0);
              } else t.velocity = 0;
              (t.velocity *= i.freeModeMomentumVelocityRatio),
                (n.velocities.length = 0);
              let e = 1e3 * i.freeModeMomentumRatio;
              const r = t.velocity * e;
              let o = t.translate + r;
              s && (o = -o);
              let c,
                d = !1;
              const u = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
              let p;
              if (o < t.maxTranslate())
                i.freeModeMomentumBounce
                  ? (o + t.maxTranslate() < -u && (o = t.maxTranslate() - u),
                    (c = t.maxTranslate()),
                    (d = !0),
                    (n.allowMomentumBounce = !0))
                  : (o = t.maxTranslate()),
                  i.loop && i.centeredSlides && (p = !0);
              else if (o > t.minTranslate())
                i.freeModeMomentumBounce
                  ? (o - t.minTranslate() > u && (o = t.minTranslate() + u),
                    (c = t.minTranslate()),
                    (d = !0),
                    (n.allowMomentumBounce = !0))
                  : (o = t.minTranslate()),
                  i.loop && i.centeredSlides && (p = !0);
              else if (i.freeModeSticky) {
                let e;
                for (let t = 0; t < l.length; t += 1)
                  if (l[t] > -o) {
                    e = t;
                    break;
                  }
                (o =
                  Math.abs(l[e] - o) < Math.abs(l[e - 1] - o) ||
                  "next" === t.swipeDirection
                    ? l[e]
                    : l[e - 1]),
                  (o = -o);
              }
              if (
                (p &&
                  t.once("transitionEnd", () => {
                    t.loopFix();
                  }),
                0 !== t.velocity)
              ) {
                if (
                  ((e = s
                    ? Math.abs((-o - t.translate) / t.velocity)
                    : Math.abs((o - t.translate) / t.velocity)),
                  i.freeModeSticky)
                ) {
                  const n = Math.abs((s ? -o : o) - t.translate),
                    r = t.slidesSizesGrid[t.activeIndex];
                  e = n < r ? i.speed : n < 2 * r ? 1.5 * i.speed : 2.5 * i.speed;
                }
              } else if (i.freeModeSticky) return void t.slideToClosest();
              i.freeModeMomentumBounce && d
                ? (t.updateProgress(c),
                  t.setTransition(e),
                  t.setTranslate(o),
                  t.transitionStart(!0, t.swipeDirection),
                  (t.animating = !0),
                  a.transitionEnd(() => {
                    t &&
                      !t.destroyed &&
                      n.allowMomentumBounce &&
                      (t.emit("momentumBounce"),
                      t.setTransition(i.speed),
                      setTimeout(() => {
                        t.setTranslate(c),
                          a.transitionEnd(() => {
                            t && !t.destroyed && t.transitionEnd();
                          });
                      }, 0));
                  }))
                : t.velocity
                ? (t.updateProgress(o),
                  t.setTransition(e),
                  t.setTranslate(o),
                  t.transitionStart(!0, t.swipeDirection),
                  t.animating ||
                    ((t.animating = !0),
                    a.transitionEnd(() => {
                      t && !t.destroyed && t.transitionEnd();
                    })))
                : t.updateProgress(o),
                t.updateActiveIndex(),
                t.updateSlidesClasses();
            } else if (i.freeModeSticky) return void t.slideToClosest();
            return void (
              (!i.freeModeMomentum || u >= i.longSwipesMs) &&
              (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
            );
          }
          let h = 0,
            f = t.slidesSizesGrid[0];
          for (
            let e = 0;
            e < o.length;
            e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup
          ) {
            const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
            void 0 !== o[e + t]
              ? p >= o[e] && p < o[e + t] && ((h = e), (f = o[e + t] - o[e]))
              : p >= o[e] && ((h = e), (f = o[o.length - 1] - o[o.length - 2]));
          }
          const m = (p - o[h]) / f,
            v = h < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
          if (u > i.longSwipesMs) {
            if (!i.longSwipes) return void t.slideTo(t.activeIndex);
            "next" === t.swipeDirection &&
              (m >= i.longSwipesRatio ? t.slideTo(h + v) : t.slideTo(h)),
              "prev" === t.swipeDirection &&
                (m > 1 - i.longSwipesRatio ? t.slideTo(h + v) : t.slideTo(h));
          } else {
            if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
            t.navigation &&
            (c.target === t.navigation.nextEl || c.target === t.navigation.prevEl)
              ? c.target === t.navigation.nextEl
                ? t.slideTo(h + v)
                : t.slideTo(h)
              : ("next" === t.swipeDirection && t.slideTo(h + v),
                "prev" === t.swipeDirection && t.slideTo(h));
          }
        }
        function Fs() {
          const e = this,
            { params: t, el: n } = e;
          if (n && 0 === n.offsetWidth) return;
          t.breakpoints && e.setBreakpoint();
          const { allowSlideNext: i, allowSlidePrev: r, snapGrid: s } = e;
          (e.allowSlideNext = !0),
            (e.allowSlidePrev = !0),
            e.updateSize(),
            e.updateSlides(),
            e.updateSlidesClasses(),
            ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
            e.isEnd &&
            !e.isBeginning &&
            !e.params.centeredSlides
              ? e.slideTo(e.slides.length - 1, 0, !1, !0)
              : e.slideTo(e.activeIndex, 0, !1, !0),
            e.autoplay &&
              e.autoplay.running &&
              e.autoplay.paused &&
              e.autoplay.run(),
            (e.allowSlidePrev = r),
            (e.allowSlideNext = i),
            e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
        }
        function Bs(e) {
          const t = this;
          t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
            t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation()));
        }
        function Ws() {
          const e = this,
            { wrapperEl: t, rtlTranslate: n } = e;
          let i;
          (e.previousTranslate = e.translate),
            e.isHorizontal()
              ? (e.translate = n
                  ? t.scrollWidth - t.offsetWidth - t.scrollLeft
                  : -t.scrollLeft)
              : (e.translate = -t.scrollTop),
            -0 === e.translate && (e.translate = 0),
            e.updateActiveIndex(),
            e.updateSlidesClasses();
          const r = e.maxTranslate() - e.minTranslate();
          (i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r),
            i !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
            e.emit("setTranslate", e.translate, !1);
        }
        let Rs = !1;
        function Vs() {}
        var Gs = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "container",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          preventInteractionOnTransition: !1,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          freeMode: !1,
          freeModeMomentum: !0,
          freeModeMomentumRatio: 1,
          freeModeMomentumBounce: !0,
          freeModeMomentumBounceRatio: 1,
          freeModeMomentumVelocityRatio: 1,
          freeModeSticky: !1,
          freeModeMinimumVelocity: 0.02,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerColumn: 1,
          slidesPerColumnFill: "column",
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !1,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          watchSlidesVisibility: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopFillGroupWithBlank: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          containerModifierClass: "swiper-container-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
        };
        const Xs = {
            update: js,
            translate: As,
            transition: Ls,
            slide: Is,
            loop: Os,
            grabCursor: Ps,
            manipulation: Ds,
            events: {
              attachEvents: function () {
                const e = this,
                  { params: t, touchEvents: n, el: i, wrapperEl: r } = e;
                (e.onTouchStart = Ns.bind(e)),
                  (e.onTouchMove = qs.bind(e)),
                  (e.onTouchEnd = Hs.bind(e)),
                  t.cssMode && (e.onScroll = Ws.bind(e)),
                  (e.onClick = Bs.bind(e));
                const s = !!t.nested;
                if (!$s.touch && $s.pointerEvents)
                  i.addEventListener(n.start, e.onTouchStart, !1),
                    bs.addEventListener(n.move, e.onTouchMove, s),
                    bs.addEventListener(n.end, e.onTouchEnd, !1);
                else {
                  if ($s.touch) {
                    const r = !(
                      "touchstart" !== n.start ||
                      !$s.passiveListener ||
                      !t.passiveListeners
                    ) && { passive: !0, capture: !1 };
                    i.addEventListener(n.start, e.onTouchStart, r),
                      i.addEventListener(
                        n.move,
                        e.onTouchMove,
                        $s.passiveListener ? { passive: !1, capture: s } : s
                      ),
                      i.addEventListener(n.end, e.onTouchEnd, r),
                      n.cancel && i.addEventListener(n.cancel, e.onTouchEnd, r),
                      Rs || (bs.addEventListener("touchstart", Vs), (Rs = !0));
                  }
                  ((t.simulateTouch && !zs.ios && !zs.android) ||
                    (t.simulateTouch && !$s.touch && zs.ios)) &&
                    (i.addEventListener("mousedown", e.onTouchStart, !1),
                    bs.addEventListener("mousemove", e.onTouchMove, s),
                    bs.addEventListener("mouseup", e.onTouchEnd, !1));
                }
                (t.preventClicks || t.preventClicksPropagation) &&
                  i.addEventListener("click", e.onClick, !0),
                  t.cssMode && r.addEventListener("scroll", e.onScroll),
                  t.updateOnWindowResize
                    ? e.on(
                        zs.ios || zs.android
                          ? "resize orientationchange observerUpdate"
                          : "resize observerUpdate",
                        Fs,
                        !0
                      )
                    : e.on("observerUpdate", Fs, !0);
              },
              detachEvents: function () {
                const e = this,
                  { params: t, touchEvents: n, el: i, wrapperEl: r } = e,
                  s = !!t.nested;
                if (!$s.touch && $s.pointerEvents)
                  i.removeEventListener(n.start, e.onTouchStart, !1),
                    bs.removeEventListener(n.move, e.onTouchMove, s),
                    bs.removeEventListener(n.end, e.onTouchEnd, !1);
                else {
                  if ($s.touch) {
                    const r = !(
                      "onTouchStart" !== n.start ||
                      !$s.passiveListener ||
                      !t.passiveListeners
                    ) && { passive: !0, capture: !1 };
                    i.removeEventListener(n.start, e.onTouchStart, r),
                      i.removeEventListener(n.move, e.onTouchMove, s),
                      i.removeEventListener(n.end, e.onTouchEnd, r),
                      n.cancel &&
                        i.removeEventListener(n.cancel, e.onTouchEnd, r);
                  }
                  ((t.simulateTouch && !zs.ios && !zs.android) ||
                    (t.simulateTouch && !$s.touch && zs.ios)) &&
                    (i.removeEventListener("mousedown", e.onTouchStart, !1),
                    bs.removeEventListener("mousemove", e.onTouchMove, s),
                    bs.removeEventListener("mouseup", e.onTouchEnd, !1));
                }
                (t.preventClicks || t.preventClicksPropagation) &&
                  i.removeEventListener("click", e.onClick, !0),
                  t.cssMode && r.removeEventListener("scroll", e.onScroll),
                  e.off(
                    zs.ios || zs.android
                      ? "resize orientationchange observerUpdate"
                      : "resize observerUpdate",
                    Fs
                  );
              },
            },
            breakpoints: {
              setBreakpoint: function () {
                const e = this,
                  {
                    activeIndex: t,
                    initialized: n,
                    loopedSlides: i = 0,
                    params: r,
                    $el: s,
                  } = e,
                  a = r.breakpoints;
                if (!a || (a && 0 === Object.keys(a).length)) return;
                const o = e.getBreakpoint(a);
                if (o && e.currentBreakpoint !== o) {
                  const l = o in a ? a[o] : void 0;
                  l &&
                    [
                      "slidesPerView",
                      "spaceBetween",
                      "slidesPerGroup",
                      "slidesPerGroupSkip",
                      "slidesPerColumn",
                    ].forEach((e) => {
                      const t = l[e];
                      void 0 !== t &&
                        (l[e] =
                          "slidesPerView" !== e || ("AUTO" !== t && "auto" !== t)
                            ? "slidesPerView" === e
                              ? parseFloat(t)
                              : parseInt(t, 10)
                            : "auto");
                    });
                  const c = l || e.originalParams,
                    d = r.slidesPerColumn > 1,
                    u = c.slidesPerColumn > 1;
                  d && !u
                    ? s.removeClass(
                        `${r.containerModifierClass}multirow ${r.containerModifierClass}multirow-column`
                      )
                    : !d &&
                      u &&
                      (s.addClass(`${r.containerModifierClass}multirow`),
                      "column" === c.slidesPerColumnFill &&
                        s.addClass(`${r.containerModifierClass}multirow-column`));
                  const p = c.direction && c.direction !== r.direction,
                    h = r.loop && (c.slidesPerView !== r.slidesPerView || p);
                  p && n && e.changeDirection(),
                    ks.extend(e.params, c),
                    ks.extend(e, {
                      allowTouchMove: e.params.allowTouchMove,
                      allowSlideNext: e.params.allowSlideNext,
                      allowSlidePrev: e.params.allowSlidePrev,
                    }),
                    (e.currentBreakpoint = o),
                    h &&
                      n &&
                      (e.loopDestroy(),
                      e.loopCreate(),
                      e.updateSlides(),
                      e.slideTo(t - i + e.loopedSlides, 0, !1)),
                    e.emit("breakpoint", c);
                }
              },
              getBreakpoint: function (e) {
                if (!e) return;
                let t = !1;
                const n = Object.keys(e).map((e) => {
                  if ("string" == typeof e && 0 === e.indexOf("@")) {
                    const t = parseFloat(e.substr(1));
                    return { value: Ss.innerHeight * t, point: e };
                  }
                  return { value: e, point: e };
                });
                n.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
                for (let e = 0; e < n.length; e += 1) {
                  const { point: i, value: r } = n[e];
                  r <= Ss.innerWidth && (t = i);
                }
                return t || "max";
              },
            },
            checkOverflow: {
              checkOverflow: function () {
                const e = this,
                  t = e.params,
                  n = e.isLocked,
                  i =
                    e.slides.length > 0 &&
                    t.slidesOffsetBefore +
                      t.spaceBetween * (e.slides.length - 1) +
                      e.slides[0].offsetWidth * e.slides.length;
                t.slidesOffsetBefore && t.slidesOffsetAfter && i
                  ? (e.isLocked = i <= e.size)
                  : (e.isLocked = 1 === e.snapGrid.length),
                  (e.allowSlideNext = !e.isLocked),
                  (e.allowSlidePrev = !e.isLocked),
                  n !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"),
                  n &&
                    n !== e.isLocked &&
                    ((e.isEnd = !1), e.navigation && e.navigation.update());
              },
            },
            classes: {
              addClasses: function () {
                const { classNames: e, params: t, rtl: n, $el: i } = this,
                  r = [];
                r.push("initialized"),
                  r.push(t.direction),
                  t.freeMode && r.push("free-mode"),
                  t.autoHeight && r.push("autoheight"),
                  n && r.push("rtl"),
                  t.slidesPerColumn > 1 &&
                    (r.push("multirow"),
                    "column" === t.slidesPerColumnFill &&
                      r.push("multirow-column")),
                  zs.android && r.push("android"),
                  zs.ios && r.push("ios"),
                  t.cssMode && r.push("css-mode"),
                  r.forEach((n) => {
                    e.push(t.containerModifierClass + n);
                  }),
                  i.addClass(e.join(" "));
              },
              removeClasses: function () {
                const { $el: e, classNames: t } = this;
                e.removeClass(t.join(" "));
              },
            },
            images: {
              loadImage: function (e, t, n, i, r, s) {
                let a;
                function o() {
                  s && s();
                }
                Ts(e).parent("picture")[0] || (e.complete && r)
                  ? o()
                  : t
                  ? ((a = new Ss.Image()),
                    (a.onload = o),
                    (a.onerror = o),
                    i && (a.sizes = i),
                    n && (a.srcset = n),
                    t && (a.src = t))
                  : o();
              },
              preloadImages: function () {
                const e = this;
                function t() {
                  null != e &&
                    e &&
                    !e.destroyed &&
                    (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                    e.imagesLoaded === e.imagesToLoad.length &&
                      (e.params.updateOnImagesReady && e.update(),
                      e.emit("imagesReady")));
                }
                e.imagesToLoad = e.$el.find("img");
                for (let n = 0; n < e.imagesToLoad.length; n += 1) {
                  const i = e.imagesToLoad[n];
                  e.loadImage(
                    i,
                    i.currentSrc || i.getAttribute("src"),
                    i.srcset || i.getAttribute("srcset"),
                    i.sizes || i.getAttribute("sizes"),
                    !0,
                    t
                  );
                }
              },
            },
          },
          Ys = {};
        class Us extends Ms {
          constructor(...e) {
            let t, n;
            1 === e.length && e[0].constructor && e[0].constructor === Object
              ? (n = e[0])
              : ([t, n] = e),
              n || (n = {}),
              (n = ks.extend({}, n)),
              t && !n.el && (n.el = t),
              super(n),
              Object.keys(Xs).forEach((e) => {
                Object.keys(Xs[e]).forEach((t) => {
                  Us.prototype[t] || (Us.prototype[t] = Xs[e][t]);
                });
              });
            const i = this;
            void 0 === i.modules && (i.modules = {}),
              Object.keys(i.modules).forEach((e) => {
                const t = i.modules[e];
                if (t.params) {
                  const e = Object.keys(t.params)[0],
                    i = t.params[e];
                  if ("object" != typeof i || null === i) return;
                  if (!(e in n) || !("enabled" in i)) return;
                  !0 === n[e] && (n[e] = { enabled: !0 }),
                    "object" != typeof n[e] ||
                      "enabled" in n[e] ||
                      (n[e].enabled = !0),
                    n[e] || (n[e] = { enabled: !1 });
                }
              });
            const r = ks.extend({}, Gs);
            i.useModulesParams(r),
              (i.params = ks.extend({}, r, Ys, n)),
              (i.originalParams = ks.extend({}, i.params)),
              (i.passedParams = ks.extend({}, n)),
              (i.$ = Ts);
            const s = Ts(i.params.el);
            if (((t = s[0]), !t)) return;
            if (s.length > 1) {
              const e = [];
              return (
                s.each((t, i) => {
                  const r = ks.extend({}, n, { el: i });
                  e.push(new Us(r));
                }),
                e
              );
            }
            let a;
            return (
              (t.swiper = i),
              s.data("swiper", i),
              t && t.shadowRoot && t.shadowRoot.querySelector
                ? ((a = Ts(
                    t.shadowRoot.querySelector(`.${i.params.wrapperClass}`)
                  )),
                  (a.children = (e) => s.children(e)))
                : (a = s.children(`.${i.params.wrapperClass}`)),
              ks.extend(i, {
                $el: s,
                el: t,
                $wrapperEl: a,
                wrapperEl: a[0],
                classNames: [],
                slides: Ts(),
                slidesGrid: [],
                snapGrid: [],
                slidesSizesGrid: [],
                isHorizontal: () => "horizontal" === i.params.direction,
                isVertical: () => "vertical" === i.params.direction,
                rtl:
                  "rtl" === t.dir.toLowerCase() || "rtl" === s.css("direction"),
                rtlTranslate:
                  "horizontal" === i.params.direction &&
                  ("rtl" === t.dir.toLowerCase() || "rtl" === s.css("direction")),
                wrongRTL: "-webkit-box" === a.css("display"),
                activeIndex: 0,
                realIndex: 0,
                isBeginning: !0,
                isEnd: !1,
                translate: 0,
                previousTranslate: 0,
                progress: 0,
                velocity: 0,
                animating: !1,
                allowSlideNext: i.params.allowSlideNext,
                allowSlidePrev: i.params.allowSlidePrev,
                touchEvents: (function () {
                  const e = [
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "touchcancel",
                  ];
                  let t = ["mousedown", "mousemove", "mouseup"];
                  return (
                    $s.pointerEvents &&
                      (t = ["pointerdown", "pointermove", "pointerup"]),
                    (i.touchEventsTouch = {
                      start: e[0],
                      move: e[1],
                      end: e[2],
                      cancel: e[3],
                    }),
                    (i.touchEventsDesktop = {
                      start: t[0],
                      move: t[1],
                      end: t[2],
                    }),
                    $s.touch || !i.params.simulateTouch
                      ? i.touchEventsTouch
                      : i.touchEventsDesktop
                  );
                })(),
                touchEventsData: {
                  isTouched: void 0,
                  isMoved: void 0,
                  allowTouchCallbacks: void 0,
                  touchStartTime: void 0,
                  isScrolling: void 0,
                  currentTranslate: void 0,
                  startTranslate: void 0,
                  allowThresholdMove: void 0,
                  formElements:
                    "input, select, option, textarea, button, video, label",
                  lastClickTime: ks.now(),
                  clickTimeout: void 0,
                  velocities: [],
                  allowMomentumBounce: void 0,
                  isTouchEvent: void 0,
                  startMoving: void 0,
                },
                allowClick: !0,
                allowTouchMove: i.params.allowTouchMove,
                touches: {
                  startX: 0,
                  startY: 0,
                  currentX: 0,
                  currentY: 0,
                  diff: 0,
                },
                imagesToLoad: [],
                imagesLoaded: 0,
              }),
              i.useModules(),
              i.params.init && i.init(),
              i
            );
          }
          slidesPerViewDynamic() {
            const {
              params: e,
              slides: t,
              slidesGrid: n,
              size: i,
              activeIndex: r,
            } = this;
            let s = 1;
            if (e.centeredSlides) {
              let e,
                n = t[r].swiperSlideSize;
              for (let a = r + 1; a < t.length; a += 1)
                t[a] &&
                  !e &&
                  ((n += t[a].swiperSlideSize), (s += 1), n > i && (e = !0));
              for (let a = r - 1; a >= 0; a -= 1)
                t[a] &&
                  !e &&
                  ((n += t[a].swiperSlideSize), (s += 1), n > i && (e = !0));
            } else
              for (let e = r + 1; e < t.length; e += 1)
                n[e] - n[r] < i && (s += 1);
            return s;
          }
          update() {
            const e = this;
            if (!e || e.destroyed) return;
            const { snapGrid: t, params: n } = e;
            function i() {
              const t = e.rtlTranslate ? -1 * e.translate : e.translate,
                n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
              e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
            }
            let r;
            n.breakpoints && e.setBreakpoint(),
              e.updateSize(),
              e.updateSlides(),
              e.updateProgress(),
              e.updateSlidesClasses(),
              e.params.freeMode
                ? (i(), e.params.autoHeight && e.updateAutoHeight())
                : ((r =
                    ("auto" === e.params.slidesPerView ||
                      e.params.slidesPerView > 1) &&
                    e.isEnd &&
                    !e.params.centeredSlides
                      ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                      : e.slideTo(e.activeIndex, 0, !1, !0)),
                  r || i()),
              n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
              e.emit("update");
          }
          changeDirection(e, t = !0) {
            const n = this,
              i = n.params.direction;
            return (
              e || (e = "horizontal" === i ? "vertical" : "horizontal"),
              e === i ||
                ("horizontal" !== e && "vertical" !== e) ||
                (n.$el
                  .removeClass(`${n.params.containerModifierClass}${i}`)
                  .addClass(`${n.params.containerModifierClass}${e}`),
                (n.params.direction = e),
                n.slides.each((t, n) => {
                  "vertical" === e ? (n.style.width = "") : (n.style.height = "");
                }),
                n.emit("changeDirection"),
                t && n.update()),
              n
            );
          }
          init() {
            const e = this;
            e.initialized ||
              (e.emit("beforeInit"),
              e.params.breakpoints && e.setBreakpoint(),
              e.addClasses(),
              e.params.loop && e.loopCreate(),
              e.updateSize(),
              e.updateSlides(),
              e.params.watchOverflow && e.checkOverflow(),
              e.params.grabCursor && e.setGrabCursor(),
              e.params.preloadImages && e.preloadImages(),
              e.params.loop
                ? e.slideTo(
                    e.params.initialSlide + e.loopedSlides,
                    0,
                    e.params.runCallbacksOnInit
                  )
                : e.slideTo(
                    e.params.initialSlide,
                    0,
                    e.params.runCallbacksOnInit
                  ),
              e.attachEvents(),
              (e.initialized = !0),
              e.emit("init"));
          }
          destroy(e = !0, t = !0) {
            const n = this,
              { params: i, $el: r, $wrapperEl: s, slides: a } = n;
            return (
              void 0 === n.params ||
                n.destroyed ||
                (n.emit("beforeDestroy"),
                (n.initialized = !1),
                n.detachEvents(),
                i.loop && n.loopDestroy(),
                t &&
                  (n.removeClasses(),
                  r.removeAttr("style"),
                  s.removeAttr("style"),
                  a &&
                    a.length &&
                    a
                      .removeClass(
                        [
                          i.slideVisibleClass,
                          i.slideActiveClass,
                          i.slideNextClass,
                          i.slidePrevClass,
                        ].join(" ")
                      )
                      .removeAttr("style")
                      .removeAttr("data-swiper-slide-index")),
                n.emit("destroy"),
                Object.keys(n.eventsListeners).forEach((e) => {
                  n.off(e);
                }),
                !1 !== e &&
                  ((n.$el[0].swiper = null),
                  n.$el.data("swiper", null),
                  ks.deleteProps(n)),
                (n.destroyed = !0)),
              null
            );
          }
          static extendDefaults(e) {
            ks.extend(Ys, e);
          }
          static get extendedDefaults() {
            return Ys;
          }
          static get defaults() {
            return Gs;
          }
          static get Class() {
            return Ms;
          }
          static get $() {
            return Ts;
          }
        }
        var Ks = {
            name: "device",
            proto: { device: zs },
            static: { device: zs },
          },
          Zs = {
            name: "support",
            proto: { support: $s },
            static: { support: $s },
          };
        const Qs = {
          isEdge: !!Ss.navigator.userAgent.match(/Edge/g),
          isSafari: (function () {
            const e = Ss.navigator.userAgent.toLowerCase();
            return (
              e.indexOf("safari") >= 0 &&
              e.indexOf("chrome") < 0 &&
              e.indexOf("android") < 0
            );
          })(),
          isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
            Ss.navigator.userAgent
          ),
        };
        var Js = {
            name: "browser",
            proto: { browser: Qs },
            static: { browser: Qs },
          },
          ea = {
            name: "resize",
            create() {
              const e = this;
              ks.extend(e, {
                resize: {
                  resizeHandler() {
                    e &&
                      !e.destroyed &&
                      e.initialized &&
                      (e.emit("beforeResize"), e.emit("resize"));
                  },
                  orientationChangeHandler() {
                    e &&
                      !e.destroyed &&
                      e.initialized &&
                      e.emit("orientationchange");
                  },
                },
              });
            },
            on: {
              init() {
                Ss.addEventListener("resize", this.resize.resizeHandler),
                  Ss.addEventListener(
                    "orientationchange",
                    this.resize.orientationChangeHandler
                  );
              },
              destroy() {
                Ss.removeEventListener("resize", this.resize.resizeHandler),
                  Ss.removeEventListener(
                    "orientationchange",
                    this.resize.orientationChangeHandler
                  );
              },
            },
          };
        const ta = {
          func: Ss.MutationObserver || Ss.WebkitMutationObserver,
          attach(e, t = {}) {
            const n = this,
              i = new (0, ta.func)((e) => {
                if (1 === e.length) return void n.emit("observerUpdate", e[0]);
                const t = function () {
                  n.emit("observerUpdate", e[0]);
                };
                Ss.requestAnimationFrame
                  ? Ss.requestAnimationFrame(t)
                  : Ss.setTimeout(t, 0);
              });
            i.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData,
            }),
              n.observer.observers.push(i);
          },
          init() {
            const e = this;
            if ($s.observer && e.params.observer) {
              if (e.params.observeParents) {
                const t = e.$el.parents();
                for (let n = 0; n < t.length; n += 1) e.observer.attach(t[n]);
              }
              e.observer.attach(e.$el[0], {
                childList: e.params.observeSlideChildren,
              }),
                e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
            }
          },
          destroy() {
            this.observer.observers.forEach((e) => {
              e.disconnect();
            }),
              (this.observer.observers = []);
          },
        };
        var na = {
          name: "observer",
          params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
          create() {
            const e = this;
            ks.extend(e, {
              observer: {
                init: ta.init.bind(e),
                attach: ta.attach.bind(e),
                destroy: ta.destroy.bind(e),
                observers: [],
              },
            });
          },
          on: {
            init() {
              this.observer.init();
            },
            destroy() {
              this.observer.destroy();
            },
          },
        };
        const ia = {
          update(e) {
            const t = this,
              {
                slidesPerView: n,
                slidesPerGroup: i,
                centeredSlides: r,
              } = t.params,
              { addSlidesBefore: s, addSlidesAfter: a } = t.params.virtual,
              {
                from: o,
                to: l,
                slides: c,
                slidesGrid: d,
                renderSlide: u,
                offset: p,
              } = t.virtual;
            t.updateActiveIndex();
            const h = t.activeIndex || 0;
            let f, m, v;
            (f = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top"),
              r
                ? ((m = Math.floor(n / 2) + i + s),
                  (v = Math.floor(n / 2) + i + a))
                : ((m = n + (i - 1) + s), (v = i + a));
            const y = Math.max((h || 0) - v, 0),
              g = Math.min((h || 0) + m, c.length - 1),
              x = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);
            function b() {
              t.updateSlides(),
                t.updateProgress(),
                t.updateSlidesClasses(),
                t.lazy && t.params.lazy.enabled && t.lazy.load();
            }
            if (
              (ks.extend(t.virtual, {
                from: y,
                to: g,
                offset: x,
                slidesGrid: t.slidesGrid,
              }),
              o === y && l === g && !e)
            )
              return (
                t.slidesGrid !== d && x !== p && t.slides.css(f, `${x}px`),
                void t.updateProgress()
              );
            if (t.params.virtual.renderExternal)
              return (
                t.params.virtual.renderExternal.call(t, {
                  offset: x,
                  from: y,
                  to: g,
                  slides: (function () {
                    const e = [];
                    for (let t = y; t <= g; t += 1) e.push(c[t]);
                    return e;
                  })(),
                }),
                void b()
              );
            const w = [],
              S = [];
            if (e) t.$wrapperEl.find(`.${t.params.slideClass}`).remove();
            else
              for (let e = o; e <= l; e += 1)
                (e < y || e > g) &&
                  t.$wrapperEl
                    .find(
                      `.${t.params.slideClass}[data-swiper-slide-index="${e}"]`
                    )
                    .remove();
            for (let t = 0; t < c.length; t += 1)
              t >= y &&
                t <= g &&
                (void 0 === l || e
                  ? S.push(t)
                  : (t > l && S.push(t), t < o && w.push(t)));
            S.forEach((e) => {
              t.$wrapperEl.append(u(c[e], e));
            }),
              w
                .sort((e, t) => t - e)
                .forEach((e) => {
                  t.$wrapperEl.prepend(u(c[e], e));
                }),
              t.$wrapperEl.children(".swiper-slide").css(f, `${x}px`),
              b();
          },
          renderSlide(e, t) {
            const n = this,
              i = n.params.virtual;
            if (i.cache && n.virtual.cache[t]) return n.virtual.cache[t];
            const r = i.renderSlide
              ? Ts(i.renderSlide.call(n, e, t))
              : Ts(
                  `<div class="${n.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`
                );
            return (
              r.attr("data-swiper-slide-index") ||
                r.attr("data-swiper-slide-index", t),
              i.cache && (n.virtual.cache[t] = r),
              r
            );
          },
          appendSlide(e) {
            const t = this;
            if ("object" == typeof e && "length" in e)
              for (let n = 0; n < e.length; n += 1)
                e[n] && t.virtual.slides.push(e[n]);
            else t.virtual.slides.push(e);
            t.virtual.update(!0);
          },
          prependSlide(e) {
            const t = this,
              n = t.activeIndex;
            let i = n + 1,
              r = 1;
            if (Array.isArray(e)) {
              for (let n = 0; n < e.length; n += 1)
                e[n] && t.virtual.slides.unshift(e[n]);
              (i = n + e.length), (r = e.length);
            } else t.virtual.slides.unshift(e);
            if (t.params.virtual.cache) {
              const e = t.virtual.cache,
                n = {};
              Object.keys(e).forEach((t) => {
                const i = e[t],
                  s = i.attr("data-swiper-slide-index");
                s && i.attr("data-swiper-slide-index", parseInt(s, 10) + 1),
                  (n[parseInt(t, 10) + r] = i);
              }),
                (t.virtual.cache = n);
            }
            t.virtual.update(!0), t.slideTo(i, 0);
          },
          removeSlide(e) {
            const t = this;
            if (null == e) return;
            let n = t.activeIndex;
            if (Array.isArray(e))
              for (let i = e.length - 1; i >= 0; i -= 1)
                t.virtual.slides.splice(e[i], 1),
                  t.params.virtual.cache && delete t.virtual.cache[e[i]],
                  e[i] < n && (n -= 1),
                  (n = Math.max(n, 0));
            else
              t.virtual.slides.splice(e, 1),
                t.params.virtual.cache && delete t.virtual.cache[e],
                e < n && (n -= 1),
                (n = Math.max(n, 0));
            t.virtual.update(!0), t.slideTo(n, 0);
          },
          removeAllSlides() {
            const e = this;
            (e.virtual.slides = []),
              e.params.virtual.cache && (e.virtual.cache = {}),
              e.virtual.update(!0),
              e.slideTo(0, 0);
          },
        };
        var ra = {
          name: "virtual",
          params: {
            virtual: {
              enabled: !1,
              slides: [],
              cache: !0,
              renderSlide: null,
              renderExternal: null,
              addSlidesBefore: 0,
              addSlidesAfter: 0,
            },
          },
          create() {
            const e = this;
            ks.extend(e, {
              virtual: {
                update: ia.update.bind(e),
                appendSlide: ia.appendSlide.bind(e),
                prependSlide: ia.prependSlide.bind(e),
                removeSlide: ia.removeSlide.bind(e),
                removeAllSlides: ia.removeAllSlides.bind(e),
                renderSlide: ia.renderSlide.bind(e),
                slides: e.params.virtual.slides,
                cache: {},
              },
            });
          },
          on: {
            beforeInit() {
              const e = this;
              if (!e.params.virtual.enabled) return;
              e.classNames.push(`${e.params.containerModifierClass}virtual`);
              const t = { watchSlidesProgress: !0 };
              ks.extend(e.params, t),
                ks.extend(e.originalParams, t),
                e.params.initialSlide || e.virtual.update();
            },
            setTranslate() {
              this.params.virtual.enabled && this.virtual.update();
            },
          },
        };
        const sa = {
          handle(e) {
            const t = this,
              { rtlTranslate: n } = t;
            let i = e;
            i.originalEvent && (i = i.originalEvent);
            const r = i.keyCode || i.charCode,
              s = t.params.keyboard.pageUpDown,
              a = s && 33 === r,
              o = s && 34 === r,
              l = 37 === r,
              c = 39 === r,
              d = 38 === r,
              u = 40 === r;
            if (
              !t.allowSlideNext &&
              ((t.isHorizontal() && c) || (t.isVertical() && u) || o)
            )
              return !1;
            if (
              !t.allowSlidePrev &&
              ((t.isHorizontal() && l) || (t.isVertical() && d) || a)
            )
              return !1;
            if (
              !(
                i.shiftKey ||
                i.altKey ||
                i.ctrlKey ||
                i.metaKey ||
                (bs.activeElement &&
                  bs.activeElement.nodeName &&
                  ("input" === bs.activeElement.nodeName.toLowerCase() ||
                    "textarea" === bs.activeElement.nodeName.toLowerCase()))
              )
            ) {
              if (
                t.params.keyboard.onlyInViewport &&
                (a || o || l || c || d || u)
              ) {
                let e = !1;
                if (
                  t.$el.parents(`.${t.params.slideClass}`).length > 0 &&
                  0 === t.$el.parents(`.${t.params.slideActiveClass}`).length
                )
                  return;
                const i = Ss.innerWidth,
                  r = Ss.innerHeight,
                  s = t.$el.offset();
                n && (s.left -= t.$el[0].scrollLeft);
                const a = [
                  [s.left, s.top],
                  [s.left + t.width, s.top],
                  [s.left, s.top + t.height],
                  [s.left + t.width, s.top + t.height],
                ];
                for (let t = 0; t < a.length; t += 1) {
                  const n = a[t];
                  n[0] >= 0 && n[0] <= i && n[1] >= 0 && n[1] <= r && (e = !0);
                }
                if (!e) return;
              }
              t.isHorizontal()
                ? ((a || o || l || c) &&
                    (i.preventDefault
                      ? i.preventDefault()
                      : (i.returnValue = !1)),
                  (((o || c) && !n) || ((a || l) && n)) && t.slideNext(),
                  (((a || l) && !n) || ((o || c) && n)) && t.slidePrev())
                : ((a || o || d || u) &&
                    (i.preventDefault
                      ? i.preventDefault()
                      : (i.returnValue = !1)),
                  (o || u) && t.slideNext(),
                  (a || d) && t.slidePrev()),
                t.emit("keyPress", r);
            }
          },
          enable() {
            const e = this;
            e.keyboard.enabled ||
              (Ts(bs).on("keydown", e.keyboard.handle),
              (e.keyboard.enabled = !0));
          },
          disable() {
            const e = this;
            e.keyboard.enabled &&
              (Ts(bs).off("keydown", e.keyboard.handle),
              (e.keyboard.enabled = !1));
          },
        };
        var aa = {
          name: "keyboard",
          params: {
            keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 },
          },
          create() {
            const e = this;
            ks.extend(e, {
              keyboard: {
                enabled: !1,
                enable: sa.enable.bind(e),
                disable: sa.disable.bind(e),
                handle: sa.handle.bind(e),
              },
            });
          },
          on: {
            init() {
              const e = this;
              e.params.keyboard.enabled && e.keyboard.enable();
            },
            destroy() {
              const e = this;
              e.keyboard.enabled && e.keyboard.disable();
            },
          },
        };
        const oa = {
          lastScrollTime: ks.now(),
          lastEventBeforeSnap: void 0,
          recentWheelEvents: [],
          event: () =>
            Ss.navigator.userAgent.indexOf("firefox") > -1
              ? "DOMMouseScroll"
              : (function () {
                  const e = "onwheel";
                  let t = e in bs;
                  if (!t) {
                    const n = bs.createElement("div");
                    n.setAttribute(e, "return;"),
                      (t = "function" == typeof n.onwheel);
                  }
                  return (
                    !t &&
                      bs.implementation &&
                      bs.implementation.hasFeature &&
                      !0 !== bs.implementation.hasFeature("", "") &&
                      (t = bs.implementation.hasFeature("Events.wheel", "3.0")),
                    t
                  );
                })()
              ? "wheel"
              : "mousewheel",
          normalize(e) {
            let t = 0,
              n = 0,
              i = 0,
              r = 0;
            return (
              "detail" in e && (n = e.detail),
              "wheelDelta" in e && (n = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (n = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = n), (n = 0)),
              (i = 10 * t),
              (r = 10 * n),
              "deltaY" in e && (r = e.deltaY),
              "deltaX" in e && (i = e.deltaX),
              e.shiftKey && !i && ((i = r), (r = 0)),
              (i || r) &&
                e.deltaMode &&
                (1 === e.deltaMode
                  ? ((i *= 40), (r *= 40))
                  : ((i *= 800), (r *= 800))),
              i && !t && (t = i < 1 ? -1 : 1),
              r && !n && (n = r < 1 ? -1 : 1),
              { spinX: t, spinY: n, pixelX: i, pixelY: r }
            );
          },
          handleMouseEnter() {
            this.mouseEntered = !0;
          },
          handleMouseLeave() {
            this.mouseEntered = !1;
          },
          handle(e) {
            let t = e;
            const n = this,
              i = n.params.mousewheel;
            n.params.cssMode && t.preventDefault();
            let r = n.$el;
            if (
              ("container" !== n.params.mousewheel.eventsTarged &&
                (r = Ts(n.params.mousewheel.eventsTarged)),
              !n.mouseEntered && !r[0].contains(t.target) && !i.releaseOnEdges)
            )
              return !0;
            t.originalEvent && (t = t.originalEvent);
            let s = 0;
            const a = n.rtlTranslate ? -1 : 1,
              o = oa.normalize(t);
            if (i.forceToAxis)
              if (n.isHorizontal()) {
                if (!(Math.abs(o.pixelX) > Math.abs(o.pixelY))) return !0;
                s = -o.pixelX * a;
              } else {
                if (!(Math.abs(o.pixelY) > Math.abs(o.pixelX))) return !0;
                s = -o.pixelY;
              }
            else
              s =
                Math.abs(o.pixelX) > Math.abs(o.pixelY)
                  ? -o.pixelX * a
                  : -o.pixelY;
            if (0 === s) return !0;
            if ((i.invert && (s = -s), n.params.freeMode)) {
              const e = {
                  time: ks.now(),
                  delta: Math.abs(s),
                  direction: Math.sign(s),
                },
                { lastEventBeforeSnap: r } = n.mousewheel,
                a =
                  r &&
                  e.time < r.time + 500 &&
                  e.delta <= r.delta &&
                  e.direction === r.direction;
              if (!a) {
                (n.mousewheel.lastEventBeforeSnap = void 0),
                  n.params.loop && n.loopFix();
                let r = n.getTranslate() + s * i.sensitivity;
                const o = n.isBeginning,
                  l = n.isEnd;
                if (
                  (r >= n.minTranslate() && (r = n.minTranslate()),
                  r <= n.maxTranslate() && (r = n.maxTranslate()),
                  n.setTransition(0),
                  n.setTranslate(r),
                  n.updateProgress(),
                  n.updateActiveIndex(),
                  n.updateSlidesClasses(),
                  ((!o && n.isBeginning) || (!l && n.isEnd)) &&
                    n.updateSlidesClasses(),
                  n.params.freeModeSticky)
                ) {
                  clearTimeout(n.mousewheel.timeout),
                    (n.mousewheel.timeout = void 0);
                  const t = n.mousewheel.recentWheelEvents;
                  t.length >= 15 && t.shift();
                  const i = t.length ? t[t.length - 1] : void 0,
                    r = t[0];
                  if (
                    (t.push(e),
                    i && (e.delta > i.delta || e.direction !== i.direction))
                  )
                    t.splice(0);
                  else if (
                    t.length >= 15 &&
                    e.time - r.time < 500 &&
                    r.delta - e.delta >= 1 &&
                    e.delta <= 6
                  ) {
                    const i = s > 0 ? 0.8 : 0.2;
                    (n.mousewheel.lastEventBeforeSnap = e),
                      t.splice(0),
                      (n.mousewheel.timeout = ks.nextTick(() => {
                        n.slideToClosest(n.params.speed, !0, void 0, i);
                      }, 0));
                  }
                  n.mousewheel.timeout ||
                    (n.mousewheel.timeout = ks.nextTick(() => {
                      (n.mousewheel.lastEventBeforeSnap = e),
                        t.splice(0),
                        n.slideToClosest(n.params.speed, !0, void 0, 0.5);
                    }, 500));
                }
                if (
                  (a || n.emit("scroll", t),
                  n.params.autoplay &&
                    n.params.autoplayDisableOnInteraction &&
                    n.autoplay.stop(),
                  r === n.minTranslate() || r === n.maxTranslate())
                )
                  return !0;
              }
            } else {
              const t = {
                  time: ks.now(),
                  delta: Math.abs(s),
                  direction: Math.sign(s),
                  raw: e,
                },
                i = n.mousewheel.recentWheelEvents;
              i.length >= 2 && i.shift();
              const r = i.length ? i[i.length - 1] : void 0;
              if (
                (i.push(t),
                r
                  ? (t.direction !== r.direction ||
                      t.delta > r.delta ||
                      t.time > r.time + 150) &&
                    n.mousewheel.animateSlider(t)
                  : n.mousewheel.animateSlider(t),
                n.mousewheel.releaseScroll(t))
              )
                return !0;
            }
            return (
              t.preventDefault ? t.preventDefault() : (t.returnValue = !1), !1
            );
          },
          animateSlider(e) {
            const t = this;
            return (
              (e.delta >= 6 && ks.now() - t.mousewheel.lastScrollTime < 60) ||
              (e.direction < 0
                ? (t.isEnd && !t.params.loop) ||
                  t.animating ||
                  (t.slideNext(), t.emit("scroll", e.raw))
                : (t.isBeginning && !t.params.loop) ||
                  t.animating ||
                  (t.slidePrev(), t.emit("scroll", e.raw)),
              (t.mousewheel.lastScrollTime = new Ss.Date().getTime()),
              !1)
            );
          },
          releaseScroll(e) {
            const t = this,
              n = t.params.mousewheel;
            if (e.direction < 0) {
              if (t.isEnd && !t.params.loop && n.releaseOnEdges) return !0;
            } else if (t.isBeginning && !t.params.loop && n.releaseOnEdges)
              return !0;
            return !1;
          },
          enable() {
            const e = this,
              t = oa.event();
            if (e.params.cssMode)
              return e.wrapperEl.removeEventListener(t, e.mousewheel.handle), !0;
            if (!t) return !1;
            if (e.mousewheel.enabled) return !1;
            let n = e.$el;
            return (
              "container" !== e.params.mousewheel.eventsTarged &&
                (n = Ts(e.params.mousewheel.eventsTarged)),
              n.on("mouseenter", e.mousewheel.handleMouseEnter),
              n.on("mouseleave", e.mousewheel.handleMouseLeave),
              n.on(t, e.mousewheel.handle),
              (e.mousewheel.enabled = !0),
              !0
            );
          },
          disable() {
            const e = this,
              t = oa.event();
            if (e.params.cssMode)
              return e.wrapperEl.addEventListener(t, e.mousewheel.handle), !0;
            if (!t) return !1;
            if (!e.mousewheel.enabled) return !1;
            let n = e.$el;
            return (
              "container" !== e.params.mousewheel.eventsTarged &&
                (n = Ts(e.params.mousewheel.eventsTarged)),
              n.off(t, e.mousewheel.handle),
              (e.mousewheel.enabled = !1),
              !0
            );
          },
        };
        const la = {
          update() {
            const e = this,
              t = e.params.navigation;
            if (e.params.loop) return;
            const { $nextEl: n, $prevEl: i } = e.navigation;
            i &&
              i.length > 0 &&
              (e.isBeginning
                ? i.addClass(t.disabledClass)
                : i.removeClass(t.disabledClass),
              i[
                e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
              ](t.lockClass)),
              n &&
                n.length > 0 &&
                (e.isEnd
                  ? n.addClass(t.disabledClass)
                  : n.removeClass(t.disabledClass),
                n[
                  e.params.watchOverflow && e.isLocked
                    ? "addClass"
                    : "removeClass"
                ](t.lockClass));
          },
          onPrevClick(e) {
            const t = this;
            e.preventDefault(),
              (t.isBeginning && !t.params.loop) || t.slidePrev();
          },
          onNextClick(e) {
            const t = this;
            e.preventDefault(), (t.isEnd && !t.params.loop) || t.slideNext();
          },
          init() {
            const e = this,
              t = e.params.navigation;
            if (!t.nextEl && !t.prevEl) return;
            let n, i;
            t.nextEl &&
              ((n = Ts(t.nextEl)),
              e.params.uniqueNavElements &&
                "string" == typeof t.nextEl &&
                n.length > 1 &&
                1 === e.$el.find(t.nextEl).length &&
                (n = e.$el.find(t.nextEl))),
              t.prevEl &&
                ((i = Ts(t.prevEl)),
                e.params.uniqueNavElements &&
                  "string" == typeof t.prevEl &&
                  i.length > 1 &&
                  1 === e.$el.find(t.prevEl).length &&
                  (i = e.$el.find(t.prevEl))),
              n && n.length > 0 && n.on("click", e.navigation.onNextClick),
              i && i.length > 0 && i.on("click", e.navigation.onPrevClick),
              ks.extend(e.navigation, {
                $nextEl: n,
                nextEl: n && n[0],
                $prevEl: i,
                prevEl: i && i[0],
              });
          },
          destroy() {
            const e = this,
              { $nextEl: t, $prevEl: n } = e.navigation;
            t &&
              t.length &&
              (t.off("click", e.navigation.onNextClick),
              t.removeClass(e.params.navigation.disabledClass)),
              n &&
                n.length &&
                (n.off("click", e.navigation.onPrevClick),
                n.removeClass(e.params.navigation.disabledClass));
          },
        };
        const ca = {
          update() {
            const e = this,
              t = e.rtl,
              n = e.params.pagination;
            if (
              !n.el ||
              !e.pagination.el ||
              !e.pagination.$el ||
              0 === e.pagination.$el.length
            )
              return;
            const i =
                e.virtual && e.params.virtual.enabled
                  ? e.virtual.slides.length
                  : e.slides.length,
              r = e.pagination.$el;
            let s;
            const a = e.params.loop
              ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup)
              : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((s = Math.ceil(
                    (e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup
                  )),
                  s > i - 1 - 2 * e.loopedSlides && (s -= i - 2 * e.loopedSlides),
                  s > a - 1 && (s -= a),
                  s < 0 && "bullets" !== e.params.paginationType && (s = a + s))
                : (s = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
              "bullets" === n.type &&
                e.pagination.bullets &&
                e.pagination.bullets.length > 0)
            ) {
              const i = e.pagination.bullets;
              let a, o, l;
              if (
                (n.dynamicBullets &&
                  ((e.pagination.bulletSize = i
                    .eq(0)
                    [e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                  r.css(
                    e.isHorizontal() ? "width" : "height",
                    e.pagination.bulletSize * (n.dynamicMainBullets + 4) + "px"
                  ),
                  n.dynamicMainBullets > 1 &&
                    void 0 !== e.previousIndex &&
                    ((e.pagination.dynamicBulletIndex += s - e.previousIndex),
                    e.pagination.dynamicBulletIndex > n.dynamicMainBullets - 1
                      ? (e.pagination.dynamicBulletIndex =
                          n.dynamicMainBullets - 1)
                      : e.pagination.dynamicBulletIndex < 0 &&
                        (e.pagination.dynamicBulletIndex = 0)),
                  (a = s - e.pagination.dynamicBulletIndex),
                  (o = a + (Math.min(i.length, n.dynamicMainBullets) - 1)),
                  (l = (o + a) / 2)),
                i.removeClass(
                  `${n.bulletActiveClass} ${n.bulletActiveClass}-next ${n.bulletActiveClass}-next-next ${n.bulletActiveClass}-prev ${n.bulletActiveClass}-prev-prev ${n.bulletActiveClass}-main`
                ),
                r.length > 1)
              )
                i.each((e, t) => {
                  const i = Ts(t),
                    r = i.index();
                  r === s && i.addClass(n.bulletActiveClass),
                    n.dynamicBullets &&
                      (r >= a &&
                        r <= o &&
                        i.addClass(`${n.bulletActiveClass}-main`),
                      r === a &&
                        i
                          .prev()
                          .addClass(`${n.bulletActiveClass}-prev`)
                          .prev()
                          .addClass(`${n.bulletActiveClass}-prev-prev`),
                      r === o &&
                        i
                          .next()
                          .addClass(`${n.bulletActiveClass}-next`)
                          .next()
                          .addClass(`${n.bulletActiveClass}-next-next`));
                });
              else {
                const t = i.eq(s),
                  r = t.index();
                if ((t.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                  const t = i.eq(a),
                    s = i.eq(o);
                  for (let e = a; e <= o; e += 1)
                    i.eq(e).addClass(`${n.bulletActiveClass}-main`);
                  if (e.params.loop)
                    if (r >= i.length - n.dynamicMainBullets) {
                      for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                        i.eq(i.length - e).addClass(
                          `${n.bulletActiveClass}-main`
                        );
                      i.eq(i.length - n.dynamicMainBullets - 1).addClass(
                        `${n.bulletActiveClass}-prev`
                      );
                    } else
                      t
                        .prev()
                        .addClass(`${n.bulletActiveClass}-prev`)
                        .prev()
                        .addClass(`${n.bulletActiveClass}-prev-prev`),
                        s
                          .next()
                          .addClass(`${n.bulletActiveClass}-next`)
                          .next()
                          .addClass(`${n.bulletActiveClass}-next-next`);
                  else
                    t
                      .prev()
                      .addClass(`${n.bulletActiveClass}-prev`)
                      .prev()
                      .addClass(`${n.bulletActiveClass}-prev-prev`),
                      s
                        .next()
                        .addClass(`${n.bulletActiveClass}-next`)
                        .next()
                        .addClass(`${n.bulletActiveClass}-next-next`);
                }
              }
              if (n.dynamicBullets) {
                const r = Math.min(i.length, n.dynamicMainBullets + 4),
                  s =
                    (e.pagination.bulletSize * r - e.pagination.bulletSize) / 2 -
                    l * e.pagination.bulletSize,
                  a = t ? "right" : "left";
                i.css(e.isHorizontal() ? a : "top", `${s}px`);
              }
            }
            if (
              ("fraction" === n.type &&
                (r
                  .find(`.${n.currentClass}`)
                  .text(n.formatFractionCurrent(s + 1)),
                r.find(`.${n.totalClass}`).text(n.formatFractionTotal(a))),
              "progressbar" === n.type)
            ) {
              let t;
              t = n.progressbarOpposite
                ? e.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : e.isHorizontal()
                ? "horizontal"
                : "vertical";
              const i = (s + 1) / a;
              let o = 1,
                l = 1;
              "horizontal" === t ? (o = i) : (l = i),
                r
                  .find(`.${n.progressbarFillClass}`)
                  .transform(`translate3d(0,0,0) scaleX(${o}) scaleY(${l})`)
                  .transition(e.params.speed);
            }
            "custom" === n.type && n.renderCustom
              ? (r.html(n.renderCustom(e, s + 1, a)),
                e.emit("paginationRender", e, r[0]))
              : e.emit("paginationUpdate", e, r[0]),
              r[
                e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
              ](n.lockClass);
          },
          render() {
            const e = this,
              t = e.params.pagination;
            if (
              !t.el ||
              !e.pagination.el ||
              !e.pagination.$el ||
              0 === e.pagination.$el.length
            )
              return;
            const n =
                e.virtual && e.params.virtual.enabled
                  ? e.virtual.slides.length
                  : e.slides.length,
              i = e.pagination.$el;
            let r = "";
            if ("bullets" === t.type) {
              const s = e.params.loop
                ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup)
                : e.snapGrid.length;
              for (let n = 0; n < s; n += 1)
                t.renderBullet
                  ? (r += t.renderBullet.call(e, n, t.bulletClass))
                  : (r += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
              i.html(r), (e.pagination.bullets = i.find(`.${t.bulletClass}`));
            }
            "fraction" === t.type &&
              ((r = t.renderFraction
                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
              i.html(r)),
              "progressbar" === t.type &&
                ((r = t.renderProgressbar
                  ? t.renderProgressbar.call(e, t.progressbarFillClass)
                  : `<span class="${t.progressbarFillClass}"></span>`),
                i.html(r)),
              "custom" !== t.type &&
                e.emit("paginationRender", e.pagination.$el[0]);
          },
          init() {
            const e = this,
              t = e.params.pagination;
            if (!t.el) return;
            let n = Ts(t.el);
            0 !== n.length &&
              (e.params.uniqueNavElements &&
                "string" == typeof t.el &&
                n.length > 1 &&
                (n = e.$el.find(t.el)),
              "bullets" === t.type && t.clickable && n.addClass(t.clickableClass),
              n.addClass(t.modifierClass + t.type),
              "bullets" === t.type &&
                t.dynamicBullets &&
                (n.addClass(`${t.modifierClass}${t.type}-dynamic`),
                (e.pagination.dynamicBulletIndex = 0),
                t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
              "progressbar" === t.type &&
                t.progressbarOpposite &&
                n.addClass(t.progressbarOppositeClass),
              t.clickable &&
                n.on("click", `.${t.bulletClass}`, function (t) {
                  t.preventDefault();
                  let n = Ts(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                }),
              ks.extend(e.pagination, { $el: n, el: n[0] }));
          },
          destroy() {
            const e = this,
              t = e.params.pagination;
            if (
              !t.el ||
              !e.pagination.el ||
              !e.pagination.$el ||
              0 === e.pagination.$el.length
            )
              return;
            const n = e.pagination.$el;
            n.removeClass(t.hiddenClass),
              n.removeClass(t.modifierClass + t.type),
              e.pagination.bullets &&
                e.pagination.bullets.removeClass(t.bulletActiveClass),
              t.clickable && n.off("click", `.${t.bulletClass}`);
          },
        };
        const da = {
          setTranslate() {
            const e = this;
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t, rtlTranslate: n, progress: i } = e,
              { dragSize: r, trackSize: s, $dragEl: a, $el: o } = t,
              l = e.params.scrollbar;
            let c = r,
              d = (s - r) * i;
            n
              ? ((d = -d),
                d > 0 ? ((c = r - d), (d = 0)) : -d + r > s && (c = s + d))
              : d < 0
              ? ((c = r + d), (d = 0))
              : d + r > s && (c = s - d),
              e.isHorizontal()
                ? (a.transform(`translate3d(${d}px, 0, 0)`),
                  (a[0].style.width = `${c}px`))
                : (a.transform(`translate3d(0px, ${d}px, 0)`),
                  (a[0].style.height = `${c}px`)),
              l.hide &&
                (clearTimeout(e.scrollbar.timeout),
                (o[0].style.opacity = 1),
                (e.scrollbar.timeout = setTimeout(() => {
                  (o[0].style.opacity = 0), o.transition(400);
                }, 1e3)));
          },
          setTransition(e) {
            const t = this;
            t.params.scrollbar.el &&
              t.scrollbar.el &&
              t.scrollbar.$dragEl.transition(e);
          },
          updateSize() {
            const e = this;
            if (!e.params.scrollbar.el || !e.scrollbar.el) return;
            const { scrollbar: t } = e,
              { $dragEl: n, $el: i } = t;
            (n[0].style.width = ""), (n[0].style.height = "");
            const r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
              s = e.size / e.virtualSize,
              a = s * (r / e.size);
            let o;
            (o =
              "auto" === e.params.scrollbar.dragSize
                ? r * s
                : parseInt(e.params.scrollbar.dragSize, 10)),
              e.isHorizontal()
                ? (n[0].style.width = `${o}px`)
                : (n[0].style.height = `${o}px`),
              (i[0].style.display = s >= 1 ? "none" : ""),
              e.params.scrollbar.hide && (i[0].style.opacity = 0),
              ks.extend(t, {
                trackSize: r,
                divider: s,
                moveDivider: a,
                dragSize: o,
              }),
              t.$el[
                e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"
              ](e.params.scrollbar.lockClass);
          },
          getPointerPosition(e) {
            return this.isHorizontal()
              ? "touchstart" === e.type || "touchmove" === e.type
                ? e.targetTouches[0].clientX
                : e.clientX
              : "touchstart" === e.type || "touchmove" === e.type
              ? e.targetTouches[0].clientY
              : e.clientY;
          },
          setDragPosition(e) {
            const t = this,
              { scrollbar: n, rtlTranslate: i } = t,
              { $el: r, dragSize: s, trackSize: a, dragStartPos: o } = n;
            let l;
            (l =
              (n.getPointerPosition(e) -
                r.offset()[t.isHorizontal() ? "left" : "top"] -
                (null !== o ? o : s / 2)) /
              (a - s)),
              (l = Math.max(Math.min(l, 1), 0)),
              i && (l = 1 - l);
            const c =
              t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * l;
            t.updateProgress(c),
              t.setTranslate(c),
              t.updateActiveIndex(),
              t.updateSlidesClasses();
          },
          onDragStart(e) {
            const t = this,
              n = t.params.scrollbar,
              { scrollbar: i, $wrapperEl: r } = t,
              { $el: s, $dragEl: a } = i;
            (t.scrollbar.isTouched = !0),
              (t.scrollbar.dragStartPos =
                e.target === a[0] || e.target === a
                  ? i.getPointerPosition(e) -
                    e.target.getBoundingClientRect()[
                      t.isHorizontal() ? "left" : "top"
                    ]
                  : null),
              e.preventDefault(),
              e.stopPropagation(),
              r.transition(100),
              a.transition(100),
              i.setDragPosition(e),
              clearTimeout(t.scrollbar.dragTimeout),
              s.transition(0),
              n.hide && s.css("opacity", 1),
              t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"),
              t.emit("scrollbarDragStart", e);
          },
          onDragMove(e) {
            const t = this,
              { scrollbar: n, $wrapperEl: i } = t,
              { $el: r, $dragEl: s } = n;
            t.scrollbar.isTouched &&
              (e.preventDefault ? e.preventDefault() : (e.returnValue = !1),
              n.setDragPosition(e),
              i.transition(0),
              r.transition(0),
              s.transition(0),
              t.emit("scrollbarDragMove", e));
          },
          onDragEnd(e) {
            const t = this,
              n = t.params.scrollbar,
              { scrollbar: i, $wrapperEl: r } = t,
              { $el: s } = i;
            t.scrollbar.isTouched &&
              ((t.scrollbar.isTouched = !1),
              t.params.cssMode &&
                (t.$wrapperEl.css("scroll-snap-type", ""), r.transition("")),
              n.hide &&
                (clearTimeout(t.scrollbar.dragTimeout),
                (t.scrollbar.dragTimeout = ks.nextTick(() => {
                  s.css("opacity", 0), s.transition(400);
                }, 1e3))),
              t.emit("scrollbarDragEnd", e),
              n.snapOnRelease && t.slideToClosest());
          },
          enableDraggable() {
            const e = this;
            if (!e.params.scrollbar.el) return;
            const {
                scrollbar: t,
                touchEventsTouch: n,
                touchEventsDesktop: i,
                params: r,
              } = e,
              s = t.$el[0],
              a = !(!$s.passiveListener || !r.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              o = !(!$s.passiveListener || !r.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            $s.touch
              ? (s.addEventListener(n.start, e.scrollbar.onDragStart, a),
                s.addEventListener(n.move, e.scrollbar.onDragMove, a),
                s.addEventListener(n.end, e.scrollbar.onDragEnd, o))
              : (s.addEventListener(i.start, e.scrollbar.onDragStart, a),
                bs.addEventListener(i.move, e.scrollbar.onDragMove, a),
                bs.addEventListener(i.end, e.scrollbar.onDragEnd, o));
          },
          disableDraggable() {
            const e = this;
            if (!e.params.scrollbar.el) return;
            const {
                scrollbar: t,
                touchEventsTouch: n,
                touchEventsDesktop: i,
                params: r,
              } = e,
              s = t.$el[0],
              a = !(!$s.passiveListener || !r.passiveListeners) && {
                passive: !1,
                capture: !1,
              },
              o = !(!$s.passiveListener || !r.passiveListeners) && {
                passive: !0,
                capture: !1,
              };
            $s.touch
              ? (s.removeEventListener(n.start, e.scrollbar.onDragStart, a),
                s.removeEventListener(n.move, e.scrollbar.onDragMove, a),
                s.removeEventListener(n.end, e.scrollbar.onDragEnd, o))
              : (s.removeEventListener(i.start, e.scrollbar.onDragStart, a),
                bs.removeEventListener(i.move, e.scrollbar.onDragMove, a),
                bs.removeEventListener(i.end, e.scrollbar.onDragEnd, o));
          },
          init() {
            const e = this;
            if (!e.params.scrollbar.el) return;
            const { scrollbar: t, $el: n } = e,
              i = e.params.scrollbar;
            let r = Ts(i.el);
            e.params.uniqueNavElements &&
              "string" == typeof i.el &&
              r.length > 1 &&
              1 === n.find(i.el).length &&
              (r = n.find(i.el));
            let s = r.find(`.${e.params.scrollbar.dragClass}`);
            0 === s.length &&
              ((s = Ts(`<div class="${e.params.scrollbar.dragClass}"></div>`)),
              r.append(s)),
              ks.extend(t, { $el: r, el: r[0], $dragEl: s, dragEl: s[0] }),
              i.draggable && t.enableDraggable();
          },
          destroy() {
            this.scrollbar.disableDraggable();
          },
        };
        const ua = {
          setTransform(e, t) {
            const { rtl: n } = this,
              i = Ts(e),
              r = n ? -1 : 1,
              s = i.attr("data-swiper-parallax") || "0";
            let a = i.attr("data-swiper-parallax-x"),
              o = i.attr("data-swiper-parallax-y");
            const l = i.attr("data-swiper-parallax-scale"),
              c = i.attr("data-swiper-parallax-opacity");
            if (
              (a || o
                ? ((a = a || "0"), (o = o || "0"))
                : this.isHorizontal()
                ? ((a = s), (o = "0"))
                : ((o = s), (a = "0")),
              (a =
                a.indexOf("%") >= 0
                  ? parseInt(a, 10) * t * r + "%"
                  : a * t * r + "px"),
              (o =
                o.indexOf("%") >= 0 ? parseInt(o, 10) * t + "%" : o * t + "px"),
              null != c)
            ) {
              const e = c - (c - 1) * (1 - Math.abs(t));
              i[0].style.opacity = e;
            }
            if (null == l) i.transform(`translate3d(${a}, ${o}, 0px)`);
            else {
              const e = l - (l - 1) * (1 - Math.abs(t));
              i.transform(`translate3d(${a}, ${o}, 0px) scale(${e})`);
            }
          },
          setTranslate() {
            const e = this,
              { $el: t, slides: n, progress: i, snapGrid: r } = e;
            t
              .children(
                "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
              )
              .each((t, n) => {
                e.parallax.setTransform(n, i);
              }),
              n.each((t, n) => {
                let s = n.progress;
                e.params.slidesPerGroup > 1 &&
                  "auto" !== e.params.slidesPerView &&
                  (s += Math.ceil(t / 2) - i * (r.length - 1)),
                  (s = Math.min(Math.max(s, -1), 1)),
                  Ts(n)
                    .find(
                      "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
                    )
                    .each((t, n) => {
                      e.parallax.setTransform(n, s);
                    });
              });
          },
          setTransition(e = this.params.speed) {
            const { $el: t } = this;
            t.find(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            ).each((t, n) => {
              const i = Ts(n);
              let r = parseInt(i.attr("data-swiper-parallax-duration"), 10) || e;
              0 === e && (r = 0), i.transition(r);
            });
          },
        };
        const pa = {
          getDistanceBetweenTouches(e) {
            if (e.targetTouches.length < 2) return 1;
            const t = e.targetTouches[0].pageX,
              n = e.targetTouches[0].pageY,
              i = e.targetTouches[1].pageX,
              r = e.targetTouches[1].pageY;
            return Math.sqrt((i - t) ** 2 + (r - n) ** 2);
          },
          onGestureStart(e) {
            const t = this,
              n = t.params.zoom,
              i = t.zoom,
              { gesture: r } = i;
            if (
              ((i.fakeGestureTouched = !1),
              (i.fakeGestureMoved = !1),
              !$s.gestures)
            ) {
              if (
                "touchstart" !== e.type ||
                ("touchstart" === e.type && e.targetTouches.length < 2)
              )
                return;
              (i.fakeGestureTouched = !0),
                (r.scaleStart = pa.getDistanceBetweenTouches(e));
            }
            (r.$slideEl && r.$slideEl.length) ||
            ((r.$slideEl = Ts(e.target).closest(`.${t.params.slideClass}`)),
            0 === r.$slideEl.length && (r.$slideEl = t.slides.eq(t.activeIndex)),
            (r.$imageEl = r.$slideEl.find(
              "img, svg, canvas, picture, .swiper-zoom-target"
            )),
            (r.$imageWrapEl = r.$imageEl.parent(`.${n.containerClass}`)),
            (r.maxRatio = r.$imageWrapEl.attr("data-swiper-zoom") || n.maxRatio),
            0 !== r.$imageWrapEl.length)
              ? (r.$imageEl && r.$imageEl.transition(0), (t.zoom.isScaling = !0))
              : (r.$imageEl = void 0);
          },
          onGestureChange(e) {
            const t = this.params.zoom,
              n = this.zoom,
              { gesture: i } = n;
            if (!$s.gestures) {
              if (
                "touchmove" !== e.type ||
                ("touchmove" === e.type && e.targetTouches.length < 2)
              )
                return;
              (n.fakeGestureMoved = !0),
                (i.scaleMove = pa.getDistanceBetweenTouches(e));
            }
            i.$imageEl &&
              0 !== i.$imageEl.length &&
              ((n.scale = $s.gestures
                ? e.scale * n.currentScale
                : (i.scaleMove / i.scaleStart) * n.currentScale),
              n.scale > i.maxRatio &&
                (n.scale = i.maxRatio - 1 + (n.scale - i.maxRatio + 1) ** 0.5),
              n.scale < t.minRatio &&
                (n.scale = t.minRatio + 1 - (t.minRatio - n.scale + 1) ** 0.5),
              i.$imageEl.transform(`translate3d(0,0,0) scale(${n.scale})`));
          },
          onGestureEnd(e) {
            const t = this,
              n = t.params.zoom,
              i = t.zoom,
              { gesture: r } = i;
            if (!$s.gestures) {
              if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
              if (
                "touchend" !== e.type ||
                ("touchend" === e.type &&
                  e.changedTouches.length < 2 &&
                  !zs.android)
              )
                return;
              (i.fakeGestureTouched = !1), (i.fakeGestureMoved = !1);
            }
            r.$imageEl &&
              0 !== r.$imageEl.length &&
              ((i.scale = Math.max(Math.min(i.scale, r.maxRatio), n.minRatio)),
              r.$imageEl
                .transition(t.params.speed)
                .transform(`translate3d(0,0,0) scale(${i.scale})`),
              (i.currentScale = i.scale),
              (i.isScaling = !1),
              1 === i.scale && (r.$slideEl = void 0));
          },
          onTouchStart(e) {
            const t = this.zoom,
              { gesture: n, image: i } = t;
            n.$imageEl &&
              0 !== n.$imageEl.length &&
              (i.isTouched ||
                (zs.android && e.cancelable && e.preventDefault(),
                (i.isTouched = !0),
                (i.touchesStart.x =
                  "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX),
                (i.touchesStart.y =
                  "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY)));
          },
          onTouchMove(e) {
            const t = this,
              n = t.zoom,
              { gesture: i, image: r, velocity: s } = n;
            if (!i.$imageEl || 0 === i.$imageEl.length) return;
            if (((t.allowClick = !1), !r.isTouched || !i.$slideEl)) return;
            r.isMoved ||
              ((r.width = i.$imageEl[0].offsetWidth),
              (r.height = i.$imageEl[0].offsetHeight),
              (r.startX = ks.getTranslate(i.$imageWrapEl[0], "x") || 0),
              (r.startY = ks.getTranslate(i.$imageWrapEl[0], "y") || 0),
              (i.slideWidth = i.$slideEl[0].offsetWidth),
              (i.slideHeight = i.$slideEl[0].offsetHeight),
              i.$imageWrapEl.transition(0),
              t.rtl && ((r.startX = -r.startX), (r.startY = -r.startY)));
            const a = r.width * n.scale,
              o = r.height * n.scale;
            if (!(a < i.slideWidth && o < i.slideHeight)) {
              if (
                ((r.minX = Math.min(i.slideWidth / 2 - a / 2, 0)),
                (r.maxX = -r.minX),
                (r.minY = Math.min(i.slideHeight / 2 - o / 2, 0)),
                (r.maxY = -r.minY),
                (r.touchesCurrent.x =
                  "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX),
                (r.touchesCurrent.y =
                  "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY),
                !r.isMoved && !n.isScaling)
              ) {
                if (
                  t.isHorizontal() &&
                  ((Math.floor(r.minX) === Math.floor(r.startX) &&
                    r.touchesCurrent.x < r.touchesStart.x) ||
                    (Math.floor(r.maxX) === Math.floor(r.startX) &&
                      r.touchesCurrent.x > r.touchesStart.x))
                )
                  return void (r.isTouched = !1);
                if (
                  !t.isHorizontal() &&
                  ((Math.floor(r.minY) === Math.floor(r.startY) &&
                    r.touchesCurrent.y < r.touchesStart.y) ||
                    (Math.floor(r.maxY) === Math.floor(r.startY) &&
                      r.touchesCurrent.y > r.touchesStart.y))
                )
                  return void (r.isTouched = !1);
              }
              e.cancelable && e.preventDefault(),
                e.stopPropagation(),
                (r.isMoved = !0),
                (r.currentX = r.touchesCurrent.x - r.touchesStart.x + r.startX),
                (r.currentY = r.touchesCurrent.y - r.touchesStart.y + r.startY),
                r.currentX < r.minX &&
                  (r.currentX = r.minX + 1 - (r.minX - r.currentX + 1) ** 0.8),
                r.currentX > r.maxX &&
                  (r.currentX = r.maxX - 1 + (r.currentX - r.maxX + 1) ** 0.8),
                r.currentY < r.minY &&
                  (r.currentY = r.minY + 1 - (r.minY - r.currentY + 1) ** 0.8),
                r.currentY > r.maxY &&
                  (r.currentY = r.maxY - 1 + (r.currentY - r.maxY + 1) ** 0.8),
                s.prevPositionX || (s.prevPositionX = r.touchesCurrent.x),
                s.prevPositionY || (s.prevPositionY = r.touchesCurrent.y),
                s.prevTime || (s.prevTime = Date.now()),
                (s.x =
                  (r.touchesCurrent.x - s.prevPositionX) /
                  (Date.now() - s.prevTime) /
                  2),
                (s.y =
                  (r.touchesCurrent.y - s.prevPositionY) /
                  (Date.now() - s.prevTime) /
                  2),
                Math.abs(r.touchesCurrent.x - s.prevPositionX) < 2 && (s.x = 0),
                Math.abs(r.touchesCurrent.y - s.prevPositionY) < 2 && (s.y = 0),
                (s.prevPositionX = r.touchesCurrent.x),
                (s.prevPositionY = r.touchesCurrent.y),
                (s.prevTime = Date.now()),
                i.$imageWrapEl.transform(
                  `translate3d(${r.currentX}px, ${r.currentY}px,0)`
                );
            }
          },
          onTouchEnd() {
            const e = this.zoom,
              { gesture: t, image: n, velocity: i } = e;
            if (!t.$imageEl || 0 === t.$imageEl.length) return;
            if (!n.isTouched || !n.isMoved)
              return (n.isTouched = !1), void (n.isMoved = !1);
            (n.isTouched = !1), (n.isMoved = !1);
            let r = 300,
              s = 300;
            const a = i.x * r,
              o = n.currentX + a,
              l = i.y * s,
              c = n.currentY + l;
            0 !== i.x && (r = Math.abs((o - n.currentX) / i.x)),
              0 !== i.y && (s = Math.abs((c - n.currentY) / i.y));
            const d = Math.max(r, s);
            (n.currentX = o), (n.currentY = c);
            const u = n.width * e.scale,
              p = n.height * e.scale;
            (n.minX = Math.min(t.slideWidth / 2 - u / 2, 0)),
              (n.maxX = -n.minX),
              (n.minY = Math.min(t.slideHeight / 2 - p / 2, 0)),
              (n.maxY = -n.minY),
              (n.currentX = Math.max(Math.min(n.currentX, n.maxX), n.minX)),
              (n.currentY = Math.max(Math.min(n.currentY, n.maxY), n.minY)),
              t.$imageWrapEl
                .transition(d)
                .transform(`translate3d(${n.currentX}px, ${n.currentY}px,0)`);
          },
          onTransitionEnd() {
            const e = this,
              t = e.zoom,
              { gesture: n } = t;
            n.$slideEl &&
              e.previousIndex !== e.activeIndex &&
              (n.$imageEl && n.$imageEl.transform("translate3d(0,0,0) scale(1)"),
              n.$imageWrapEl && n.$imageWrapEl.transform("translate3d(0,0,0)"),
              (t.scale = 1),
              (t.currentScale = 1),
              (n.$slideEl = void 0),
              (n.$imageEl = void 0),
              (n.$imageWrapEl = void 0));
          },
          toggle(e) {
            const t = this.zoom;
            t.scale && 1 !== t.scale ? t.out() : t.in(e);
          },
          in(e) {
            const t = this,
              n = t.zoom,
              i = t.params.zoom,
              { gesture: r, image: s } = n;
            if (
              (r.$slideEl ||
                (t.params.virtual && t.params.virtual.enabled && t.virtual
                  ? (r.$slideEl = t.$wrapperEl.children(
                      `.${t.params.slideActiveClass}`
                    ))
                  : (r.$slideEl = t.slides.eq(t.activeIndex)),
                (r.$imageEl = r.$slideEl.find(
                  "img, svg, canvas, picture, .swiper-zoom-target"
                )),
                (r.$imageWrapEl = r.$imageEl.parent(`.${i.containerClass}`))),
              !r.$imageEl || 0 === r.$imageEl.length)
            )
              return;
            let a, o, l, c, d, u, p, h, f, m, v, y, g, x, b, w, S, C;
            r.$slideEl.addClass(`${i.zoomedSlideClass}`),
              void 0 === s.touchesStart.x && e
                ? ((a =
                    "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX),
                  (o =
                    "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY))
                : ((a = s.touchesStart.x), (o = s.touchesStart.y)),
              (n.scale = r.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
              (n.currentScale =
                r.$imageWrapEl.attr("data-swiper-zoom") || i.maxRatio),
              e
                ? ((S = r.$slideEl[0].offsetWidth),
                  (C = r.$slideEl[0].offsetHeight),
                  (l = r.$slideEl.offset().left),
                  (c = r.$slideEl.offset().top),
                  (d = l + S / 2 - a),
                  (u = c + C / 2 - o),
                  (f = r.$imageEl[0].offsetWidth),
                  (m = r.$imageEl[0].offsetHeight),
                  (v = f * n.scale),
                  (y = m * n.scale),
                  (g = Math.min(S / 2 - v / 2, 0)),
                  (x = Math.min(C / 2 - y / 2, 0)),
                  (b = -g),
                  (w = -x),
                  (p = d * n.scale),
                  (h = u * n.scale),
                  p < g && (p = g),
                  p > b && (p = b),
                  h < x && (h = x),
                  h > w && (h = w))
                : ((p = 0), (h = 0)),
              r.$imageWrapEl
                .transition(300)
                .transform(`translate3d(${p}px, ${h}px,0)`),
              r.$imageEl
                .transition(300)
                .transform(`translate3d(0,0,0) scale(${n.scale})`);
          },
          out() {
            const e = this,
              t = e.zoom,
              n = e.params.zoom,
              { gesture: i } = t;
            i.$slideEl ||
              (e.params.virtual && e.params.virtual.enabled && e.virtual
                ? (i.$slideEl = e.$wrapperEl.children(
                    `.${e.params.slideActiveClass}`
                  ))
                : (i.$slideEl = e.slides.eq(e.activeIndex)),
              (i.$imageEl = i.$slideEl.find(
                "img, svg, canvas, picture, .swiper-zoom-target"
              )),
              (i.$imageWrapEl = i.$imageEl.parent(`.${n.containerClass}`))),
              i.$imageEl &&
                0 !== i.$imageEl.length &&
                ((t.scale = 1),
                (t.currentScale = 1),
                i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                i.$imageEl
                  .transition(300)
                  .transform("translate3d(0,0,0) scale(1)"),
                i.$slideEl.removeClass(`${n.zoomedSlideClass}`),
                (i.$slideEl = void 0));
          },
          enable() {
            const e = this,
              t = e.zoom;
            if (t.enabled) return;
            t.enabled = !0;
            const n = !(
                "touchstart" !== e.touchEvents.start ||
                !$s.passiveListener ||
                !e.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i = !$s.passiveListener || { passive: !1, capture: !0 },
              r = `.${e.params.slideClass}`;
            $s.gestures
              ? (e.$wrapperEl.on("gesturestart", r, t.onGestureStart, n),
                e.$wrapperEl.on("gesturechange", r, t.onGestureChange, n),
                e.$wrapperEl.on("gestureend", r, t.onGestureEnd, n))
              : "touchstart" === e.touchEvents.start &&
                (e.$wrapperEl.on(e.touchEvents.start, r, t.onGestureStart, n),
                e.$wrapperEl.on(e.touchEvents.move, r, t.onGestureChange, i),
                e.$wrapperEl.on(e.touchEvents.end, r, t.onGestureEnd, n),
                e.touchEvents.cancel &&
                  e.$wrapperEl.on(e.touchEvents.cancel, r, t.onGestureEnd, n)),
              e.$wrapperEl.on(
                e.touchEvents.move,
                `.${e.params.zoom.containerClass}`,
                t.onTouchMove,
                i
              );
          },
          disable() {
            const e = this,
              t = e.zoom;
            if (!t.enabled) return;
            e.zoom.enabled = !1;
            const n = !(
                "touchstart" !== e.touchEvents.start ||
                !$s.passiveListener ||
                !e.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              i = !$s.passiveListener || { passive: !1, capture: !0 },
              r = `.${e.params.slideClass}`;
            $s.gestures
              ? (e.$wrapperEl.off("gesturestart", r, t.onGestureStart, n),
                e.$wrapperEl.off("gesturechange", r, t.onGestureChange, n),
                e.$wrapperEl.off("gestureend", r, t.onGestureEnd, n))
              : "touchstart" === e.touchEvents.start &&
                (e.$wrapperEl.off(e.touchEvents.start, r, t.onGestureStart, n),
                e.$wrapperEl.off(e.touchEvents.move, r, t.onGestureChange, i),
                e.$wrapperEl.off(e.touchEvents.end, r, t.onGestureEnd, n),
                e.touchEvents.cancel &&
                  e.$wrapperEl.off(e.touchEvents.cancel, r, t.onGestureEnd, n)),
              e.$wrapperEl.off(
                e.touchEvents.move,
                `.${e.params.zoom.containerClass}`,
                t.onTouchMove,
                i
              );
          },
        };
        const ha = {
          loadInSlide(e, t = !0) {
            const n = this,
              i = n.params.lazy;
            if (void 0 === e) return;
            if (0 === n.slides.length) return;
            const r =
              n.virtual && n.params.virtual.enabled
                ? n.$wrapperEl.children(
                    `.${n.params.slideClass}[data-swiper-slide-index="${e}"]`
                  )
                : n.slides.eq(e);
            let s = r.find(
              `.${i.elementClass}:not(.${i.loadedClass}):not(.${i.loadingClass})`
            );
            !r.hasClass(i.elementClass) ||
              r.hasClass(i.loadedClass) ||
              r.hasClass(i.loadingClass) ||
              (s = s.add(r[0])),
              0 !== s.length &&
                s.each((e, s) => {
                  const a = Ts(s);
                  a.addClass(i.loadingClass);
                  const o = a.attr("data-background"),
                    l = a.attr("data-src"),
                    c = a.attr("data-srcset"),
                    d = a.attr("data-sizes"),
                    u = a.parent("picture");
                  n.loadImage(a[0], l || o, c, d, !1, () => {
                    if (null != n && n && (!n || n.params) && !n.destroyed) {
                      if (
                        (o
                          ? (a.css("background-image", `url("${o}")`),
                            a.removeAttr("data-background"))
                          : (c &&
                              (a.attr("srcset", c), a.removeAttr("data-srcset")),
                            d && (a.attr("sizes", d), a.removeAttr("data-sizes")),
                            u.length &&
                              u.children("source").each((e, t) => {
                                const n = Ts(t);
                                n.attr("data-srcset") &&
                                  (n.attr("srcset", n.attr("data-srcset")),
                                  n.removeAttr("data-srcset"));
                              }),
                            l && (a.attr("src", l), a.removeAttr("data-src"))),
                        a.addClass(i.loadedClass).removeClass(i.loadingClass),
                        r.find(`.${i.preloaderClass}`).remove(),
                        n.params.loop && t)
                      ) {
                        const e = r.attr("data-swiper-slide-index");
                        if (r.hasClass(n.params.slideDuplicateClass)) {
                          const t = n.$wrapperEl.children(
                            `[data-swiper-slide-index="${e}"]:not(.${n.params.slideDuplicateClass})`
                          );
                          n.lazy.loadInSlide(t.index(), !1);
                        } else {
                          const t = n.$wrapperEl.children(
                            `.${n.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`
                          );
                          n.lazy.loadInSlide(t.index(), !1);
                        }
                      }
                      n.emit("lazyImageReady", r[0], a[0]),
                        n.params.autoHeight && n.updateAutoHeight();
                    }
                  }),
                    n.emit("lazyImageLoad", r[0], a[0]);
                });
          },
          load() {
            const e = this,
              { $wrapperEl: t, params: n, slides: i, activeIndex: r } = e,
              s = e.virtual && n.virtual.enabled,
              a = n.lazy;
            let o = n.slidesPerView;
            function l(e) {
              if (s) {
                if (
                  t.children(`.${n.slideClass}[data-swiper-slide-index="${e}"]`)
                    .length
                )
                  return !0;
              } else if (i[e]) return !0;
              return !1;
            }
            function c(e) {
              return s ? Ts(e).attr("data-swiper-slide-index") : Ts(e).index();
            }
            if (
              ("auto" === o && (o = 0),
              e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0),
              e.params.watchSlidesVisibility)
            )
              t.children(`.${n.slideVisibleClass}`).each((t, n) => {
                const i = s
                  ? Ts(n).attr("data-swiper-slide-index")
                  : Ts(n).index();
                e.lazy.loadInSlide(i);
              });
            else if (o > 1)
              for (let t = r; t < r + o; t += 1) l(t) && e.lazy.loadInSlide(t);
            else e.lazy.loadInSlide(r);
            if (a.loadPrevNext)
              if (o > 1 || (a.loadPrevNextAmount && a.loadPrevNextAmount > 1)) {
                const t = a.loadPrevNextAmount,
                  n = o,
                  s = Math.min(r + n + Math.max(t, n), i.length),
                  c = Math.max(r - Math.max(n, t), 0);
                for (let t = r + o; t < s; t += 1) l(t) && e.lazy.loadInSlide(t);
                for (let t = c; t < r; t += 1) l(t) && e.lazy.loadInSlide(t);
              } else {
                const i = t.children(`.${n.slideNextClass}`);
                i.length > 0 && e.lazy.loadInSlide(c(i));
                const r = t.children(`.${n.slidePrevClass}`);
                r.length > 0 && e.lazy.loadInSlide(c(r));
              }
          },
        };
        const fa = {
          LinearSpline: function (e, t) {
            const n = (function () {
              let e, t, n;
              return (i, r) => {
                for (t = -1, e = i.length; e - t > 1; )
                  (n = (e + t) >> 1), i[n] <= r ? (t = n) : (e = n);
                return e;
              };
            })();
            let i, r;
            return (
              (this.x = e),
              (this.y = t),
              (this.lastIndex = e.length - 1),
              (this.interpolate = function (e) {
                return e
                  ? ((r = n(this.x, e)),
                    (i = r - 1),
                    ((e - this.x[i]) * (this.y[r] - this.y[i])) /
                      (this.x[r] - this.x[i]) +
                      this.y[i])
                  : 0;
              }),
              this
            );
          },
          getInterpolateFunction(e) {
            const t = this;
            t.controller.spline ||
              (t.controller.spline = t.params.loop
                ? new fa.LinearSpline(t.slidesGrid, e.slidesGrid)
                : new fa.LinearSpline(t.snapGrid, e.snapGrid));
          },
          setTranslate(e, t) {
            const n = this,
              i = n.controller.control;
            let r, s;
            function a(e) {
              const t = n.rtlTranslate ? -n.translate : n.translate;
              "slide" === n.params.controller.by &&
                (n.controller.getInterpolateFunction(e),
                (s = -n.controller.spline.interpolate(-t))),
                (s && "container" !== n.params.controller.by) ||
                  ((r =
                    (e.maxTranslate() - e.minTranslate()) /
                    (n.maxTranslate() - n.minTranslate())),
                  (s = (t - n.minTranslate()) * r + e.minTranslate())),
                n.params.controller.inverse && (s = e.maxTranslate() - s),
                e.updateProgress(s),
                e.setTranslate(s, n),
                e.updateActiveIndex(),
                e.updateSlidesClasses();
            }
            if (Array.isArray(i))
              for (let e = 0; e < i.length; e += 1)
                i[e] !== t && i[e] instanceof Us && a(i[e]);
            else i instanceof Us && t !== i && a(i);
          },
          setTransition(e, t) {
            const n = this,
              i = n.controller.control;
            let r;
            function s(t) {
              t.setTransition(e, n),
                0 !== e &&
                  (t.transitionStart(),
                  t.params.autoHeight &&
                    ks.nextTick(() => {
                      t.updateAutoHeight();
                    }),
                  t.$wrapperEl.transitionEnd(() => {
                    i &&
                      (t.params.loop &&
                        "slide" === n.params.controller.by &&
                        t.loopFix(),
                      t.transitionEnd());
                  }));
            }
            if (Array.isArray(i))
              for (r = 0; r < i.length; r += 1)
                i[r] !== t && i[r] instanceof Us && s(i[r]);
            else i instanceof Us && t !== i && s(i);
          },
        };
        var ma = {
          name: "controller",
          params: { controller: { control: void 0, inverse: !1, by: "slide" } },
          create() {
            const e = this;
            ks.extend(e, {
              controller: {
                control: e.params.controller.control,
                getInterpolateFunction: fa.getInterpolateFunction.bind(e),
                setTranslate: fa.setTranslate.bind(e),
                setTransition: fa.setTransition.bind(e),
              },
            });
          },
          on: {
            update() {
              const e = this;
              e.controller.control &&
                e.controller.spline &&
                ((e.controller.spline = void 0), delete e.controller.spline);
            },
            resize() {
              const e = this;
              e.controller.control &&
                e.controller.spline &&
                ((e.controller.spline = void 0), delete e.controller.spline);
            },
            observerUpdate() {
              const e = this;
              e.controller.control &&
                e.controller.spline &&
                ((e.controller.spline = void 0), delete e.controller.spline);
            },
            setTranslate(e, t) {
              this.controller.control && this.controller.setTranslate(e, t);
            },
            setTransition(e, t) {
              this.controller.control && this.controller.setTransition(e, t);
            },
          },
        };
        const va = {
          makeElFocusable: (e) => (e.attr("tabIndex", "0"), e),
          makeElNotFocusable: (e) => (e.attr("tabIndex", "-1"), e),
          addElRole: (e, t) => (e.attr("role", t), e),
          addElLabel: (e, t) => (e.attr("aria-label", t), e),
          disableEl: (e) => (e.attr("aria-disabled", !0), e),
          enableEl: (e) => (e.attr("aria-disabled", !1), e),
          onEnterKey(e) {
            const t = this,
              n = t.params.a11y;
            if (13 !== e.keyCode) return;
            const i = Ts(e.target);
            t.navigation &&
              t.navigation.$nextEl &&
              i.is(t.navigation.$nextEl) &&
              ((t.isEnd && !t.params.loop) || t.slideNext(),
              t.isEnd
                ? t.a11y.notify(n.lastSlideMessage)
                : t.a11y.notify(n.nextSlideMessage)),
              t.navigation &&
                t.navigation.$prevEl &&
                i.is(t.navigation.$prevEl) &&
                ((t.isBeginning && !t.params.loop) || t.slidePrev(),
                t.isBeginning
                  ? t.a11y.notify(n.firstSlideMessage)
                  : t.a11y.notify(n.prevSlideMessage)),
              t.pagination &&
                i.is(`.${t.params.pagination.bulletClass}`) &&
                i[0].click();
          },
          notify(e) {
            const t = this.a11y.liveRegion;
            0 !== t.length && (t.html(""), t.html(e));
          },
          updateNavigation() {
            const e = this;
            if (e.params.loop || !e.navigation) return;
            const { $nextEl: t, $prevEl: n } = e.navigation;
            n &&
              n.length > 0 &&
              (e.isBeginning
                ? (e.a11y.disableEl(n), e.a11y.makeElNotFocusable(n))
                : (e.a11y.enableEl(n), e.a11y.makeElFocusable(n))),
              t &&
                t.length > 0 &&
                (e.isEnd
                  ? (e.a11y.disableEl(t), e.a11y.makeElNotFocusable(t))
                  : (e.a11y.enableEl(t), e.a11y.makeElFocusable(t)));
          },
          updatePagination() {
            const e = this,
              t = e.params.a11y;
            e.pagination &&
              e.params.pagination.clickable &&
              e.pagination.bullets &&
              e.pagination.bullets.length &&
              e.pagination.bullets.each((n, i) => {
                const r = Ts(i);
                e.a11y.makeElFocusable(r),
                  e.a11y.addElRole(r, "button"),
                  e.a11y.addElLabel(
                    r,
                    t.paginationBulletMessage.replace(
                      /\{\{index\}\}/,
                      r.index() + 1
                    )
                  );
              });
          },
          init() {
            const e = this;
            e.$el.append(e.a11y.liveRegion);
            const t = e.params.a11y;
            let n, i;
            e.navigation && e.navigation.$nextEl && (n = e.navigation.$nextEl),
              e.navigation && e.navigation.$prevEl && (i = e.navigation.$prevEl),
              n &&
                (e.a11y.makeElFocusable(n),
                e.a11y.addElRole(n, "button"),
                e.a11y.addElLabel(n, t.nextSlideMessage),
                n.on("keydown", e.a11y.onEnterKey)),
              i &&
                (e.a11y.makeElFocusable(i),
                e.a11y.addElRole(i, "button"),
                e.a11y.addElLabel(i, t.prevSlideMessage),
                i.on("keydown", e.a11y.onEnterKey)),
              e.pagination &&
                e.params.pagination.clickable &&
                e.pagination.bullets &&
                e.pagination.bullets.length &&
                e.pagination.$el.on(
                  "keydown",
                  `.${e.params.pagination.bulletClass}`,
                  e.a11y.onEnterKey
                );
          },
          destroy() {
            const e = this;
            let t, n;
            e.a11y.liveRegion &&
              e.a11y.liveRegion.length > 0 &&
              e.a11y.liveRegion.remove(),
              e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
              e.navigation && e.navigation.$prevEl && (n = e.navigation.$prevEl),
              t && t.off("keydown", e.a11y.onEnterKey),
              n && n.off("keydown", e.a11y.onEnterKey),
              e.pagination &&
                e.params.pagination.clickable &&
                e.pagination.bullets &&
                e.pagination.bullets.length &&
                e.pagination.$el.off(
                  "keydown",
                  `.${e.params.pagination.bulletClass}`,
                  e.a11y.onEnterKey
                );
          },
        };
        const ya = {
          init() {
            const e = this;
            if (!e.params.history) return;
            if (!Ss.history || !Ss.history.pushState)
              return (
                (e.params.history.enabled = !1),
                void (e.params.hashNavigation.enabled = !0)
              );
            const t = e.history;
            (t.initialized = !0),
              (t.paths = ya.getPathValues()),
              (t.paths.key || t.paths.value) &&
                (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit),
                e.params.history.replaceState ||
                  Ss.addEventListener("popstate", e.history.setHistoryPopState));
          },
          destroy() {
            const e = this;
            e.params.history.replaceState ||
              Ss.removeEventListener("popstate", e.history.setHistoryPopState);
          },
          setHistoryPopState() {
            const e = this;
            (e.history.paths = ya.getPathValues()),
              e.history.scrollToSlide(e.params.speed, e.history.paths.value, !1);
          },
          getPathValues() {
            const e = Ss.location.pathname
                .slice(1)
                .split("/")
                .filter((e) => "" !== e),
              t = e.length;
            return { key: e[t - 2], value: e[t - 1] };
          },
          setHistory(e, t) {
            const n = this;
            if (!n.history.initialized || !n.params.history.enabled) return;
            const i = n.slides.eq(t);
            let r = ya.slugify(i.attr("data-history"));
            Ss.location.pathname.includes(e) || (r = `${e}/${r}`);
            const s = Ss.history.state;
            (s && s.value === r) ||
              (n.params.history.replaceState
                ? Ss.history.replaceState({ value: r }, null, r)
                : Ss.history.pushState({ value: r }, null, r));
          },
          slugify: (e) =>
            e
              .toString()
              .replace(/\s+/g, "-")
              .replace(/[^\w-]+/g, "")
              .replace(/--+/g, "-")
              .replace(/^-+/, "")
              .replace(/-+$/, ""),
          scrollToSlide(e, t, n) {
            const i = this;
            if (t)
              for (let r = 0, s = i.slides.length; r < s; r += 1) {
                const s = i.slides.eq(r);
                if (
                  ya.slugify(s.attr("data-history")) === t &&
                  !s.hasClass(i.params.slideDuplicateClass)
                ) {
                  const t = s.index();
                  i.slideTo(t, e, n);
                }
              }
            else i.slideTo(0, e, n);
          },
        };
        const ga = {
          onHashCange() {
            const e = this;
            e.emit("hashChange");
            const t = bs.location.hash.replace("#", "");
            if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
              const n = e.$wrapperEl
                .children(`.${e.params.slideClass}[data-hash="${t}"]`)
                .index();
              if (void 0 === n) return;
              e.slideTo(n);
            }
          },
          setHash() {
            const e = this;
            if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
              if (
                e.params.hashNavigation.replaceState &&
                Ss.history &&
                Ss.history.replaceState
              )
                Ss.history.replaceState(
                  null,
                  null,
                  `#${e.slides.eq(e.activeIndex).attr("data-hash")}` || ""
                ),
                  e.emit("hashSet");
              else {
                const t = e.slides.eq(e.activeIndex),
                  n = t.attr("data-hash") || t.attr("data-history");
                (bs.location.hash = n || ""), e.emit("hashSet");
              }
          },
          init() {
            const e = this;
            if (
              !e.params.hashNavigation.enabled ||
              (e.params.history && e.params.history.enabled)
            )
              return;
            e.hashNavigation.initialized = !0;
            const t = bs.location.hash.replace("#", "");
            if (t) {
              const n = 0;
              for (let i = 0, r = e.slides.length; i < r; i += 1) {
                const r = e.slides.eq(i);
                if (
                  (r.attr("data-hash") || r.attr("data-history")) === t &&
                  !r.hasClass(e.params.slideDuplicateClass)
                ) {
                  const t = r.index();
                  e.slideTo(t, n, e.params.runCallbacksOnInit, !0);
                }
              }
            }
            e.params.hashNavigation.watchState &&
              Ts(Ss).on("hashchange", e.hashNavigation.onHashCange);
          },
          destroy() {
            const e = this;
            e.params.hashNavigation.watchState &&
              Ts(Ss).off("hashchange", e.hashNavigation.onHashCange);
          },
        };
        const xa = {
          run() {
            const e = this,
              t = e.slides.eq(e.activeIndex);
            let n = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") &&
              (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
              clearTimeout(e.autoplay.timeout),
              (e.autoplay.timeout = ks.nextTick(() => {
                e.params.autoplay.reverseDirection
                  ? e.params.loop
                    ? (e.loopFix(),
                      e.slidePrev(e.params.speed, !0, !0),
                      e.emit("autoplay"))
                    : e.isBeginning
                    ? e.params.autoplay.stopOnLastSlide
                      ? e.autoplay.stop()
                      : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0),
                        e.emit("autoplay"))
                    : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay"))
                  : e.params.loop
                  ? (e.loopFix(),
                    e.slideNext(e.params.speed, !0, !0),
                    e.emit("autoplay"))
                  : e.isEnd
                  ? e.params.autoplay.stopOnLastSlide
                    ? e.autoplay.stop()
                    : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay"))
                  : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")),
                  e.params.cssMode && e.autoplay.running && e.autoplay.run();
              }, n));
          },
          start() {
            const e = this;
            return (
              void 0 === e.autoplay.timeout &&
              !e.autoplay.running &&
              ((e.autoplay.running = !0),
              e.emit("autoplayStart"),
              e.autoplay.run(),
              !0)
            );
          },
          stop() {
            const e = this;
            return (
              !!e.autoplay.running &&
              void 0 !== e.autoplay.timeout &&
              (e.autoplay.timeout &&
                (clearTimeout(e.autoplay.timeout), (e.autoplay.timeout = void 0)),
              (e.autoplay.running = !1),
              e.emit("autoplayStop"),
              !0)
            );
          },
          pause(e) {
            const t = this;
            t.autoplay.running &&
              (t.autoplay.paused ||
                (t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
                (t.autoplay.paused = !0),
                0 !== e && t.params.autoplay.waitForTransition
                  ? (t.$wrapperEl[0].addEventListener(
                      "transitionend",
                      t.autoplay.onTransitionEnd
                    ),
                    t.$wrapperEl[0].addEventListener(
                      "webkitTransitionEnd",
                      t.autoplay.onTransitionEnd
                    ))
                  : ((t.autoplay.paused = !1), t.autoplay.run())));
          },
        };
        const ba = {
          setTranslate() {
            const e = this,
              { slides: t } = e;
            for (let n = 0; n < t.length; n += 1) {
              const t = e.slides.eq(n);
              let i = -t[0].swiperSlideOffset;
              e.params.virtualTranslate || (i -= e.translate);
              let r = 0;
              e.isHorizontal() || ((r = i), (i = 0));
              const s = e.params.fadeEffect.crossFade
                ? Math.max(1 - Math.abs(t[0].progress), 0)
                : 1 + Math.min(Math.max(t[0].progress, -1), 0);
              t.css({ opacity: s }).transform(`translate3d(${i}px, ${r}px, 0px)`);
            }
          },
          setTransition(e) {
            const t = this,
              { slides: n, $wrapperEl: i } = t;
            if ((n.transition(e), t.params.virtualTranslate && 0 !== e)) {
              let e = !1;
              n.transitionEnd(() => {
                if (e) return;
                if (!t || t.destroyed) return;
                (e = !0), (t.animating = !1);
                const n = ["webkitTransitionEnd", "transitionend"];
                for (let e = 0; e < n.length; e += 1) i.trigger(n[e]);
              });
            }
          },
        };
        const wa = {
          setTranslate() {
            const e = this,
              {
                $el: t,
                $wrapperEl: n,
                slides: i,
                width: r,
                height: s,
                rtlTranslate: a,
                size: o,
              } = e,
              l = e.params.cubeEffect,
              c = e.isHorizontal(),
              d = e.virtual && e.params.virtual.enabled;
            let u,
              p = 0;
            l.shadow &&
              (c
                ? ((u = n.find(".swiper-cube-shadow")),
                  0 === u.length &&
                    ((u = Ts('<div class="swiper-cube-shadow"></div>')),
                    n.append(u)),
                  u.css({ height: `${r}px` }))
                : ((u = t.find(".swiper-cube-shadow")),
                  0 === u.length &&
                    ((u = Ts('<div class="swiper-cube-shadow"></div>')),
                    t.append(u))));
            for (let e = 0; e < i.length; e += 1) {
              const t = i.eq(e);
              let n = e;
              d && (n = parseInt(t.attr("data-swiper-slide-index"), 10));
              let r = 90 * n,
                s = Math.floor(r / 360);
              a && ((r = -r), (s = Math.floor(-r / 360)));
              const u = Math.max(Math.min(t[0].progress, 1), -1);
              let h = 0,
                f = 0,
                m = 0;
              n % 4 == 0
                ? ((h = 4 * -s * o), (m = 0))
                : (n - 1) % 4 == 0
                ? ((h = 0), (m = 4 * -s * o))
                : (n - 2) % 4 == 0
                ? ((h = o + 4 * s * o), (m = o))
                : (n - 3) % 4 == 0 && ((h = -o), (m = 3 * o + 4 * o * s)),
                a && (h = -h),
                c || ((f = h), (h = 0));
              const v = `rotateX(${c ? 0 : -r}deg) rotateY(${
                c ? r : 0
              }deg) translate3d(${h}px, ${f}px, ${m}px)`;
              if (
                (u <= 1 &&
                  u > -1 &&
                  ((p = 90 * n + 90 * u), a && (p = 90 * -n - 90 * u)),
                t.transform(v),
                l.slideShadows)
              ) {
                let e = c
                    ? t.find(".swiper-slide-shadow-left")
                    : t.find(".swiper-slide-shadow-top"),
                  n = c
                    ? t.find(".swiper-slide-shadow-right")
                    : t.find(".swiper-slide-shadow-bottom");
                0 === e.length &&
                  ((e = Ts(
                    `<div class="swiper-slide-shadow-${
                      c ? "left" : "top"
                    }"></div>`
                  )),
                  t.append(e)),
                  0 === n.length &&
                    ((n = Ts(
                      `<div class="swiper-slide-shadow-${
                        c ? "right" : "bottom"
                      }"></div>`
                    )),
                    t.append(n)),
                  e.length && (e[0].style.opacity = Math.max(-u, 0)),
                  n.length && (n[0].style.opacity = Math.max(u, 0));
              }
            }
            if (
              (n.css({
                "-webkit-transform-origin": `50% 50% -${o / 2}px`,
                "-moz-transform-origin": `50% 50% -${o / 2}px`,
                "-ms-transform-origin": `50% 50% -${o / 2}px`,
                "transform-origin": `50% 50% -${o / 2}px`,
              }),
              l.shadow)
            )
              if (c)
                u.transform(
                  `translate3d(0px, ${r / 2 + l.shadowOffset}px, ${
                    -r / 2
                  }px) rotateX(90deg) rotateZ(0deg) scale(${l.shadowScale})`
                );
              else {
                const e = Math.abs(p) - 90 * Math.floor(Math.abs(p) / 90),
                  t =
                    1.5 -
                    (Math.sin((2 * e * Math.PI) / 360) / 2 +
                      Math.cos((2 * e * Math.PI) / 360) / 2),
                  n = l.shadowScale,
                  i = l.shadowScale / t,
                  r = l.shadowOffset;
                u.transform(
                  `scale3d(${n}, 1, ${i}) translate3d(0px, ${s / 2 + r}px, ${
                    -s / 2 / i
                  }px) rotateX(-90deg)`
                );
              }
            const h = Qs.isSafari || Qs.isWebView ? -o / 2 : 0;
            n.transform(
              `translate3d(0px,0,${h}px) rotateX(${
                e.isHorizontal() ? 0 : p
              }deg) rotateY(${e.isHorizontal() ? -p : 0}deg)`
            );
          },
          setTransition(e) {
            const t = this,
              { $el: n, slides: i } = t;
            i
              .transition(e)
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .transition(e),
              t.params.cubeEffect.shadow &&
                !t.isHorizontal() &&
                n.find(".swiper-cube-shadow").transition(e);
          },
        };
        const Sa = {
          setTranslate() {
            const e = this,
              { slides: t, rtlTranslate: n } = e;
            for (let i = 0; i < t.length; i += 1) {
              const r = t.eq(i);
              let s = r[0].progress;
              e.params.flipEffect.limitRotation &&
                (s = Math.max(Math.min(r[0].progress, 1), -1));
              let a = -180 * s,
                o = 0,
                l = -r[0].swiperSlideOffset,
                c = 0;
              if (
                (e.isHorizontal()
                  ? n && (a = -a)
                  : ((c = l), (l = 0), (o = -a), (a = 0)),
                (r[0].style.zIndex = -Math.abs(Math.round(s)) + t.length),
                e.params.flipEffect.slideShadows)
              ) {
                let t = e.isHorizontal()
                    ? r.find(".swiper-slide-shadow-left")
                    : r.find(".swiper-slide-shadow-top"),
                  n = e.isHorizontal()
                    ? r.find(".swiper-slide-shadow-right")
                    : r.find(".swiper-slide-shadow-bottom");
                0 === t.length &&
                  ((t = Ts(
                    `<div class="swiper-slide-shadow-${
                      e.isHorizontal() ? "left" : "top"
                    }"></div>`
                  )),
                  r.append(t)),
                  0 === n.length &&
                    ((n = Ts(
                      `<div class="swiper-slide-shadow-${
                        e.isHorizontal() ? "right" : "bottom"
                      }"></div>`
                    )),
                    r.append(n)),
                  t.length && (t[0].style.opacity = Math.max(-s, 0)),
                  n.length && (n[0].style.opacity = Math.max(s, 0));
              }
              r.transform(
                `translate3d(${l}px, ${c}px, 0px) rotateX(${o}deg) rotateY(${a}deg)`
              );
            }
          },
          setTransition(e) {
            const t = this,
              { slides: n, activeIndex: i, $wrapperEl: r } = t;
            if (
              (n
                .transition(e)
                .find(
                  ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
                )
                .transition(e),
              t.params.virtualTranslate && 0 !== e)
            ) {
              let e = !1;
              n.eq(i).transitionEnd(function () {
                if (e) return;
                if (!t || t.destroyed) return;
                (e = !0), (t.animating = !1);
                const n = ["webkitTransitionEnd", "transitionend"];
                for (let e = 0; e < n.length; e += 1) r.trigger(n[e]);
              });
            }
          },
        };
        const Ca = {
          setTranslate() {
            const e = this,
              {
                width: t,
                height: n,
                slides: i,
                $wrapperEl: r,
                slidesSizesGrid: s,
              } = e,
              a = e.params.coverflowEffect,
              o = e.isHorizontal(),
              l = e.translate,
              c = o ? t / 2 - l : n / 2 - l,
              d = o ? a.rotate : -a.rotate,
              u = a.depth;
            for (let e = 0, t = i.length; e < t; e += 1) {
              const t = i.eq(e),
                n = s[e],
                r = ((c - t[0].swiperSlideOffset - n / 2) / n) * a.modifier;
              let l = o ? d * r : 0,
                p = o ? 0 : d * r,
                h = -u * Math.abs(r),
                f = a.stretch;
              "string" == typeof f &&
                -1 !== f.indexOf("%") &&
                (f = (parseFloat(a.stretch) / 100) * n);
              let m = o ? 0 : f * r,
                v = o ? f * r : 0,
                y = 1 - (1 - a.scale) * Math.abs(r);
              Math.abs(v) < 0.001 && (v = 0),
                Math.abs(m) < 0.001 && (m = 0),
                Math.abs(h) < 0.001 && (h = 0),
                Math.abs(l) < 0.001 && (l = 0),
                Math.abs(p) < 0.001 && (p = 0),
                Math.abs(y) < 0.001 && (y = 0);
              const g = `translate3d(${v}px,${m}px,${h}px)  rotateX(${p}deg) rotateY(${l}deg) scale(${y})`;
              if (
                (t.transform(g),
                (t[0].style.zIndex = 1 - Math.abs(Math.round(r))),
                a.slideShadows)
              ) {
                let e = o
                    ? t.find(".swiper-slide-shadow-left")
                    : t.find(".swiper-slide-shadow-top"),
                  n = o
                    ? t.find(".swiper-slide-shadow-right")
                    : t.find(".swiper-slide-shadow-bottom");
                0 === e.length &&
                  ((e = Ts(
                    `<div class="swiper-slide-shadow-${
                      o ? "left" : "top"
                    }"></div>`
                  )),
                  t.append(e)),
                  0 === n.length &&
                    ((n = Ts(
                      `<div class="swiper-slide-shadow-${
                        o ? "right" : "bottom"
                      }"></div>`
                    )),
                    t.append(n)),
                  e.length && (e[0].style.opacity = r > 0 ? r : 0),
                  n.length && (n[0].style.opacity = -r > 0 ? -r : 0);
              }
            }
            if ($s.pointerEvents || $s.prefixedPointerEvents) {
              r[0].style.perspectiveOrigin = `${c}px 50%`;
            }
          },
          setTransition(e) {
            this.slides
              .transition(e)
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .transition(e);
          },
        };
        const Ta = {
          init() {
            const e = this,
              { thumbs: t } = e.params,
              n = e.constructor;
            t.swiper instanceof n
              ? ((e.thumbs.swiper = t.swiper),
                ks.extend(e.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                ks.extend(e.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }))
              : ks.isObject(t.swiper) &&
                ((e.thumbs.swiper = new n(
                  ks.extend({}, t.swiper, {
                    watchSlidesVisibility: !0,
                    watchSlidesProgress: !0,
                    slideToClickedSlide: !1,
                  })
                )),
                (e.thumbs.swiperCreated = !0)),
              e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass),
              e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
          },
          onThumbClick() {
            const e = this,
              t = e.thumbs.swiper;
            if (!t) return;
            const n = t.clickedIndex,
              i = t.clickedSlide;
            if (i && Ts(i).hasClass(e.params.thumbs.slideThumbActiveClass))
              return;
            if (null == n) return;
            let r;
            if (
              ((r = t.params.loop
                ? parseInt(Ts(t.clickedSlide).attr("data-swiper-slide-index"), 10)
                : n),
              e.params.loop)
            ) {
              let t = e.activeIndex;
              e.slides.eq(t).hasClass(e.params.slideDuplicateClass) &&
                (e.loopFix(),
                (e._clientLeft = e.$wrapperEl[0].clientLeft),
                (t = e.activeIndex));
              const n = e.slides
                  .eq(t)
                  .prevAll(`[data-swiper-slide-index="${r}"]`)
                  .eq(0)
                  .index(),
                i = e.slides
                  .eq(t)
                  .nextAll(`[data-swiper-slide-index="${r}"]`)
                  .eq(0)
                  .index();
              r = void 0 === n ? i : void 0 === i ? n : i - t < t - n ? i : n;
            }
            e.slideTo(r);
          },
          update(e) {
            const t = this,
              n = t.thumbs.swiper;
            if (!n) return;
            const i =
                "auto" === n.params.slidesPerView
                  ? n.slidesPerViewDynamic()
                  : n.params.slidesPerView,
              r = t.params.thumbs.autoScrollOffset,
              s = r && !n.params.loop;
            if (t.realIndex !== n.realIndex || s) {
              let a,
                o,
                l = n.activeIndex;
              if (n.params.loop) {
                n.slides.eq(l).hasClass(n.params.slideDuplicateClass) &&
                  (n.loopFix(),
                  (n._clientLeft = n.$wrapperEl[0].clientLeft),
                  (l = n.activeIndex));
                const e = n.slides
                    .eq(l)
                    .prevAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                    .eq(0)
                    .index(),
                  i = n.slides
                    .eq(l)
                    .nextAll(`[data-swiper-slide-index="${t.realIndex}"]`)
                    .eq(0)
                    .index();
                (a =
                  void 0 === e
                    ? i
                    : void 0 === i
                    ? e
                    : i - l == l - e
                    ? l
                    : i - l < l - e
                    ? i
                    : e),
                  (o = t.activeIndex > t.previousIndex ? "next" : "prev");
              } else
                (a = t.realIndex), (o = a > t.previousIndex ? "next" : "prev");
              s && (a += "next" === o ? r : -1 * r),
                n.visibleSlidesIndexes &&
                  n.visibleSlidesIndexes.indexOf(a) < 0 &&
                  (n.params.centeredSlides
                    ? (a =
                        a > l
                          ? a - Math.floor(i / 2) + 1
                          : a + Math.floor(i / 2) - 1)
                    : a > l && (a = a - i + 1),
                  n.slideTo(a, e ? 0 : void 0));
            }
            let a = 1;
            const o = t.params.thumbs.slideThumbActiveClass;
            if (
              (t.params.slidesPerView > 1 &&
                !t.params.centeredSlides &&
                (a = t.params.slidesPerView),
              t.params.thumbs.multipleActiveThumbs || (a = 1),
              (a = Math.floor(a)),
              n.slides.removeClass(o),
              n.params.loop || (n.params.virtual && n.params.virtual.enabled))
            )
              for (let e = 0; e < a; e += 1)
                n.$wrapperEl
                  .children(`[data-swiper-slide-index="${t.realIndex + e}"]`)
                  .addClass(o);
            else
              for (let e = 0; e < a; e += 1)
                n.slides.eq(t.realIndex + e).addClass(o);
          },
        };
        const _a = [
          Ks,
          Zs,
          Js,
          ea,
          na,
          ra,
          aa,
          {
            name: "mousewheel",
            params: {
              mousewheel: {
                enabled: !1,
                releaseOnEdges: !1,
                invert: !1,
                forceToAxis: !1,
                sensitivity: 1,
                eventsTarged: "container",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                mousewheel: {
                  enabled: !1,
                  enable: oa.enable.bind(e),
                  disable: oa.disable.bind(e),
                  handle: oa.handle.bind(e),
                  handleMouseEnter: oa.handleMouseEnter.bind(e),
                  handleMouseLeave: oa.handleMouseLeave.bind(e),
                  animateSlider: oa.animateSlider.bind(e),
                  releaseScroll: oa.releaseScroll.bind(e),
                  lastScrollTime: ks.now(),
                  lastEventBeforeSnap: void 0,
                  recentWheelEvents: [],
                },
              });
            },
            on: {
              init() {
                const e = this;
                !e.params.mousewheel.enabled &&
                  e.params.cssMode &&
                  e.mousewheel.disable(),
                  e.params.mousewheel.enabled && e.mousewheel.enable();
              },
              destroy() {
                const e = this;
                e.params.cssMode && e.mousewheel.enable(),
                  e.mousewheel.enabled && e.mousewheel.disable();
              },
            },
          },
          {
            name: "navigation",
            params: {
              navigation: {
                nextEl: null,
                prevEl: null,
                hideOnClick: !1,
                disabledClass: "swiper-button-disabled",
                hiddenClass: "swiper-button-hidden",
                lockClass: "swiper-button-lock",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                navigation: {
                  init: la.init.bind(e),
                  update: la.update.bind(e),
                  destroy: la.destroy.bind(e),
                  onNextClick: la.onNextClick.bind(e),
                  onPrevClick: la.onPrevClick.bind(e),
                },
              });
            },
            on: {
              init() {
                this.navigation.init(), this.navigation.update();
              },
              toEdge() {
                this.navigation.update();
              },
              fromEdge() {
                this.navigation.update();
              },
              destroy() {
                this.navigation.destroy();
              },
              click(e) {
                const t = this,
                  { $nextEl: n, $prevEl: i } = t.navigation;
                if (
                  t.params.navigation.hideOnClick &&
                  !Ts(e.target).is(i) &&
                  !Ts(e.target).is(n)
                ) {
                  let e;
                  n
                    ? (e = n.hasClass(t.params.navigation.hiddenClass))
                    : i && (e = i.hasClass(t.params.navigation.hiddenClass)),
                    !0 === e
                      ? t.emit("navigationShow", t)
                      : t.emit("navigationHide", t),
                    n && n.toggleClass(t.params.navigation.hiddenClass),
                    i && i.toggleClass(t.params.navigation.hiddenClass);
                }
              },
            },
          },
          {
            name: "pagination",
            params: {
              pagination: {
                el: null,
                bulletElement: "span",
                clickable: !1,
                hideOnClick: !1,
                renderBullet: null,
                renderProgressbar: null,
                renderFraction: null,
                renderCustom: null,
                progressbarOpposite: !1,
                type: "bullets",
                dynamicBullets: !1,
                dynamicMainBullets: 1,
                formatFractionCurrent: (e) => e,
                formatFractionTotal: (e) => e,
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                modifierClass: "swiper-pagination-",
                currentClass: "swiper-pagination-current",
                totalClass: "swiper-pagination-total",
                hiddenClass: "swiper-pagination-hidden",
                progressbarFillClass: "swiper-pagination-progressbar-fill",
                progressbarOppositeClass:
                  "swiper-pagination-progressbar-opposite",
                clickableClass: "swiper-pagination-clickable",
                lockClass: "swiper-pagination-lock",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                pagination: {
                  init: ca.init.bind(e),
                  render: ca.render.bind(e),
                  update: ca.update.bind(e),
                  destroy: ca.destroy.bind(e),
                  dynamicBulletIndex: 0,
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.pagination.init(), e.pagination.render(), e.pagination.update();
              },
              activeIndexChange() {
                const e = this;
                (e.params.loop || void 0 === e.snapIndex) &&
                  e.pagination.update();
              },
              snapIndexChange() {
                const e = this;
                e.params.loop || e.pagination.update();
              },
              slidesLengthChange() {
                const e = this;
                e.params.loop && (e.pagination.render(), e.pagination.update());
              },
              snapGridLengthChange() {
                const e = this;
                e.params.loop || (e.pagination.render(), e.pagination.update());
              },
              destroy() {
                this.pagination.destroy();
              },
              click(e) {
                const t = this;
                if (
                  t.params.pagination.el &&
                  t.params.pagination.hideOnClick &&
                  t.pagination.$el.length > 0 &&
                  !Ts(e.target).hasClass(t.params.pagination.bulletClass)
                ) {
                  !0 ===
                  t.pagination.$el.hasClass(t.params.pagination.hiddenClass)
                    ? t.emit("paginationShow", t)
                    : t.emit("paginationHide", t),
                    t.pagination.$el.toggleClass(t.params.pagination.hiddenClass);
                }
              },
            },
          },
          {
            name: "scrollbar",
            params: {
              scrollbar: {
                el: null,
                dragSize: "auto",
                hide: !1,
                draggable: !1,
                snapOnRelease: !0,
                lockClass: "swiper-scrollbar-lock",
                dragClass: "swiper-scrollbar-drag",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                scrollbar: {
                  init: da.init.bind(e),
                  destroy: da.destroy.bind(e),
                  updateSize: da.updateSize.bind(e),
                  setTranslate: da.setTranslate.bind(e),
                  setTransition: da.setTransition.bind(e),
                  enableDraggable: da.enableDraggable.bind(e),
                  disableDraggable: da.disableDraggable.bind(e),
                  setDragPosition: da.setDragPosition.bind(e),
                  getPointerPosition: da.getPointerPosition.bind(e),
                  onDragStart: da.onDragStart.bind(e),
                  onDragMove: da.onDragMove.bind(e),
                  onDragEnd: da.onDragEnd.bind(e),
                  isTouched: !1,
                  timeout: null,
                  dragTimeout: null,
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.scrollbar.init(),
                  e.scrollbar.updateSize(),
                  e.scrollbar.setTranslate();
              },
              update() {
                this.scrollbar.updateSize();
              },
              resize() {
                this.scrollbar.updateSize();
              },
              observerUpdate() {
                this.scrollbar.updateSize();
              },
              setTranslate() {
                this.scrollbar.setTranslate();
              },
              setTransition(e) {
                this.scrollbar.setTransition(e);
              },
              destroy() {
                this.scrollbar.destroy();
              },
            },
          },
          {
            name: "parallax",
            params: { parallax: { enabled: !1 } },
            create() {
              const e = this;
              ks.extend(e, {
                parallax: {
                  setTransform: ua.setTransform.bind(e),
                  setTranslate: ua.setTranslate.bind(e),
                  setTransition: ua.setTransition.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                e.params.parallax.enabled &&
                  ((e.params.watchSlidesProgress = !0),
                  (e.originalParams.watchSlidesProgress = !0));
              },
              init() {
                this.params.parallax.enabled && this.parallax.setTranslate();
              },
              setTranslate() {
                this.params.parallax.enabled && this.parallax.setTranslate();
              },
              setTransition(e) {
                this.params.parallax.enabled && this.parallax.setTransition(e);
              },
            },
          },
          {
            name: "zoom",
            params: {
              zoom: {
                enabled: !1,
                maxRatio: 3,
                minRatio: 1,
                toggle: !0,
                containerClass: "swiper-zoom-container",
                zoomedSlideClass: "swiper-slide-zoomed",
              },
            },
            create() {
              const e = this,
                t = {
                  enabled: !1,
                  scale: 1,
                  currentScale: 1,
                  isScaling: !1,
                  gesture: {
                    $slideEl: void 0,
                    slideWidth: void 0,
                    slideHeight: void 0,
                    $imageEl: void 0,
                    $imageWrapEl: void 0,
                    maxRatio: 3,
                  },
                  image: {
                    isTouched: void 0,
                    isMoved: void 0,
                    currentX: void 0,
                    currentY: void 0,
                    minX: void 0,
                    minY: void 0,
                    maxX: void 0,
                    maxY: void 0,
                    width: void 0,
                    height: void 0,
                    startX: void 0,
                    startY: void 0,
                    touchesStart: {},
                    touchesCurrent: {},
                  },
                  velocity: {
                    x: void 0,
                    y: void 0,
                    prevPositionX: void 0,
                    prevPositionY: void 0,
                    prevTime: void 0,
                  },
                };
              "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out"
                .split(" ")
                .forEach((n) => {
                  t[n] = pa[n].bind(e);
                }),
                ks.extend(e, { zoom: t });
              let n = 1;
              Object.defineProperty(e.zoom, "scale", {
                get: () => n,
                set(t) {
                  if (n !== t) {
                    const n = e.zoom.gesture.$imageEl
                        ? e.zoom.gesture.$imageEl[0]
                        : void 0,
                      i = e.zoom.gesture.$slideEl
                        ? e.zoom.gesture.$slideEl[0]
                        : void 0;
                    e.emit("zoomChange", t, n, i);
                  }
                  n = t;
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.params.zoom.enabled && e.zoom.enable();
              },
              destroy() {
                this.zoom.disable();
              },
              touchStart(e) {
                this.zoom.enabled && this.zoom.onTouchStart(e);
              },
              touchEnd(e) {
                this.zoom.enabled && this.zoom.onTouchEnd(e);
              },
              doubleTap(e) {
                const t = this;
                t.params.zoom.enabled &&
                  t.zoom.enabled &&
                  t.params.zoom.toggle &&
                  t.zoom.toggle(e);
              },
              transitionEnd() {
                const e = this;
                e.zoom.enabled &&
                  e.params.zoom.enabled &&
                  e.zoom.onTransitionEnd();
              },
              slideChange() {
                const e = this;
                e.zoom.enabled &&
                  e.params.zoom.enabled &&
                  e.params.cssMode &&
                  e.zoom.onTransitionEnd();
              },
            },
          },
          {
            name: "lazy",
            params: {
              lazy: {
                enabled: !1,
                loadPrevNext: !1,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: !1,
                elementClass: "swiper-lazy",
                loadingClass: "swiper-lazy-loading",
                loadedClass: "swiper-lazy-loaded",
                preloaderClass: "swiper-lazy-preloader",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                lazy: {
                  initialImageLoaded: !1,
                  load: ha.load.bind(e),
                  loadInSlide: ha.loadInSlide.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                e.params.lazy.enabled &&
                  e.params.preloadImages &&
                  (e.params.preloadImages = !1);
              },
              init() {
                const e = this;
                e.params.lazy.enabled &&
                  !e.params.loop &&
                  0 === e.params.initialSlide &&
                  e.lazy.load();
              },
              scroll() {
                const e = this;
                e.params.freeMode && !e.params.freeModeSticky && e.lazy.load();
              },
              resize() {
                const e = this;
                e.params.lazy.enabled && e.lazy.load();
              },
              scrollbarDragMove() {
                const e = this;
                e.params.lazy.enabled && e.lazy.load();
              },
              transitionStart() {
                const e = this;
                e.params.lazy.enabled &&
                  (e.params.lazy.loadOnTransitionStart ||
                    (!e.params.lazy.loadOnTransitionStart &&
                      !e.lazy.initialImageLoaded)) &&
                  e.lazy.load();
              },
              transitionEnd() {
                const e = this;
                e.params.lazy.enabled &&
                  !e.params.lazy.loadOnTransitionStart &&
                  e.lazy.load();
              },
              slideChange() {
                const e = this;
                e.params.lazy.enabled && e.params.cssMode && e.lazy.load();
              },
            },
          },
          ma,
          {
            name: "a11y",
            params: {
              a11y: {
                enabled: !0,
                notificationClass: "swiper-notification",
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                a11y: {
                  liveRegion: Ts(
                    `<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
                  ),
                },
              }),
                Object.keys(va).forEach((t) => {
                  e.a11y[t] = va[t].bind(e);
                });
            },
            on: {
              init() {
                const e = this;
                e.params.a11y.enabled &&
                  (e.a11y.init(), e.a11y.updateNavigation());
              },
              toEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
              },
              fromEdge() {
                this.params.a11y.enabled && this.a11y.updateNavigation();
              },
              paginationUpdate() {
                this.params.a11y.enabled && this.a11y.updatePagination();
              },
              destroy() {
                this.params.a11y.enabled && this.a11y.destroy();
              },
            },
          },
          {
            name: "history",
            params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
            create() {
              const e = this;
              ks.extend(e, {
                history: {
                  init: ya.init.bind(e),
                  setHistory: ya.setHistory.bind(e),
                  setHistoryPopState: ya.setHistoryPopState.bind(e),
                  scrollToSlide: ya.scrollToSlide.bind(e),
                  destroy: ya.destroy.bind(e),
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.params.history.enabled && e.history.init();
              },
              destroy() {
                const e = this;
                e.params.history.enabled && e.history.destroy();
              },
              transitionEnd() {
                const e = this;
                e.history.initialized &&
                  e.history.setHistory(e.params.history.key, e.activeIndex);
              },
              slideChange() {
                const e = this;
                e.history.initialized &&
                  e.params.cssMode &&
                  e.history.setHistory(e.params.history.key, e.activeIndex);
              },
            },
          },
          {
            name: "hash-navigation",
            params: {
              hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 },
            },
            create() {
              const e = this;
              ks.extend(e, {
                hashNavigation: {
                  initialized: !1,
                  init: ga.init.bind(e),
                  destroy: ga.destroy.bind(e),
                  setHash: ga.setHash.bind(e),
                  onHashCange: ga.onHashCange.bind(e),
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.params.hashNavigation.enabled && e.hashNavigation.init();
              },
              destroy() {
                const e = this;
                e.params.hashNavigation.enabled && e.hashNavigation.destroy();
              },
              transitionEnd() {
                const e = this;
                e.hashNavigation.initialized && e.hashNavigation.setHash();
              },
              slideChange() {
                const e = this;
                e.hashNavigation.initialized &&
                  e.params.cssMode &&
                  e.hashNavigation.setHash();
              },
            },
          },
          {
            name: "autoplay",
            params: {
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                autoplay: {
                  running: !1,
                  paused: !1,
                  run: xa.run.bind(e),
                  start: xa.start.bind(e),
                  stop: xa.stop.bind(e),
                  pause: xa.pause.bind(e),
                  onVisibilityChange() {
                    "hidden" === document.visibilityState &&
                      e.autoplay.running &&
                      e.autoplay.pause(),
                      "visible" === document.visibilityState &&
                        e.autoplay.paused &&
                        (e.autoplay.run(), (e.autoplay.paused = !1));
                  },
                  onTransitionEnd(t) {
                    e &&
                      !e.destroyed &&
                      e.$wrapperEl &&
                      t.target === this &&
                      (e.$wrapperEl[0].removeEventListener(
                        "transitionend",
                        e.autoplay.onTransitionEnd
                      ),
                      e.$wrapperEl[0].removeEventListener(
                        "webkitTransitionEnd",
                        e.autoplay.onTransitionEnd
                      ),
                      (e.autoplay.paused = !1),
                      e.autoplay.running ? e.autoplay.run() : e.autoplay.stop());
                  },
                },
              });
            },
            on: {
              init() {
                const e = this;
                e.params.autoplay.enabled &&
                  (e.autoplay.start(),
                  document.addEventListener(
                    "visibilitychange",
                    e.autoplay.onVisibilityChange
                  ));
              },
              beforeTransitionStart(e, t) {
                const n = this;
                n.autoplay.running &&
                  (t || !n.params.autoplay.disableOnInteraction
                    ? n.autoplay.pause(e)
                    : n.autoplay.stop());
              },
              sliderFirstMove() {
                const e = this;
                e.autoplay.running &&
                  (e.params.autoplay.disableOnInteraction
                    ? e.autoplay.stop()
                    : e.autoplay.pause());
              },
              touchEnd() {
                const e = this;
                e.params.cssMode &&
                  e.autoplay.paused &&
                  !e.params.autoplay.disableOnInteraction &&
                  e.autoplay.run();
              },
              destroy() {
                const e = this;
                e.autoplay.running && e.autoplay.stop(),
                  document.removeEventListener(
                    "visibilitychange",
                    e.autoplay.onVisibilityChange
                  );
              },
            },
          },
          {
            name: "effect-fade",
            params: { fadeEffect: { crossFade: !1 } },
            create() {
              const e = this;
              ks.extend(e, {
                fadeEffect: {
                  setTranslate: ba.setTranslate.bind(e),
                  setTransition: ba.setTransition.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                if ("fade" !== e.params.effect) return;
                e.classNames.push(`${e.params.containerModifierClass}fade`);
                const t = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                ks.extend(e.params, t), ks.extend(e.originalParams, t);
              },
              setTranslate() {
                "fade" === this.params.effect && this.fadeEffect.setTranslate();
              },
              setTransition(e) {
                "fade" === this.params.effect && this.fadeEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-cube",
            params: {
              cubeEffect: {
                slideShadows: !0,
                shadow: !0,
                shadowOffset: 20,
                shadowScale: 0.94,
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                cubeEffect: {
                  setTranslate: wa.setTranslate.bind(e),
                  setTransition: wa.setTransition.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                if ("cube" !== e.params.effect) return;
                e.classNames.push(`${e.params.containerModifierClass}cube`),
                  e.classNames.push(`${e.params.containerModifierClass}3d`);
                const t = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  resistanceRatio: 0,
                  spaceBetween: 0,
                  centeredSlides: !1,
                  virtualTranslate: !0,
                };
                ks.extend(e.params, t), ks.extend(e.originalParams, t);
              },
              setTranslate() {
                "cube" === this.params.effect && this.cubeEffect.setTranslate();
              },
              setTransition(e) {
                "cube" === this.params.effect && this.cubeEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-flip",
            params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
            create() {
              const e = this;
              ks.extend(e, {
                flipEffect: {
                  setTranslate: Sa.setTranslate.bind(e),
                  setTransition: Sa.setTransition.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                if ("flip" !== e.params.effect) return;
                e.classNames.push(`${e.params.containerModifierClass}flip`),
                  e.classNames.push(`${e.params.containerModifierClass}3d`);
                const t = {
                  slidesPerView: 1,
                  slidesPerColumn: 1,
                  slidesPerGroup: 1,
                  watchSlidesProgress: !0,
                  spaceBetween: 0,
                  virtualTranslate: !0,
                };
                ks.extend(e.params, t), ks.extend(e.originalParams, t);
              },
              setTranslate() {
                "flip" === this.params.effect && this.flipEffect.setTranslate();
              },
              setTransition(e) {
                "flip" === this.params.effect && this.flipEffect.setTransition(e);
              },
            },
          },
          {
            name: "effect-coverflow",
            params: {
              coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                scale: 1,
                modifier: 1,
                slideShadows: !0,
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                coverflowEffect: {
                  setTranslate: Ca.setTranslate.bind(e),
                  setTransition: Ca.setTransition.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this;
                "coverflow" === e.params.effect &&
                  (e.classNames.push(
                    `${e.params.containerModifierClass}coverflow`
                  ),
                  e.classNames.push(`${e.params.containerModifierClass}3d`),
                  (e.params.watchSlidesProgress = !0),
                  (e.originalParams.watchSlidesProgress = !0));
              },
              setTranslate() {
                "coverflow" === this.params.effect &&
                  this.coverflowEffect.setTranslate();
              },
              setTransition(e) {
                "coverflow" === this.params.effect &&
                  this.coverflowEffect.setTransition(e);
              },
            },
          },
          {
            name: "thumbs",
            params: {
              thumbs: {
                swiper: null,
                multipleActiveThumbs: !0,
                autoScrollOffset: 0,
                slideThumbActiveClass: "swiper-slide-thumb-active",
                thumbsContainerClass: "swiper-container-thumbs",
              },
            },
            create() {
              const e = this;
              ks.extend(e, {
                thumbs: {
                  swiper: null,
                  init: Ta.init.bind(e),
                  update: Ta.update.bind(e),
                  onThumbClick: Ta.onThumbClick.bind(e),
                },
              });
            },
            on: {
              beforeInit() {
                const e = this,
                  { thumbs: t } = e.params;
                t && t.swiper && (e.thumbs.init(), e.thumbs.update(!0));
              },
              slideChange() {
                this.thumbs.swiper && this.thumbs.update();
              },
              update() {
                this.thumbs.swiper && this.thumbs.update();
              },
              resize() {
                this.thumbs.swiper && this.thumbs.update();
              },
              observerUpdate() {
                this.thumbs.swiper && this.thumbs.update();
              },
              setTransition(e) {
                const t = this.thumbs.swiper;
                t && t.setTransition(e);
              },
              beforeDestroy() {
                const e = this.thumbs.swiper;
                e && this.thumbs.swiperCreated && e && e.destroy();
              },
            },
          },
        ];
        void 0 === Us.use &&
          ((Us.use = Us.Class.use), (Us.installModule = Us.Class.installModule)),
          Us.use(_a);
        const Ea = Us;
        n(357);
        class ka {
          constructor(e, n) {
            (this.DURATION = 120),
              (this.onZoomIn = (e) => {
                this.$element.width() >= t()(e).width()
                  ? this.$element.find(".zoomImg").addClass("hide")
                  : (this.$element.find(".zoomImg").removeClass("hide"),
                    (this.timer = setTimeout(() => {
                      this.img.classList.add("product-image-hidden"),
                        (this.timer = null);
                    }, this.DURATION)));
              }),
              (this.onZoomOut = () => {
                this.timer && (clearTimeout(this.timer), (this.timer = null)),
                  this.img.classList.remove("product-image-hidden");
              }),
              (this.destroy = () => {
                this.$element.trigger("zoom.destroy");
              }),
              (this.theme = e),
              (this.element = n),
              (this.$element = t()(n)),
              (this.img = n.querySelector("img")),
              (this.timer = null);
            const i = this;
            this.$element.zoom({
              url: this.img.dataset.zoomImg || this.img.src,
              touch: !1,
              duration: this.DURATION,
              onZoomIn: function () {
                i.onZoomIn(this);
              },
              onZoomOut: this.onZoomOut,
            });
          }
        }
        class $a {
          constructor(e, n, i, r) {
            (this.isMobile = () =>
              window.matchMedia("screen and (max-width: 767px)").matches),
              (this.load = () =>
                new Promise((e) => {
                  if (this.loaded) return void e();
                  const t = this.parent.querySelector("template");
                  if (!t) return this.onLoad(), void e();
                  const n = ((e) => {
                      if ("content" in e)
                        return document.importNode(e.content, !0);
                      {
                        const t = document.createDocumentFragment(),
                          n = e.childNodes;
                        for (let e = 0; e < n.length; e++)
                          t.appendChild(n[e].cloneNode(!0));
                        return t;
                      }
                    })(t),
                    i = this.targetElement.querySelector(
                      '[data-media-id="' + this.media_id + '"]'
                    );
                  if (i)
                    try {
                      this.targetElement.removeChild(i);
                    } catch (e) {
                      console.error(e);
                    }
                  switch (
                    (t.parentNode === this.targetElement
                      ? this.targetElement.insertBefore(n, t)
                      : this.targetElement.appendChild(n),
                    (this.mediaWrapper = this.targetElement.querySelector(
                      '[data-media-id="' + this.media_id + '"]'
                    )),
                    this.selected &&
                      this.mediaWrapper.classList.add(
                        "product-single__media--selected"
                      ),
                    this.type)
                  ) {
                    case "model":
                      window.Shopify.loadFeatures(
                        [{ name: "model-viewer-ui", version: "1.0" }],
                        () => {
                          (this.modelController =
                            new window.Shopify.ModelViewerUI(
                              this.mediaWrapper.querySelector("model-viewer")
                            )),
                            this.modelController.viewer.parentElement.addEventListener(
                              "mouseup",
                              (e) => {
                                e.stopPropagation = function () {};
                              },
                              { capture: !0 }
                            ),
                            this.modelController.elements.controlButton.addEventListener(
                              "click",
                              (e) => {
                                e.stopImmediatePropagation();
                              },
                              { capture: !0 }
                            ),
                            this.modelController.viewer.addEventListener(
                              "shopify_model_viewer_ui_toggle_pause",
                              this.onPause
                            ),
                            this.modelController.viewer.addEventListener(
                              "shopify_model_viewer_ui_toggle_play",
                              this.onPlay
                            ),
                            this.onLoad(),
                            e();
                        }
                      );
                      break;
                    case "video":
                      window.Shopify.loadFeatures([
                        {
                          name: "video-ui",
                          version: "1.0",
                          onLoad: () => {
                            const t = this.mediaWrapper.querySelector("video"),
                              n = "true" === t.parentNode.dataset.videoLoop;
                            (this.plyrController = new window.Shopify.Plyr(t, {
                              loop: { active: n },
                              focusOnPlay: !1,
                            })),
                              t.addEventListener("play", this.onPlay),
                              t.addEventListener("pause", this.onPause),
                              t.addEventListener("ended", this.onPause),
                              this.onLoad(),
                              e();
                          },
                        },
                      ]);
                      break;
                    case "external_video":
                      this.theme.loadYoutubeApi().then(() => {
                        const t = this.mediaWrapper.querySelector("iframe"),
                          n = "true" === t.parentNode.dataset.videoLoop;
                        new window.YT.Player(t, {
                          events: {
                            onReady: (t) => {
                              (this.youtubeController = t.target),
                                this.onLoad(),
                                e();
                            },
                            onStateChange: (e) => {
                              e.data === window.YT.PlayerState.PLAYING
                                ? this.onPlay()
                                : e.data === window.YT.PlayerState.PAUSED
                                ? this.onPause()
                                : e.data === window.YT.PlayerState.ENDED &&
                                  (n
                                    ? this.youtubeController.playVideo()
                                    : this.onPause());
                            },
                            onError: (e) => {
                              console.warn("Youtube video error", e, e.data),
                                this.onPause();
                            },
                          },
                        });
                      });
                      break;
                    case "image":
                      this.mediaWrapper
                        .querySelector(".product-single__media img")
                        .addEventListener("load", () => {
                          "true" !== this.parent.dataset.imageZoomEnable ||
                            this.isMobile() ||
                            new ka(
                              this.theme,
                              this.mediaWrapper.querySelector(
                                ".product-single__media__image"
                              )
                            ),
                            this.onLoad(),
                            e();
                        });
                      break;
                    default:
                      this.onLoad(), e();
                  }
                })),
              (this.onLoad = () => {
                if (!this.mediaWrapper.parentNode) return;
                (this.loaded = !0),
                  this.mediaWrapper.parentNode.classList.add(
                    "product-single__media--loaded"
                  );
                const e = new CustomEvent("media-load", {
                  detail: { parent: this.parent, media: this },
                });
                this.parent.dispatchEvent(e),
                  window.ShopifyXR &&
                    window.ShopifyXR.setupXRElements &&
                    window.ShopifyXR.setupXRElements();
              }),
              (this.play = () => {
                this.loaded ? this._play() : this.load().then(this._play);
              }),
              (this._play = () => {
                switch (this.type) {
                  case "model":
                    this.modelController.play(), this.onPlay();
                    break;
                  case "video":
                    this.plyrController
                      .play()
                      .then(this.onPlay)
                      .catch(console.warn);
                    break;
                  case "external_video":
                    this.youtubeController.playVideo(), this.onPlay();
                }
              }),
              (this.onPlay = () => {
                (this.active = !0),
                  this.mediaWrapper.classList.add(
                    "product-single__media--active"
                  ),
                  this.loaded ||
                    ((this.loaded = !0),
                    this.mediaWrapper.parentNode.classList.add(
                      "product-single__media--loaded"
                    ));
                const e = new CustomEvent("media-play", {
                  detail: { parent: this.parent, media: this },
                });
                this.parent.dispatchEvent(e),
                  document.activeElement === document.body && this.focus();
              }),
              (this.autoplay = () => {
                t()(window).width() > 768 && this.play();
              }),
              (this.pause = () => {
                if (this.active) {
                  switch (this.type) {
                    case "model":
                      break;
                    case "video":
                      this.plyrController.pause();
                      break;
                    case "external_video":
                      this.youtubeController.pauseVideo();
                  }
                  this.onPause();
                }
              }),
              (this.togglePlay = () => {
                this.active ? this.pause() : this.play();
              }),
              (this.onPause = () => {
                (this.active = !1),
                  this.mediaWrapper.classList.remove(
                    "product-single__media--active"
                  );
                const e = new CustomEvent("media-pause", {
                  detail: { parent: this.parent, media: this },
                });
                this.parent.dispatchEvent(e);
              }),
              (this.select = () => {
                (this.selected = !0),
                  this.mediaWrapper &&
                    this.mediaWrapper.classList.add(
                      "product-single__media--selected"
                    );
              }),
              (this.deselect = () => {
                this.selected &&
                  ((this.selected = !1),
                  this.mediaWrapper &&
                    this.mediaWrapper.classList.remove(
                      "product-single__media--selected"
                    ));
              }),
              (this.reattach = (e) => {
                (this.targetElement = e),
                  this.mediaWrapper &&
                    (e.appendChild(this.mediaWrapper),
                    this.selected
                      ? e.classList.add("product-single__media--selected")
                      : e.classList.remove("product-single__media--selected"));
              }),
              (this.scrollIntoView = (e) => {
                requestAnimationFrame(function () {
                  const n = t()(".sticky-header-wrapper").height() || 0,
                    i = e.getBoundingClientRect().top + window.pageYOffset - n;
                  window.scrollTo(0, i);
                });
              }),
              (this.focus = () => {
                switch (this.type) {
                  case "video": {
                    const e = this.mediaWrapper.querySelector(".plyr");
                    e && (this.scrollIntoView(e), e.focus());
                    break;
                  }
                  case "model": {
                    const e = this.mediaWrapper.querySelector("model-viewer");
                    e && e.shadowRoot
                      ? (this.scrollIntoView(e), e.focus())
                      : setTimeout(this.focus, 1e3);
                    break;
                  }
                  case "external_video": {
                    const e = this.mediaWrapper.querySelector("iframe");
                    this.scrollIntoView(e), e.focus(), e.contentWindow.focus();
                    break;
                  }
                  default:
                    this.mediaWrapper &&
                      (this.scrollIntoView(this.mediaWrapper),
                      this.mediaWrapper.focus());
                }
              }),
              (this.destroy = () => {}),
              (this.theme = e),
              (this.parent = n),
              (this.media_id = n.dataset.mediaId),
              (this.type = n.dataset.mediaType),
              (this.loaded = !1),
              (this.active = !1),
              (this.plyrController = null),
              (this.modelController = null),
              (this.youtubeController = null),
              (this.targetElement = i),
              (this.mediaWrapper = null),
              (this.selected = this.parent.classList.contains(
                "product-single__thumbnail--selected"
              )),
              this.selected && r && this.load();
          }
        }
        class Ma {
          constructor(e, n, i) {
            (this.updatePrices = (e) => {
              e.items, e.items_subtotal_price;
              var n = this.$element.find(".line-item").length,
                i = e.items.length;
              if (e.total_discount > 0 || n !== i)
                return t()("#update_quantities").click(), !1;
              e.items.forEach((t, n) => {
                var i = this.$element.find(".id-" + t.id);
                0 === e.total_discount &&
                  i.find(".cart-table-price").html('<div class="money">--</div>'),
                  i.length > 0 &&
                    (i
                      .find(".cart-table-price .money")
                      .html(this.theme.formatMoney(t.original_price)),
                    i
                      .find(".cart-table-line-price")
                      .html(this.theme.formatMoney(t.final_line_price)));
              }),
                this.$element
                  .find("#cart-total-final-price")
                  .html(this.theme.formatMoney(e.total_price));
            }),
              (this.updateCartItem = (e) => {
                this.$wrapper.addClass("cart-item-quantity-active");
                var t = e <= 0 ? this.FADE_OUT_ANIMATION_DURATION : 0;
                e >= 1
                  ? this.cartSetQuantity(t).always(() => {
                      this.$wrapper.removeClass("cart-item-quantity-active");
                    })
                  : this.$wrapper.removeClass("cart-item-quantity-active");
              }),
              (this.cartSetQuantity = (e) => {
                var n = t().Deferred();
                return (
                  t()(".cart-error-box").text(""),
                  t()
                    .ajax({
                      type: "POST",
                      url: "/cart/update.js",
                      dataType: "json",
                      data: t()("#cartform").serialize(),
                    })
                    .then((t) => {
                      n.resolve(),
                        setTimeout(() => {
                          this.updatePrices(t);
                        }, e);
                    })
                    .fail((e, i, r) => {
                      n.reject(),
                        console.error("Cart error", i, e, r),
                        t()(".cart-error-box")
                          .empty()
                          .text("Unable to update item quantity");
                    }),
                  n
                );
              }),
              (this.theme = e),
              (this.element = n),
              (this.$element = t()(this.element)),
              (this.$wrapper = this.$element.find(".quantity-controls")),
              (this.FADE_OUT_ANIMATION_DURATION = 800);
            var r = this;
            this.$element
              .find(".quantity-controls button.qty-plus")
              .off()
              .on("click", function (e) {
                e.preventDefault();
                var n = t()(this)
                    .closest(".quantity-controls")
                    .find("input.quantity-selector"),
                  s = t()(this).closest(".quantity-controls").data("stock-count");
                let a = t()(this)
                    .closest(".quantity-controls")
                    .data("inventory-policy"),
                  o = t()(this)
                    .closest(".quantity-controls")
                    .data("inventory-management");
                var l = t()(this).parent().next();
                const c = parseInt(n.val().toString(), 10);
                if (s)
                  if (c < s || "continue" == a || "shopify" != o) var d = c + 1;
                  else l.removeClass("d-none"), (d = s);
                else d = c + 1;
                n.val(d), i && r.updateCartItem(d);
              }),
              this.$element
                .find(".quantity-controls button.qty-minus")
                .off()
                .on("click", function (e) {
                  e.preventDefault();
                  var n = t()(this)
                    .closest(".quantity-controls")
                    .find("input.quantity-selector");
                  const s = parseInt(n.val().toString(), 10);
                  var a = t()(this)
                    .closest(".quantity-controls")
                    .data("stock-count");
                  let o = t()(this)
                      .closest(".quantity-controls")
                      .data("inventory-policy"),
                    l = t()(this)
                      .closest(".quantity-controls")
                      .data("inventory-management");
                  var c = t()(this).parent().next(),
                    d = s - 1 < 1 ? 1 : s - 1;
                  n.val(d),
                    a &&
                      d <= a &&
                      ("continue" == o || "shopify" != l) &&
                      c.addClass("d-none"),
                    i && r.updateCartItem(d);
                }),
              this.$element
                .find("input.quantity-selector")
                .off()
                .on("change", function (e) {
                  var n = t()(this)
                      .closest(".quantity-controls")
                      .find("input.quantity-selector"),
                    s = t()(this)
                      .closest(".quantity-controls")
                      .data("stock-count");
                  let a = t()(this)
                      .closest(".quantity-controls")
                      .data("inventory-policy"),
                    o = t()(this)
                      .closest(".quantity-controls")
                      .data("inventory-management");
                  var l = t()(this).parent().next(),
                    c = parseInt(e.currentTarget.value.toString(), 10);
                  c > s && ("continue" !== a || "shopify" == o)
                    ? (n.val(s), l.removeClass("d-none"))
                    : (n.val(c), l.addClass("d-none")),
                    i && r.updateCartItem(c);
                });
          }
        }
        class ja extends Zr {
          constructor(e, n, i, r = !1) {
            super(e, n, i),
              (this.initializeSizeGuide = () => {
                (this.$sizeGuideFocusable = this.$sizeGuideWrapper.find(
                  "button, a, input, select, textarea, iframe, #size-guide__content"
                )),
                  this.$sizeGuideFocusable.each(function () {
                    t()(this).attr("tabindex", "-1");
                  }),
                  this.$sizeGuideLink.on("click", this.sizeGuideOpen),
                  this.$sizeGuideClose.on("click", this.sizeGuideClose),
                  this.$sizeGuideClose.on("keydown", this.keySizeGuideClose),
                  this.$sizeGuideWrapper.on(
                    "click",
                    this.backgroundSizeGuideClose
                  ),
                  this.$sizeGuideWrapper.on("rendered", Xr().replace());
              }),
              (this.initializeSlider = () => {
                var e = this,
                  n = this.element.querySelector("div[data-swiper-container]"),
                  i = this.element.querySelector("div[data-swiper-wrapper]");
                n.classList.add("swiper-container"),
                  i.classList.add("swiper-wrapper");
                var r = this.element.querySelector(".product-single__thumbnails");
                if (!r) return;
                var s = this.element.querySelectorAll(
                    ".product-single__thumbnail"
                  ).length,
                  a = r.querySelector(".swiper-container");
                if (!a) return;
                const o = {
                  el: a.parentNode.querySelector(".swiper-pagination"),
                  type: "bullets",
                  clickable: !0,
                  renderBullet: (e, t) =>
                    '<span class="' +
                    t +
                    '"><span class="swiper-pagination-bullet-dot"></span></span>',
                };
                var l = new Ea(a, {
                  direction: "horizontal",
                  slidesPerView: 1,
                  updateOnImagesReady: !0,
                  spaceBetween: 20,
                  threshold: 10,
                  navigation: {
                    nextEl: ".thumbs-direction-nav--next",
                    prevEl: ".thumbs-direction-nav--prev",
                  },
                  pagination: o,
                  loop: !r.classList.contains("no-arrows"),
                  autoHeight: !0,
                  loopedSlides: 1,
                  breakpoints: this.isFeaturedProduct
                    ? null
                    : {
                        768: {
                          slidesPerView: a.dataset.slidesPerView,
                          direction: a.dataset.direction || "horizontal",
                          autoHeight: !1,
                        },
                      },
                });
                l.on("slideChange", function () {
                  var t = this.slidesPerViewDynamic();
                  1 === t
                    ? e.onMediaElementSelect(this.slides[this.activeIndex], {})
                    : this.isEnd
                    ? this.slideTo(1)
                    : this.isBeginning &&
                      this.slideTo(this.slides.length - 1 - t),
                    Aa(this);
                }),
                  Aa(l),
                  s <= 1 &&
                    r
                      .querySelector(".swiper-pagination-bullets")
                      .classList.add("hide");
                const c = a.parentNode;
                l.slidesPerViewDynamic() > 1 &&
                  c.classList.add("product-single__thumbnails--carousel");
                var d = l.currentBreakpoint;
                l.on("resize", function (t) {
                  this.slidesPerViewDynamic() > 1
                    ? c.classList.add("product-single__thumbnails--carousel")
                    : c.classList.remove("product-single__thumbnails--carousel"),
                    this.currentBreakpoint != d &&
                      ((d = this.currentBreakpoint),
                      "max" === this.currentBreakpoint
                        ? (a.classList.add("product-single__thumbnails--mobile"),
                          e.mediaToMobile(),
                          (l.autoHeight = !0),
                          r.classList.toggle("hide", s < 1))
                        : (a.classList.remove(
                            "product-single__thumbnails--mobile"
                          ),
                          e.mediaToDesktop(),
                          (l.autoHeight = !1),
                          r.classList.toggle("hide", s <= 1)));
                }),
                  "max" === l.currentBreakpoint
                    ? (a.classList.add("product-single__thumbnails--mobile"),
                      r.classList.toggle("hide", s < 1))
                    : void 0 !== l.currentBreakpoint &&
                      r.classList.toggle("hide", s <= 1);
                const u = a.parentNode.querySelector(".swiper-pagination");
                return (
                  u.addEventListener(
                    "keydown",
                    // (e) => {
                    //   13 === e.keyCode &&
                    //     t()(e.target).index() === l.activeIndex - 1 &&
                    //     this.onMediaElementSelect(l.slides[l.activeIndex], {
                    //       forcePlay: !0,
                    //       focus: !0,
                    //     });
                    // },
                    { capture: !0 }
                  ),
                  l.device.ios && u.classList.add("swiper-pagination-hide-focus"),
                  l
                );
              }),
              (this.mediaToDesktop = () => {
                var e = this.element.querySelector(".product-single__medias");
                this.mediaById.forEach((t) => {
                  t.reattach(e),
                    t.loaded
                      ? e.classList.add("product-single__thumbnail--loaded")
                      : t.selected &&
                        (e.classList.add("product-single__media--selected"),
                        t.load());
                });
              }),
              (this.mediaToMobile = () => {
                this.mediaById.forEach((e) => {
                  var t = this.element.querySelector(
                    '.product-single__thumbnail[data-media-id="' +
                      e.media_id +
                      '"]'
                  );
                  e.reattach(t);
                });
              }),
              (this.preloadImages = () => {
                t()("#product-thumbnails img").each((e, n) => {
                  if (t()(n).data("zoom-img")) {
                    var i = "https:" + t()(n).data("zoom-img");
                    try {
                      new Image().src = i;
                    } catch (e) {
                      console.error("Unable to preload image:", e);
                    }
                  }
                });
              }),
              (this.setVariantOptions = (e) => {
                var t = this.product.variants.filter((t) => {
                  for (var n = 0; n < e.length; n++)
                    if (e[n] !== t.options[n]) return !1;
                  return !0;
                });
                0 === t.length
                  ? this.updateVariant(null)
                  : this.updateVariant(t[0]);
  
                  // gf.E バリエーション制御
                  // カートボタンよりクラス「product--reserve--btn」を削除
                  document.getElementById("purchase").classList.remove('product--reserve--btn');
                  // カートボタンよりクラス「gfe-css-br」を削除
                  document.getElementById("purchase").classList.remove('gfe-css-br');
                  // 予約タグを非表示
                  document.getElementById("detail--reserve--icon").style.display ="none";
                  // 商品コメントを非表示
                  document.getElementById("product_control_message_normal").style.display ="none";
                  document.getElementById("product_control_message_reserve").style.display ="none";
  
                  var objSelect = document.getElementById("product-select-variant");
  
                  for(i=0;objSelect.length>i;i++){
                    // 2024/10/02 gf.E SOLDOUT斜線追加対応
                    if(objSelect.options[i].getAttribute('data-option1') == t[0].option1){
                      document.getElementById("swatch-size-element-"+objSelect.options[i].getAttribute('data-option2')).classList.remove('line-sold-out-selectd');
                      if(objSelect.options[i].getAttribute('data-quantity') < 1){
                        document.getElementById("swatch-size-element-"+objSelect.options[i].getAttribute('data-option2')).classList.add('line-sold-out');
                      } else {
                        document.getElementById("swatch-size-element-"+objSelect.options[i].getAttribute('data-option2')).classList.remove('line-sold-out');
                      }
                    }
                    // バリエーション毎の予約コメントを非表示
                    document.getElementById("product-variant-" + objSelect.options[i].value).style.display ="none";
                    // バリエーション毎の在庫数を非表示
                    document.getElementById("product-variant-stock-" + objSelect.options[i].value).style.display ="none";
                    // バリエーション毎のバリエーションコメントを非表示
                    document.getElementById("product-variant-itemComment-always-" + objSelect.options[i].value).style.display ="none";
                    // 【改修】商品バリエーションcomingsoonコメント表示対応
                    // バリエーション毎のバリエーションcomingsoonコメントを非表示
                    document.getElementById("product-variant-comingsoonText-" + objSelect.options[i].value).style.display ="none";
  
                    // gf.E カートボタン制御（カート内の状況とオプション時変更毎に制御）
                    var objCartItemReserveId = document.getElementById("Cart__control-product_id").textContent;
                    var objCartItemReserve = document.getElementById("Cart__control-product").textContent;
                    var objCartItemCount = document.getElementById("Cart__control-count").textContent;
                    var objSelectVariant = objSelect.options[i].textContent;
  
                    // 選択中のオプション値と隠し項目のセレクト値が一致している場合
                    if(objSelect.options[i].value == t[0].id){
                      // 2024/10/15 gf.E 洗濯中の商品がSOLDOUTの場合に斜線追加対応
                      document.getElementById("swatch-size-element-"+objSelect.options[i].getAttribute('data-option2')).classList.add('line-sold-out-selectd');
                      // バリエーション毎のバリエーションコメントを非表示
                      document.getElementById("product-variant-itemComment-always-" + objSelect.options[i].value).style.display ="block";
                      // バリエーション毎の在庫数を非表示
                      document.getElementById("product-variant-stock-" + objSelect.options[i].value).style.display ="block";
                      //隠し項目の選択を変更
                      objSelect.options[i].selected = true;
  
                      // comingsoonコメント表示フラグがtureの場合にcomingsoonコメントの文言を表示する
                      // 文言の設定がない場合は「COMINGSOON」を表示する
                      // SOLD OUT、予約よりcomingsoon表示を優先する
                      var comingsoonDisplayFlag = document.getElementById("product-variant-comingsoonText-" + objSelect.options[i].value).getAttribute('value');
  
                      // 配送メッセージを非表示
                      document.getElementById('message-shipping-standard').style.display = "none";
                      document.getElementById('message-shipping-backorder').style.display = "none";

                      //  在庫ありの場合
                      if(t[0].available){
                        // バリエーション予約設定が「TRUE」かつcomingsoonコメント表示フラグが「TRUE」以外
                        if(objSelect.options[i].text == "true" && comingsoonDisplayFlag != "true"){
  
                          // 予約タグを表示
                          document.getElementById("detail--reserve--icon").style.display ="inline-block";
                          // カートボタンを"予約する"へ変更（"product--reserve--btn"のクラスを付与）
                          document.getElementById("purchase").innerText = "予約する";
                          document.getElementById("purchase").classList.add('product--reserve--btn');
      
                          // 予約商品がカートに入ってた場合（Cart__control-product == true）
                          if(objCartItemReserve == "true"){
                            // 選択中のオプション（バリエーション）の予約コメント（itemComment）を表示
                            document.getElementById("product-variant-" + objSelect.options[i].value).style.display ="block";
                            // 商品コメントを表示
                            document.getElementById("product_control_message_reserve").style.display ="block";
  
                            // カート内にある商品と同一ではない場合は、購入ボタン非活性
                            if(objCartItemReserveId == t[0].id ){
                            } else {
                              //document.getElementById("purchase").setAttribute("disabled", true);
                              //document.getElementById("purchase").classList.add('gfe-css-br');
                              //document.getElementById("purchase").innerHTML = "同送出来ない商品が<span>カートに入っています</span>";
                            }
      
                          // 通常商品がカートに入ってた場合（Cart__control-count != 0 && Cart__control-product == false）
                          } else if(objCartItemCount != "0" && objCartItemReserve == "false"){
                            // 選択中のオプション（バリエーション）の予約コメント（itemComment）を表示
                            document.getElementById("product-variant-" + objSelect.options[i].value).style.display ="block";
                            // 商品コメントを表示
                            document.getElementById("product_control_message_reserve").style.display ="block";
                            //購入ボタン非活性
                            //document.getElementById("purchase").setAttribute("disabled", true);
                            //document.getElementById("purchase").classList.add('gfe-css-br');
                            //document.getElementById("purchase").innerHTML = "同送出来ない商品が<span>カートに入っています</span>";
                            
                          } else {
                            // 選択中のオプション（バリエーション）の予約コメント（itemComment）を表示
                            document.getElementById("product-variant-" + objSelect.options[i].value).style.display ="block";
                            // 商品コメントを表示
                            document.getElementById("product_control_message_reserve").style.display ="block";
                            
                          }
                        } else {
                          // 予約商品がカートに入ってた場合（Cart__control-product == true）
                          if(objCartItemReserve == "true"){
                            // 商品コメントを表示
                            document.getElementById("product_control_message_normal").style.display ="block";
                            //購入ボタン非活性
                            //document.getElementById("purchase").setAttribute("disabled", true);
                            //document.getElementById("purchase").classList.add('gfe-css-br');
                            //document.getElementById("purchase").innerHTML = "同送出来ない商品が<span>カートに入っています</span>";
                          }
                          // お取り寄せ判定
                          getBackorder(t[0].sku);
                        }
                      }
                      // 【改修】商品バリエーションcomingsoonコメント表示対応
                      if (comingsoonDisplayFlag == "true") {
                        // 在庫数は非表示にする
                        document.getElementById("product-variant-stock-" + objSelect.options[i].value).style.display ="none";
                        document.getElementById("purchase").setAttribute("disabled", true);
                        var comingsoonText = document.getElementById("product-variant-comingsoonText-" + objSelect.options[i].value).innerText;
                        if (comingsoonText) {
                          document.getElementById("purchase").innerText = document.getElementById("product-variant-comingsoonText-" + objSelect.options[i].value).innerText;
                        } else {
                          document.getElementById("purchase").innerText = "COMING SOON";
                        }
                      }
  
                      // 【改修】COMINGSOONグレーアウト・アイコン位置修正対応
                      // 商品COMINGSOONタグコメントを非表示
                      document.getElementById("product-comingsoonText").style.display ="none";
                      var productComingsoonText = document.getElementById("product-comingsoonText").textContent;
                      if (productComingsoonText) {
                        // 在庫数は非表示にする
                        document.getElementById("product-variant-stock-" + objSelect.options[i].value).style.display ="none";
                        document.getElementById("purchase").setAttribute("disabled", true);
                        document.getElementById("purchase").innerText = productComingsoonText;
                      }
                    }
                  }
  
  
                  // WazzUp LINE 表示制御
                const wazzupLineButton = document.getElementById("wazzup-line-button");
                if(wazzupLineButton){
                  if(t[0].available == true){
                    document.getElementById("wazzup-line-button").style.display ="none";
                  }else if(t[0].available == false){
                    document.getElementById("wazzup-line-button").style.display ="block";
                  }
                  wazzupLineButton.dataset.skuCode = t[0].sku;
                  document.getElementById("w-variant-id").textContent = t[0].id;
                  document.getElementById("w-variant-sku").textContent = t[0].sku;
                  document.getElementById("w-variant-barcode").textContent = t[0].barcode;
                  document.getElementById("w-variant-price").textContent = t[0].price.toString(10).slice(0,-2);
                  document.getElementById("w-variant-option1").textContent = t[0].option1;
                  document.getElementById("w-variant-option2").textContent = t[0].option2;
                }
                /*
                  if(t[0].available == true){
                    document.getElementById("wazzup-line-button").style.display ="none";
                  }else if(t[0].available == false){
                    document.getElementById("wazzup-line-button").style.display ="block";
                  }
                  document.getElementById("w-variant-id").textContent = t[0].id;
                  document.getElementById("w-variant-sku").textContent = t[0].sku;
                  document.getElementById("w-variant-barcode").textContent = t[0].barcode;
                  document.getElementById("w-variant-price").textContent = t[0].price.toString(10).slice(0,-2);
                  document.getElementById("w-variant-option1").textContent = t[0].option1;
                  document.getElementById("w-variant-option2").textContent = t[0].option2;
                */
  
                  // gf.E バリアント毎に金額を制御
  
                  // 2023.11.14 プレセール設定を追加
                  var is_presale = document.getElementById("is_presale");
  
                  // 【改修】獲得ポイントの表示対応
                  var point_sale_flg = false;
                  var point_price_sale = 0;
  
                if( t[0].compare_at_price > t[0].price){
                    document.getElementById("variant__comparepriceSale").style.display ="block";
                    document.getElementById("variant__priceSale").style.display ="block";
                    document.getElementById("variant__priceSale__perOff").style.display ="block";
                    document.getElementById("variant__priceRegular").style.display ="none";
                    let compare_at_price = t[0].compare_at_price.toString(10).slice(0,-2);
                    let numCompare_at_price = parseInt(compare_at_price, 10);
                    document.getElementById("variant__comparepriceSale").textContent = `¥ ${numCompare_at_price.toLocaleString()}`;
                    let price = t[0].price.toString(10).slice(0,-2);
                    let numPrice = parseInt(price, 10);
                    document.getElementById("variant__priceSale").textContent = `¥ ${numPrice.toLocaleString()}`;
                    document.getElementById("variant__priceTax").classList.add('u-color__text--red');
                    let numPerOff = Math.round((1 - numPrice / numCompare_at_price) * 100);
                    document.getElementById("variant__priceSale__perOff").textContent = `${numPerOff.toLocaleString()}%OFF`;
                    document.getElementById("variant__priceSale__perOff").classList.add('u-color__text--red');
                    
                    // 【改修】獲得ポイントの表示対応
                    point_sale_flg = true;
                    point_price_sale = numPrice;
  
                  } else if(is_presale.dataset.presale == 'true') {
                    document.getElementById("variant__comparepriceSale").style.display ="block";
                    document.getElementById("variant__priceSale").style.display ="block";
                    document.getElementById("variant__priceSale__perOff").style.display ="none";
                    document.getElementById("variant__priceRegular").style.display ="none";
                    document.getElementById("variant__priceTax").classList.add('u-color__text--red');
                    let compare_at_price = t[0].price.toString(10).slice(0,-2);
                    let numCompare_at_price = parseInt(compare_at_price, 10);
                    document.getElementById("variant__comparepriceSale").textContent = `¥ ${numCompare_at_price.toLocaleString()}`;
                  } else {
                    document.getElementById("variant__comparepriceSale").style.display ="none";
                    document.getElementById("variant__priceSale").style.display ="none";
                    document.getElementById("variant__priceSale__perOff").style.display ="none";
                    document.getElementById("variant__priceRegular").style.display ="block";
                    let price = t[0].price.toString(10).slice(0,-2);
                    let numPrice = parseInt(price, 10);
                    document.getElementById("variant__priceRegular").textContent = `¥ ${numPrice.toLocaleString()}`;
                    document.getElementById("variant__priceTax").classList.remove('u-color__text--red');
                  }
  
                  // 【改修】獲得ポイントの表示対応
                  document.getElementById("product-point-usually").style.display ="none";
                  document.getElementById("product-point-sale").style.display ="none";
                  if(point_sale_flg) {
                    document.getElementById("product-point-sale").style.display ="block";
                    // 2026.01.08 セール時は獲得ポイントをゼロに固定
                    //point_price_sale = point_price_sale / 1.1;
                    //let sale_point = point_price_sale * 0.01;
                    //sale_point = Math.floor(sale_point);
                    //document.getElementById("sale-point").textContent = sale_point.toLocaleString();
                    document.getElementById("sale-point").textContent = '0';
                  } else {
                    document.getElementById("product-point-usually").style.display ="block";
                    let price = t[0].price.toString(10).slice(0,-2);
                    let numPrice = parseInt(price, 10);
                    numPrice = numPrice / 1.1;
                    numPrice = Math.ceil(numPrice);//切り上げ
                    // ポイント表示次元設定
                    var objPointPublished = document.getElementById("point_published").textContent;
                    let rank_diamond_point = numPrice * 0.07;
                    let rank_platinum_point = numPrice * 0.05;
                    let rank_gold_point = numPrice * 0.03;
                    let rank_silver_point = numPrice * 0.02;
                    let rank_bronze_point = numPrice * 0.01;
                    let rank_regular_point = numPrice * 0.01;
                    document.getElementById("product-point-info").style.display ="none";
                    if(objPointPublished == 'true'){
                      rank_diamond_point = numPrice * 0.12;
                      rank_platinum_point = numPrice * 0.10;
                      rank_gold_point = numPrice * 0.08;
                      rank_silver_point = numPrice * 0.07;
                      rank_bronze_point = numPrice * 0.06;
                      rank_regular_point = numPrice * 0.06;
                      document.getElementById("product-point-info").style.display ="block";
                    }
                    rank_diamond_point = Math.floor(rank_diamond_point);
                    document.getElementById("rank-diamond-point").textContent = rank_diamond_point.toLocaleString();
                    rank_platinum_point = Math.floor(rank_platinum_point);
                    document.getElementById("rank-platinum-point").textContent = rank_platinum_point.toLocaleString();
                    rank_gold_point = Math.floor(rank_gold_point);
                    document.getElementById("rank-gold-point").textContent = rank_gold_point.toLocaleString();
                    rank_silver_point = Math.floor(rank_silver_point);
                    document.getElementById("rank-silver-point").textContent = rank_silver_point.toLocaleString();
                    rank_bronze_point = Math.floor(rank_bronze_point);
                    document.getElementById("rank-bronze-point").textContent = rank_bronze_point.toLocaleString();
                    rank_regular_point = Math.floor(rank_regular_point);
                    document.getElementById("rank-regular-point").textContent = rank_regular_point.toLocaleString();
                  }

                  // 2025/12/16 gf.E 複製ボタンを更新
                  const originalButton = document.getElementById("purchase");
                  const targetContainer = document.querySelector('.jlounge-layout-cart.c-float-cart');
                  
                  if (originalButton && targetContainer) {
                    const existingClone = targetContainer.querySelector('button');
                    if (existingClone) {
                      existingClone.remove();
                    }
                    const clonedButton = originalButton.cloneNode(true);
                    targetContainer.appendChild(clonedButton);
                  }
                
              }),
              (this.onSelectChange = () => {
                var e = this.$selects.map((e, n) => t()(n).val());
                this.setVariantOptions(e);
              }),
              (this.onSwatchChange = () => {
                var e = [];
                this.$addToCartForm.serializeArray().forEach((t) => {
                  0 === t.name.indexOf("option-") &&
                    (e[parseInt(t.name.split("-")[1], 10)] = t.value);
                }),
                  this.setVariantOptions(e);
              }),
              (this.sizeGuideOpen = (e) => {
                e.preventDefault(),
                  t()("#size-guide__prompt").addClass("size-guide--visible"),
                  t()(".size-guide__background").addClass("size-guide--visible");
                const n = window.scrollY;
                (document.body.style.position = "fixed"),
                  (document.body.style.top = `-${n}px`),
                  (document.body.style.overflowY = "scroll"),
                  this.$sizeGuideFocusable.each(function () {
                    t()(this).attr("tabindex", "0");
                  }),
                  this.trapFocus();
              }),
              (this.trapFocus = () => {
                var e = t().makeArray(this.$sizeGuideFocusable),
                  n = e[0],
                  i = e[e.length - 1];
                this.$sizeGuideContent.focus(),
                  i.addEventListener("keydown", function (e) {
                    9 !== e.keyCode ||
                      e.shiftKey ||
                      (e.preventDefault(), n.focus());
                  }),
                  n.addEventListener("keydown", function (e) {
                    9 === e.keyCode &&
                      e.shiftKey &&
                      (e.preventDefault(), i.focus());
                  });
              }),
              (this.sizeGuideClose = () => {
                t()("#size-guide__prompt").removeClass("size-guide--visible"),
                  t()(".size-guide__background").removeClass(
                    "size-guide--visible"
                  );
                const e = document.body.style.top;
                (document.body.style.position = ""),
                  (document.body.style.top = ""),
                  window.scrollTo(0, -1 * parseInt(e || "0")),
                  (document.body.style.overflowY = ""),
                  this.$sizeGuideFocusable.each(function () {
                    t()(this).attr("tabindex", "-1");
                  }),
                  this.$sizeGuideClose.attr("tabindex", "-1");
              }),
              (this.keySizeGuideClose = (e) => {
                13 === e.which &&
                  (this.sizeGuideClose(), this.$sizeGuideLink.focus());
              }),
              (this.backgroundSizeGuideClose = (e) => {
                e.target == e.currentTarget && this.sizeGuideClose();
              }),
              // (this.onMediaElementSelect = (e, t) => {
              //   var n = this.mediaById.get(e.dataset.mediaId);
              //   this.mediaById.forEach((e) => {
              //     e.media_id !== n.media_id && (e.pause(), e.deselect());
              //   }),
              //     n.select(),
              //     t.togglePlay
              //       ? n.togglePlay()
              //       : t.forcePlay
              //       ? n.play()
              //       : t.load &&
              //         n.load().then(function () {
              //           t.focus && n.focus();
              //         }),
              //     t.focus && n.focus();
              // }),
              (this.onVariantSelected = (e) => {
                var t = this.product.variants.filter((t) => t.id == e);
                if (0 === t.length) this.updateVariant(null);
                else {
                  var n = t[0];
                  this.updateVariant(t[0]);
                  for (var i = 0; i < n.options.length; i++) {
                    const e = this.element.querySelector(
                      "#SingleOptionSelector-" + i
                    );
                    if (!e) continue;
                    e.value = n.options[i];
                    const t = new CustomEvent("change");
                    e.dispatchEvent(t);
                  }
                }
              }),
              (this.storeAvailability = (e, t) => {
                var n = "/variants/" + e + "/?section_id=store-availability";
                if (this.element.querySelector(".store-pickup-enabled")) {
                  var i = document.createElement("div");
                  i.classList.add("product__store__availability__container");
                  var r = document.createElement("div");
                  r.setAttribute("data-store-availability-modal-container", "");
                  var s = this.element.querySelector(
                      ".featured-product--submit-action"
                    ),
                    a = this.element.querySelector(".product-page--local-pickup");
                  i &&
                    ((i.innerHTML = ""),
                    fetch(n)
                      .then(function (e) {
                        return e.text();
                      })
                      .then(
                        function (e) {
                          if (
                            "" === e.trim() ||
                            !e.includes('"store-availability-information"')
                          )
                            return;
                          const n = this.element.querySelector(
                            ".product__store__availability__container"
                          );
                          n && n.remove(), (i.innerHTML = e);
                          var o = i.querySelector(
                            ".store-availability-container"
                          );
                          (i.innerHTML = o.innerHTML),
                            s
                              ? (s.after(i), i.after(r))
                              : a && (a.after(i), i.after(r));
                          var l = this.element.querySelector(
                              "a[data-store-availability-modal-open]"
                            ),
                            c = this.element.querySelector(
                              "h2[data-store-availability-modal-product-title]"
                            );
                          l &&
                            (l.addEventListener(
                              "click",
                              function () {
                                setTimeout(function () {
                                  var e = t.querySelectorAll(
                                      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
                                    ),
                                    n = e[0],
                                    i = e[e.length - 1];
                                  t.focus(),
                                    t.addEventListener("keydown", function (e) {
                                      ("Tab" === e.key || 9 === e.keyCode) &&
                                        (e.shiftKey
                                          ? document.activeElement === n &&
                                            (i.focus(), e.preventDefault())
                                          : document.activeElement === i &&
                                            (n.focus(), e.preventDefault()));
                                    });
                                }, 500);
                                var e = this.element.querySelector(
                                    "div[data-store-availability-modal-container]"
                                  ),
                                  t = this.element.querySelector(
                                    "#StoreAvailabilityModal"
                                  ),
                                  n = document.querySelector("body");
                                n.classList.add("availability-modal--open"),
                                  e.classList.add(
                                    "store-availabilities-modal--open"
                                  ),
                                  t.classList.add("open"),
                                  (t.style = "visibility: visible;"),
                                  n.classList.contains(
                                    "availability-modal--open"
                                  ) &&
                                    e.addEventListener("click", function () {
                                      e.classList.remove(
                                        "store-availabilities-modal--open"
                                      ),
                                        n.classList.remove(
                                          "availability-modal--open"
                                        ),
                                        t.classList.remove("open"),
                                        (t.style = "visibility: hidden;");
                                    });
                                var i = this.element.querySelector(
                                  ".store-availabilities-modal__close"
                                );
                                i &&
                                  i.addEventListener("click", function () {
                                    e.classList.remove(
                                      "store-availabilities-modal--open"
                                    ),
                                      n.classList.remove(
                                        "availability-modal--open"
                                      ),
                                      t.classList.remove("open"),
                                      (t.style = "visibility: hidden;");
                                  });
                              }.bind(this)
                            ),
                            c && (c.textContent = t));
                        }.bind(this)
                      ));
                }
              }),
              (this.handleVariant = (e) => {
                this.$originalSelect.val(e.id),
                  this.storeAvailability(e.id, this.product.title);
                var n = e.compare_at_price && e.compare_at_price > e.price;
                if (
                  (this.$sale.toggleClass("hide", !n),
                  e.sku && this.$sku.text(e.sku),
                  this.$sku.toggleClass("hide", !e.sku),
                  this.$price.html(this.theme.formatMoney(e.price)),
                  this.$sale_price.html(
                    n ? this.theme.formatMoney(e.compare_at_price) : ""
                  ),
                  this.$variantPercentageWrapper.length > 0 &&
                    e.compare_at_price > e.price)
                ) {
                  this.$variantPercentageWrapper.removeClass("hide");
                  var i =
                    (100 * (e.compare_at_price - e.price)) / e.compare_at_price;
                  this.$variantPercentageWrapper
                    .find(".variant-percentage")
                    .text(i.toFixed(0) + "%");
                } else this.$variantPercentageWrapper.addClass("hide");
                if (
                  this.$variantValueWrapper.length > 0 &&
                  e.compare_at_price > e.price
                ) {
                  this.$variantValueWrapper.removeClass("hide");
                  var r = e.compare_at_price - e.price;
                  this.$variantValueWrapper
                    .find(".variant-value")
                    .html(this.theme.formatMoney(r));
                } else this.$variantValueWrapper.addClass("hide");
                if (
                  (e.unit_price_measurement
                    ? this.$pricePerUnit.html(
                        '<span class="price">(' +
                          this.theme.formatMoney(e.unit_price) +
                          " / " +
                          (1 != e.unit_price_measurement.reference_value
                            ? e.unit_price_measurement.reference_value
                            : "") +
                          " " +
                          e.unit_price_measurement.reference_unit +
                          ")"
                      )
                    : this.$pricePerUnit.text(""),
                  e.available
                    ? (this.hideVariantOutOfStockForm(),
                      this.$cart.prop("disabled", !1),
                      this.$spb
                        .show()
                        .css({ opacity: 1 })
                        .animate({ opacity: 1 }),
                      this.$cart.text(this.theme.translations.addToCart),
                      t().event.trigger({
                        type: "variantAvailable",
                        time: new Date(),
                      }))
                    : (this.showVariantOutOfStockForm(
                        this.product.title,
                        e.title
                      ),
                      this.$cart.prop("disabled", !0),
                      this.$spb
                        .css({ opacity: 1 })
                        .animate({ opacity: 0 })
                        .hide(),
                      this.$cart.text(this.theme.translations.soldOut),
                      t().event.trigger({
                        type: "variantUnavailable",
                        time: new Date(),
                        variant: e,
                      })),
                  e.featured_media)
                ) {
                  const t = this.product.media.findIndex(
                    (t) => t.id === e.featured_media.id
                  );
                  if (t >= 0) {
                    var s = this.$element.find(
                      '.product-single__thumbnail[data-media-id$="' +
                        e.featured_media.id +
                        '"]'
                    );
                    // this.onMediaElementSelect(s[0], { load: !0 }),
                    //   1 === this.slider.slidesPerViewDynamic() &&
                    //     this.slider.slideToLoop(t);
                  }
                }
                var a = this.$element
                    .closest(".shopify-section")
                    .hasClass("homepage-section--indiv-product-wrapper"),
                  o = this.product.variants.length > 1;
                if (window.history.replaceState && !a && o) {
                  var l = [];
                  window.location.search.length > 1 &&
                    (l = window.location.search
                      .slice(1)
                      .split("&")
                      .filter(function (e) {
                        return 0 !== e.indexOf("variant=");
                      })),
                    l.push("variant=" + e.id);
                  var c =
                    window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?" +
                    l.join("&");
                  window.history.replaceState({ path: c }, "", c);
                }
                if (this.$swatchInputs.length > 0) {
                  var d = this.$element.data("section-id");
                  e.options.forEach((e, t) => {
                    var n;
                    this.$swatchInputs
                      .filter(
                        "#section-" +
                          d +
                          "-swatch-" +
                          t +
                          "-" +
                          ((n = e),
                          n
                            .toLowerCase()
                            .replace(/[()]/g, "")
                            .replace(/[\W]/g, "-"))
                      )
                      .prop("checked", !0);
                  });
                }
              }),
              (this.handleNullVariant = () => {
                this.$selects.filter(function (e, n) {
                  return "" === t()(n).val();
                }).length > 0
                  ? this.$price.text(this.theme.translations.makeASelection)
                  : (this.$price.text(this.theme.translations.unavailable),
                    this.hideVariantOutOfStockForm()),
                  this.$cart.prop("disabled", !0),
                  this.$sale.addClass("hide"),
                  this.$variantPercentageWrapper.addClass("hide"),
                  this.$variantValueWrapper.addClass("hide"),
                  this.$sku.addClass("hide");
              }),
              (this.updateVariant = (e) => {
                e ? this.handleVariant(e) : this.handleNullVariant();
              }),
              (this.CART_LOADING =
                '<div class="lds-dual-ring"></div><span class="sr-only">Loading...</span>'),
              (this.addToCart = () => {
                this.clearError(),
                  t().ajax({
                    url: this.config.shopifyAjaxAddUrl,
                    dataType: "json",
                    type: "post",
                    data: this.$addToCartForm.serialize(),
                    success: this.addedToCart,
                    error: this.addToCartFailed,
                  });
              }),
              (this.disableCartButton = () => {
                this.addedTextTimeout &&
                  (clearTimeout(this.addedTextTimeout),
                  (this.addedTextTimeout = null)),
                  this.$cart
                    .addClass("disabled")
                    .prop("disabled", !0)
                    .html(this.CART_LOADING);
              }),
              (this.enableCartButton = () => {
                this.addedTextTimeout &&
                  (clearTimeout(this.addedTextTimeout),
                  (this.addedTextTimeout = null)),
                  this.$cart
                    .removeClass("disabled")
                    .prop("disabled", !1)
                    .html(this.theme.translations.addToCart);
              }),
              (this.addedToCart = (e) => {
                this.updateCart();
              }),
              (this.openCartPage = () => {
                window.location.href = this.$addToCartForm
                  .find("#cart-link")
                  .val()
                  .toString();
              }),
              (this.showCart = () => {
                t()(".js-cart-drawer-status")
                  .text("Item added to your cart")
                  .appendTo(".cart-drawer__top"),
                  this.$cartSliderWrapper.trigger("cart:open");
              }),
              (this.updateCart = () => {
                t()
                  .ajax({
                    cache: !1,
                    url: this.config.shopifyAjaxUrl,
                    dataType: "json",
                  })
                  .then(this.updatedCart)
                  .fail(this.updateCartFailed);
              }),
              (this.updatedCart = (e) => {
                this.theme.updateCartDrawer(e), this.enableCartButton();
                var t = this.$cart.data("cart-action");
                "cart" === t
                  ? this.openCartPage()
                  : "added" === t
                  ? (this.$cart.html(this.theme.translations.added),
                    this.$cartCount.text(e.item_count),
                    this.addedTextTimeout &&
                      (clearTimeout(this.addedTextTimeout),
                      (this.addedTextTimeout = null)),
                    (this.addedTextTimeout = setTimeout(() => {
                      this.$cart.html(this.theme.translations.addToCart);
                    }, 2e3)))
                  : this.showCart();
              }),
              (this.updateCartFailed = (e) => {
                this.enableCartButton(),
                  console.error("Updating the cart failed: ", e);
              }),
              (this.addToCartFailed = (e) => {
                this.enableCartButton();
                var t = "Unknown error";
                0 == e.status ||
                  (e.responseJSON
                    ? (t = e.responseJSON.description
                        ? e.responseJSON.description
                        : e.responseJSON.message)
                    : e.responseText && (t = e.responseText)),
                  this.showError(t);
              }),
              (this.showError = (e) => {
                t()('<div id="cart-error"></div>')
                  .addClass("alert alert-danger")
                  .text(e)
                  .insertAfter(this.$cart);
              }),
              (this.clearError = () => {
                t()("#cart-error").remove();
              }),
              (this.loadTabs = () => {
                t()("ul.tabs").each(function () {
                  const e = t()(this).find("a");
                  let n = e.first().addClass("active"),
                    i = t()(n.attr("href"));
                  e.not(":first").each(function () {
                    t()(t()(this).attr("href")).hide();
                  }),
                    t()(this)
                      .find("a")
                      .on("click", function (e) {
                        return (
                          n.removeClass("active"),
                          i.hide(),
                          (n = t()(this)),
                          (i = t()(t()(this).attr("href"))),
                          n.addClass("active"),
                          i.fadeIn(),
                          !1
                        );
                      });
                });
              }),
              (this.loadSlider = () => {
                this.$element
                  .find(".mobile-product-slider")
                  .flexslider({
                    animation: "slide",
                    directionNav: !1,
                    controlNav: !0,
                    startAt: 0,
                    slideshow: !1,
                  });
              }),
              (this.showVariantOutOfStockForm = (e, t) => {
                if (
                  this.$element
                    .find(".product-description-main-wrapper")
                    .data("stock-email-enabled")
                ) {
                  var n = this.$element.find(
                      '#notify-me-wrapper input[name="contact[body]"]'
                    ),
                    i = `Please notify me when ${e}, variant: ${t} becomes available.`,
                    r = document.querySelector("#variant_title"),
                    s = document.querySelector("#sold-out"),
                    a = document.querySelector("#notify-me-wrapper .btn");
                  if (!r) return;
                  (r.innerText = "- " + t),
                    s.addEventListener("submit", function () {
                      a.value = "";
                    }),
                    n.val(i),
                    this.$element.find(".variant-out-of-stock").fadeIn();
                }
              }),
              (this.hideVariantOutOfStockForm = () => {
                this.$element
                  .find(".product-description-main-wrapper")
                  .data("stock-email-enabled") &&
                  (this.$element.find(".variant-out-of-stock").hide(),
                  this.$element
                    .find(".product-page--submit-action")
                    .removeClass("hidden"));
              }),
              (this.responsiveTables = () => {
                this.$element
                  .find(".product-description-wrapper table")
                  .wrap('<div class="rte__table-wrapper"></div>');
              }),
              (this.isFeaturedProduct = r),
              (this.config = {
                shopifyAjaxAddUrl: "/cart/add.js",
                shopifyAjaxUrl: "/cart.js",
              }),
              (this.$element = t()(n)),
              (this.sectionId = this.element.dataset.sectionId);
            var s = this.element.querySelector(".product-json");
            if (s) {
              (this.product = JSON.parse(s.textContent)),
                (this.$selects = this.$element.find(
                  ".selector-wrapper select, .product-option-select select"
                )),
                this.$selects.on("change", this.onSelectChange),
                (this.$originalSelect = this.$element.find(".original-select")),
                (this.$old_price = this.$element.find(
                  ".compare-at-price .money"
                )),
                (this.$price = this.$element.find("#price-field")),
                (this.$cart = this.$element.find("#purchase")),
                (this.$cartCount = t()(".cart-item-count-header--quantity")),
                (this.$spb = this.$element.find(".shopify-payment-button")),
                (this.$sale = this.$element.find(
                  ".sale-badge,.compare-at-price"
                )),
                (this.$sale_price = this.$element.find(".compare-at-price")),
                (this.$pricePerUnit = this.$element.find(
                  ".product-page--pricing--price-per-unit"
                )),
                (this.$variantPercentageWrapper = this.$element.find(
                  ".variant-percentage-wrapper"
                )),
                (this.$variantValueWrapper = this.$element.find(
                  ".variant-value-wrapper"
                )),
                (this.$variantValue = this.$element.find(".variant-value")),
                (this.$featuredImageWrapper = this.$element.find(
                  ".featured-image-div"
                )),
                (this.$featuredImage = this.$element.find(".product-main-image")),
                (this.$addToCartForm = this.$element.find("#add-to-cart-form")),
                (this.$mobileSlider = this.$element.find(
                  ".mobile-product-slider"
                )),
                (this.$cartSliderWrapper = t()("#cartSlideoutWrapper")),
                (this.$thumbnails = this.$element.find(
                  ".product-single__thumbnail"
                )),
                (this.$swatchInputs = this.$element
                  .find("#add-to-cart-form")
                  .find(".swatch input")),
                (this.$swatchLabels = this.$element
                  .find("#add-to-cart-form")
                  .find(".swatch label")),
                (this.$sku = this.$element.find(".indiv-product-sku-text")),
                (this.$sizeGuideLink = this.$element.find(".size-guide-link")),
                (this.$sizeGuideClose = this.$element.find(
                  ".size-guide__close-btn"
                )),
                (this.$sizeGuideWrapper = this.$element.find(
                  ".size-guide__background"
                )),
                (this.$sizeGuidePrompt = this.$element.find(
                  "#size-guide__prompt"
                )),
                (this.$sizeGuideContent = this.$element.find(
                  "#size-guide__content"
                )),
                (this.$sizeGuideFocusable = null),
                (this.storeAvailabilityContainer = this.$element.find(
                  "[data-store-availability-container]"
                )),
                (this.zoomSelector = ".zoomImg"),
                (this.addedTextTimeout = null),
                (this.slider = this.initializeSlider()),
                (this.mediaById = new Map());
              var a = window.matchMedia("screen and (max-width: 767px)").matches,
                o = !a;
              (this.mediaTarget = this.element.querySelector(
                ".product-single__medias"
              )),
                Array.prototype.forEach.call(
                  this.element.querySelectorAll(
                    ".product-single__thumbnail:not(.swiper-slide-duplicate)"
                  ),
                  (e) => {
                    var t = new $a(
                      this.theme,
                      e,
                      a || this.isFeaturedProduct ? e : this.mediaTarget,
                      o
                    );
                    this.mediaById.set(e.dataset.mediaId, t),
                      e.addEventListener("media-play", () => {
                        this.slider.allowTouchMove = !1;
                      }),
                      e.addEventListener("media-pause", () => {
                        this.slider.allowTouchMove = !0;
                      });
                  }
                ),
                this.$element.find(".product-single__view-in-space").length > 0 &&
                  window.Shopify.loadFeatures([
                    { name: "shopify-xr", version: "1.0" },
                  ]);
              var l = this;
              this.$swatchLabels.length > 0 &&
                this.$swatchLabels.each((e, n) => {
                  t()(n).on("keypress", (e) => {
                    if (13 == e.which) {
                      const n = t()(e.target).attr("for");
                      t()("#" + n).prop("checked", !0), l.onSwatchChange();
                    }
                  });
                }),
                this.$swatchInputs.length > 0
                  ? this.onSwatchChange()
                  : this.onSelectChange(),
                this.$cart.on("click", (e) => {
                  e.preventDefault(), this.disableCartButton(), this.addToCart();
                }),
                (this.selects = this.element.querySelectorAll(
                  ".selector-wrapper select, .product-option-select select"
                )),
                (this.addToCartForm =
                  this.element.querySelector("#add-to-cart-form")),
                this.selects.forEach((e) => {
                  e.addEventListener("change", function () {
                    const e = new Event("change");
                    l.addToCartForm.dispatchEvent(e);
                  });
                }),
                this.$thumbnails.off("click keydown").on("click keydown", (e) => {
                  if ("keydown" === e.type) {
                    if (13 !== e.keyCode && 27 !== e.keyCode) return;
                    if (
                      e.target.classList.contains(
                        "shopify-model-viewer-ui__button"
                      ) ||
                      e.target.classList.contains("plyr__control")
                    )
                      return;
                  }
                  if (
                    (e.preventDefault(),
                    e.target.classList.contains("product-single__view-in-space"))
                  )
                    return;
                  if (
                    "MODEL-VIEWER" === e.target.tagName ||
                    e.target.classList.contains(
                      "shopify-model-viewer-ui__controls-overlay"
                    )
                  )
                    return;
                  if (e.target.classList.contains("plyr__control")) return;
                  if (
                    "image" === e.currentTarget.dataset.mediaType &&
                    1 === this.slider.slidesPerViewDynamic()
                  )
                    return;
                  const t = e.currentTarget.classList.contains(
                      "product-single__media--loaded"
                    ),
                    n = e.currentTarget.classList.contains(
                      "product-single__media--active"
                    );
                  // (t && n) ||
                  //   this.onMediaElementSelect(e.currentTarget, {
                  //     load: !0,
                  //     togglePlay: !0,
                  //     focus: !0,
                  //   });
                }),
                this.$swatchInputs.on("change", this.onSwatchChange),
                this.$sizeGuideWrapper.length > 0 && this.initializeSizeGuide(),
                this.preloadImages(),
                this.loadTabs(),
                this.loadSlider(),
                (this.quantityControls = new Ma(this.theme, this.element)),
                this.responsiveTables();
            }
          }
        }
        function Aa(e) {
          var n = e.slidesPerViewDynamic(),
            i = e.activeIndex,
            r = i + n;
          e.slides.each(function (e, n) {
            var s = e >= i && e < r ? "0" : "-1",
              a = n.querySelector(".product-single__media__icon");
            a && a.setAttribute("tabindex", s),
              t()(n)
                .find(
                  ".product-single__media__icon, button, model-viewer, input:not([hidden]), .plyr, iframe, a, select, textarea"
                )
                .attr("tabindex", s);
          });
        }
        class La extends ja {
          constructor(e, t, n) {
            super(e, t, n, !0),
              (this.loadSlider = () => {
                this.$element
                  .find(".homepage-sections--indiv-product-slider")
                  .flexslider({
                    directionNav: !1,
                    slideshow: !1,
                    animation: "slide",
                  });
              });
          }
        }
        class Ia extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
            let i = this.element.querySelectorAll(".stl__dot--container");
            const r = (e) => {
                o("stl__dot--active"),
                  e.parentElement.blur(),
                  e.parentElement.classList.add("stl__dot--active"),
                  l(".stl__products", "stl__product--faded");
                const t = this.element.querySelector(
                  `[data-stl-product-block-id="${e.dataset.stlDotBlockId}"]`
                );
                c(t, "stl__product--faded"), d(t);
              },
              s = (e) => {
                const t = this.element.querySelector(
                  `[data-stl-dot-block-id="${e.detail.blockId}"]`
                );
                r(t);
              },
              a = () => {
                o("stl__dot--active"), o("stl__product--faded");
              },
              o = (e) => {
                this.element
                  .querySelectorAll(`.${e}`)
                  .forEach((t) => t.classList.remove(`${e}`));
              },
              l = (e, t) => {
                this.element
                  .querySelectorAll(`${e}`)
                  .forEach((e) => e.classList.add(`${t}`));
              },
              c = (e, t) => e.classList.remove(`${t}`),
              d = (e) => {
                window.innerWidth < 768 &&
                  e.scrollIntoView({ behavior: "smooth", block: "end" });
              };
            i.length > 0 &&
              (document.addEventListener("click", (e) => {
                e.target.hasAttribute("data-index") ||
                  (o("stl__dot--active"), o("stl__product--faded"));
              }),
              window.Shopify.designMode &&
                (document.addEventListener("shopify:block:select", s),
                document.addEventListener("shopify:block:deselect", a)),
              i.forEach((e) => {
                e.addEventListener("click", (e) => r(e.target)),
                  e.addEventListener("keypress", (e) => {
                    13 === e.keyCode && r(e.target);
                  });
              }));
          }
        }
        var Oa = n(755);
        class Pa extends Zr {
          constructor(e, t, n) {
            super(e, t, n),
              (this.load = () => {
                var e = this.element.dataset.productId,
                  t = this.element.dataset.limit,
                  n = this.element.dataset.wethemeSectionId,
                  i = `${this.element.dataset.recommendationsUrl}?section_id=${n}&limit=${t}&product_id=${e}`,
                  r = new XMLHttpRequest();
                r.open("GET", i), (r.onload = () => this.onLoad(r)), r.send();
              }),
              (this.onLoad = (e) => {
                if (e.status >= 200 && e.status < 300) {
                  var t = document.createElement("div");
                  (t.innerHTML = e.response),
                    (this.element.parentElement.innerHTML = t.querySelector(
                      ".product-recommendations"
                    ).innerHTML),
                    this.gridSwatches();
                } else
                  console.warn(
                    "Recommend products cannot be loaded:",
                    e.responseText
                  );
              }),
              (this.gridSwatches = () => {
                Oa(".indiv-product__swatches")
                  .find("input")
                  .on("change", function () {
                    var e = Oa(this).attr("data-href"),
                      t = Oa(this)
                        .closest(".indiv-product")
                        .find(".grid__image img");
                    t.attr({ src: e }),
                      t.attr({ srcset: e }),
                      t.data({ lowsrc: e }),
                      t.data({ srcset: e });
                  });
              }),
              this.load();
          }
        }
        class Da extends Kr {
          constructor(e, n) {
            super(e, n),
              (this.onWindowResize = () => {
                (this.img_height = t()(this.img).height()),
                  (this.container_height =
                    (this.$element.height() > 0
                      ? this.$element.height()
                      : this.img_height) || 500),
                  (this.active = !window.matchMedia(
                    "screen and (max-width: 767px)"
                  ).matches),
                  this.update();
              }),
              (this.update = () => {
                if (this.active) {
                  var e =
                      document.body.scrollTop ||
                      document.documentElement.scrollTop,
                    t = this.img_height - this.container_height,
                    n = this.element.getBoundingClientRect().top + e,
                    i = n + this.container_height,
                    r = window.innerHeight,
                    s = t * ((e + r - n) / (this.container_height + r));
                  i > e &&
                    n < e + r &&
                    (this.img.style.transform =
                      "translate3D(-50%," + s + "px, 0)");
                } else this.img.style.transform = "";
              }),
              (this.theme = e),
              (this.element = n),
              (this.$element = t()(n)),
              (this.img = n.querySelector(".img")),
              (this.active = !1),
              this.$element
                .children(".img")
                .one("load", () => {
                  this.onWindowResize(), (this.img.style.display = "block");
                })
                .each(function () {
                  (!this.complete && this.src) || t()(this).trigger("load");
                }),
              window.addEventListener("scroll", this.update.bind(this), {
                capture: !0,
                passive: !0,
              });
          }
        }
        class za extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
            const i = t.querySelector(".parallax");
            i && (this.parallax = new Da(e, i));
          }
        }
        class Na extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
            const i = t.querySelector(".parallax-enabled");
            i && (this.parallax = new Da(e, i));
          }
        }
        class qa extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
            const i = t.querySelector(".parallax");
            i && (this.parallax = new Da(e, i));
          }
        }
        function Ha(e) {
          const t = e || {};
          (this.settings = Object.assign(
            {
              method: "scroll",
              container: "#AjaxinateContainer",
              pagination: "#AjaxinatePagination",
              offset: 0,
              loadingText: "Loading",
              callback: null,
            },
            t
          )),
            (this.addScrollListeners = this.addScrollListeners.bind(this)),
            (this.addClickListener = this.addClickListener.bind(this)),
            (this.checkIfPaginationInView =
              this.checkIfPaginationInView.bind(this)),
            (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
            (this.removeClickListener = this.removeClickListener.bind(this)),
            (this.removeScrollListener = this.removeScrollListener.bind(this)),
            (this.removePaginationElement =
              this.removePaginationElement.bind(this)),
            (this.destroy = this.destroy.bind(this)),
            (this.containerElement = document.querySelector(
              this.settings.container
            )),
            (this.paginationElement = document.querySelector(
              this.settings.pagination
            )),
            this.initialize();
        }
        (Ha.prototype.initialize = function () {
          if (!this.containerElement) return;
          ({ click: this.addClickListener, scroll: this.addScrollListeners }[
            this.settings.method
          ]());
        }),
          (Ha.prototype.addScrollListeners = function () {
            this.paginationElement &&
              (document.addEventListener("scroll", this.checkIfPaginationInView),
              window.addEventListener("resize", this.checkIfPaginationInView),
              window.addEventListener(
                "orientationchange",
                this.checkIfPaginationInView
              ));
          }),
          (Ha.prototype.addClickListener = function () {
            this.paginationElement &&
              ((this.nextPageLinkElement =
                this.paginationElement.querySelector("a")),
              (this.clickActive = !0),
              void 0 !== this.nextPageLinkElement &&
                null !== this.nextPageLinkElement &&
                this.nextPageLinkElement.addEventListener(
                  "click",
                  this.preventMultipleClicks
                ));
          }),
          (Ha.prototype.preventMultipleClicks = function (e) {
            e.preventDefault(),
              this.clickActive &&
                ((this.nextPageLinkElement.innerText = this.settings.loadingText),
                (this.nextPageUrl = this.nextPageLinkElement.href),
                (this.clickActive = !1),
                this.loadMore());
          }),
          (Ha.prototype.checkIfPaginationInView = function () {
            const e =
                this.paginationElement.getBoundingClientRect().top -
                this.settings.offset,
              t =
                this.paginationElement.getBoundingClientRect().bottom +
                this.settings.offset;
            e <= window.innerHeight &&
              t >= 0 &&
              ((this.nextPageLinkElement =
                this.paginationElement.querySelector("a")),
              this.removeScrollListener(),
              this.nextPageLinkElement &&
                ((this.nextPageLinkElement.innerText = this.settings.loadingText),
                (this.nextPageUrl = this.nextPageLinkElement.href),
                this.loadMore()));
          }),
          (Ha.prototype.loadMore = function () {
            (this.request = new XMLHttpRequest()),
              (this.request.onreadystatechange = function () {
                if (!this.request.responseXML) return;
                if (
                  4 === !this.request.readyState ||
                  200 === !this.request.status
                )
                  return;
                const e = this.request.responseXML.querySelectorAll(
                    this.settings.container
                  )[0],
                  t = this.request.responseXML.querySelectorAll(
                    this.settings.pagination
                  )[0];
                this.containerElement.insertAdjacentHTML(
                  "beforeend",
                  e.innerHTML
                ),
                  void 0 === t
                    ? this.removePaginationElement()
                    : ((this.paginationElement.innerHTML = t.innerHTML),
                      this.settings.callback &&
                        "function" == typeof this.settings.callback &&
                        this.settings.callback(this.request.responseXML),
                      this.initialize());
              }.bind(this)),
              this.request.open("GET", this.nextPageUrl),
              (this.request.responseType = "document"),
              this.request.send();
          }),
          (Ha.prototype.removeClickListener = function () {
            this.nextPageLinkElement.removeEventListener(
              "click",
              this.preventMultipleClicks
            );
          }),
          (Ha.prototype.removePaginationElement = function () {
            (this.paginationElement.innerHTML = ""), this.destroy();
          }),
          (Ha.prototype.removeScrollListener = function () {
            document.removeEventListener("scroll", this.checkIfPaginationInView),
              window.removeEventListener("resize", this.checkIfPaginationInView),
              window.removeEventListener(
                "orientationchange",
                this.checkIfPaginationInView
              );
          }),
          (Ha.prototype.destroy = function () {
            return (
              {
                click: this.removeClickListener,
                scroll: this.removeScrollListener,
              }[this.settings.method](),
              this
            );
          });
        Ha.prototype.loadMore = function () {
          (this.request = new XMLHttpRequest()),
            (this.request.onreadystatechange = function () {
              var e = new DOMParser().parseFromString(
                this.request.responseText,
                "text/html"
              );
              if (4 === this.request.readyState && 200 === this.request.status) {
                var t = e.querySelectorAll(this.settings.container)[0],
                  n = e.querySelectorAll(this.settings.pagination)[0];
                this.containerElement.insertAdjacentHTML(
                  "beforeend",
                  t.innerHTML
                ),
                  (this.paginationElement.innerHTML = n.innerHTML),
                  this.settings.callback &&
                    "function" == typeof this.settings.callback &&
                    this.settings.callback(this.request.responseXML),
                  this.initialize();
              }
            }.bind(this)),
            this.request.open("GET", this.nextPageUrl),
            this.request.overrideMimeType("text/html"),
            this.request.send();
        };
        class Fa extends Zr {
          constructor(e, n, i) {
            super(e, n, i),
              (this.colorSwatchCheck = () => {
                t()(
                  ".indiv-product__swatches.colour label, .indiv-product__swatches.color label"
                ).each(function (e, n) {
                  const i = t()(n).attr("for"),
                    r = t()("#" + i).val(),
                    s = t()(n)
                      .closest(".indiv-product")
                      .find(".product-grid-json")
                      .get(0);
                  if (!s) return;
                  0 ===
                    JSON.parse(s.textContent).variants.filter(
                      (e) => e.options.indexOf(r) > -1 && 1 == e.available
                    ).length && t()(n).addClass("soldout");
                });
              }),
              (this.loadPaging = () => {
                t()("#AjaxinateInfiniteScrolling").length &&
                  new Ha({
                    container: "#AjaxinateContainer",
                    pagination: "#AjaxinateInfiniteScrolling",
                    method: "scroll",
                    loadingText: "Loading",
                    offset: 500,
                  }),
                  t()("#AjaxinateLoadMore").length &&
                    new Ha({
                      container: "#AjaxinateContainer",
                      pagination: "#AjaxinateLoadMore",
                      method: "click",
                      loadingText: "Loading",
                    });
              }),
              (this.loadTagFilter = () => {
                var e = t()(".coll-filter");
                e.on("change", function () {
                  var n = [];
                  if (
                    (e.each(function () {
                      var e = t()(this).val();
                      e && n.push(e);
                    }),
                    n.length)
                  ) {
                    var i = n.join("+");
                    window.location.href = t()("#link-to-tag-generic a")
                      .attr("href")
                      .replace(/\/tag($|\?)/, "/" + i + "$1");
                  } else window.location.href = t()("#link-to-collection").val().toString();
                });
              }),
              (this.loadSort = () => {
                const e = {};
                if (location.search.length)
                  for (
                    var n, i = 0, r = location.search.substr(1).split("&");
                    i < r.length;
                    i++
                  )
                    (n = r[i].split("=")).length > 1 &&
                      (e[decodeURIComponent(n[0])] = decodeURIComponent(n[1]));
                var s = t()("#collection-sort-by").val();
                t()("#sort-by")
                  .val(s)
                  .on("change", function () {
                    (e.sort_by = t()(this).val()),
                      (location.search = t().param(e).replace(/\+/g, "%20"));
                  });
              }),
              this.loadTagFilter(),
              this.loadSort(),
              this.colorSwatchCheck(),
              this.loadPaging(),
              document.addEventListener("paginate", this.loadPaging);
          }
        }
        class Ba extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
          }
        }
        var Wa = n(755);
        class Ra extends Zr {
          constructor(e, t, n) {
            super(e, t, n),
              (this.mobileSidebar = () => {
                Wa(".collection-sidebar--section h2").on("click", function () {
                  Wa(this).parent().toggleClass("expanded");
                });
              }),
              this.mobileSidebar();
          }
        }
        class Va extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
          }
        }
        class Ga extends Zr {
          constructor(e, t, n) {
            super(e, t, n);
          }
        }
        class Xa extends Zr {
          constructor(e, n, i) {
            super(e, n, i),
              (this.cartTerms = new Jr(e, n)),
              t()('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').on(
                "click",
                this.cartTerms.checkTerms
              ),
              (this.quantityControls = new Ma(this.theme, this.element, !0));
          }
        }
        class Ya {
          constructor(e) {
            if (
              ((this.onSubmit = (e) => {
                e.preventDefault();
                var t = this;
                const n = e.target,
                  i = new FormData(n),
                  r = n.querySelector(".newsletter-spinner"),
                  s = n.querySelector(
                    '#newsletter-wrapper, [id^="newsletter-wrapper"]'
                  ),
                  a = n.querySelector(".form-success");
                r.classList.remove("hide"),
                  s && s.classList.add("hide"),
                  fetch("/contact", { method: "post", body: i })
                    .then((e) =>
                      "string" == typeof e.url && e.url.includes("/challenge")
                        ? (n.removeEventListener("submit", t.onSubmit),
                          n.submit(),
                          !1)
                        : e
                    )
                    .then((e) => {
                      !1 !== e &&
                        (r.classList.add("hide"),
                        a && a.classList.remove("hide"));
                    });
              }),
              (this.showAlert = (e) => {
                const t = document.createElement("div");
                t.classList.add("page-alert", "page-alert--hidden"),
                  t.append(e.cloneNode(!0)),
                  document.body.append(t);
                const n = document.querySelector(".page-alert");
                document
                  .querySelectorAll(".success-msg")
                  .forEach((e) => e.classList.remove("hidden")),
                  setTimeout(() => {
                    n.classList.remove("page-alert--hidden");
                  }, 1e3),
                  setTimeout(() => {
                    n.classList.add("page-alert--hidden");
                  }, 8e3);
              }),
              (this.theme = e),
              (this.forms = document.querySelector(".contact-form")),
              !this.forms)
            )
              return;
            this.forms.addEventListener("submit", this.onSubmit);
            const t = document.querySelector(".contact-form .form-success"),
              n = document.querySelector(".contact-form .errors");
            n && n.length > 0 && n[0].children.length > 0
              ? this.showAlert(n[0])
              : t.length > 0 && this.showAlert(t[0]);
          }
        }
        let Ua = 0;
        const Ka = Vr.extend({
          props: {
            fit: {
              type: String,
              default: "parent",
              validator: function (e) {
                return -1 !== ["parent", "current", "longest"].indexOf(e);
              },
            },
            direction: {
              type: String,
              default: "down",
              validator: function (e) {
                return -1 !== ["down", "up"].indexOf(e);
              },
            },
          },
          data: function () {
            return {
              theme: null,
              id: "",
              title: "",
              isOpen: !1,
              options: [],
              selectedOption: void 0,
              focusedIndex: 0,
              selectComponent: void 0,
            };
          },
          beforeMount() {
            const e = this.$root.$el.querySelector("select");
            e.id
              ? (this.id = e.id)
              : ((Ua += 1), (this.id = "wetheme-dropdown-" + Ua));
            const t = this.$root.$el.querySelector("label");
            this.title = t ? t.textContent : void 0;
            const n = [];
            Array.prototype.forEach.call(
              e.querySelectorAll("option"),
              function (e, t) {
                void 0 === e.dataset.placeholder &&
                  n.push({ value: e.value, label: e.textContent }),
                  e.defaultSelected &&
                    ((this.selectedOption = e), (this.focusedIndex = t));
              }.bind(this)
            ),
              (this.options = n),
              this.selectedOption ||
                ((this.selectedOption = n[0]), (this.focusedIndex = 0)),
              (this.selectWidth = ((e) => {
                var t = e.cloneNode(!0);
                (t.style.cssText =
                  "position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset"),
                  document.body.appendChild(t);
                var n = t.getBoundingClientRect().width;
                return document.body.removeChild(t), n;
              })(e)),
              (this.selectComponent = e),
              (this.selectComponent.style.display = "none"),
              e.addEventListener("input", this.onSelectChange),
              e.addEventListener("change", this.onSelectChange);
          },
          mounted: function () {
            if ("longest" === this.fit) {
              const e = this.selectWidth + 20;
              (this.$el.style.width = e + "px"),
                (this.$refs.ul.style.width = e + "px");
            }
            this.$el.appendChild(this.selectComponent);
          },
          computed: {
            dropdownId: function () {
              return this.id + "-dropdown";
            },
            focusedOption: function () {
              return this.options[this.focusedIndex].value;
            },
          },
          methods: {
            findOptionIndex: function (e) {
              let t;
              return (
                this.options.forEach(function (n, i) {
                  n.value === e.value && (t = i);
                }),
                t
              );
            },
            optionClicked: function (e) {
              (this.selectedOption = e),
                (this.focusedIndex = this.findOptionIndex(e)),
                (this.selectComponent.value = e.value),
                this.$nextTick(function () {
                  const e = new CustomEvent("change");
                  this.selectComponent.dispatchEvent(e), this.exitList();
                });
            },
            moveFocusedIndex: function (e) {
              const t = this.focusedIndex + e;
              t >= 0 && t < this.options.length && (this.focusedIndex = t),
                this.isOpen || this.applyFocused(!0);
            },
            applyFocused: function (e) {
              this.isOpen || e
                ? (this.optionClicked(this.options[this.focusedIndex]),
                  (this.isOpen = !1))
                : (this.isOpen = !0);
            },
            close: function () {
              this.isOpen = !1;
            },
            focusList: function () {
              this.$nextTick(function () {
                this.$refs.ul.focus();
              });
            },
            exitList: function () {
              (this.isOpen = !1), this.$refs.button.focus();
            },
            toggleDropdown: function () {
              (this.isOpen = !this.isOpen),
                this.isOpen ? this.focusList() : this.$refs.button.focus();
            },
            onSelectChange: function (e) {
              const t = this.selectComponent.value;
              if (t !== this.selectedOption.value) {
                let e, n;
                this.options.forEach((i, r) => {
                  t === i.value && ((e = r), (n = i));
                }),
                  (this.selectedOption = n),
                  (this.focusedIndex = e);
              }
            },
            optionIsSelected: function (e) {
              return e.value === this.options[this.focusedIndex].value;
            },
          },
        });
        function Za(e, t, n, i, r, s, a, o) {
          var l,
            c = "function" == typeof e ? e.options : e;
          if (
            (t && ((c.render = t), (c.staticRenderFns = n), (c._compiled = !0)),
            i && (c.functional = !0),
            s && (c._scopeId = "data-v-" + s),
            a
              ? ((l = function (e) {
                  (e =
                    e ||
                    (this.$vnode && this.$vnode.ssrContext) ||
                    (this.parent &&
                      this.parent.$vnode &&
                      this.parent.$vnode.ssrContext)) ||
                    "undefined" == typeof __VUE_SSR_CONTEXT__ ||
                    (e = __VUE_SSR_CONTEXT__),
                    r && r.call(this, e),
                    e &&
                      e._registeredComponents &&
                      e._registeredComponents.add(a);
                }),
                (c._ssrRegister = l))
              : r &&
                (l = o
                  ? function () {
                      r.call(
                        this,
                        (c.functional ? this.parent : this).$root.$options
                          .shadowRoot
                      );
                    }
                  : r),
            l)
          )
            if (c.functional) {
              c._injectStyles = l;
              var d = c.render;
              c.render = function (e, t) {
                return l.call(t), d(e, t);
              };
            } else {
              var u = c.beforeCreate;
              c.beforeCreate = u ? [].concat(u, l) : [l];
            }
          return { exports: e, options: c };
        }
        const Qa = Za(
          Ka,
          function () {
            var e = this,
              t = e.$createElement,
              n = e._self._c || t;
            return n(
              "div",
              {
                ref: "component",
                staticClass: "wetheme-dropdown",
                class: [
                  "fit-" + this.fit,
                  e.isOpen
                    ? "wetheme-dropdown--open"
                    : "wetheme-dropdown--closed",
                  "wetheme-dropdown--" + e.direction,
                ],
              },
              [
                e.title
                  ? n("label", {
                      attrs: { for: e.id },
                      domProps: { textContent: e._s(e.title) },
                    })
                  : e._e(),
                e._v(" "),
                n(
                  "div",
                  { staticClass: "wetheme-dropdown__wrapper" },
                  [
                    n(
                      "button",
                      {
                        ref: "button",
                        staticClass: "alt-focus",
                        attrs: {
                          "aria-haspopup": "listbox",
                          type: "button",
                          readonly: "true",
                          id: e.id + "-button",
                          "aria-expanded": e.isOpen,
                        },
                        on: {
                          click: e.toggleDropdown,
                          keydown: [
                            function (t) {
                              return !t.type.indexOf("key") &&
                                e._k(t.keyCode, "enter", 13, t.key, "Enter")
                                ? null
                                : (t.preventDefault(),
                                  e.toggleDropdown.apply(null, arguments));
                            },
                            function (t) {
                              return !t.type.indexOf("key") &&
                                e._k(t.keyCode, "space", 32, t.key, [
                                  " ",
                                  "Spacebar",
                                ])
                                ? null
                                : (t.preventDefault(),
                                  e.toggleDropdown.apply(null, arguments));
                            },
                            function (t) {
                              return !t.type.indexOf("key") &&
                                e._k(t.keyCode, "up", 38, t.key, [
                                  "Up",
                                  "ArrowUp",
                                ])
                                ? null
                                : (t.preventDefault(), e.moveFocusedIndex(-1));
                            },
                            function (t) {
                              return !t.type.indexOf("key") &&
                                e._k(t.keyCode, "down", 40, t.key, [
                                  "Down",
                                  "ArrowDown",
                                ])
                                ? null
                                : (t.preventDefault(), e.moveFocusedIndex(1));
                            },
                            function (t) {
                              return !t.type.indexOf("key") &&
                                e._k(t.keyCode, "esc", 27, t.key, [
                                  "Esc",
                                  "Escape",
                                ])
                                ? null
                                : (t.preventDefault(),
                                  e.close.apply(null, arguments));
                            },
                          ],
                        },
                      },
                      [
                        n("span", {
                          domProps: {
                            textContent: e._s(e.selectedOption.label || " "),
                          },
                        }),
                      ]
                    ),
                    e._v(" "),
                    n(
                      "transition",
                      { attrs: { name: "wetheme-dropdown-fade" } },
                      [
                        n(
                          "ul",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: e.isOpen,
                                expression: "isOpen",
                              },
                            ],
                            ref: "ul",
                            attrs: {
                              id: e.dropdownId,
                              role: "listbox",
                              "aria-activedescendant":
                                e.id + "_" + e.focusedOption,
                              tabindex: "0",
                            },
                            on: {
                              keydown: [
                                function (t) {
                                  return !t.type.indexOf("key") &&
                                    e._k(t.keyCode, "up", 38, t.key, [
                                      "Up",
                                      "ArrowUp",
                                    ])
                                    ? null
                                    : (t.preventDefault(),
                                      e.moveFocusedIndex(-1));
                                },
                                function (t) {
                                  return !t.type.indexOf("key") &&
                                    e._k(t.keyCode, "down", 40, t.key, [
                                      "Down",
                                      "ArrowDown",
                                    ])
                                    ? null
                                    : (t.preventDefault(), e.moveFocusedIndex(1));
                                },
                                function (t) {
                                  return !t.type.indexOf("key") &&
                                    e._k(t.keyCode, "enter", 13, t.key, "Enter")
                                    ? null
                                    : (t.preventDefault(), e.applyFocused(!1));
                                },
                                function (t) {
                                  return !t.type.indexOf("key") &&
                                    e._k(t.keyCode, "space", 32, t.key, [
                                      " ",
                                      "Spacebar",
                                    ])
                                    ? null
                                    : (t.preventDefault(), e.applyFocused(!1));
                                },
                                function (t) {
                                  return !t.type.indexOf("key") &&
                                    e._k(t.keyCode, "esc", 27, t.key, [
                                      "Esc",
                                      "Escape",
                                    ])
                                    ? null
                                    : (t.preventDefault(),
                                      e.exitList.apply(null, arguments));
                                },
                              ],
                              blur: e.exitList,
                            },
                          },
                          e._l(e.options, function (t) {
                            return n("li", {
                              key: t.value,
                              class: { selected: e.optionIsSelected(t) },
                              attrs: {
                                role: "option",
                                id: t.value,
                                value: t.value,
                                "aria-selected": e.optionIsSelected(t),
                              },
                              domProps: { textContent: e._s(t.label) },
                              on: {
                                mousedown: function (n) {
                                  return e.optionClicked(t);
                                },
                              },
                            });
                          }),
                          0
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            );
          },
          [],
          !1,
          null,
          null,
          null
        ).exports;
        class Ja {
          constructor(e, t) {
            (this.getAutoplay = (e) =>
              (!("connection" in navigator) || !navigator.connection.saveData) &&
              !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
              e),
              (this._load = async function () {}),
              (this.init = (e) => {}),
              (this.play = () => {}),
              (this.pause = () => {}),
              (this.theme = e),
              (this.element = t);
          }
        }
        class eo extends Ja {
          constructor(...e) {
            super(...e),
              (this._load = () => this.theme.loadYoutubeApi()),
              (this.init = ({
                autoplay: e,
                hideControls: t,
                url: n,
                mute: i,
                loop: r,
                onPlay: s,
                onEnd: a,
                hero: o,
              }) => {
                e = this.getAutoplay(e);
                const l = ((e) => {
                  const t = e
                    .replace(/(>|<)/gi, "")
                    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
                  return void 0 !== t[2] ? t[2].split(/[^0-9a-z_-]/i)[0] : e;
                })(n);
                return new Promise((n) => {
                  this._load().then((c) => {
                    this.player = new c.Player(this.element, {
                      videoId: l,
                      playerVars: {
                        showinfo: 0,
                        modestbranding: 1,
                        rel: 0,
                        autoplay: e ? 1 : 0,
                        controls: t ? 0 : 1,
                        mute: i || e ? 1 : 0,
                        playlist: l,
                        cc_load_policy: 0,
                        fs: 0,
                        iv_load_policy: 3,
                        playsinline: 1,
                        branding: 0,
                        origin: window.location.origin,
                      },
                      events: {
                        onReady: (t) => {
                          if (((this.player = t.target), o)) {
                            const e = Object.keys(this.player).find(
                              (e) => "IFRAME" == this.player[e].tagName
                            );
                            this.player[e].tabIndex = -1;
                          }
                          (i || e) && this.player.mute(),
                            e && this.player.playVideo(),
                            n(this.player);
                        },
                        onStateChange: (e) => {
                          e.data === c.PlayerState.PLAYING && s(),
                            e.data === c.PlayerState.ENDED &&
                              r &&
                              (this.player.playVideo(), a());
                        },
                      },
                    });
                  });
                });
              });
          }
        }
        class to extends Ja {
          constructor(...e) {
            super(...e),
              (this._load = () => this.theme.loadVimeoApi()),
              (this.init = ({
                autoplay: e,
                hideControls: t,
                url: n,
                mute: i,
                loop: r,
                onPlay: s,
                onEnd: a,
                hero: o,
              }) => {
                e = this.getAutoplay(e);
                const l = (function (e) {
                  const t = e.match(
                    /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/
                  );
                  if (t && void 0 !== t[2]) {
                    var n = t[2];
                    return t[2].includes("/") && (n = t[2].split("/")[0]), n;
                  }
                  return e;
                })(n);
                return new Promise((n, c) => {
                  this._load().then((c) => {
                    (this.player = new c.Player(this.element, {
                      id: l,
                      autoplay: e,
                      controls: !t,
                    })),
                      this.player.ready().then(() => {
                        o && (this.player.element.tabIndex = -1),
                          (i || e) && this.player.setVolume(0),
                          r && this.player.setLoop(!0),
                          e && this.player.play(),
                          n(this.player);
                      }),
                      this.player.on("play", () => {
                        s();
                      }),
                      this.player.on("ended", () => {
                        a();
                      });
                  });
                });
              });
          }
        }
        class no extends Ja {
          constructor(...e) {
            super(...e),
              (this._load = () =>
                new Promise((e) => {
                  window.Shopify.loadFeatures([
                    {
                      name: "video-ui",
                      version: "1.0",
                      onLoad: function () {
                        e(window.Shopify.Plyr);
                      },
                    },
                  ]);
                })),
              (this.init = ({
                autoplay: e,
                hideControls: t,
                url: n,
                mute: i,
                loop: r,
                onPlay: s,
                onEnd: a,
                hero: o,
              }) => (
                (e = this.getAutoplay(e)),
                new Promise((n, l) => {
                  this._load().then((l) => {
                    (this.player = new l(this.element, {
                      loop: { active: r },
                      autoplay: e,
                      muted: i,
                      fullscreen: { enabled: !1 },
                      focusOnPlay: !1,
                    })),
                      this.player.on("ready", (i) => {
                        (this.player = i.detail.plyr),
                          o && (this.player.elements.container.tabIndex = -1),
                          e && this.player.play(),
                          t &&
                            this.player.media
                              .closest(".plyr--video")
                              .querySelector(".plyr__controls")
                              .remove(),
                          n();
                      }),
                      this.player.on("playing", () => {
                        s();
                      }),
                      this.player.on("ended", () => {
                        a();
                      });
                  });
                })
              ));
          }
        }
        const io = Za(
          Vr.extend({
            props: {
              theme: Ur,
              hero: Boolean,
              videoType: {
                type: String,
                required: !0,
                validator: function (e) {
                  return -1 !== ["youtube", "vimeo", "mp4"].indexOf(e);
                },
              },
              url: { type: String, required: !0 },
              autoplay: { type: Boolean, required: !0 },
              loop: Boolean,
              mute: Boolean,
              hideControls: { type: Boolean, default: !1 },
            },
            data: () => ({ player: null }),
            mounted() {
              "youtube" === this.videoType
                ? (this.player = new eo(this.theme, this.$refs.video))
                : "vimeo" === this.videoType
                ? (this.player = new to(this.theme, this.$refs.video))
                : "mp4" === this.videoType &&
                  (this.player = new no(this.theme, this.$refs.videoMP4)),
                this.player.init({
                  autoplay: this.autoplay,
                  hideControls: this.hideControls,
                  url: this.url,
                  mute: this.mute,
                  loop: this.loop,
                  onPlay: this.onPlay,
                  onEnd: this.onEnd,
                  hero: this.hero,
                });
            },
            methods: { onPlay() {}, onEnd() {} },
          }),
          function () {
            var e = this,
              t = e.$createElement,
              n = e._self._c || t;
            return n("div", { ref: "video", staticClass: "video" }, [
              "mp4" === e.videoType
                ? n(
                    "video",
                    {
                      ref: "videoMP4",
                      staticClass: "hero-video-mp4",
                      attrs: { playsinline: "", controls: "" },
                    },
                    [n("source", { attrs: { src: e.url, type: "video/mp4" } })]
                  )
                : e._e(),
            ]);
          },
          [],
          !1,
          null,
          null,
          null
        ).exports;
        (window.wetheme = new (class extends Ur {
          constructor() {
            super(),
              (this.RESIZE_DEBOUNCE_INTERVAL = 400),
              (this.SECTIONS = {
                header: fs,
                "collection--featured-collection": Ga,
                "image--image": za,
                "image--slideshow": vs,
                "image--image-with-text-block": Na,
                "image--image-with-text-overlay": qa,
                "product--featured-product": La,
                "product--shop-the-look": Ia,
                "template--collection": Fa,
                "template--collection-filter-sort": Ra,
                "template--collection-header": Ba,
                "template--collections-list": Va,
                "template--product": ja,
                "template--product--recommandations": Pa,
                "template--cart": Xa,
                "text--testimonials": ys,
                "text--text-adverts": ds,
                "video--video": Zr,
                "video--video-with-text-overlay": Zr,
              }),
              (this.VUE_COMPONENTS = {
                "wetheme-dropdown": Qa,
                "wetheme-video": io,
              }),
              (this.loadDrawers = () => {
                document.body.classList.contains("password-page") ||
                  ((this.drawer = new ss(this)),
                  (this.cartDrawer = this.drawer.slideouts.right
                    ? new es(this, this.drawer.slideouts.right.menu)
                    : null));
              }),
              (this._loadCartKey = () => "cd4f908b-0400-4e45-b574-a97f4e8c2a77"),
              (this.loadGlobal = () => {
                const e = document.querySelector("#wetheme-global");
                if (!e)
                  return void console.warn(
                    "Script #wetheme-global with global definitions not found"
                  );
                let t;
                try {
                  t = JSON.parse(e.textContent);
                } catch (e) {
                  return void console.warn(
                    "Invalid syntax in #wetheme-global",
                    e
                  );
                }
                (this.translations = t.translations),
                  (this.moneyFormat = t.moneyFormat);
              }),
              (this.loadVueComponents = (e) => {
                Object.entries(this.VUE_COMPONENTS).forEach(([t, n]) => {
                  this.loadVueComponent(e, t, n);
                });
              }),
              (this.loadVueComponent = (e, t, n) => {
                Array.prototype.forEach.call(e.querySelectorAll(t), (e) => {
                  const t = { theme: this };
                  if (e.hasAttributes()) {
                    var i = e.attributes;
                    for (let e = i.length - 1; e >= 0; e--) {
                      const { name: n, value: r } = i[e];
                      t[n] = "true" === r || ("false" !== r && r);
                    }
                  }
                  const r = new Vr({ el: e, render: (e) => e(n, { attrs: t }) });
                  this.vueComponents.push(r);
                });
              }),
              (this.loadSection = (e, t, n) => {
                const i = new t(this, e, n);
                this.sectionById.set(e.dataset.wethemeSectionId, i);
                const r = e.dataset.wethemeSectionType;
                let s = this.sectionsByType.get(r);
                s || ((s = []), this.sectionsByType.set(r, s)),
                  s.push(i),
                  this.loadVueComponents(e);
              }),
              (this.loadSectionsByType = (e, t, n) => {
                const i = `[data-wetheme-section-type="${e}"]`;
                Array.prototype.forEach.call(
                  document.querySelectorAll(i),
                  (i) => {
                    try {
                      this.loadSection(i, t, n);
                    } catch (t) {
                      console.error(
                        `Unable to load section ${e} on element`,
                        i,
                        t
                      );
                    }
                  }
                );
              }),
              (this.onLoadAll = () => {
                this.load(),
                  Object.entries(this.SECTIONS).forEach(([e, t]) => {
                    this.loadSectionsByType(e, t, !0);
                  });
              }),
              (this.onSectionLoad = (e) => {
                const { sectionId: t } = e.detail,
                  n = `[data-wetheme-section-id="${t}"]`,
                  i = document.querySelector(n);
                if (!i)
                  return void console.warn(
                    `Element with ${n} not found, section won't be loaded`
                  );
                const r = i.dataset.wethemeSectionType,
                  s = this.SECTIONS[r];
                s
                  ? this.loadSection(i, s, !1)
                  : console.warn(`Cannot find class with type "${r}"`);
              }),
              (this.onSectionUnload = (e) => {
                const t = e.target,
                  { sectionId: n } = e.detail,
                  i = this.sectionById.get(n);
                i
                  ? i.destroy({ element: t })
                  : console.warn(
                      `No section with id ${n}, nothing will be unloaded`
                    );
              }),
              (this.onSectionSelect = (e) => {
                const t = e.target,
                  { sectionId: n, load: i } = e.detail,
                  r = this.sectionById.get(n);
                r
                  ? r.onSectionSelect({ element: t, sectionId: n, load: i })
                  : console.warn(
                      `No section with id ${n}, nothing will be selected`
                    );
              }),
              (this.onSectionDeselect = (e) => {
                const t = e.target,
                  { sectionId: n } = e.detail,
                  i = this.sectionById.get(n);
                i
                  ? i.onSectionDeselect({ element: t, sectionId: n })
                  : console.warn(
                      `No section with id ${n}, nothing will be deselected`
                    );
              }),
              (this.onSectionReorder = (e) => {
                const t = e.target,
                  { sectionId: n } = e.detail,
                  i = this.sectionById.get(n);
                i
                  ? i.onSectionReorder({ element: t, sectionId: n })
                  : console.warn(
                      `No section with id ${n}, nothing will be done on reorder`
                    );
              }),
              (this.onBlockSelect = (e) => {
                const t = e.target,
                  { sectionId: n, blockId: i, load: r } = e.detail,
                  s = this.sectionById.get(n);
                s
                  ? s.onBlockSelect({
                      element: t,
                      sectionId: n,
                      blockId: i,
                      load: r,
                    })
                  : console.warn(
                      `No section with id ${n}, block select will do nothing`
                    );
              }),
              (this.onBlockDeselect = (e) => {
                const t = e.target,
                  { sectionId: n, blockId: i } = e.detail,
                  r = this.sectionById.get(n);
                r
                  ? r.onBlockDeselect({ element: t, sectionId: n, blockId: i })
                  : console.warn(
                      `No section with id ${n}, block deselect will do nothing`
                    );
              }),
              (this.onResize = (e) => {
                const t = this.getWindowWidth(),
                  n = this.previousWidth;
                this.registeredComponents.forEach((e) =>
                  e.onWindowResizeRaw({ width: t })
                ),
                  this.resizeDebounceTimer &&
                    clearTimeout(this.resizeDebounceTimer),
                  (this.resizeDebounceTimer = setTimeout(() => {
                    this.resizeDebounceTimer = null;
                    const e = this.getBreakpoint(t);
                    this.registeredComponents.forEach((i) => {
                      i.onWindowResize({ width: t, oldWidth: n, breakpoint: e }),
                        e !== this.breakpoint &&
                          i.onWindowResizeBreakpoint({
                            breakpoint: e,
                            oldBreakpoint: this.breakpoint,
                            width: t,
                          });
                    }),
                      (this.previousWidth = t),
                      (this.breakpoint = e);
                  }, this.RESIZE_DEBOUNCE_INTERVAL));
              }),
              (this.loadIcons = (e = null) => {
                const t = e || document;
                var n = Object.keys(Xr().icons);
                Array.prototype.forEach.call(
                  t.querySelectorAll("[data-feather]"),
                  function (e) {
                    var t = e.dataset.feather;
                    n.indexOf(t) < 0 &&
                      (console.warn(
                        'No such icon "' + t + '" in feather, element',
                        e
                      ),
                      (e.dataset.featherInvalid = t),
                      delete e.dataset.feather);
                  }
                );
                try {
                  Xr().replace();
                } catch (e) {
                  console.error("Unable to load icons:", e);
                }
              }),
              (this.handleAccordions = () => {
                let e = document.querySelectorAll("details");
                for (let t of e)
                  t.addEventListener("click", (e) => {
                    e.currentTarget;
                    setTimeout(() => {
                      const e = t.open ? "true" : "false";
                      t.firstElementChild.setAttribute("aria-expanded", e);
                    }, 0);
                  });
              }),
              (this.loadYoutubeApi = () =>
                new Promise((e, t) => {
                  if (window.YT) e(window.YT);
                  else if (document.querySelector("#youtube_api"))
                    this.youtubeLoadedCallbacks.push({ resolve: e, reject: t });
                  else {
                    this.youtubeLoadedCallbacks.push({ resolve: e, reject: t });
                    const n = document.querySelectorAll(".embed-container")[0],
                      i = document.querySelector("#main-body").dataset.editorOpen;
                    if (n && "false" == i) {
                      let e = n.offsetTop,
                        t = (function (e) {
                          const t = e.getBoundingClientRect();
                          return (
                            t.top >= 101 &&
                            t.left >= 0 &&
                            t.right <=
                              (window.innerWidth ||
                                document.documentElement.clientWidth)
                          );
                        })(n);
                      e > 10 && e <= 100
                        ? this.createScript(
                            "youtube_api",
                            "https://www.youtube.com/player_api",
                            !0
                          )
                        : document.addEventListener(
                            "scroll",
                            function () {
                              t &&
                                this.createScript(
                                  "youtube_api",
                                  "https://www.youtube.com/player_api",
                                  !0
                                );
                            }.bind(this),
                            { passive: !0 }
                          );
                    } else
                      this.createScript(
                        "youtube_api",
                        "https://www.youtube.com/player_api",
                        !0
                      );
                  }
                })),
              (this.onYoutubeLoaded = () => {
                this.youtubeLoadedCallbacks.forEach(({ resolve: e }) => {
                  e(window.YT);
                }),
                  this.youtubeLoadedCallbacks.splice(0);
              }),
              (this.loadVimeoApi = () =>
                new Promise((e, t) => {
                  if (window.Vimeo) e(window.Vimeo);
                  else if (document.querySelector("#vimeo_api"))
                    this.vimeoLoadedCallbacks.push({ resolve: e, reject: t });
                  else {
                    this.createScript(
                      "vimeo_api",
                      "https://player.vimeo.com/api/player.js"
                    ).onload = () => {
                      e(window.Vimeo), this.onVimeoLoaded();
                    };
                  }
                })),
              (this.onVimeoLoaded = () => {
                this.vimeoLoadedCallbacks.forEach(({ resolve: e }) => {
                  e(window.Vimeo);
                }),
                  this.vimeoLoadedCallbacks.splice(0);
              }),
              (this.updateCartDrawer = (e) => {
                this.cartDrawer && this.cartDrawer.updateCartDrawer(e);
              }),
              (this.createScript = (e, t, n = !1) => {
                const i = document.createElement("script");
                (i.id = e), (i.src = t), n && ((i.defer = !0), (i.async = !0));
                const r = document.getElementsByTagName("script")[0];
                return r.parentNode.insertBefore(i, r), i;
              }),
              (this.registerComponent = (e) => {
                this.registeredComponents.push(e);
              }),
              (this.makeVideoEmbedsResponsive = () => {
                t()(
                  ".template-page iframe, .template-blog iframe, .template-article iframe"
                ).each(function (e, n) {
                  var i = t()(n).attr("src");
                  if (
                    i.indexOf("youtube.com") >= 0 ||
                    i.indexOf("vimeo.com") >= 0 ||
                    i.indexOf("dailymotion.com") >= 0
                  ) {
                    var r = document.createElement("div");
                    t()(r).addClass("embed-container");
                    var s = t()(n).clone();
                    t()(r).append(s), t()(n).replaceWith(r);
                  }
                });
              }),
              (this.gridSwatches = () => {
                t()(".indiv-product__swatches")
                  .find("input")
                  .on("change", function () {
                    var e = t()(this).attr("data-href"),
                      n = t()(this)
                        .closest(".indiv-product")
                        .find(".grid__image img");
                    n.attr({ src: e }),
                      n.attr({ srcset: e }),
                      n.data({ lowsrc: e }),
                      n.data({ srcset: e });
                  });
              }),
              (this.name = "Envy"),
              (this.$ = t()),
              (this.sectionById = new Map()),
              (this.sectionsByType = new Map()),
              (this.registeredComponents = []),
              (this.vueComponents = []),
              (this.youtubeLoadedCallbacks = []),
              (this.vimeoLoadedCallbacks = []),
              (this.resizeDebounceTimer = null),
              document.addEventListener(
                "shopify:section:load",
                this.onSectionLoad
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.onSectionUnload
              ),
              document.addEventListener(
                "shopify:section:select",
                this.onSectionSelect
              ),
              document.addEventListener(
                "shopify:section:deselect",
                this.onSectionDeselect
              ),
              document.addEventListener(
                "shopify:section:reorder",
                this.onSectionReorder
              ),
              document.addEventListener(
                "shopify:block:select",
                this.onBlockSelect
              ),
              document.addEventListener(
                "shopify:block:deselect",
                this.onBlockDeselect
              ),
              document.addEventListener("DOMContentLoaded", this.onLoadAll),
              window.addEventListener("resize", this.onResize);
          }
          load() {
            this.loadGlobal(),
              (this.breakpoint = this.getBreakpoint()),
              (this.wow = new (r())().init()),
              this.loadDrawers(),
              this.handleAccordions(),
              (this.popup = null);
            const e = document.querySelector("#popup");
            e &&
              "/challenge" !== window.location.pathname &&
              (this.popup = new Qr(this, e)),
              (this.ageCheck = null);
            const t = document.querySelector(".verification-popup-container");
            t &&
              "/challenge" !== window.location.pathname &&
              (this.ageCheck = new as(this, t)),
              this.loadIcons(),
              (this.newsletter = new Ya(this)),
              document.body.classList.contains("template-customers-login") &&
                (this.login = new os(this)),
              document.body.classList.contains("template-search") &&
                (this.searchPage = new ls(
                  this,
                  document.querySelector("#search_results")
                )),
              document.body.classList.contains("template-customers-addresses") &&
                (this.addressPage = new cs(
                  this,
                  document.querySelector("#addresses")
                )),
              this.makeVideoEmbedsResponsive(),
              this.gridSwatches();
          }
        })()),
          (window.onYouTubePlayerAPIReady = () => {
            window.wetheme.onYoutubeLoaded();
          });
      })();
  })();
  //# sourceMappingURL=theme.min.js.map

async function getBackorder(sku_cd) {
  const standard = document.getElementById('message-shipping-standard');
  const backorder = document.getElementById('message-shipping-backorder');
  const url = "/apps/proxy/backorder";

  let response = await fetch(url, {
    method: "POST",
	  headers: {
        'Content-Type': 'application/json'
	  },
    body: JSON.stringify({ sku_cd: sku_cd })
  })
  .then((response) => response.json())
  .then((data) => {
    //console.log('data', data);
    if(data.status == "success") {
	  if(data.soldout == false) {
        if(data.backorder == true) {
          backorder.style.display = "block";
        }else{
          standard.style.display = "block";
        }
      }
    }
  })
  .catch((error) => {
    console.error('エラーが発生しました:', error);
  });

  return;
}

document.addEventListener('DOMContentLoaded', () => {

  // ページ内のすべてのスライダーコンテナを取得
  const sliders = document.querySelectorAll('.product-slider-container');
  if(!sliders.length) {
    return;
  }

  // ブレイクポイントの定義（768px以下をモバイルとする）
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  sliders.forEach(slider => {
    const wrapper = slider.querySelector('.product-slider-wrapper');
    const prevBtn = slider.querySelector('.product-slider-button-prev');
    const nextBtn = slider.querySelector('.product-slider-button-next');

    // 必要な要素が揃っていない場合はスキップ
    if (!wrapper || !prevBtn || !nextBtn) return;

    // 現在のデバイス環境でスクロールを有効にするか判定する関数
    function isScrollEnabled() {
      const isMobile = mobileQuery.matches;
      const hasDesktopAttr = slider.hasAttribute('data-scroll-desktop');
      const hasMobileAttr = slider.hasAttribute('data-scroll-mobile');

      if (isMobile) return false; // スマホは非表示に変更
      if (isMobile && hasMobileAttr) return true;
      if (!isMobile && hasDesktopAttr) return true;
      
      return false;
    }

    // 矢印の表示/非表示を更新する関数
    function updateArrows() {
      // スクロール対象外のデバイス環境なら、矢印を両方とも非表示にして終了
      if (!isScrollEnabled()) {
        prevBtn.classList.add('is-hidden');
        nextBtn.classList.add('is-hidden');
        return;
      }

      const scrollLeft = wrapper.scrollLeft;
      const maxScrollLeft = wrapper.scrollWidth - wrapper.clientWidth;

      // 左端の判定（1px以内の誤差を許容）
      if (scrollLeft <= 1) {
        prevBtn.classList.add('is-hidden');
      } else {
        prevBtn.classList.remove('is-hidden');
      }

      // 右端の判定（2px以内の誤差を許容）
      if (scrollLeft >= maxScrollLeft - 2) {
        nextBtn.classList.add('is-hidden');
      } else {
        nextBtn.classList.remove('is-hidden');
      }
    }

    // 矢印をクリックしたときのスクロール処理
    function scrollAmount(direction) {
      // 現在表示されているエリア幅の80%をスクロール量にする
      const amount = wrapper.clientWidth * 0.8; 

      // 現在のスクロール位置を基準に左右に移動させる
      const targetScrollLeft = direction === 'next' 
        ? wrapper.scrollLeft + amount 
        : wrapper.scrollLeft - amount;

      wrapper.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth' // なめらかにスクロールさせる
      });
    }

    // イベントリスナーの登録
    wrapper.addEventListener('scrollend', updateArrows);
    mobileQuery.addEventListener('change', updateArrows);

    // 矢印ボタンのクリックイベント
    prevBtn.addEventListener('click', () => scrollAmount('prev'));
    nextBtn.addEventListener('click', () => scrollAmount('next'));

    // 動的な要素追加を監視するMutationObserver
    const observer = new MutationObserver(() => {
      // 子要素（liなど）が追加・削除されたら、矢印の表示を再計算する
      updateArrows();
    });

    // ul要素の「子要素の変化（childList）」を監視開始
    observer.observe(wrapper, { childList: true });

    // 初回の表示状態を反映
    updateArrows();
    window.addEventListener('load', updateArrows);
  });
});
